// @formatter:off
(function (window) {
  /** @mixin */
  var ds = window.ds;
  if (!window.ds) ds = window.ds = {};
  ds.types = {
    field: Field,
    pk: PrimaryKeyField,
    combined: Combined
  };

  /** @type FieldExpression
  * @constructor */
  function Field() {}

  /**@type FieldExpression
  * @constructor */
  function PrimaryKeyField() {}

  /** @type ModelExpression
  * @param modelName
  * @constructor */
  function Combined(modelName) {
    this.modelName = modelName;
  }
  var f = new Field(),
    p = new PrimaryKeyField(),
    c = Combined;
  ds.QAmclAmiTDeviation = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    deviationType: f,
    deviationDistance: f,
    sailingStatus: f,
    latitude: f,
    longitude: f,
    crs: f,
    runHrs: f,
    runDist: f,
    obsSpeed: f,
    distGo: f,
    nextPortCd: f,
    nextPortType: f,
    etaNextPort: f,
    windDir: f,
    windScale: f,
    waveDir: f,
    waveHeight: f,
    airTemp: f,
    seaTemp: f,
    currDir: f,
    velocity: f,
    meAvgRpm: f,
    meKw: f,
    avgSpd: f,
    slip: f,
    foRestriction: f,
    spdRestriction: f,
    rpmRestriction: f,
    etaRequirement: f,
    otherRqmnt: f,
    aFoHEng: f,
    aFoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aFoHBoiler: f,
    aFoLBoiler: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    tHsfo: f,
    tLsfo: f,
    tHsmgo: f,
    tLsmgo: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aBoilerWater: f,
    aDomesticWater: f,
    mFoH: f,
    mFoL: f,
    mMgoH: f,
    mMgoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBoilerWater: f,
    mDomesticWater: f,
    remark: f,
    fuelOilInertTemp: f,
    oilFlowRate: f,
    specialPoint1: f,
    eSpecialTime1: f,
    aPassTime1: f,
    specialPoint2: f,
    eSpecialTime2: f,
    aPassTime2: f,
    totalRunDist: f,
    totalRunTime: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    basisSpeed: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    isCargoRob: f,
    cargoRob: f,
    reason: f,
    periodBeginTm: f,
    utc: f,
    periodEndTm: f,
    endUtc: f,
    duration: f,
    aFoHCargoHeating: f,
    aFoLCargoHeating: f,
    aFoHTankCleaning: f,
    aFoLTankCleaning: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    aWaterBoiler: f,
    aWaterDomestic: f,
    mBWater: f,
    mDWater: f,
    mNonLiqSlops: f,
    mLiqSlops: f,
    tFoHEng: f,
    tFoLEng: f,
    tFoHGen: f,
    tFoLGen: f,
    tFoHBoiler: f,
    tFoLBoiler: f,
    tMgoHEng: f,
    tMgoLEng: f,
    tMgoHGen: f,
    tMgoLGen: f,
    tMgoHBoiler: f,
    tMgoLBoiler: f,
    tFoHCargoHeating: f,
    tFoLCargoHeating: f,
    tFoHTankCleaning: f,
    tFoLTankCleaning: f,
    tMgoHIgg: f,
    tMgoLIgg: f,
    tMgoHInc: f,
    tMgoLInc: f,
    tMgoHOther: f,
    tMgoLOther: f,
    tFoHIgg: f,
    tFoLIgg: f,
    tFoHInc: f,
    tFoLInc: f,
    tFoHOther: f,
    tFoLOther: f,
    tSulphurHfo: f,
    tSulphurLfo: f,
    tSulphurHmgo: f,
    tSulphurLmgo: f,
    tTtlFoH: f,
    tTtlFoL: f,
    tTtlMgoH: f,
    tTtlMgoL: f,
    tLuboilEng: f,
    tLuboilCyl: f,
    tLuboilGen: f,
    tBoilerWater: f,
    tDomesticWater: f,
    tMFoH: f,
    tMFoL: f,
    tMMgoH: f,
    tMMgoL: f,
    tMLuboilEng: f,
    tMLuboilCyl: f,
    tMLuboilGen: f,
    tMBoilerWater: f,
    tMDomesticWater: f,
    tMNonLiqSlops: f,
    tMLiqSlops: f,
    portCd: f,
    cascadeWaterTemp: f,
    reasonDetail: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QChrEstimateBunkerCost = {
    id: p,
    bunkerCost: f,
    bunkerType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    mainId: f,
    bunkerId: f,
    bunkerSpec: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QOpsSo = {
    discPortDesc: f,
    soNo: f,
    discPortName: f,
    packageType: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    carrierName: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    goodsDesc: f,
    discPortCode: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    mateRemark: f,
    agentLockUser: f,
    shipperName: f,
    opsBlTemplateId: f,
    loadingDate: f,
    agentLockTime: f,
    goodsCube: f,
    shipperDesc: f,
    createOffice: f,
    createOfficeName: f,
    carrierCode: f,
    consigneeCode: f,
    createName: f,
    noOfPackage: f,
    weightUnit: f,
    vesselName: f,
    agentLockUserName: f,
    consigneeDesc: f,
    remark: f,
    shipperCode: f,
    agentLockFlag: f,
    lockUserName: f,
    consigneeName: f,
    ispFleetCode: f,
    lockTime: f,
    lockUser: f,
    principalOrgCode: f,
    loadPortName: f,
    notifyCode: f,
    loadPortDesc: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    deckDesc: f,
    cubeUnit: f,
    marks: f,
    lastModifyByName: f,
    lockFlag: f,
    grossWeight: f,
    loadPortCode: f,
    notifyDesc: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    notifyName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    discPortNameEn: f,
    loadPortNameEn: f,
    vesselNameEn: f,
    consigneeNameEn: f,
    shipperNameEn: f,
    carrierNameEn: f,
    consigneeDescEn: f,
    notifyNameEn: f,
    opsBlSoRelate: new c("OpsBlSoRelate")
  };
  ds.QFlowCall = {
    id: p,
    startModelKey: f,
    endModelKey: f
  };
  ds.QChrSettlementPortFeeDetail = {
    id: p,
    portFeeId: f,
    portCode: f,
    portName: f,
    dataSourceId: f,
    portFee: f,
    type: f,
    invoiceDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    oriCurrency: f,
    exchangeRate: f
  };
  ds.QChrContractGeneral = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractName: f,
    contractType: f,
    contractDate: f,
    contractStatus: f,
    contractNo: f,
    contractCurrency: f,
    contractYear: f,
    signPlace: f,
    endDate: f,
    signDate: f,
    bidDate: f,
    effectiveDate: f,
    emergencyLevel: f,
    moneyFlow: f,
    effectConditions: f,
    foreignFlag: f,
    bidContext: f,
    bidAmount: f,
    contractPeriod: f,
    bidAmountFlag: f,
    contractRate: f,
    jurisdictionArea: f,
    applicableLaw: f,
    mainTerms: f,
    lawFlag: f,
    sanctionComplianceType: f,
    contractOppNo: f,
    relateVesselType: f,
    relateBizType: f,
    relateVesselCode: f,
    relateVesselName: f,
    signatory: f,
    signSubjectCode: f,
    isProvideSecurity: f,
    signSubjectName: f,
    oppPartyFiles: f,
    ownerFiles: f,
    assureName: f,
    assureCode: f,
    oppSignerName: f,
    oppSignerCode: f,
    oppAssureName: f,
    oppAssureCode: f,
    secretFlag: f,
    importantFlag: f,
    importantFlagLc: f,
    bidAmountRmb: f,
    ispFleetCode: f,
    contractVersion: f,
    numberFiles: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    lastFlag: f,
    assureNameEn: f,
    signSubjectNameEn: f,
    oppAssureNameEn: f,
    oppSignerNameEn: f,
    relateVesselNameEn: f,
    invoiceType: f,
    tradeFlag: f,
    attachId: f
  };
  ds.QChrTceEstimateDetail = {
    id: p,
    mainId: f,
    estimateDate: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    vesselType: f,
    voyageNo: f,
    contractNo: f,
    netTce: f,
    comm: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    operationDay: f
  };
  ds.QOpsVesselStatus = {
    id: p,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    voyageNo: f,
    cargoQty: f,
    vesselStatus: f,
    statusTime: f,
    statusTimeGmt: f,
    portCode: f,
    portName: f,
    portNameEn: f,
    portSequence: f,
    estDepartureTime: f,
    arrivalTime: f,
    timeZone: f,
    course: f,
    speed: f,
    currentLat: f,
    latFlag: f,
    currentLong: f,
    longFlag: f,
    mainCargoName: f,
    mainCargoNameEn: f,
    mainCargoCode: f,
    holdWater: f,
    aftDrf: f,
    midDrf: f,
    befDrf: f,
    statusRemark: f,
    nextPortTime: f,
    nextPortCode: f,
    nextPortName: f,
    nextPortNameEn: f,
    windScale: f,
    windDirection: f,
    seaScale: f,
    visibilitysScale: f,
    actionCode: f,
    actionName: f,
    sailMile: f,
    nextMile: f,
    specialFlag: f,
    useWater: f,
    berthingTimeFlag: f,
    departureTimeFlag: f,
    loadBallast: f,
    engineRpm: f,
    nextPortSequence: f,
    waveDirection: f,
    waveHeight: f,
    swellHeight: f,
    swellDirect: f,
    slip: f,
    lastReportTime: f,
    weather: f,
    airTemp: f,
    seaTemp: f,
    sepcialFlagMark: f,
    nextPortRemark: f,
    nextVoyCharterRemark: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    berthingTime: f,
    sailTime: f,
    currentDirection: f,
    currentScale: f,
    opsVoyageTaskId: f
  };
  ds.QFineInternational = {
    id: p,
    description: f,
    i18nkey: f,
    language: f,
    i18nvalue: f
  };
  ds.QBookEstimateAnalysis = {
    id: p,
    mainId: f,
    analysisType: f,
    indexNum: f,
    analysisNumber: f,
    influenceNumber: f,
    actualTce: f,
    roundActualTce: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QAmiTDptDisch = {
    reason: f,
    gasMgoLBoiler: f,
    daLuboilEng: f,
    pscOtherInspFlag: f,
    gasMgoLGen: f,
    tugsUsed: f,
    basisSpeed: f,
    daMgoHGen: f,
    ptLuboilCyl: f,
    lastModifyTimeZone: f,
    gasMgoHInc: f,
    gasMgoHEng: f,
    daMgoHBoiler: f,
    rmFoL: f,
    recordVersion: f,
    rmBWater: f,
    daDomesticWater: f,
    daMgoLOther: f,
    anchoringTm: f,
    ttlPortH: f,
    daTLsmgo: f,
    daMgoLInc: f,
    daMgoLEng: f,
    cwMm: f,
    createTimeZone: f,
    id: p,
    daTHsfo: f,
    rmFoH: f,
    rmLuboilCyl: f,
    daFoHIgg: f,
    daMgoLIgg: f,
    fuelFoHInc: f,
    fuelFoHEng: f,
    daLuboilCyl: f,
    createOffice: f,
    isCargoRobFlag: f,
    rmLuboilEng: f,
    fuelFoLGen: f,
    onberthTm: f,
    daFoHOther: f,
    garDispFlag: f,
    daSulphurHmgo: f,
    reservedDate: f,
    unberthing: f,
    daTHsmgo: f,
    latitude: f,
    sfFr: f,
    faopSpdTm: f,
    baseInfoId: f,
    ptLuboilEng: f,
    bmFr: f,
    principalOrgCode: f,
    runningHours: f,
    rmDWater: f,
    creator: f,
    daMgoLBoiler: f,
    sulphurHmgo: f,
    waterTreatUsed: f,
    portCode: f,
    daFoHBoiler: f,
    daFoLGen: f,
    fuelFoLBoiler: f,
    fuelFoHIgg: f,
    liquid: f,
    createTime: f,
    shiftingTm: f,
    lastModifyTime: f,
    gasMgoLIgg: f,
    da: f,
    daFoHInc: f,
    daFoHEng: f,
    fuelFoHOther: f,
    daMgoHInc: f,
    daMgoHEng: f,
    rmLuboilGen: f,
    df: f,
    ttlMgoH: f,
    gasMgoHGen: f,
    fuelFoLIgg: f,
    dm: f,
    gasMgoLInc: f,
    runDist: f,
    gasMgoLEng: f,
    strBmFr: f,
    daFoLOther: f,
    totalTm: f,
    ttlFoL: f,
    ttlFoH: f,
    daMgoHOther: f,
    berthing: f,
    rmDoH: f,
    strSfFr: f,
    daTLsfo: f,
    longitude: f,
    rmDoL: f,
    lastModifyBy: f,
    fuelFoLInc: f,
    ptLuboilGen: f,
    fuelFoLEng: f,
    daFoLIgg: f,
    reservedLong2: f,
    gasMgoHOther: f,
    daFoLBoiler: f,
    reservedLong1: f,
    daLuboilGen: f,
    fuelFoHGen: f,
    daMgoHIgg: f,
    ttlMgoL: f,
    freBWater: f,
    gasMgoLOther: f,
    nextAssignment: f,
    fuelFoLOther: f,
    sulphurHfo: f,
    daSulphurLfo: f,
    sulphurLfo: f,
    nonLiquid: f,
    daBoilerWater: f,
    reservedStr3: f,
    cargoRob: f,
    reservedStr2: f,
    reservedStr1: f,
    daSulphurHfo: f,
    daSulphurLmgo: f,
    reservedInt1: f,
    reservedInt2: f,
    prostestRemarks: f,
    driftingTm: f,
    lastModifyOffice: f,
    sulphurLmgo: f,
    fuelFoHBoiler: f,
    crs: f,
    etaNextPort: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    daMgoLGen: f,
    freDWater: f,
    daFoHGen: f,
    nextPort: f,
    shiftingDist: f,
    sscecValidDate: f,
    gasMgoHBoiler: f,
    daFoLInc: f,
    daFoLEng: f,
    remarks: f,
    gasMgoHIgg: f,
    cashReceived: f,
    nextPortEn: f,
    nextPortCn: f,
    amiTDptDischPortDelay: new c("AmiTDptDischPortDelay"),
    amiTDepDischOilSupplited: new c("AmiTDepDischOilSupplited"),
    amiTDptDischCargo: new c("AmiTDptDischCargo"),
    amiTDepDischFlow: new c("AmiTDepDischFlow"),
    amiTDepDischPumping: new c("AmiTDepDischPumping")
  };
  ds.QFinRuleConfig20231215 = {
    id: f,
    businessType: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    vesselType: f,
    accountType: f,
    businessTypeId: f,
    operateType: f,
    accountSet: f,
    debitCreditFlag: f,
    debitAccountCode: f,
    debitName: f,
    debitFeeCode: f,
    creditAccountCode: f,
    creditName: f,
    creditFeeCode: f,
    accountGroupId: f,
    contractType: f,
    sceneCode: f,
    accountingEngineSceneCode: f,
    sceneName: f,
    companyId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    startTime: f,
    endTime: f,
    configRemark: f,
    dispOrder: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFinRuleConfig20231214 = {
    id: p,
    businessType: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    vesselType: f,
    accountType: f,
    businessTypeId: f,
    operateType: f,
    accountSet: f,
    debitCreditFlag: f,
    debitAccountCode: f,
    debitName: f,
    debitFeeCode: f,
    creditAccountCode: f,
    creditName: f,
    creditFeeCode: f,
    accountGroupId: f,
    contractType: f,
    sceneCode: f,
    accountingEngineSceneCode: f,
    sceneName: f,
    companyId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    startTime: f,
    endTime: f,
    configRemark: f,
    dispOrder: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QComApTaxInvoiceDtl = {
    seqNo: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    chargeName: f,
    unitPrice: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    quantity: f,
    lastModifyOfficeName: f,
    specification: f,
    serviceName: f,
    lastModifyByName: f,
    taxRate: f,
    unit: f,
    apTaxInvoiceId: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    preTaxInvoiceAmount: f,
    lastModifyTime: f,
    taxAmount: f,
    createName: f,
    chargeCode: f,
    invoiceAmount: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f
  };
  ds.QBgtAnnualBudgetVessel = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyTimeZone: f,
    vesselId: f,
    totalAmount: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    annualBudgetId: f,
    deletedFlag: f,
    lastModifyTime: f,
    vesselNameCn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    vesselName: f
  };
  ds.QMtrPoMain = {
    id: p,
    applyMainId: f,
    inquiryMainId: f,
    vesselId: f,
    vesselCode: f,
    dept: f,
    applyNo: f,
    applyPurpose: f,
    urgency: f,
    etp: f,
    etpNameCn: f,
    etpNameEn: f,
    eta: f,
    etd: f,
    poNo: f,
    orderDate: f,
    poStatus: f,
    orderType: f,
    specBusinessMark: f,
    poRemark: f,
    currency: f,
    rate: f,
    amount: f,
    amountStandard: f,
    discount: f,
    miscAmount: f,
    applyType: f,
    deductionAmount: f,
    leadTime: f,
    paymentPeriod: f,
    supplierId: f,
    supplierConfirmFlag: f,
    officeId: f,
    paymentType: f,
    receiveStatus: f,
    paymentStatus: f,
    chargeId: f,
    chargeCode: f,
    expenseSource: f,
    payFor: f,
    stockingStatus: f,
    logisticsReceiveFlag: f,
    transferFlag: f,
    transferType: f,
    transferSource: f,
    transferVesselId: f,
    repairPlanId: f,
    repairPlanDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    supplierNameCn: f,
    vesselNameEn: f,
    supplierNameEn: f,
    vesselNameCn: f,
    transferVesselNameCn: f,
    transferVesselNameEn: f,
    extraMiscAmount: f,
    chargeNameEn: f,
    officeNameCn: f,
    chargeNameCn: f,
    officeNameEn: f,
    quoteMainId: f,
    baseCurrency: f,
    auditGroupId: f,
    electricFlag: f,
    sendFinanceFlag: f,
    applyRoleCode: f,
    sendFinanceTime: f,
    voyageNo: f,
    extraMiscFlag: f,
    deviceInstallFlag: f,
    purposeType: f,
    purposeTypeDevice: f,
    taxRate: f,
    taxAmount: f,
    taxRateCode: f,
    safetyContainFlag: f,
    safetyCharge: f,
    safetyReviewStatus: f,
    signRate: f,
    receiveCompleteUserNameEn: f,
    receiveCompleteUserCode: f,
    receiveCompleteDate: f,
    receiveCompleteUserNameCn: f,
    mtrPoDetails: new c("MtrPoDetail")
  };
  ds.QChrSettlementBunkerCostDetail = {
    id: p,
    mainId: f,
    bunkerSpec: f,
    bunkerPrice: f,
    ballastCost: f,
    ladenCost: f,
    portCost: f,
    totalCost: f,
    totalCostAmount: f
  };
  ds.QOpsOilSupply = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    bunkerId: f,
    voyageNo: f,
    custCode: f,
    custName: f,
    currency: f,
    oilPrice1: f,
    oilPrice2: f,
    oilPrice3: f,
    actCustRemark: f,
    supplierOtherFee: f,
    ispFleetCode: f,
    suppliersOrder: f,
    actCustCode: f,
    oilType: f,
    actCustName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    custNameEn: f,
    actCustNameEn: f,
    traderCode: f,
    traderNameEn: f,
    traderName: f
  };
  ds.QChrPreSettlementDemurrage = {
    id: p,
    mainId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    grossFlag: f,
    contractNo: f,
    chargeDescription: f,
    invoceType: f,
    actualChargeFee: f,
    chargeName: f,
    invoiceNo: f,
    chargeCode: f,
    estimateChargeFee: f,
    chargeFeeRateUnit: f,
    chargeFeeRate: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f
  };
  ds.QEmployee = {
    employeeId: p,
    username: f,
    cname: f,
    password: f,
    age: f,
    sex: f,
    email: f,
    mobile: f,
    address: f,
    deptId: f,
    creator: f,
    modifier: f,
    createTime: f
  };
  ds.QAppKeyAuthority = {
    id: f,
    appKey: f,
    modelKey: f,
    authority: f
  };
  ds.QFineScheduleTaskParam = {
    id: p,
    param: f,
    taskid: f,
    taskname: f
  };
  ds.QOpsInsExagreementCompany = {
    id: p,
    opsInsExagreementId: f,
    insCompanyCode: f,
    insCompanyName: f,
    amount: f,
    ispFleetCode: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    inScale: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    insCompanyNameEn: f,
    discount: f
  };
  ds.QPoolContractAgent = {
    lastModifyOffice: f,
    commisDescribe: f,
    creator: f,
    agent: f,
    lastModifyBy: f,
    payer: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    freightBasis: f,
    lastModifyTime: f,
    superiorCompanyCode: f,
    principalOrgCode: f,
    commission: f,
    poolContNo: f,
    createTimeZone: f,
    id: p
  };
  ds.QCdmVesselEeoi = {
    lastModifyTime: f,
    id: p,
    lastModifyTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    principalOrgCode: f,
    json: f,
    deletedFlag: f,
    createTime: f,
    createTimeZone: f,
    vesselId: f,
    remark: f,
    recordVersion: f,
    lastModifyOffice: f,
    creator: f
  };
  ds.QBgtAnnualBudget = {
    budgetType: f,
    lastModifyOffice: f,
    deptName: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    year: f,
    deptId: f,
    remark: f,
    lastModifyTimeZone: f,
    deptNameCn: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    budgetVerson: f,
    id: p,
    status: f,
    fillType: f,
    createNameCn: f,
    createNameEn: f,
    companyCode: f,
    companyNameEn: f,
    companyNameCn: f,
    companyId: f
  };
  ds.QFineHomepageExpand = {
    id: p,
    androidpadhomepage: f,
    androidphonehomepage: f,
    ipadhomepage: f,
    iphonehomepage: f,
    pchomepage: f,
    type: f
  };
  ds.QOpsInsPiagreementPi = {
    id: p,
    insCompanyCode: f,
    ispFleetCode: f,
    insAmount: f,
    insScale: f,
    insDisAmount: f,
    brokerRate: f,
    brokerComm: f,
    isIta: f,
    isLeader: f,
    insDays: f,
    ivRate: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    remark: f,
    expireRate: f,
    apbRate: f,
    insDisRate: f,
    tax: f,
    currencyCode: f,
    netPremium: f,
    opsInsPiagreementId: f,
    exchangeRate: f,
    indianOcean: f,
    persianGulf: f,
    oman: f,
    insCompanyName: f,
    invoiceId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    insCompanyNameEn: f,
    insAgreement: f,
    lat: f,
    netPremiumRmb: f,
    exchageRate: f,
    baseCurrencyCode: f
  };
  ds.QCdmShipManager = {
    id: p,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    charteringCode: f,
    charteringName: f,
    charteringManagerCode: f,
    charteringManagerName: f,
    dispatcherCode: f,
    dispatcherName: f,
    dispatcherManagerCode: f,
    dispatcherManagerName: f,
    businessCode: f,
    businessName: f,
    businessManagerCode: f,
    businessManagerName: f,
    maintenanceCode: f,
    maintenanceName: f,
    maintenanceManagerCode: f,
    maintenanceManagerName: f,
    crewCode: f,
    crewName: f,
    crewManagerCode: f,
    crewManagerName: f,
    safetyCode: f,
    safetyName: f,
    safetyManagerCode: f,
    safetyManagerName: f,
    sqdCode: f,
    sqdName: f,
    sqdManagerCode: f,
    sqdManagerName: f,
    financeCode: f,
    financeName: f,
    financeManagerCode: f,
    financeManagerName: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    ispFleetCode: f
  };
  ds.QAmiTDepDischPumping = {
    id: p,
    tkDptDischId: f,
    shoreADRate: f,
    shoreADPressure: f,
    pumpingHours: f,
    pumpingUsed: f,
    maxPressure: f,
    tankCow: f,
    balHConcurrent: f,
    balHSeparate: f,
    sdtCow: f,
    sdtStripping: f,
    sdtShore: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QAmiBBunkerAdjustment = {
    id: p,
    baseInfoId: f,
    adjustNature: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    measurementLocation: f,
    correctReportType: f,
    correctReportId: f,
    correctReportTm: f
  };
  ds.QSysCorp = {
    sysCorpId: p,
    corpCode: f,
    corpName: f,
    corpType: f,
    corpShortCode: f,
    financiaCode: f,
    contactPerson: f,
    tel: f,
    contactMode: f,
    remark: f,
    invoiceQuota: f,
    isActive: f,
    baseCurrencyCode: f,
    parentOfficeId: f,
    parentOfficeName: f,
    corpNameCn: f,
    corpNameEn: f,
    addressCn: f,
    addressEn: f,
    businessRegisterNo: f,
    depositBank: f,
    bankAccount: f,
    mailingAddress: f,
    creatorId: f,
    createOffice: f,
    createTime: f,
    lastModifierId: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    principalGroupCode: f,
    recordVersion: f,
    unionpayMerchantNo: f,
    isDeleted: f,
    creatorName: f,
    createOfficeName: f,
    lastModifierName: f,
    lastModifyOfficeName: f,
    systemRate: f,
    settleAccount: f,
    gtPayee: f,
    gtReviewer: f,
    appCode: f,
    taxNature: f,
    mdmId: f
  };
  ds.QShBaseVesselGeneral = {
    fileid: p,
    vesselCd: f,
    vesselEnNm: f,
    vesselCnNm: f,
    financialCode: f,
    builder: f,
    builtdate: f,
    hullno: f,
    seaBallastSpeed: f,
    seaLadenSpeed: f,
    company: f,
    fleetCd: f,
    vsslTyp: f,
    shipClass1: f,
    shipClass2: f,
    classCharacter: f,
    flag: f,
    homeport: f,
    officialno: f,
    callsign: f,
    imo: f,
    telphoneDriver: f,
    telphoneCaptain: f,
    telphoneC: f,
    fax: f,
    email: f,
    validFlag: f,
    retiredDate: f,
    builderCost: f,
    addDepreciation: f,
    sscNameCn: f,
    sscNameEn: f,
    sscLegalPerson: f,
    sscCountry: f,
    sscRegistry: f,
    sscAddressCn: f,
    sscAddressEn: f,
    sscBankInfo: f,
    sscEmail: f,
    sscTelphone: f,
    sscContact: f,
    lOA: f,
    lBP: f,
    mldbreadth: f,
    mlddepth: f,
    grtIntl: f,
    nrtIntl: f,
    grtPanama: f,
    nrtPanama: f,
    grtSuez: f,
    nrtSuez: f,
    ladderequ: f,
    ums: f,
    freeboardTrf: f,
    freeboardFrw: f,
    freeboardTro: f,
    freeboardSum: f,
    freeboardWin: f,
    draftTrf: f,
    draftFrw: f,
    draftTro: f,
    draft: f,
    draftWin: f,
    deadweightTrf: f,
    deadweightFrw: f,
    deadweightTro: f,
    sumweight: f,
    deadweightWin: f,
    netDeadweight: f,
    capacityHfo: f,
    capacityLfo: f,
    capacityHdo: f,
    capacityLdo: f,
    capacityLoMeCyline: f,
    capacityLoMeSystem: f,
    capacityLoGeSystem: f,
    capacityFwDaily: f,
    capacityFwDrink: f,
    capacityBallast: f,
    totalGrainCapacity: f,
    ventilation: f,
    fireFightingSys: f,
    foPortIdle: f,
    mgoPortIdle: f,
    foPortWorkLoad: f,
    mgoPortWorkLoad: f,
    foPortWorkDisch: f,
    mgoPortWorkDisch: f,
    foCargoHeating: f,
    foTankCleaning: f,
    foInerting: f,
    mgoInertGasGenerator: f,
    createrid: f,
    updaterid: f,
    createdate: f,
    updatedate: f,
    remark: f,
    recordstatus: f,
    focusCd: f,
    focusNm: f,
    ownership: f,
    shipOwner: f,
    minmanning: f,
    lightshipweight: f,
    orderby: f,
    smallcode: f,
    shortNm: f,
    otherNm: f,
    follow24: f,
    managercd: f,
    receiveTm: f,
    isautoReport: f,
    mmsi: f,
    fbb1: f,
    fbb2: f,
    smi1: f,
    smi2: f,
    amiversion: f,
    sisterCd: f,
    fbbposition: f,
    iridiumNum: f,
    emailC: f,
    telphoneCcr: f,
    telphoneFbb1: f,
    telphoneFbb2: f,
    fax2: f,
    telphoneC2: f,
    telphoneC3: f,
    iridiumModel: f,
    iridiumImei: f,
    iridiumAct: f,
    iridiumEff: f,
    remarkFbb: f,
    statTm: f,
    managementType: f,
    dockRepairTm: f,
    hcbCode: f,
    bizScope: f,
    builderCd: f,
    controlTyp: f,
    sscCd: f,
    fixTce: f,
    handleOffice: f,
    vlocType: f
  };
  ds.QStcRelationCpBusiness = {
    id: p,
    cpId: f,
    referenceId: f,
    businessNo: f,
    businessType: f,
    businessAmount: f,
    vesselId: f,
    vesselCode: f,
    vesselNameEn: f,
    vesselNameCn: f,
    businessDate: f,
    createTime: f,
    createOffice: f,
    creatorNameCn: f,
    creatorNameEn: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deleteFlag: f
  };
  ds.QComCmllaytimePort = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    portSequence: f,
    portCode: f,
    portName: f,
    ldType: f,
    cargoQuantity: f,
    ldRate: f,
    ldRateUnit: f,
    ldTerms: f,
    laytimeBegin: f,
    laytimeEnd: f,
    laytimeExpire: f,
    laytimePercent: f,
    laytimeUsed: f,
    laytimeEarly: f,
    laytimeAllowed: f,
    laytimeDeduct: f,
    demuRate: f,
    demuDate: f,
    demuRateUnit: f,
    despRate: f,
    despRateUnit: f,
    despDate: f,
    byBerth: f,
    demurrage: f,
    despatch: f,
    fixed: f,
    ispFleetCode: f,
    cmllaytimeId: f,
    cmllaytimeFeeId: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    ldTypeNameEn: f,
    ldTypeName: f,
    demuDateSecond: f,
    laytimeEarlySecond: f,
    laytimeAllowedSecond: f,
    despDateSecond: f,
    laytimeUsedSecond: f,
    laytimeDeductSecond: f
  };
  ds.QAmiBDrifting = {
    id: p,
    baseInfoId: f,
    driftingType: f,
    sailingStatus: f,
    latitude: f,
    longitude: f,
    driftingStatus: f,
    startDriftingTime: f,
    driftingNoonTime: f,
    endDriftingTime: f,
    driftingTime: f,
    totalDriftingTime: f,
    driftingDist: f,
    totalDriftingDist: f,
    totalFaDist: f,
    windDirection: f,
    windScale: f,
    waveDirection: f,
    waveHeight: f,
    swellHeight: f,
    swellDirect: f,
    visibilitysCale: f,
    remark: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    ataMWater: f,
    fwGen: f,
    totalOilWear: f,
    totalAvgOilWear: f,
    fuelno1s: f,
    fuelno2s: f,
    fuelno3s: f,
    fuelno4s: f,
    fuelno1p: f,
    fuelno2p: f,
    fuelno3p: f,
    fuelno4p: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    berthedName: f,
    robFoH: f,
    robFoL: f,
    robMgoH: f,
    robMgoL: f,
    robWater: f,
    waterDensity: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    runDist: f,
    runHrs: f,
    totalRunTime: f,
    hsfoService: f,
    hsfoSettling: f,
    hsfoOverflow: f,
    noonCompletionTm: f,
    endFaTm: f,
    noonVariableSpeedTm: f,
    noonRunDist: f,
    endFoH: f,
    endFoL: f,
    endMgoL: f,
    noonMgoH: f,
    noonStandbyTm: f,
    noonMgoL: f,
    endMgoH: f,
    noonFoL: f,
    endStandbyTm: f,
    endRunDist: f,
    noonFoH: f,
    endVariableSpeedTm: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f
  };
  ds.QVscUpgradePackage = {
    id: p,
    vesselCode: f,
    serverPackage: f,
    majorVersion: f,
    minorVersion: f,
    syncStatus: f,
    startTime: f,
    endTime: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QComPortPdaOffsetRelate = {
    id: p,
    offsetComPortPdaId: f,
    offsetAmount: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    sourceDocType: f,
    settleStatus: f,
    paymentApplicationId: f,
    sourceDocId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QMtrInventoryRecordDel = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    dept: f,
    materialInfoId: f,
    validPeriod: f,
    materialVersion: f,
    locationId: f,
    supplierId: f,
    supplierNameEn: f,
    supplierNameCn: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    productId: f,
    businessId: f,
    businessNo: f,
    sendFinanceTime: f,
    creatorNameEn: f,
    creatorNameCn: f,
    invoicePrice: f
  };
  ds.QMtrInfoTmp0820 = {
    id: f,
    category1: f,
    category2: f,
    category3: f,
    category4: f,
    materialNameCn: f,
    materialNameEn: f,
    materialCode: f,
    monitorFlag: f,
    spec: f,
    specEn: f,
    unit: f,
    location: f,
    price: f,
    currency: f,
    qty: f,
    vesselName: f,
    tmp1: f,
    tmp2: f,
    tmp3: f,
    tmp4: f,
    tmp5: f,
    chargeCode: f,
    primaryId: p
  };
  ds.QAmiTArrivalCargo = {
    id: p,
    tkArrivalId: f,
    cargoNm: f,
    cargoWeight: f,
    cargoVolume: f,
    api: f,
    temperature: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSysOffice = {
    id: p,
    officeCode: f,
    officeName: f,
    officeNameEn: f,
    officeAlias: f,
    officeType: f,
    parentOfficeId: f,
    parentOfficeCode: f,
    parentOfficeName: f,
    address: f,
    addressEn: f,
    tel: f,
    fax: f,
    email: f,
    countryCode: f,
    countryName: f,
    homeCurrency: f,
    masterDataCode: f,
    remark: f,
    validFlag: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    reservedStr4: f,
    reservedStr5: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    seqNo: f,
    effDate: f,
    expDate: f,
    invalidDate: f
  };
  ds.QFinOperateLog = {
    id: p,
    companyCode: f,
    vesselName: f,
    logType: f,
    logInfo: f,
    operFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QFineSwiftTablePath = {
    clusterid: f,
    tablekey: f,
    lastpath: f,
    tablepath: f,
    tmpdir: f
  };
  ds.QTempVessel = {
    id: f,
    vesselCode: f,
    vesselEnName: f,
    vesselCnName: f,
    builder: f,
    builtDate: f,
    hullNo: f,
    seaBallastSpeed: f,
    seaLadenSpeed: f,
    company: f,
    vesselType: f,
    vesselType2: f,
    shipClass1: f,
    shipClass2: f,
    classCharacter: f,
    flag: f,
    homePort: f,
    officialNo: f,
    callSign: f,
    imo: f,
    telphoneDriver: f,
    telphoneCaptain: f,
    telphoneC: f,
    fax: f,
    email: f,
    retiredFlag: f,
    retiredDate: f,
    builderCost: f,
    addDepreciation: f,
    sscNameCn: f,
    sscNameEn: f,
    sscLegalPerson: f,
    sscCountry: f,
    sscRegistry: f,
    sscAddressCn: f,
    sscAddressEn: f,
    sscBankInfo: f,
    sscEmail: f,
    sscTelphone: f,
    sscContact: f,
    loa: f,
    lbp: f,
    mldbreadth: f,
    mlddepth: f,
    grtIntl: f,
    nrtIntl: f,
    grtPanama: f,
    nrtPanama: f,
    grtSuez: f,
    nrtSuez: f,
    ladderequ: f,
    ums: f,
    freeboardTrf: f,
    freeboardFrw: f,
    freeboardTro: f,
    freeboardSum: f,
    freeboardWin: f,
    draftTrf: f,
    draftFrw: f,
    draftTro: f,
    draft: f,
    draftWin: f,
    deadweightTrf: f,
    deadweightFrw: f,
    deadweightTro: f,
    sumWeight: f,
    deadweightWin: f,
    netDeadweight: f,
    capacityHfo: f,
    capacityLfo: f,
    capacityHdo: f,
    capacityLdo: f,
    capacityLoGeCyline: f,
    capacityLoMeSystem: f,
    capacityLoGeSystem: f,
    capacityFwDaily: f,
    capacityFwDrink: f,
    capacityBallast: f,
    totalGrainCapacity: f,
    ventilation: f,
    fireFightingSystem: f,
    foPortIdle: f,
    mgoPortIdle: f,
    foPortWorkLoad: f,
    mgoPortWorkLoad: f,
    foPortWorkDisch: f,
    mgoPortWorkDisch: f,
    foCargoHeating: f,
    foTankCleaning: f,
    foInerting: f,
    mgoInertGasGenerator: f,
    remark: f,
    focusCode: f,
    focusName: f,
    ownerShip: f,
    shipOwner: f,
    minManning: f,
    lightshipWeight: f,
    orderBy: f,
    smallCode: f,
    shortName: f,
    otherName: f,
    follow24Flag: f,
    managerCode: f,
    receiveTime: f,
    autoReportFlag: f,
    mmsi: f,
    fbb1: f,
    fbb2: f,
    smi1: f,
    smi2: f,
    amiversion: f,
    sisterCode: f,
    fbbPosition: f,
    iridiumNum: f,
    emailC: f,
    telphoneCcr: f,
    telphoneFbb1: f,
    telphoneFbb2: f,
    fax2: f,
    telphoneC2: f,
    telphoneC3: f,
    iridiumModel: f,
    iridiumImei: f,
    iridiumAct: f,
    iridiumEff: f,
    remarkFbb: f,
    staticTime: f,
    managementType: f,
    dockRepairTime: f,
    hcbCode: f,
    bizScope: f,
    builderCode: f,
    controlType: f,
    sscCode: f,
    fixTce: f,
    handleOffice: f,
    vlocType: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    superiorCompanyCode: f
  };
  ds.QOpsInsPiagreement = {
    id: p,
    insYear: f,
    insStart: f,
    insEnd: f,
    brokerCode: f,
    brokerName: f,
    hmInsAmount: f,
    ivInsAmount: f,
    warInsAmount: f,
    feeAmount: f,
    brokerRate: f,
    brokerAmount: f,
    totalYearDays: f,
    vesselName: f,
    vesselCode: f,
    surrender: f,
    status: f,
    finType: f,
    insAgreement: f,
    ispFleetCode: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    remark: f,
    quitDate: f,
    insType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    brokerNameEn: f,
    vesselNameEn: f,
    checkStatus: f,
    baseCurrencyCode: f,
    currencyCode: f,
    opsInsPiagreementPi: new c("OpsInsPiagreementPi")
  };
  ds.QStcPayAdvanceDtl = {
    id: p,
    payAdvanceId: f,
    deptId: f,
    chargeId: f,
    chargeCode: f,
    remark: f,
    dataSource: f,
    vesselCode: f,
    voyageNo: f,
    vesselId: f,
    principalOrgCode: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    deletedFlag: f,
    createTimeZone: f,
    lastModifyBy: f,
    deptName: f,
    chargeNameCn: f,
    deptNameCn: f,
    vesselNameCn: f,
    chargeName: f,
    vesselName: f,
    businessNo: f,
    payAmount: f,
    paymentApplicationId: f
  };
  ds.QOpsInsExagreement = {
    id: p,
    insYear: f,
    feeAmount: f,
    currency: f,
    brokerCode: f,
    brokerName: f,
    insStart: f,
    insEnd: f,
    adminFee: f,
    insAgreement: f,
    ispFleetCode: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    insType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    brokerNameEn: f,
    opsInsExagreementDetail: new c("OpsInsExagreementDetail"),
    opsInsExagreementCompany: new c("OpsInsExagreementCompany"),
    opsInsExagreementOther: new c("OpsInsExagreementOther")
  };
  ds.QOpsOilReviewAnalysis = {
    id: p,
    factors: f,
    percent: f,
    point: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QStcManageContractCostCycle = {
    id: p,
    manageContractId: f,
    seq: f,
    chargeId: f,
    chargeCode: f,
    chargeNameEn: f,
    chargeNameCn: f,
    dateFrom: f,
    dateTo: f,
    invoiceNo: f,
    invoiceId: f,
    amount: f,
    currency: f,
    costType: f,
    status: f,
    settlementStatus: f,
    settlementDate: f,
    submittedDate: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineBlockIp = {
    id: p,
    createtime: f,
    ip: f,
    rejectedvisits: f
  };
  ds.QVscCommConfig = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    commKeyLabel: f,
    remark: f,
    commValue: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    commKey: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p
  };
  ds.QOpsInsExagreementDetail = {
    id: p,
    opsInsExagreementId: f,
    vesselName: f,
    voyageNo: f,
    entryListed: f,
    portAta1: f,
    portAta2: f,
    portAta3: f,
    exitListed: f,
    portAtd1: f,
    portAtd2: f,
    portAtd3: f,
    freeBoard: f,
    armedGuardCompany: f,
    noOfDays: f,
    noOfArmedguard: f,
    insuredValue: f,
    rate: f,
    grossPremium: f,
    slipDiscount: f,
    breachArea: f,
    lohCoveredDays: f,
    krPremium: f,
    dailyHire: f,
    lohPremium: f,
    totalPremium: f,
    ncb: f,
    continuityCredit: f,
    netPremium: f,
    chartersAc: f,
    ispFleetCode: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselCode: f,
    tax: f,
    lohRate: f,
    brokerComm: f,
    premium: f,
    insStart: f,
    brokerRate: f,
    invoiceId: f,
    insDays: f,
    insEnd: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    insAgreement: f,
    armedGuardCompanyEn: f,
    armedGuardCompanyCode: f
  };
  ds.QRipServiceTypeSet = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    serviceCode: f,
    remark: f,
    nameEn: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    ripBaseInfoId: f,
    hcbCode: f
  };
  ds.QFinChargeConfigDtlCopy1 = {
    id: p,
    chargeConfigId: f,
    chargeCodeId: f,
    chooseFlag: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineSwiftDaysRecord = {
    taskId: p,
    taskResult: f,
    taskCondition: f,
    taskType: f
  };
  ds.QSpsCheckListDetail = {
    id: p,
    referenceId: f,
    locationId: f,
    lastQty: f,
    receiveQty: f,
    consumeQty: f,
    seqNo: f,
    systemStockQty: f,
    checkDate: f,
    checkStockQty: f,
    checkRemark: f,
    vesselCode: f,
    checkListMainId: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselId: f,
    inventoryProfit: f,
    inventoryProfitAmount: f,
    inventoryProfitQty: f,
    compareStockQty: f,
    devInfoId: f,
    devFlag: f,
    devVesselCodeId: f,
    firstSubmitQty: f
  };
  ds.QFinRuleConfig = {
    id: p,
    businessType: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    vesselType: f,
    accountType: f,
    businessTypeId: f,
    operateType: f,
    accountSet: f,
    debitCreditFlag: f,
    debitAccountCode: f,
    debitName: f,
    debitFeeCode: f,
    creditAccountCode: f,
    creditName: f,
    creditFeeCode: f,
    accountGroupId: f,
    contractType: f,
    sceneCode: f,
    accountingEngineSceneCode: f,
    sceneName: f,
    companyId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    startTime: f,
    endTime: f,
    configRemark: f,
    dispOrder: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QComPortPdaChargeDetail = {
    id: p,
    comPortPdaId: f,
    chargeCode: f,
    chargeName: f,
    amount: f,
    baseAmount: f,
    discount: f,
    discountAmount: f,
    discountBaseAmount: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f
  };
  ds.QTest = {
    b: f,
    a: f
  };
  ds.QSysSendMailLog = {
    id: p,
    businessCode: f,
    vesselId: f,
    referenceId: f,
    mailFrom: f,
    mailTo: f,
    mailCc: f,
    subject: f,
    content: f,
    roleId: f,
    userId: f,
    attachmentIdGroup: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    creatorNameCn: f,
    creatorNameEn: f,
    creator: f
  };
  ds.QActHiVarinst = {
    id: p,
    procInstId: f,
    executionId: f,
    taskId: f,
    name: f,
    varType: f,
    rev: f,
    bytearrayId: f,
    double: f,
    long: f,
    text: f,
    text2: f,
    createTime: f,
    lastUpdatedTime: f
  };
  ds.QActDmnDeploymentResource = {
    id: p,
    name: f,
    deploymentId: f,
    resourceBytes: f
  };
  ds.QRipEvaluationFrom = {
    departmentComment: f,
    evalStatus: f,
    serviceQuality: f,
    leaderComment: f,
    evalDept: f,
    lastModifyTimeZone: f,
    conclusion: f,
    expectationImproved: f,
    managementTeam: f,
    recordVersion: f,
    price: f,
    cooperationPerformance: f,
    evalDeptNameEn: f,
    principalOrgCode: f,
    evalDeptNameCn: f,
    createTimeZone: f,
    id: p,
    evaluator: f,
    evalBasis: f,
    evalType: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    evalDate: f,
    needsExpectations: f,
    creditability: f,
    evalYear: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    ripBaseInfoId: f,
    evalMethod: f,
    basisOtherDetail: f,
    economicSanctionsComplianceScreening: f,
    evaluators: f,
    stockingDeliveryTimeliness: f,
    briefIntroduction: f,
    cmgBlacklistCheckResult: f,
    durationOfDiscontinuation: f,
    foreignCompanyCreditReviewResults: f,
    afterSalesService: f,
    timelinessOfQuotation: f,
    qualification: f,
    unqualifiedReason: f,
    domesticIntegrityAuditResult: f
  };
  ds.QChrContractLockrange = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractVersion: f,
    lockBeginDate: f,
    lockEndDate: f,
    lockDay: f,
    contractId: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QModelAutoScanLog = {
    id: p,
    schemaName: f,
    tableName: f,
    eventDatetime: f,
    warnMessage: f,
    warnType: f,
    reviewArgument: f
  };
  ds.QSysTaskWorkflowTaskLog = {
    id: p,
    infoId: f,
    filedContent: f,
    imageType: f,
    imageContent: f
  };
  ds.QDatabasechangeloglock = {
    id: p,
    locked: f,
    lockgranted: f,
    lockedby: f
  };
  ds.QAmiSuppliedWater = {
    id: p,
    baseInfoId: f,
    suppliedDate: f,
    suppliedBoiler: f,
    suppliedDomestic: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f
  };
  ds.QChrContractCargo = {
    dischargePortText: f,
    cargoCode: f,
    delayRate: f,
    totalLoadMin: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ldTotalFlag: f,
    attaFeeTerms: f,
    dischargeEfficiencyUnit: f,
    invoiceType: f,
    createTimeZone: f,
    id: p,
    valuationType: f,
    totalLoadMax: f,
    batchNo: f,
    cargoDesc: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    loadEfficiencyUnit: f,
    weight: f,
    cargoQuantityMin: f,
    cargoName: f,
    createOffice: f,
    ldTotal: f,
    loadAppointor: f,
    cargoUnit: f,
    cargoQuantityMax: f,
    dischargeEfficiency: f,
    dischargePortName: f,
    loadPortText: f,
    unitBatchQuantity: f,
    createName: f,
    freightDesc: f,
    demuDispTermDesc: f,
    volumeNumber: f,
    contractNo: f,
    otherFeeDesc: f,
    layTerm: f,
    remark: f,
    loadEfficiency: f,
    contractVersion: f,
    freightType: f,
    demuDispTermName: f,
    principalOrgCode: f,
    demurrageRate: f,
    freightTax: f,
    loadPortName: f,
    dischargePortCode: f,
    lastModifyOffice: f,
    creator: f,
    ldTotalUnit: f,
    demuDispTermCode: f,
    lastModifyByName: f,
    dispatchRate: f,
    loadPortCode: f,
    createTime: f,
    deletedFlag: f,
    cargoQuantityFloat: f,
    lastModifyTime: f,
    contractId: f,
    cargoRule: f,
    certCompliance: f,
    freightFee: f,
    freightRate: f,
    ispFleetCode: f,
    dischargeTerm: f,
    ldRemark: f,
    estOilPrice: f,
    calMode: f,
    oilRate: f,
    cargoAppointor: f,
    loadTerm: f,
    bafFlag: f,
    basicOilPrice: f,
    totalCargoAppointor: f,
    singleCargoAppointor: f,
    totalCargo: f,
    singleCargo: f,
    ilowTerm: f,
    loadPortNameEn: f,
    dischargePortNameEn: f,
    cargoNo: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    cargoNameEn: f,
    cargoOutId: f,
    chrContractCargoOver: new c("ChrContractCargoOver"),
    chrContractCargoPlan: new c("ChrContractCargoPlan")
  };
  ds.QCdmCargo = {
    isDanagerousCargo: f,
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    cargoCode: f,
    cargoName: f,
    cargoGroupCode: f,
    activeFlag: f,
    cargoNameCn: f,
    cdmCodedict: new c("CdmCodedict")
  };
  ds.QAuthorize = {
    id: p,
    modelKey: f,
    nodeName: f,
    user: f,
    userName: f,
    startDate: f,
    endDate: f,
    authorizeUser: f
  };
  ds.QComPaymentInvoiceAr = {
    id: p,
    paymentApplicationId: f,
    invoiceId: f,
    invoiceNo: f,
    amount: f,
    remark: f,
    invoiceSource: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineSwiftConfigEntity = {
    configkey: p,
    configvalue: f
  };
  ds.QQrtzLocks = {
    lockName: f,
    schedName: f
  };
  ds.QAmclAmiTDepLoad = {
    id: p,
    reportNo: f,
    portCd: f,
    df: f,
    dm: f,
    da: f,
    stressBm: f,
    stressBmFr: f,
    stressSf: f,
    sterssSfFr: f,
    cashReceived: f,
    etaNextPort: f,
    nextPort: f,
    nextAssignment: f,
    prostestRemarks: f,
    aFoHEng: f,
    aFoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aFoHHeating: f,
    aFoLHeating: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aBWater: f,
    aDWater: f,
    mFoH: f,
    mFoL: f,
    mMgoH: f,
    mMgoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBoilerWater: f,
    mDomesticWater: f,
    ttlPortH: f,
    faopSpdTm: f,
    finalCargoPlan: f,
    crewMovement: f,
    remark: f,
    runningHours: f,
    runDist: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    berthing: f,
    unberthing: f,
    sscecValidDate: f,
    garDisp: f,
    pscOtherInsp: f,
    basisSpeed: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    onberthTm: f,
    waterTreatUsed: f,
    reason: f,
    tugsUsed: f,
    dFoHEng: f,
    dFoLEng: f,
    dFoHGen: f,
    dFoLGen: f,
    dFoHBoiler: f,
    dFoLBoiler: f,
    dFoHIgg: f,
    dFoLIgg: f,
    dFoHInc: f,
    dFoLInc: f,
    dFoHOther: f,
    dFoLOther: f,
    dSulphurHfo: f,
    dSulphurLfo: f,
    dMgoHEng: f,
    dMgoLEng: f,
    dMgoHGen: f,
    dMgoLGen: f,
    dMgoHBoiler: f,
    dMgoLBoiler: f,
    dMgoHIgg: f,
    dMgoLIgg: f,
    dMgoHInc: f,
    dMgoLInc: f,
    dMgoHOther: f,
    dMgoLOther: f,
    dSulphurHmgo: f,
    dSulphurLmgo: f,
    dTHsfo: f,
    dTLsfo: f,
    dTHsmgo: f,
    dTLsmgo: f,
    dLuboilCyl: f,
    dLuboilEng: f,
    dLuboilGen: f,
    dBoilerWater: f,
    dDomesticWater: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    waterDensity: f,
    terminalName: f,
    terminalBerth: f,
    nextPortType: f,
    shoreWasteOil: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    nextPortNameEn: f,
    portType: f,
    portNameCn: f,
    nextPortNameCn: f,
    baseInfoId: f,
    portCode: f,
    portNameEn: f
  };
  ds.QSysUserOffice = {
    id: p,
    userId: f,
    officeId: f,
    officeCode: f,
    officeName: f,
    userCode: f,
    userName: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    defaultOfficeFlag: f
  };
  ds.QRipAnnualEvalDetails = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    remark: f,
    averageScore: f,
    lastModifyTimeZone: f,
    conclusion: f,
    evalQuantity: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lessThree: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    ripAnnualEvalId: f,
    ripBaseInfoId: f,
    moreThree: f,
    serviceCodes: f,
    contactsEmail: f,
    serviceTypes: f,
    hcbCode: f,
    nameCn: f,
    serviceTypesCn: f,
    nameEn: f,
    contactsTel: f,
    contactsAddress: f,
    contacts: f
  };
  ds.QSysRoleUser = {
    id: p,
    roleId: f,
    userId: f,
    seqNo: f,
    defaultRoleFlag: f,
    userNameCn: f,
    appId: f,
    appCode: f,
    userCode: f,
    userName: f,
    roleCode: f,
    roleName: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    deletedFlag: f
  };
  ds.QFineSwiftFilekey = {
    segmentid: f,
    timekey: f
  };
  ds.QStcTenderProcurementInfo = {
    id: p,
    poMainId: f,
    reportId: f,
    operationMode: f,
    domesticOrForeigh: f,
    nonTender: f,
    nonTenderRemark: f,
    reportStatus: f,
    reportType: f,
    businessNo: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QActRuSuspendedJob = {
    id: p,
    rev: f,
    type: f,
    exclusive: f,
    executionId: f,
    processInstanceId: f,
    procDefId: f,
    retries: f,
    exceptionStackId: f,
    exceptionMsg: f,
    duedate: f,
    repeat: f,
    handlerType: f,
    handlerCfg: f,
    tenantId: f
  };
  ds.QMtrQuoteMain = {
    id: p,
    inquiryMainId: f,
    applyMainId: f,
    vesselId: f,
    vesselCode: f,
    applyNo: f,
    quotationNo: f,
    supplierId: f,
    applyType: f,
    quotationDate: f,
    quotationStatus: f,
    currency: f,
    rate: f,
    amount: f,
    amountStandard: f,
    discount: f,
    miscAmount: f,
    deductionAmount: f,
    leadTime: f,
    paymentPeriod: f,
    periodValidity: f,
    quotationSource: f,
    orderType: f,
    specBusinessMark: f,
    quotationRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    supplierNameEn: f,
    vesselNameCn: f,
    supplierNameCn: f,
    vesselNameEn: f,
    baseCurrency: f,
    electricFlag: f,
    taxRate: f,
    taxAmount: f,
    taxRateCode: f
  };
  ds.QVscLogParseError = {
    id: p,
    serverName: f,
    errorMessage: f,
    createTime: f,
    vesselCode: f,
    serverPathCapacity: f,
    backupSize: f,
    backupTime: f,
    backupPathCapacity: f,
    serverStatus: f,
    backupName: f
  };
  ds.QSpsProsOrderDetail = {
    id: p,
    vesselId: f,
    vesselCode: f,
    useType: f,
    locationId: f,
    referenceId: f,
    handleType: f,
    handleQty: f,
    handleRemark: f,
    returnQty: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    mainId: f,
    useInfoId: f,
    devModel: f,
    supplierId: f,
    devCode: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    supplierNameEn: f,
    vesselNameCn: f,
    supplierNameCn: f,
    devNameEn: f,
    devNameCn: f,
    vesselNameEn: f,
    devInfoId: f,
    devSerialNo: f,
    devMakerId: f,
    devFlag: f,
    devVesselCodeId: f
  };
  ds.QChrContractHeader = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractName: f,
    contractType: f,
    contractDate: f,
    contractStatus: f,
    contractNo: f,
    contractCurrency: f,
    chartererName: f,
    chartererCode: f,
    cargoGroup: f,
    endDate: f,
    effectiveDesc: f,
    contractTemplate: f,
    vesselCode: f,
    effectedDate: f,
    vesselName: f,
    coaContractNo: f,
    tradeFlag: f,
    summaryCommRate: f,
    signNetwork: f,
    isProvideSecurity: f,
    isCargoArea: f,
    isBreakingIwl: f,
    contractRoute: f,
    commModel: f,
    isSublet: f,
    signatory: f,
    isOriginalContract: f,
    chartererComm: f,
    chartererSignatory: f,
    ownerSignatory: f,
    ownerCode: f,
    ownerName: f,
    ownerComm: f,
    actChartererCode: f,
    actChartererName: f,
    isDeducted: f,
    signArea: f,
    isChartererEnable: f,
    contractEvaluation: f,
    limitTerms: f,
    isForwardPallet: f,
    batchNo: f,
    palletNo: f,
    contractSummary: f,
    otherClaimLimit: f,
    demuClaimLimit: f,
    otherTerms: f,
    ctaxStandard: f,
    chartererBear: f,
    ctaxStandardUnit: f,
    layEndDate: f,
    layBeginDate: f,
    coaContractVersion: f,
    contractVersion: f,
    voyageNo: f,
    signSubjectName: f,
    signSubjectCode: f,
    compFlag: f,
    importantFlag: f,
    vesselFullLoaddraft: f,
    vesselSummerWeight: f,
    vesselDesc: f,
    escrowContractNo: f,
    vesselEstDay: f,
    vesselEstStartTime: f,
    ownerCommUnit: f,
    chartererCommUnit: f,
    signRemark: f,
    periodDesc: f,
    layDesc: f,
    companyName: f,
    companyCode: f,
    companySignatory: f,
    mgCompanyCode: f,
    mgCompanyName: f,
    ctaxStandardRemark: f,
    otherClaimLimitFlag: f,
    demuClaimLimitFlag: f,
    limitTermsFlag: f,
    ourAccount: f,
    handlingFee: f,
    contractTemplateCode: f,
    jurisdiction: f,
    applicableLaw: f,
    calType: f,
    taxFlag: f,
    fleetDeptCode: f,
    ispFleetCode: f,
    contractRouteChild: f,
    invoiceType: f,
    closeFlag: f,
    ownerComm2: f,
    chartererComm2: f,
    chartererCommUnit2: f,
    ownerCommUnit2: f,
    cargoName: f,
    terminalDate: f,
    cargoCode: f,
    templateFlag: f,
    importantType: f,
    commDesc: f,
    btbContractNo: f,
    templateName: f,
    estimateId: f,
    attachId: f,
    parentContractVersion: f,
    parentContractNo: f,
    lastFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    stampCount: f,
    stampTime: f,
    vesselNameEn: f,
    companyNameEn: f,
    signSubjectNameEn: f,
    mgCompanyNameEn: f,
    chartererNameEn: f,
    ownerNameEn: f,
    cargoNameEn: f,
    actChartererNameEn: f,
    norTerms: f,
    chrContractRent: new c("ChrContractRent"),
    chrContractLockrange: new c("ChrContractLockrange"),
    chrContractPool: new c("ChrContractPool"),
    chrContractApprove: new c("ChrContractApprove"),
    chrContractCargo: new c("ChrContractCargo"),
    chrContractBroker: new c("ChrContractBroker")
  };
  ds.QCdmCountry = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    countryCode: f,
    countryTwoCode: f,
    countryNameCn: f,
    countryNameEn: f,
    litigationPeriod: f,
    activeFlag: f
  };
  ds.QFineUserRoleMiddle = {
    id: p,
    tenantid: f,
    roleid: f,
    roletype: f,
    userid: f
  };
  ds.QFineOutputEmail = {
    id: p,
    addlink: f,
    addlinklist: f,
    bccaddress: f,
    bodycontent: f,
    ccaddress: f,
    customaddress: f,
    custombccaddress: f,
    customccaddress: f,
    emailaccountconfigid: f,
    previewattach: f,
    previewattachlist: f,
    previewwidget: f,
    subject: f,
    useattach: f,
    useattachlist: f
  };
  ds.QOpsBlTemplate = {
    shippingAgentName: f,
    opsVoyageTaskId: f,
    signature: f,
    sendAgentDate: f,
    sendAgentFlag: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    carrierName: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    shippingAgentCode: f,
    id: p,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    shippingAgentMail: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    sendAgentUserName: f,
    carrierCode: f,
    sendAgentUser: f,
    createName: f,
    vesselName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    carrierNameEn: f,
    shippingAgentNameEn: f,
    sendAgentUserNameEn: f,
    opsBlTemplateSono: new c("OpsBlTemplateSono"),
    opsBl: new c("OpsBl")
  };
  ds.QSysMessagePool = {
    objectCode: f,
    businessId: f,
    readTime: f,
    remark: f,
    objectType: f,
    lastModifyTimeZone: f,
    vesselId: f,
    messageUrl: f,
    recordVersion: f,
    messageType: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    readUserCode: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    messageSubject: f,
    messageSubType: f,
    readFlag: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    messageMode: f,
    messageSubjectEn: f
  };
  ds.QFineAuthority = {
    id: p,
    tenantid: f,
    authority: f,
    authorityentityid: f,
    authorityentitytype: f,
    authoritytype: f,
    roleid: f,
    roletype: f
  };
  ds.QAmiReportConsumption = {
    id: p,
    baseInfoId: f,
    machineType: f,
    fuelType: f,
    foLSulphur: f,
    foHSulphur: f,
    mgoLSulphur: f,
    mgoHSulphur: f,
    other: f,
    usedFor: f,
    suppliedFuelId: f,
    sulphurContent: f,
    visc: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    nox: f,
    runingHour: f,
    power: f,
    totalRevolutionCounter: f,
    averageRevolutionCounter: f
  };
  ds.QFineProcessExpand = {
    id: p,
    processtype: f
  };
  ds.QScheduleLog = {
    id: p,
    triggerId: f,
    scheduleId: f,
    status: f,
    shard: f,
    workerNode: f,
    supervisor: f,
    startTime: f,
    endTime: f,
    consumingTime: f,
    description: f,
    createTime: f,
    updateTime: f
  };
  ds.QSpsLocationInfo = {
    id: p,
    vesselCode: f,
    locationCode: f,
    parentId: f,
    locationNameCn: f,
    locationNameEn: f,
    locationDescCn: f,
    locationDescEn: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselId: f,
    vesselNameCn: f,
    vesselNameEn: f,
    personInCharge: f,
    locationType: f,
    deletedFlag: f
  };
  ds.QStcRelationBusinessCost = {
    id: p,
    relationBusniessId: f,
    chargeId: f,
    chargeCode: f,
    currency: f,
    amount: f,
    taxAmount: f,
    remark: f,
    claimAmount: f,
    technicalTransAmount: f,
    safetyAmount: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFinReceiptMaterialInOut = {
    id: p,
    bizInOutId: f,
    receiptItemId: f,
    receiptId: f,
    inOutId: f,
    orderId: f,
    orderNo: f,
    materialId: f,
    inOutQuantity: f,
    orderUnitPrice: f,
    itemDiscount: f,
    invoiceUnitPrice: f,
    lastUnitPriceOld: f,
    lastUnitPrice: f,
    notaxAmount: f,
    vesselId: f,
    vesselCode: f,
    vesselSource: f,
    companyId: f,
    chargeId: f,
    supplierId: f,
    currency: f,
    rate: f,
    useItemPrice: f,
    inOutDateOld: f,
    inOutDate: f,
    inOutBy: f,
    sendUnitPrice: f,
    transactionTypeOld: f,
    transactionType: f,
    transactionId: f,
    controlFlagOld: f,
    controlFlag: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselNameCn: f,
    vesselNameEn: f,
    materialCode: f,
    materialName: f,
    unitName: f,
    materialType: f,
    unitPrice: f,
    discount: f,
    taxAmount: f,
    currencyLocal: f,
    taxAmountLocal: f,
    notaxAmountLocal: f,
    remainQuantity: f,
    supplierNameCn: f,
    supplierNameEn: f,
    fromOrderNo: f,
    businessType: f,
    specialMark: f,
    estimateReceiptId: f,
    projectReceiptId: f,
    costReceiptId: f,
    displayOrder: f,
    genFlag: f
  };
  ds.QPurchaseFaiInventoryAft = {
    id: p,
    mainId: f,
    inOutId: f,
    itemId: f,
    beginDate: f,
    endDate: f,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    currency: f,
    baseCurrency: f,
    price: f,
    stockQty: f,
    amountStandard: f,
    sendFinanceFlag: f,
    monitorFlag: f,
    needCalFlag: f,
    errorFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    poNo: f
  };
  ds.QAmiTUnberth = {
    id: p,
    baseInfoId: f,
    portCode: f,
    portNameEn: f,
    portNameCn: f,
    runDist: f,
    isinsertFlag: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    tugsUsed: f,
    remark: f,
    totalTm: f,
    onberthTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRobFlag: f,
    cargoRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt3: f,
    reservedInt4: f,
    reservedLong3: f,
    reservedLong4: f,
    reservedDecimal3: f,
    reservedDecimal4: f,
    reservedDate2: f,
    reservedStr4: f,
    reservedStr5: f,
    reservedStr6: f
  };
  ds.QChrTceEstimateMain = {
    id: p,
    estimateDate: f,
    companyName: f,
    companyNameEn: f,
    companyCode: f,
    lockFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QCdmVesselErs = {
    id: p,
    vesselGeneralId: f,
    groupName: f,
    contacs: f,
    phone: f,
    email: f,
    fax: f,
    website: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFinReceiptAccount = {
    id: p,
    receiptAuxId: f,
    receiptId: f,
    accountType: f,
    accountTypeName: f,
    accountCode: f,
    accountName: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSysVesselProgram = {
    id: p,
    vesselId: f,
    vesselCode: f,
    vesselHash: f,
    firstDeployTime: f,
    firstMajorVersion: f,
    firstMinorVersion: f,
    deployTime: f,
    majorVersion: f,
    minorVersion: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QChrEstimateHire = {
    id: p,
    mainId: f,
    serialNumber: f,
    beginDate: f,
    endDate: f,
    hireDay: f,
    hireRate: f,
    hire: f,
    outAddrCommissonCargo: f,
    outbrokerCommissonCargo: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cve: f,
    ballastSubsidy: f,
    sweepFee: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    contractNo: f,
    contractVersion: f,
    contractId: f,
    otherIncome: f,
    preCve: f,
    ballastGrossType: f,
    contractType: f,
    chartererCode: f,
    chartererNameEn: f,
    chartererName: f
  };
  ds.QEdsRole = {
    id: f,
    name: f,
    serviceMapping: f,
    body: f,
    projectId: f,
    projectName: f,
    serviceType: f
  };
  ds.QActFoFormDefinition = {
    id: p,
    name: f,
    version: f,
    key: f,
    category: f,
    deploymentId: f,
    parentDeploymentId: f,
    tenantId: f,
    resourceName: f,
    description: f
  };
  ds.QSpsInventoryRecordDel = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameCn: f,
    vesselNameEn: f,
    dept: f,
    devInfoId: f,
    devCode: f,
    devNameCn: f,
    devNameEn: f,
    devMakerId: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    devModel: f,
    devSerialNo: f,
    partsInfoId: f,
    locationId: f,
    supplierId: f,
    supplierNameCn: f,
    supplierNameEn: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    productId: f,
    businessId: f,
    businessNo: f,
    devVesselCodeId: f,
    devFlag: f,
    sendFinanceTime: f,
    devTypeId: f,
    devTypeNameCn: f,
    devTypeNameEn: f,
    creatorNameEn: f,
    creatorNameCn: f,
    invoicePrice: f
  };
  ds.QFineOpsExceedTemplates = {
    id: p,
    templatename: f,
    templatetype: f
  };
  ds.QChrAccountRecord = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    companyName: f,
    companyNameEn: f,
    companyCode: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    voyageNo: f,
    contractNo: f,
    statdateYm: f,
    statBeginDate: f,
    statEndDate: f,
    voyageType: f,
    hireDay: f,
    sourceTable: f,
    sourceId: f,
    netTce: f,
    grossTce: f,
    commRate: f,
    netIncome: f,
    grossIncome: f,
    ballastCompensation: f,
    adjustFee: f,
    offhireDay: f,
    ballastDay: f,
    offhireFee: f,
    bunkerConsumptionCost: f,
    actIncome: f,
    voyageDay: f,
    adjustDay: f,
    repairDay: f
  };
  ds.QTest5 = {
    id: f,
    fileKey: f,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStragegyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f,
    fileType: f,
    deleteFlag: f,
    syncFlag: f,
    businessCode: f,
    subBusinessCode: f,
    businessContent: f,
    vesselCode: f,
    vesselId: f,
    referenceId: f,
    referenceTable: f,
    sequence: f,
    managerId: f,
    md5Code: f,
    dataSource: f,
    backup1: f,
    backup2: f,
    backup3: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QComCmllaytimeTruntime = {
    truntimeDesc: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    truntimeWeek: f,
    remark: f,
    truntimeIndex: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    truntimeDatetime: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    ispFleetCode: f,
    cmllaytimeId: f,
    cmllaytimePortId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QTest3 = {
    id: f,
    fileKey: f,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStragegyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f,
    fileType: f,
    deleteFlag: f,
    syncFlag: f,
    businessCode: f,
    subBusinessCode: f,
    businessContent: f,
    vesselCode: f,
    vesselId: f,
    referenceId: f,
    referenceTable: f,
    sequence: f,
    managerId: f,
    md5Code: f,
    dataSource: f,
    backup1: f,
    backup2: f,
    backup3: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QEdsTaskLog = {
    id: p,
    taskLogId: f,
    taskDefinitionId: f,
    response: f,
    begin: f,
    end: f,
    request: f
  };
  ds.QTest2 = {
    date2: f,
    date1: f
  };
  ds.QComInvoiceExpress = {
    id: p,
    courierCompany: f,
    waybillNo: f,
    sendDate: f,
    recipient: f,
    expressStatus: f,
    sendUser: f,
    sendUserName: f,
    sendTime: f,
    signConfirmUser: f,
    signConfirmUserName: f,
    signConfirmTime: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    comInvoiceExpressDetail: new c("ComInvoiceExpressDetail")
  };
  ds.QSysVesselFollowNot = {
    id: p,
    vesselId: f,
    userId: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    creator: f
  };
  ds.QChrPreSettlementBunkerConsumption = {
    id: p,
    mainId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    bunkerQuantity: f,
    bunkerBatch: f,
    bunkerPrice: f,
    bunkerType: f,
    bunkerSeq: f,
    consumptionQuantity: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    bunkerAmount: f
  };
  ds.QChrPreSettlementBunkerCost = {
    id: p,
    mainId: f,
    item: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    speed: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chrPreSettlementBunkerCostDetailList: new c("ChrPreSettlementBunkerCostDetail")
  };
  ds.QAmiBArrival = {
    id: p,
    baseInfoId: f,
    portCode: f,
    endSailingTime: f,
    endMFoL: f,
    endMFoH: f,
    endMMgoH: f,
    endMMgoL: f,
    ataNor: f,
    ataMFoH: f,
    ataMFoL: f,
    ataMMgoH: f,
    ataMMgoL: f,
    ataMWater: f,
    macLuboilEng: f,
    macLuboilCyl: f,
    macLuboilGen: f,
    df: f,
    da: f,
    waterDensity: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    ttlWater: f,
    avgAFoH: f,
    avgAFoL: f,
    avgAMgoH: f,
    avgAMgoL: f,
    avgAWater: f,
    actSailingHrs: f,
    runDist: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    theoreticalSpd: f,
    slip: f,
    anchorTm: f,
    anchorDesc: f,
    anchorPosition: f,
    estBerthedTm: f,
    remark: f,
    fwe: f,
    asp: f,
    arrivedTime: f,
    remarkSea: f,
    dop: f,
    pob: f,
    etd: f,
    latitude: f,
    longitude: f,
    drifttime: f,
    trantime: f,
    distToquay: f,
    distToanch: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    anchorFoH: f,
    anchorFoL: f,
    anchorMgoH: f,
    anchorMgoL: f,
    anchorAWater: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasMLuboilEng: f,
    gasMLuboilGen: f,
    gasMLuboilCyl: f,
    avPuelMainH: f,
    avPuelMainL: f,
    avPuelAuxH: f,
    avPuelAuxL: f,
    avPuelBoilerH: f,
    avPuelBoilerL: f,
    avPuelIncH: f,
    avPuelIncL: f,
    avPuelSulphurH: f,
    avPuelSulphurL: f,
    avGasMainH: f,
    avGasMainL: f,
    avGasAuxH: f,
    avGasAuxL: f,
    avGasBoilerH: f,
    avGasBoilerL: f,
    avGasIncH: f,
    avGasIncL: f,
    avGasSulphurH: f,
    avGasSulphurL: f,
    avMLuboilEng: f,
    avMLuboilGen: f,
    avMLuboilCyl: f,
    puelTotalFoH: f,
    puelTotalFoL: f,
    gasTotalMgoH: f,
    gasTotalMgoL: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    portNameCn: f,
    portNameEn: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f,
    dailySailingRunTime: f,
    dailySailingRunDist: f
  };
  ds.QRipServiceTypeSetChange = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    serviceCode: f,
    remark: f,
    nameEn: f,
    ripBaseInfoChangeId: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    hcbCode: f
  };
  ds.QMtrApplyDetail = {
    vesselApplyQty: f,
    id: p,
    applyMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    materialInfoId: f,
    materialCategoryId: f,
    materialCategoryNameCn: f,
    materialCategoryNameEn: f,
    materialNameCn: f,
    materialNameEn: f,
    materialCode: f,
    spec: f,
    unit: f,
    minStockQty: f,
    validPeriod: f,
    materialVersion: f,
    harmfulFlag: f,
    applyQty: f,
    crewFlag: f,
    transferQty: f,
    newItemFlag: f,
    newItemId: f,
    applyRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    specEn: f,
    orderCode: f,
    existVersion: f,
    newVersion: f
  };
  ds.QAmclAmiTWorking = {
    id: p,
    reportNo: f,
    portCd: f,
    portNm: f,
    jobName: f,
    jobStart: f,
    jobEnd: f,
    runDist: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    mLuboilEng: f,
    mLuboilGen: f,
    mLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    remark: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    isinsert: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    tugsUsed: f,
    totalTm: f,
    driftingTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    berthedTm: f,
    berthedName: f,
    berthedside1: f,
    seawaterDensity: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    portType: f,
    portNameCn: f,
    baseInfoId: f,
    portNameEn: f
  };
  ds.QOpsInsPfagreement = {
    id: p,
    company: f,
    vesselName: f,
    insYear: f,
    insCompanyCode: f,
    currency: f,
    insBrokerCode: f,
    ttlYearDays: f,
    insCompanyCode2: f,
    insStart: f,
    insEnd: f,
    brokerRate: f,
    status: f,
    insAgreement: f,
    ispFleetCode: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    remark: f,
    vesselCode: f,
    insType: f,
    insBrokerName: f,
    brokerage: f,
    fddRate: f,
    insCompanyName2: f,
    insCompanyName: f,
    piRate: f,
    fddMinDay: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    insCompanyNameEn: f,
    insCompanyName2En: f,
    vesselNameEn: f,
    insBrokerNameEn: f,
    supplementaryRate: f,
    opsInsPfagreementVsl: new c("OpsInsPfagreementVsl")
  };
  ds.QChrMarketPriceIndex = {
    id: p,
    indexCode: f,
    indexDate: f,
    indexValue: f,
    priceVolume: f,
    priceRange: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    portCode: f,
    indexMax: f,
    indexMin: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QActRuTask = {
    id: p,
    rev: f,
    executionId: f,
    procInstId: f,
    procDefId: f,
    name: f,
    parentTaskId: f,
    description: f,
    taskDefKey: f,
    owner: f,
    assignee: f,
    delegation: f,
    priority: f,
    createTime: f,
    dueDate: f,
    category: f,
    suspensionState: f,
    tenantId: f,
    formKey: f,
    claimTime: f
  };
  ds.QSpsQuoteDetail = {
    reservedDate: f,
    partsCode: f,
    seqNo: f,
    origin: f,
    discount: f,
    taxes: f,
    partsInfoId: f,
    leadTime: f,
    supplierHarmfulFlag: f,
    lastModifyTimeZone: f,
    vesselId: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    rate: f,
    price: f,
    principalOrgCode: f,
    currency: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    quoationDetailRemark: f,
    harmfulFlag: f,
    partsNameEn: f,
    lastModifyOffice: f,
    quotationQty: f,
    creator: f,
    amount: f,
    partsDrawing: f,
    partsNameCn: f,
    lastModifyBy: f,
    enquireQty: f,
    reservedLong2: f,
    reservedDecimal2: f,
    quoteMainId: f,
    reservedDecimal1: f,
    reservedLong1: f,
    taxRate: f,
    amountStandard: f,
    unit: f,
    partsDrawingItem: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    minStockQty: f,
    partsType: f,
    devModel: f,
    devMakerNameCn: f,
    devNameCn: f,
    devSerialNo: f,
    devCode: f,
    devMakerNameEn: f,
    devNameEn: f,
    devInfoId: f,
    devMakerId: f,
    devVesselCodeId: f,
    devFlag: f,
    partsModel: f
  };
  ds.QSysAuthorizedComplete = {
    id: p,
    authorizedApprovalId: f,
    groupNo: f,
    initRecordId: f,
    uri: f,
    referenceId: f,
    taskCode: f,
    activityId: f,
    executionId: f,
    referenceNo: f,
    newActivityNameCn: f,
    newActivityNameEn: f,
    authorizedNameCn: f,
    authorizedNameEn: f,
    authorizedId: f,
    approveTime: f,
    approvalStatus: f,
    approvalStatusEn: f,
    approvalOpinion: f,
    authorizedCompanyId: f,
    authorizedRoleId: f,
    spare6: f,
    authorizedCompanyCn: f,
    authorizedRoleCn: f,
    remark: f,
    authorizerRoleId: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    modelName: f,
    modelNameCn: f,
    modelNameEn: f,
    publishTime: f
  };
  ds.QOpsFuelFuturesContractDetail = {
    unitPrice: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    oilFloating: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    oilType: f,
    lastModifyTime: f,
    oilQuantity: f,
    contractId: f,
    principalOrgCode: f,
    oilModel: f,
    createTimeZone: f,
    id: p,
    createName: f,
    remarks: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QGtxTrans = {
    gtxTransId: p,
    transName: f,
    xid: f,
    identifier: f,
    participants: f,
    txStatus: f,
    txMode: f,
    txCreateTime: f,
    modifyTime: f,
    modifyTimeSec: f,
    tryCount: f
  };
  ds.QPerson = {
    id: p,
    firstName: f,
    lastName: f
  };
  ds.QBookEstimateBunkerCost = {
    id: p,
    mainId: f,
    bunkerCost: f,
    bunkerId: f,
    bunkerSpec: f,
    bunkerType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QConsumerGroup = {
    id: p,
    topic: f,
    groupName: f,
    consumerCount: f,
    consumerMode: f,
    messageMode: f,
    settings: f,
    createTime: f,
    createUser: f,
    updateTime: f,
    updateUser: f
  };
  ds.QCdmPortCharge = {
    id: p,
    portCode: f,
    portName: f,
    portNameEn: f,
    currencyCode: f,
    currencyName: f,
    unit: f,
    loadFee: f,
    loadQtyPerHour: f,
    loadDailyWorkHour: f,
    dailyLoadQty: f,
    dischargeFee: f,
    dischargeQtyPerHour: f,
    dischargeDailyWorkHour: f,
    dailyDischargeQty: f,
    waitingTime: f,
    status: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extendInt1: f,
    extendInt2: f,
    extendLong1: f,
    extendLong2: f,
    extendDecimal1: f,
    extendDecimal2: f,
    extendDate: f,
    extendStr1: f,
    extendStr2: f,
    extendStr3: f
  };
  ds.QLooseNumber = {
    id: p,
    numberKey: f,
    lastSn: f,
    createTime: f,
    updateTime: f
  };
  ds.QBookCargoListDetail = {
    id: p,
    cargoListId: f,
    shipperCode: f,
    shipperName: f,
    shipperNameEn: f,
    contractShipperCode: f,
    contractShipperName: f,
    contractShipperNameEn: f,
    contractId: f,
    contractNo: f,
    contractName: f,
    contractType: f,
    loadPort: f,
    loadPortName: f,
    loadPortNameEn: f,
    dischargePort: f,
    dischargePortName: f,
    dischargePortNameEn: f,
    brand: f,
    model: f,
    quantity: f,
    length: f,
    width: f,
    height: f,
    singleVolume: f,
    singleWeight: f,
    totalVolume: f,
    totalWeight: f,
    currencyCode: f,
    currencyName: f,
    cargoUnit: f,
    price: f,
    totalAmount: f,
    isNewEnergy: f,
    overHightWeight: f,
    bookingStatus: f,
    opsConfirmsStatus: f,
    salesPerson: f,
    salesPersonName: f,
    salesPersonNameEn: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extendInt1: f,
    extendInt2: f,
    extendLong1: f,
    extendLong2: f,
    extendDecimal1: f,
    extendDecimal2: f,
    extendDate: f,
    extendStr1: f,
    extendStr2: f,
    extendStr3: f,
    mileage: f,
    dateOfProduction: f,
    newUsedCar: f
  };
  ds.QChrContractRentPeriod = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    contractNo: f,
    periodEndTime: f,
    remark: f,
    lastModifyByName: f,
    contractVersion: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    periodStartTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    periodRentDay: f,
    periodDay: f,
    createName: f,
    rentId: f,
    periodRentType: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    feeUnit: f,
    feeNum: f,
    feeType: f
  };
  ds.QCpmProtocolSupplier = {
    id: p,
    protocolId: f,
    supplierId: f,
    supplierCode: f,
    supplierNameCn: f,
    supplierNameEn: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    contactPerson: f,
    email: f,
    hcbCode: f
  };
  ds.QFineScheduleTask = {
    id: p,
    backupfilepath: f,
    conditionparameter: f,
    creator: f,
    editable: f,
    fileclearcount: f,
    nextfiretime: f,
    outputstr: f,
    prefiretime: f,
    repeattime: f,
    repeattimes: f,
    scheduleoutput: f,
    sendbackupfile: f,
    showtype: f,
    taskcondition: f,
    taskdescription: f,
    taskname: f,
    taskparameter: f,
    taskstate: f,
    tasktype: f,
    templatepath: f,
    triggergroup: f,
    usergroup: f
  };
  ds.QAmiTDepLoadOilSupplited = {
    id: p,
    tkDepLoadId: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    engLub: f,
    cylLub: f,
    genLub: f,
    boWater: f,
    doWater: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QOpsLoiBlRemind = {
    voyageNo: f,
    lastModifyOffice: f,
    remindNum: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    mailMainbody: f,
    id: p,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QAmiTDepDischFlow = {
    completeDischarging: f,
    commenceDischarging: f,
    reservedDate: f,
    lastModifyTimeZone: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    hoseConnected: f,
    tkDptDischId: f,
    hoseDisconnected: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    reservedLong2: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f
  };
  ds.QWfUser = {
    id: p,
    username: f,
    password: f,
    email: f,
    phoneNumber: f,
    companyName: f,
    projectId: f,
    projectName: f
  };
  ds.QFinAccountCloseDate = {
    id: p,
    companyCode: f,
    companyName: f,
    yearAndMonth: f,
    closeAccountDate: f,
    confirmDate: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    confirmStatus: f
  };
  ds.QVscVesselMaintenance = {
    id: p,
    lastModifyOffice: f,
    creator: f,
    fileName: f,
    lastModifyBy: f,
    upgradeVersion: f,
    upgradeStatus: f,
    lastModifyTimeZone: f,
    vesselId: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    fileSize: f,
    lastModifyTime: f,
    vesselNameCn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    vesselNameEn: f,
    upgradeLog: f,
    fileId: f
  };
  ds.QOpsOilSuppliers = {
    foCustRemark: f,
    remark: f,
    bunkerId: f,
    doCustCode: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    currency: f,
    vesselCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    doHPrice1: f,
    doHPrice3: f,
    foCustCode: f,
    doHPrice2: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    foHPrice1: f,
    lastModifyOfficeName: f,
    isselected: f,
    suppliersOrder: f,
    doCustRemark: f,
    suppliersSelect: f,
    foHPrice2: f,
    foHPrice3: f,
    custCode: f,
    lastModifyByName: f,
    doHPrice: f,
    foHPrice: f,
    foLPrice1: f,
    createOffice: f,
    createTime: f,
    foLPrice3: f,
    deletedFlag: f,
    foLPrice2: f,
    lastModifyTime: f,
    doLPrice2: f,
    doLPrice3: f,
    doLPrice1: f,
    doLPrice: f,
    foLPrice: f,
    createName: f,
    wPrice: f,
    vesselName: f,
    doCustName: f,
    custName: f,
    foCustName: f,
    supplierOtherFee: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QStcRelationBusniess = {
    id: p,
    payAdvanceDtlId: f,
    deptId: f,
    taxRate: f,
    payStatus: f,
    specBusinessMark: f,
    expenseSource: f,
    vesselId: f,
    vesselCode: f,
    voyageNo: f,
    claimAmount: f,
    technicalTransAmount: f,
    safetyAmount: f,
    payFor: f,
    remark: f,
    status: f,
    currency: f,
    discount: f,
    deductionAmount: f,
    amount: f,
    paidAdvanceAmount: f,
    applyPurpose: f,
    placeDate: f,
    invoiceCompleted: f,
    chargeCode: f,
    chargeId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    deletedFlag: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deptName: f,
    deptNameCn: f,
    chargeNameCn: f,
    vesselNameCn: f,
    chargeName: f,
    vesselName: f,
    businessId: f,
    businessNo: f,
    businessType: f,
    paymentInvoiceDtlId: f,
    payFlag: f,
    miscAmount: f,
    payAmount: f,
    taxAmount: f,
    taxRateCode: f,
    miscRate: f,
    miscTaxAmount: f,
    miscTaxRateCode: f
  };
  ds.QOpsOilReview = {
    id: p,
    reportTitle: f,
    reportStartDate: f,
    reportEndDate: f,
    approvalStatus: f,
    oilPericeTrend: f,
    requireRelation: f,
    macroeconomics: f,
    politicalFactor: f,
    marketPrediction: f,
    technicalIndicators: f,
    oilPriceSummary: f,
    fuelProPolicy: f,
    totalPoint: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineDataPortalEntryAccess = {
    id: p,
    entryid: f,
    time: f,
    userid: f
  };
  ds.QCdmVesselRadioFuelCost = {
    id: p,
    vesselGeneralId: f,
    speed: f,
    foSeaLaden: f,
    foSeaBallast: f,
    mgoSeaBallast: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    hsmgoSeaBallast: f,
    hsfoSeaBallast: f,
    hsmgoSeaLaden: f,
    mgoSeaLaden: f,
    hsfoSeaLaden: f
  };
  ds.QChrPreSettlementBunkerCostDetail = {
    id: p,
    costId: f,
    bunkerCost: f,
    consumptionStandardQuantity: f,
    bunkerSpec: f,
    totalBunker: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QCpmProtocolCompany = {
    id: p,
    protocolId: f,
    companyId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFineScheduleRecord = {
    id: p,
    creator: f,
    detailmessage: f,
    filepath: f,
    logmessage: f,
    logtime: f,
    logtype: f,
    nextfiretime: f,
    runtype: f,
    taskid: f,
    taskname: f
  };
  ds.QAmiBaseInfo = {
    reservedDate: f,
    receivedTm: f,
    reportTn: f,
    failcount: f,
    reportTm: f,
    companyName: f,
    errorInfo: f,
    analyticaling: f,
    lastModifyTimeZone: f,
    reportType: f,
    vesselId: f,
    reservedStr3: f,
    reservedStr2: f,
    checkStatus: f,
    vygNo: f,
    reservedStr1: f,
    recordVersion: f,
    reportFlag: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    companyCode: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    portPlace: f,
    crs: f,
    reportContentstatus: f,
    reservedLong2: f,
    companyNameEn: f,
    reportStatus: f,
    timeZone: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    vesselEnName: f,
    version: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    vesselCnName: f,
    timeZoneEn: f,
    timeZoneCn: f,
    rightAnchor: f,
    leftCableLength: f,
    leftAnchor: f,
    rightCableLength: f,
    leftAnchorStatus: f,
    rightAnchorStatus: f,
    loadingAnchorage: f,
    adVoyNo: f,
    amiBArrival: new c("AmiBArrival"),
    amiTArrival: new c("AmiTArrival"),
    amiBDpt: new c("AmiBDpt"),
    amiBBunkerDebunker: new c("AmiBBunkerDebunker"),
    amiBBerth: new c("AmiBBerth"),
    amiBDeviation: new c("AmiBDeviation"),
    amiGArrivalPilot: new c("AmiGArrivalPilot"),
    amiTInportnoon: new c("AmiTInportnoon"),
    amiTNoon: new c("AmiTNoon"),
    amiTDptDisch: new c("AmiTDptDisch"),
    amiBArrBerth: new c("AmiBArrBerth"),
    amiBNoon: new c("AmiBNoon"),
    amiBShifting: new c("AmiBShifting"),
    amiBDelivery: new c("AmiBDelivery"),
    amiTDepLoad: new c("AmiTDepLoad"),
    amiGArrival: new c("AmiGArrival"),
    amiBDrifting: new c("AmiBDrifting"),
    amiGDeparture: new c("AmiGDeparture"),
    amiBWorking: new c("AmiBWorking"),
    amiBPortDynamic: new c("AmiBPortDynamic"),
    amiBBunkerAdjustment: new c("AmiBBunkerAdjustment"),
    amiGOthers: new c("AmiGOthers"),
    amiTUnberth: new c("AmiTUnberth"),
    amiTWorking: new c("AmiTWorking"),
    amiGDepartureLoadDisc: new c("AmiGDepartureLoadDisc"),
    amiBRedelivery: new c("AmiBRedelivery"),
    amiGNoon: new c("AmiGNoon")
  };
  ds.QStcFrameProtocol = {
    id: p,
    preparedBidingId: f,
    reportType: f,
    projectName: f,
    reportNo: f,
    bidName: f,
    country: f,
    province: f,
    city: f,
    reportOperation: f,
    reportPerson: f,
    reportPersonPhone: f,
    projectCompany: f,
    projectManager: f,
    projectManagerPhone: f,
    secondaryPrimaryUnit: f,
    notOnInstructions: f,
    purchaseType: f,
    isOpenTender: f,
    isCentralizedPurchase: f,
    tenderType: f,
    agentCompany: f,
    isLaw: f,
    isTenderLocal: f,
    publishPlatform: f,
    otherProjectName: f,
    otherProjectNo: f,
    purchaseProjectCategory: f,
    purchaseProjectDetail: f,
    autoFlag2: f,
    protocolType: f,
    protocolSignDate: f,
    protocolEstEndDate: f,
    protocolNo: f,
    sendStatus: f,
    receiveData: f,
    backUrl: f,
    baoBeiVersion: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QOpsVoyageCargoDis = {
    id: p,
    opsVoyageCargoId: f,
    vesselCode: f,
    voyageNo: f,
    unloadQty: f,
    perDisQty: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    turnOver: f,
    portSequence: f,
    tfPortCode: f,
    tfPortName: f,
    cargoUnit: f,
    contractNo: f,
    cargoCode: f,
    loadQty: f,
    contractQty: f,
    cargoName: f,
    portName: f,
    cargoQty: f,
    portCode: f,
    tfPortNameEn: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    contractCargoId: f,
    cargoNameEn: f
  };
  ds.QActHiComment = {
    id: p,
    type: f,
    time: f,
    userId: f,
    taskId: f,
    procInstId: f,
    action: f,
    message: f,
    fullMsg: f
  };
  ds.QQrtzJobDetails = {
    jobGroup: f,
    jobName: f,
    schedName: f,
    creator: f,
    description: f,
    isDurable: f,
    isNonconcurrent: f,
    isUpdateData: f,
    jobClassName: f,
    jobData: f,
    requestsRecovery: f
  };
  ds.QFinFuelStockBusiness = {
    id: p,
    businessId: f,
    operationNo: f,
    status: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    finFuelStockFlow: new c("FinFuelStockFlow")
  };
  ds.QFineLabelIndex = {
    id: p,
    labelid: f,
    relatedid: f
  };
  ds.QIdempotentRecord = {
    id: p,
    consumerGroup: f,
    msgId: f
  };
  ds.QActHiProcinst = {
    id: p,
    procInstId: f,
    businessKey: f,
    procDefId: f,
    startTime: f,
    endTime: f,
    duration: f,
    startUserId: f,
    startActId: f,
    endActId: f,
    superProcessInstanceId: f,
    deleteReason: f,
    tenantId: f,
    name: f
  };
  ds.QCdmChargeCode = {
    id: p,
    parentId: f,
    sort: f,
    deletedFlag: f,
    chargeCode: f,
    chargeName: f,
    chargeNameCn: f,
    companyCode: f,
    remark: f,
    activeFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    childFlag: f,
    effDate: f,
    expDate: f,
    businessFlag: f,
    domesticTaxRate: f,
    masterDataCode: f,
    chargeCodePms: f,
    safetyProductionType: f,
    businessType: f,
    seq: f,
    voyageCostFlag: f
  };
  ds.QBookEstimateOthers = {
    id: p,
    mainId: f,
    feeCode: f,
    feeName: f,
    feeNameEn: f,
    amount: f,
    rpType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    businessType: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QSysFileInfo = {
    byteSize: f,
    fileKey: f,
    referenceId: f,
    uploaderStragegyId: f,
    lastModifyTimeZone: f,
    vesselId: f,
    deleteFlag: f,
    businessCode: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    referenceTable: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    syncFlag: f,
    smallThumbnailUrl: f,
    largeThumbnailUrl: f,
    subBusinessCode: f,
    url: f,
    largeThumbnailEtag: f,
    sequence: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    name: f,
    etag: f,
    smallThumbnailEtag: f,
    businessContent: f,
    fileType: f,
    dataSource: f,
    managerId: f,
    md5Code: f,
    backup1: f,
    backup2: f,
    backup3: f,
    sysOffice: new c("SysOffice"),
    sysUser: new c("SysUser")
  };
  ds.QModelLog = {
    id: p,
    processDefinitionId: f,
    processInstanceId: f,
    executionId: f,
    modelKey: f,
    modelName: f,
    modelClass: f,
    projectId: f,
    projectName: f,
    publisher: f,
    publishTime: f,
    preActivityId: f,
    currActivityId: f,
    status: f,
    operateTime: f,
    currOperatorName: f,
    currTaskName: f,
    preTaskId: f,
    endTime: f,
    execTime: f,
    exception: f,
    payload: f,
    msgKey: f
  };
  ds.QFineSwiftMetadata = {
    id: p,
    fields: f,
    remark: f,
    schemaname: f,
    swiftschema: f,
    tablename: f
  };
  ds.QOpsInsClaimExpensesApprove = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    opsInsClaimExpensesId: f,
    comInvoiceApproveId: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QStcBaoBei = {
    id: p,
    preparedBidingId: f,
    reportType: f,
    projectName: f,
    reportNo: f,
    bidName: f,
    country: f,
    province: f,
    city: f,
    reportOperation: f,
    reportPerson: f,
    reportPersonPhone: f,
    projectCompany: f,
    projectManager: f,
    projectManagerPhone: f,
    secondaryPrimaryUnit: f,
    notOnInstructions: f,
    purchaseType: f,
    isOpenTender: f,
    isCentralizedPurchase: f,
    tenderType: f,
    agentCompany: f,
    isLaw: f,
    isTenderLocal: f,
    publishPlatform: f,
    otherProjectName: f,
    otherProjectNo: f,
    purchaseProjectCategory: f,
    purchaseProjectDetail: f,
    legalContractNo: f,
    contractNo: f,
    contractAmount: f,
    currency: f,
    rate: f,
    amountCny: f,
    bgtAmount: f,
    bgtCurrency: f,
    bgtRate: f,
    bgtAmountCny: f,
    paymentType: f,
    paymentTypeOther: f,
    contractDate: f,
    contractSupplier: f,
    supplierContactPerson: f,
    supplierContactTel: f,
    dayOfDuration: f,
    contractDeadline: f,
    remarkOfDuration: f,
    autoFlag: f,
    protocolProjectId: f,
    protocolProjectNo: f,
    protocolProjectType: f,
    protocolProjectName: f,
    sendStatus: f,
    receiveData: f,
    backUrl: f,
    baoBeiVersion: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    district: f,
    ispFleetCode: f,
    createName: f
  };
  ds.QComTaxInvoiceDetail = {
    taxReliefCode: f,
    zeroRateType: f,
    remark: f,
    favorablePolicy: f,
    lastModifyTimeZone: f,
    itemName: f,
    businessNo: f,
    recordVersion: f,
    ispFleetCode: f,
    favorableParticular: f,
    price: f,
    oriTaxInvoiceCode: f,
    oriTaxInvoiceInfo: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    submitStatus: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    quantity: f,
    taxInvoiceCode: f,
    lastModifyOfficeName: f,
    taxInvoiceId: f,
    taxClassify: f,
    specification: f,
    tradeCompanyType: f,
    lastModifyByName: f,
    oriTaxInvoiceNo: f,
    taxRate: f,
    unit: f,
    createOffice: f,
    deduction: f,
    createTime: f,
    taxInvoiceItemId: f,
    createOfficeName: f,
    preTaxInvoiceAmount: f,
    lastModifyTime: f,
    redInvoiceNo: f,
    reverseCancelParticular: f,
    invoiceId: f,
    taxInvoiceAmount: f,
    taxInvoiceNo: f,
    taxAmount: f,
    createName: f,
    reverseCancelFlag: f,
    oriTaxInvoiceId: f,
    imageNo: f,
    invoicePreviewLink: f,
    invoiceApproveId: f,
    getDocumentFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QTransferMaterialInfo = {
    id: p,
    materialNameCn: f,
    materialNameEn: f,
    smisMaterialName: f
  };
  ds.QMtrMaterialCompanyInfo = {
    id: p,
    materialInfoId: f,
    companyId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    blindFlag: f,
    criticalFlag: f,
    monitorFlag: f,
    safetyFlag: f,
    proposedPrice: f,
    proposedPriceCurrency: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QPoolVoyageForeRent = {
    id: p,
    voyageRoute: f,
    year: f,
    routeNumber: f,
    lastRouteNumber: f,
    ratio: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    createName: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QPmLoReport = {
    id: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    reportMonth: f,
    startDate: f,
    endDate: f
  };
  ds.QSysTeamVessel = {
    id: p,
    vesselTeamId: f,
    vesselId: f,
    vesselCode: f,
    vesselName: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QComPaymentActualBack = {
    lastModifyOffice: f,
    creator: f,
    estDueDate: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    settleStatus: f,
    particular: f,
    remark: f,
    paymentApplicationId: f,
    balanceAmount: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    paidType: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    paidAmount: f,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QStcRelationBusinessDtl = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    payQty: f,
    itemNo: f,
    relationBusniessIdt: f,
    lastModifyTimeZone: f,
    itemName: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    itemNameCn: f,
    itemId: f,
    isChecked: f
  };
  ds.QAppNodes = {
    nodeName: f,
    nodeNum: f,
    appName: f,
    id: p
  };
  ds.QSyncTaskLog = {
    id: p,
    type: f,
    status: f,
    content: f,
    assignerId: f,
    slaveExecutionId: f,
    masterExecutionId: f,
    processDefinitionId: f,
    msgKey: f
  };
  ds.QChrEstimateMain = {
    ciiLevel: f,
    dispatchChargesTotalRound: f,
    extraCharge: f,
    demurrageTotalIncomeRound: f,
    grossFlagDemurrageCharge: f,
    groessFlag: f,
    id: p,
    vesselType: f,
    canalDays: f,
    carbonEmissionCurrent: f,
    ciiRank: f,
    ciiRankEst: f,
    eeoi: f,
    estimateType: f,
    estimateNo: f,
    vesselName: f,
    vesselCode: f,
    vesselResoure: f,
    voyageNo: f,
    startTime: f,
    endTime: f,
    deadweight: f,
    carbonEmissionCumulative: f,
    eeoiEst: f,
    voyageProfit: f,
    carbonEmissionVoyage: f,
    currency: f,
    voyageDays: f,
    ladenSeaDays: f,
    ballastDays: f,
    ballastSeaDays: f,
    loadDays: f,
    portNotworkDays: f,
    dischargeDays: f,
    roundVoyageDays: f,
    roundLadenSeaDays: f,
    roundBallastSeaDays: f,
    roundLoadDays: f,
    roundPortNotworkDays: f,
    roundDischargeDays: f,
    roundCanalDays: f,
    hsfoPrice: f,
    lsfoPrice: f,
    lsmgoPrice: f,
    hsmgoPrice: f,
    profit: f,
    tceNet: f,
    freightTotalIncome: f,
    freightTotalExpense: f,
    demurrageTotalIncome: f,
    ohtersIncomeTotal: f,
    totalIncome: f,
    totalCommission: f,
    totalNetIncome: f,
    totalPortCost: f,
    totalBunkerExpense: f,
    totalDailyRent: f,
    totalOthersCost: f,
    totalCost: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    dispatchChargesTotal: f,
    grossFlagExtraCharge: f,
    grossFlagDispatchCharges: f,
    totalHireDay: f,
    version: f,
    bbIncome: f,
    status: f,
    vesselGroup: f,
    totalAddCommission: f,
    bbCost: f,
    totalBunkerExpenseRound: f,
    startPort: f,
    backToBack: f,
    description: f,
    tradeType: f,
    lowCanalDays: f,
    lowPortNotworkDays: f,
    lowLoadDays: f,
    lowBallastDays: f,
    lowDischargeDays: f,
    lowVoyageDays: f,
    lowBallastSeaDays: f,
    lowLadenSeaDays: f,
    ballastSubsidy: f,
    ispFleetCode: f,
    totalSaleAmount: f,
    totalSoliciteCommission: f,
    totalSoliciteAmount: f,
    totalSaleCommission: f,
    commonType: f,
    sweepFee: f,
    companyCode: f,
    tceBalance: f,
    companyNameEn: f,
    startPortNameEn: f,
    companyNameCn: f,
    startPortNameCn: f,
    tceBalanceRound: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    brokerCommAmount: f,
    brokerComm: f,
    vesselNameEn: f,
    approvalTime: f,
    brokerLumpAmount: f,
    route: f,
    routeNameEn: f,
    tradingArea: f,
    routeName: f,
    cargoClass: f,
    approvalUserCode: f,
    taskCode: f,
    approvalUserName: f,
    totalLightBunkerExpense: f,
    totalHeavyBunkerExpense: f,
    wsStep: f,
    hireRateStep: f,
    ballastSpeedStep: f,
    flatRateStep: f,
    bunkerPriceStep: f,
    workEfficiencyStep: f,
    ladenSpeedStep: f,
    lsmgoBunkerStep: f,
    addFuelDays: f,
    addFuelLowDays: f,
    chrEstimateHire: new c("ChrEstimateHire"),
    chrEstimatePort: new c("ChrEstimatePort"),
    chrEstimateCargo: new c("ChrEstimateCargo"),
    chrEstimateBunker: new c("ChrEstimateBunker"),
    chrEstimateCost: new c("ChrEstimateCost"),
    chrEstimateHireIn: new c("ChrEstimateHireIn"),
    chrEstimateOthers: new c("ChrEstimateOthers")
  };
  ds.QVscCommVessel = {
    id: p,
    vesselId: f,
    vesselCode: f,
    email: f,
    passwd: f,
    email2: f,
    passwd2: f,
    mailType: f,
    commStatus: f,
    failRetryTime: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cdmVesselGeneral: new c("CdmVesselGeneral")
  };
  ds.QFineBackupExcludeEntity = {
    id: p,
    value: f
  };
  ds.QSysProgramPackage = {
    id: p,
    serverPackage: f,
    sqlScript: f,
    releaseNote: f,
    buildTime: f,
    majorVersion: f,
    minorVersion: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QStcCpFile = {
    id: p,
    cpId: f,
    cpNm: f,
    cpNo: f,
    cpVersion: f,
    cpTotalNum: f,
    filedDate: f,
    filedDeptCd: f,
    filedDeptNm: f,
    filedbyNm: f,
    filedbyId: f,
    filedOthdeptCd: f,
    filedNum: f,
    filedOthdeptNum: f,
    filedOthdeptNm: f,
    remark: f,
    isfiled: f,
    cpType: f,
    archPeriod: f,
    createTime: f,
    createOffice: f,
    creatorNameCn: f,
    creatorNameEn: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    filedOthdeptId: f
  };
  ds.QSysVesselManageInfo = {
    id: p,
    vesselTeamId: f,
    vesselTeamCode: f,
    vesselTeamName: f,
    userId: f,
    userCode: f,
    userName: f,
    userNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselName: f,
    beginDate: f,
    endDate: f,
    positionCode: f,
    positionName: f,
    deletedFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QAmiMonthOilLube = {
    checkdateSup: f,
    checkerTkr: f,
    checker: f,
    thisRob: f,
    lastModifyTimeZone: f,
    vesselId: f,
    thisRobAdjust: f,
    recordVersion: f,
    monthOilMainId: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    isCheckSupFlag: f,
    smonth: f,
    isCheckFinFlag: f,
    lastModifyBy: f,
    oiltype: f,
    reservedLong2: f,
    reservedLong1: f,
    createOffice: f,
    checkerSup: f,
    syear: f,
    importer: f,
    reservedDate: f,
    thisCon: f,
    checkdateFin: f,
    reservedStr3: f,
    ischeck: f,
    reservedStr2: f,
    reservedStr1: f,
    thisRvcdAdjust: f,
    lastRobAdjust: f,
    senddate: f,
    principalOrgCode: f,
    isCheckTkrFlag: f,
    thisRvcd: f,
    reservedInt1: f,
    reservedInt2: f,
    lastModifyOffice: f,
    creator: f,
    importdate: f,
    reservedDecimal2: f,
    isImportFlag: f,
    reservedDecimal1: f,
    createTime: f,
    checkdateTkr: f,
    sno: f,
    lastModifyTime: f,
    checkerFin: f,
    oilname: f,
    lastRob: f,
    checkdate: f,
    vesselCnName: f,
    vesselEnName: f,
    tkrHeckDate: f,
    asdLockDate: f,
    asdLockUser: f,
    asdLock: f,
    opnCheck: f,
    tkrCheck: f,
    spyCheckDate: f,
    spyCheckUser: f,
    trkCheck: f,
    tkrHeckUser: f
  };
  ds.QComInsApproveInvoice = {
    id: p,
    insApproveId: f,
    invoiceId: f,
    invoiceType: f,
    rpType: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    invoiceNo: f,
    amount: f
  };
  ds.QAmiMonthOil = {
    id: p,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    thisHfoRob: f,
    thisLfoRob: f,
    thisHgoRob: f,
    thisLgoRob: f,
    lastHfoRob: f,
    lastLfoRob: f,
    lastHgoRob: f,
    lastLgoRob: f,
    thisHfoRvcd: f,
    thisLfoRvcd: f,
    thisHgoRvcd: f,
    thisLgoRvcd: f,
    logHfoRob: f,
    logLfoRob: f,
    logHgoRob: f,
    logLgoRob: f,
    thisHfoCon: f,
    thisLfoCon: f,
    thisHgoCon: f,
    thisLgoCon: f,
    hfoMe: f,
    lfoMe: f,
    hgoMe: f,
    lgoMe: f,
    hfoGe: f,
    lfoGe: f,
    hgoGe: f,
    lgoGe: f,
    hfoBo: f,
    lfoBo: f,
    hgoBo: f,
    lgoBo: f,
    hfoHi: f,
    lfoHi: f,
    hgoHi: f,
    lgoHi: f,
    hfoIn: f,
    lfoIn: f,
    hgoIn: f,
    lgoIn: f,
    pasXiazhiCnt: f,
    pasLaotieshanCnt: f,
    pasSingaporeSt: f,
    pasHormuzSt: f,
    pasGulfAden: f,
    pasSuezCnt: f,
    pasNorthindiaSea: f,
    anyCargoclaimCase: f,
    hfoCl: f,
    lfoCl: f,
    hgoCl: f,
    lgoCl: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    voys: f,
    sulphur: f,
    sulphurMgo: f,
    isCheckTkrFlag: f,
    checkerTkr: f,
    checkdateTkr: f,
    fleet: f,
    isCheckSupFlag: f,
    checkerSup: f,
    checkdateSup: f,
    isCheckFinFlag: f,
    checkerFin: f,
    checkdateFin: f,
    tkrFlag: f,
    receivedTm: f,
    senddate: f,
    isStockFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselCnName: f,
    vesselEnName: f,
    opnCheckUser: f,
    trkCheck: f,
    opnCheckDate: f,
    trkCheckDate: f,
    opnCheck: f,
    trkCheckUser: f,
    amiMonthOilDetail: new c("AmiMonthOilDetail")
  };
  ds.QChrTceLockDetail = {
    id: p,
    mainId: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    voyageNo: f,
    voyageStatus: f,
    contractNo: f,
    lockYear: f,
    lockMonth: f,
    lockDay: f,
    lockTce: f,
    lockTceIncome: f,
    offHire: f,
    lockType: f,
    remark: f
  };
  ds.QActWoComments = {
    id: p,
    message: f,
    created: f,
    createdBy: f,
    taskId: f,
    procInstId: f,
    commentDefinition: f
  };
  ds.QFinReceiptItem = {
    batchNo: f,
    id: p,
    receiptId: f,
    itemSummary: f,
    ccyCode: f,
    exchangeRate: f,
    debitCredit: f,
    debitFeeCode: f,
    creditFeeCode: f,
    originalAmount: f,
    itemQuantity: f,
    unitName: f,
    unitPrice: f,
    debitAmount: f,
    creditAmount: f,
    settlementHang: f,
    categoryCode: f,
    vesselId: f,
    vesselCode: f,
    vesselName: f,
    supplierId: f,
    supplierName: f,
    vesselSource: f,
    costElement: f,
    personalStatistic: f,
    projectNum: f,
    fareProperty: f,
    categoryId: f,
    categoryName: f,
    orderId: f,
    orderNo: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    loadFromOrderFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    handleDate: f,
    baseAmount: f,
    remark: f,
    noTaxAmount: f,
    exTaxAtion: f,
    debitName: f,
    creditName: f,
    finReceiptAccountList: new c("FinReceiptAccount")
  };
  ds.QChrContractFile = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractName: f,
    contractType: f,
    contractDate: f,
    contractStatus: f,
    contractNo: f,
    fileTotalNum: f,
    filedDate: f,
    filedNum: f,
    filedOthdeptNum: f,
    filedOthdeptName: f,
    filedOthdeptCode: f,
    isFiled: f,
    archPeriod: f,
    filedbyName: f,
    filedDeptCode: f,
    filedbyCode: f,
    filedDeptName: f,
    contractId: f,
    endDate: f,
    contractTemplateCode: f,
    effectiveDesc: f,
    contractTemplate: f,
    effectedDate: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    legalStatus: f,
    contractFlag: f
  };
  ds.QTtt = {
    t1: f,
    t2: f
  };
  ds.QMtrMaterialInfoCopy1 = {
    id: p,
    productId: f,
    materialCode: f,
    materialCategoryId: f,
    applyType: f,
    spec: f,
    specEn: f,
    materialNameCn: f,
    materialNameEn: f,
    unit: f,
    highValueFlag: f,
    blindFlag: f,
    criticalFlag: f,
    harmfulFlag: f,
    monitorFlag: f,
    proposedPrice: f,
    proposedPriceCurrency: f,
    status: f,
    remark: f,
    dept: f,
    annualSupply: f,
    supplyIns: f,
    partsDrawing: f,
    drawingItem: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    partsType: f,
    partsParameter: f,
    safetyFlag: f,
    smisMrpid: f
  };
  ds.QFineMobilePushMessage = {
    id: p,
    groupid: f,
    mediaid: f,
    msgtype: f,
    terminal: f,
    title: f
  };
  ds.QActRuEventSubscr = {
    id: p,
    rev: f,
    eventType: f,
    eventName: f,
    executionId: f,
    procInstId: f,
    activityId: f,
    configuration: f,
    created: f,
    procDefId: f,
    tenantId: f
  };
  ds.QFineExtraProperty = {
    id: p,
    name: f,
    relatedid: f,
    type: f,
    value: f
  };
  ds.QTopic = {
    id: p,
    mqName: f,
    topic: f,
    createTime: f,
    createUser: f,
    updateTime: f,
    updateUser: f
  };
  ds.QStcPayAdvance = {
    supplierId: f,
    applyDeptEn: f,
    applyDeptCn: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    settlementStatus: f,
    payAdvanceNo: f,
    principalOrgCode: f,
    currency: f,
    supplierNameCn: f,
    createTimeZone: f,
    id: p,
    supplierName: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    paymentNo: f,
    paymentDueDate: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    applyUserEn: f,
    settlementAmount: f,
    applyUserCn: f,
    status: f,
    supplierCode: f
  };
  ds.QSysTransferFileInfo = {
    id: p,
    name: f,
    url: f,
    fileModule: f,
    syncFlag: f,
    uploadFlag: f,
    businessCode: f,
    subBusinessCode: f,
    businessContent: f,
    vesselCode: f,
    vesselId: f,
    referenceId: f,
    referenceTable: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QChrMarketIndexInfo = {
    id: p,
    indexCode: f,
    indexRounte: f,
    indexDescription: f,
    indexSizeMt: f,
    indexType: f,
    infoType: f,
    empty: f,
    active: f,
    recordStatus: f,
    sno: f,
    jsonCode: f,
    roundFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QActivityType = {
    activityTypeCode: f,
    activityTypeName: f,
    activityUrl: f,
    id: f
  };
  ds.QOpsCpOil = {
    maxVoyageNo: f,
    delType: f,
    eRedHfoPrice: f,
    eRedLfoPrice: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    createOffice: f,
    createOfficeName: f,
    createName: f,
    vesselName: f,
    masterDataCodeR: f,
    flag: f,
    eRedLdoPrice: f,
    contractNo: f,
    remark: f,
    masterDataCode: f,
    chrContractHeaderId: f,
    minVoyageNo: f,
    eDelLfoPrice: f,
    principalOrgCode: f,
    eDelHfoPrice: f,
    lastModifyOffice: f,
    creator: f,
    eDelHdoPrice: f,
    eDelLdoPrice: f,
    lastModifyByName: f,
    eRedHdoPrice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    ispFleetCode: f,
    estRedType: f,
    captainRedChecker: f,
    captainRedUsed: f,
    finaDelChecker: f,
    estDelPaymode: f,
    actRedRemark: f,
    actRedTime: f,
    captainRedStatus: f,
    captainDelUsed: f,
    estDelType: f,
    actDelRemark: f,
    finaDelRemark: f,
    estDelPorts: f,
    finaRedChecker: f,
    captainDelCheckdate: f,
    actRedTimeLt: f,
    finaDelUsed: f,
    finaRedStatus: f,
    finaDelStatus: f,
    estRedPaymode: f,
    finaRedRemark: f,
    actDelTimeLt: f,
    actRedPort: f,
    actDelPort: f,
    actEstDelPrice: f,
    estRedPorts: f,
    captainDelChecker: f,
    finaRedCheckdate: f,
    captainRedCheckdate: f,
    finaRedUsed: f,
    actEstRedPrice: f,
    actDelTime: f,
    estDelRemark: f,
    estEstPrice: f,
    captainDelStatus: f,
    finaDelCheckdate: f,
    estRedRemark: f,
    cpNotice: f,
    cpNoticeDesc: f,
    isBallast: f,
    fuelNature: f,
    currency: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    returnOilFlag: f,
    opsCpOilAct: new c("OpsCpOilAct")
  };
  ds.QSpsPoPayment = {
    poNo: p,
    paymentStatus: f
  };
  ds.QChrPreSettlementCargoOver = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cargoOqMin: f,
    cargoOqMax: f,
    cargoOqStandards: f,
    cargoOqMode: f,
    cargoId: f,
    ispFleetCode: f,
    cargoOverNo: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFsFileInfo2 = {
    fileKey: f,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStrategyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f
  };
  ds.QFineTenant = {
    id: p,
    name: f
  };
  ds.QCpmProtocolItem = {
    id: p,
    protocolId: f,
    protocolType: f,
    itemId: f,
    itemCode: f,
    itemNameEn: f,
    itemNameCn: f,
    unit: f,
    remark: f,
    price: f,
    discount: f,
    currency: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    rebateFlag: f,
    cpmProtocolItemDetail: new c("CpmProtocolItemDetail")
  };
  ds.QFsFileInfo3 = {
    fileKey: f,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStrategyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f
  };
  ds.QAmiReportIfs = {
    id: p,
    baseInfoId: f,
    vesselId: f,
    vesselCode: f,
    vesselEnName: f,
    vesselCnName: f,
    vygNo: f,
    reportTn: f,
    reportType: f,
    reportTm: f,
    executeStatus: f,
    sendTm: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    errorInfo: f,
    reportRecord: f
  };
  ds.QFineScheduleOutput = {
    id: p,
    basename: f,
    basenamemap: f,
    createattachbyusername: f,
    formats: f,
    formatsmap: f
  };
  ds.QFineOutputMount = {
    id: p,
    description: f,
    folderentryid: f,
    folderentryname: f,
    folderentrystr: f
  };
  ds.QSpsCheckListMain = {
    checkType: f,
    lastModifyOffice: f,
    checkSubmitDate: f,
    creator: f,
    lastModifyBy: f,
    remark: f,
    dept: f,
    vesselId: f,
    lastModifyTimeZone: f,
    checkStatus: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    checkNo: f,
    checkUserCn: f,
    checkUserEn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    vesselNameCn: f,
    vesselNameEn: f,
    electricFlag: f
  };
  ds.QSpsChargeConfig = {
    id: p,
    companyId: f,
    deptId: f,
    bussinessCode: f,
    bussinessName: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QAmiBdAllcargo = {
    id: p,
    bkDptId: f,
    allcargoNm: f,
    allttlQty: f,
    allcargoNum: f,
    qtyH1: f,
    qtyH2: f,
    qtyH3: f,
    qtyH4: f,
    qtyH5: f,
    qtyH6: f,
    qtyH7: f,
    qtyH8: f,
    qtyH9: f,
    qtyH10: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt3: f,
    reservedInt4: f,
    reservedLong3: f,
    reservedLong4: f,
    reservedDecimal3: f,
    reservedDecimal4: f,
    reservedDate2: f,
    reservedStr4: f,
    reservedStr5: f,
    reservedStr6: f,
    allcargoNameEn: f,
    allcargoNameCn: f
  };
  ds.QQrtzSimpropTriggers = {
    schedName: f,
    triggerGroup: f,
    triggerName: f,
    boolProp1: f,
    boolProp2: f,
    decProp1: f,
    decProp2: f,
    intProp1: f,
    intProp2: f,
    longProp1: f,
    longProp2: f,
    strProp1: f,
    strProp2: f,
    strProp3: f
  };
  ds.QSpsInvoicePrice = {
    id: p,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    poMainId: f,
    inventoryRecordId: f,
    poNo: f,
    applyNo: f,
    invoicePrice: f,
    baseCurrency: f,
    currency: f,
    rate: f,
    discount: f,
    qty: f,
    deletedFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    itemId: f,
    itemType: f
  };
  ds.QSpsApplyMain = {
    orderType: f,
    transferStatus: f,
    devModel: f,
    memo: f,
    devMakerNameCn: f,
    lastModifyTimeZone: f,
    urgencyVessel: f,
    vesselId: f,
    recordVersion: f,
    eta: f,
    etd: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    vesselNameEn: f,
    processNode: f,
    devNameCn: f,
    etp: f,
    lastModifyBy: f,
    devSerialNo: f,
    reservedLong2: f,
    reservedLong1: f,
    applyPurpose: f,
    etpNameCn: f,
    createOffice: f,
    applyRemark: f,
    applyStatus: f,
    urgencyShore: f,
    reservedDate: f,
    devCode: f,
    compareAuditRemark: f,
    devMakerNameEn: f,
    equipmentType: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    specBusinessMark: f,
    vesselNameCn: f,
    principalOrgCode: f,
    reservedInt1: f,
    devNameEn: f,
    reservedInt2: f,
    devInfoId: f,
    lastModifyOffice: f,
    creator: f,
    applyReason: f,
    enquireStatus: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    dept: f,
    etpNameEn: f,
    createTime: f,
    lastModifyTime: f,
    applyNo: f,
    orderFlag: f,
    electricFlag: f,
    applyDate: f,
    devMakerId: f,
    applyRoleCode: f,
    applyType: f,
    devTypeId: f,
    devTypeNameCn: f,
    inquiryRemark: f,
    devTypeNameEn: f,
    devVesselCodeId: f,
    devFlag: f,
    mergeMainNo: f,
    mergeOtherNo: f,
    creatorNameCn: f,
    creatorNameEn: f,
    applyForRoleCode: f,
    deviceInstallFlag: f,
    purposeType: f,
    purposeTypeDevice: f,
    applyDetail: new c("SpsApplyDetail")
  };
  ds.QChrPreSettlementPort = {
    id: p,
    mainId: f,
    portFalg: f,
    portPurpose: f,
    distance: f,
    speed: f,
    weatherFactor: f,
    sailDate: f,
    ldEfficiency: f,
    ldTotal: f,
    ttTime: f,
    nonOperationInPort: f,
    inPortTime: f,
    timeZone: f,
    arrivalTime: f,
    departureTime: f,
    arrivalFlag: f,
    departureFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    portName: f,
    portCode: f,
    loadQty: f,
    unloadQty: f,
    portSequence: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f
  };
  ds.QVscSendTask = {
    fileName: f,
    batchNo: f,
    partCount: f,
    retryCount: f,
    retryTime: f,
    fileMd5: f,
    partIndex: f,
    priority: f,
    vesselId: f,
    createTime: f,
    fileSize: f,
    commType: f,
    lastModifyTime: f,
    sendDtm: f,
    commitDtm: f,
    sendStatus: f,
    vesselCode: f,
    id: p,
    businessType: f,
    sendQueueId: f,
    contentType: f,
    sendFileName: f,
    cdmVesselGeneral: new c("CdmVesselGeneral")
  };
  ds.QActDeModelHistory = {
    id: p,
    name: f,
    modelKey: f,
    description: f,
    modelComment: f,
    created: f,
    createdBy: f,
    lastUpdated: f,
    lastUpdatedBy: f,
    removalDate: f,
    version: f,
    modelEditorJson: f,
    modelId: f,
    modelType: f,
    modelProjectName: f,
    modelClass: f,
    modelProjectId: f,
    svgImg: f
  };
  ds.QAmiBwStoppage = {
    id: p,
    bkPortDynamicId: f,
    starttime: f,
    endtime: f,
    reason: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QOpsInsClaim = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    ispFleetCode: f,
    vesselName: f,
    vesselNameEn: f,
    vesselCode: f,
    voyageNo: f,
    dateOfIncident: f,
    location: f,
    caseCategory: f,
    caseName: f,
    caseNo: f,
    insComCaseNo: f,
    deductibleAmount: f,
    securityAmount: f,
    claimAmount: f,
    claimCurrency: f,
    endCaseFlag: f,
    arbitrationFlag: f,
    letigationFlag: f,
    orSecurity: f,
    invalidFlag: f,
    invalidUser: f,
    invalidUserName: f,
    invalidTime: f,
    approveStatus: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    securityType: f
  };
  ds.QComCmllaytimeSof = {
    lastModifyOffice: f,
    sofWeek: f,
    creator: f,
    sofAdjust: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    sofIndex: f,
    remark: f,
    sofTime: f,
    lastModifyByName: f,
    sofDesc: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    sofDatetime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    sofFinaltime: f,
    createName: f,
    ispFleetCode: f,
    cmllaytimeId: f,
    cmllaytimePortId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    sofEndDatetime: f,
    sofTimeSecond: f,
    sofCumulativeTime: f
  };
  ds.QComTaxInvoice = {
    taxApplicationTime: f,
    partnerAccountNo: f,
    partnerProperty: f,
    extNo: f,
    invoiceAmount: f,
    taxExchangeRate: f,
    taxApplicationStatus: f,
    contactTel: f,
    authenticateCode: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    receiptUser: f,
    invoiceType: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    taxInvoiceUser: f,
    deviceType: f,
    terminalNo: f,
    settleOfficeCode: f,
    lastModifyBy: f,
    priceTaxSepFlag: f,
    lastModifyOfficeName: f,
    propertyRightCode: f,
    taxInvoiceType: f,
    checkUser: f,
    partnerContactAddr: f,
    bankId: f,
    createOffice: f,
    partnerBank: f,
    createOfficeName: f,
    preTaxInvoiceAmount: f,
    taxEmail: f,
    taxInvoiceAmount: f,
    taxAmount: f,
    createName: f,
    vesselName: f,
    partnerCode: f,
    accountName: f,
    settleOfficeName: f,
    partnerContactMobile: f,
    bankName: f,
    partnerBankName: f,
    taxParticular: f,
    ispFleetCode: f,
    currencyName: f,
    contactAddr: f,
    accountNo: f,
    specialInvoiceType: f,
    principalOrgCode: f,
    taxCodeVersion: f,
    applicationUserRemark: f,
    groupExchangeRate: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    taxRemark: f,
    partnerName: f,
    taxCurrencyCode: f,
    partnerTaxNo: f,
    serviceName: f,
    lastModifyByName: f,
    partnerContactTel: f,
    partnerBankId: f,
    createTime: f,
    lastModifyTime: f,
    invoiceId: f,
    currencyCode: f,
    invSerialNo: f,
    partnerRipInvoiceId: f,
    ripInvoiceId: f,
    taxNo: f,
    partnerInvoiceHeader: f,
    invoiceHeader: f,
    invoiceApproveId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    invoiceHeaderEn: f,
    partnerInvoiceHeaderEn: f,
    partnerNameEn: f,
    settleOfficeNameEn: f,
    comTaxInvoiceItem: new c("ComTaxInvoiceItem")
  };
  ds.QMtrQuoteReplaceDetail = {
    id: p,
    quoteMainId: f,
    seqNo: f,
    materialCode: f,
    materialName: f,
    unit: f,
    spec: f,
    enquireQty: f,
    price: f,
    discount: f,
    taxRate: f,
    remark: f,
    createTime: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f
  };
  ds.QChrContractBroker = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    brokerCommDesc: f,
    lastModifyOfficeName: f,
    contractNo: f,
    remark: f,
    lastModifyByName: f,
    contractVersion: f,
    brokerBillStandards: f,
    lastModifyTimeZone: f,
    brokerComm: f,
    brokerCode: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    contractId: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    brokerName: f,
    createName: f,
    commPayer: f,
    ispFleetCode: f,
    brokerComm2: f,
    brokerBillStandards2: f,
    brokerNo: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    brokerNameEn: f
  };
  ds.QFineOpsCrashDetail = {
    id: p,
    downtime: f,
    node: f,
    reasondetail: f,
    solution: f
  };
  ds.QActProcdefInfo = {
    id: p,
    procDefId: f,
    rev: f,
    infoJsonId: f
  };
  ds.QFineReportExpand = {
    id: p,
    showtype: f,
    transmitparameters: f
  };
  ds.QActDmnDatabasechangelog = {
    id: f,
    author: f,
    filename: f,
    dateexecuted: f,
    orderexecuted: f,
    exectype: f,
    md5sum: f,
    description: f,
    comments: f,
    tag: f,
    liquibase: f,
    contexts: f,
    labels: f,
    deploymentId: f
  };
  ds.QAmiGArrival = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    latitude: f,
    longitude: f,
    crs: f,
    latitudeScore: f,
    latitudeFlag: f,
    longitudeScore: f,
    longitudeFlag: f,
    baseLineCode: f,
    dailyRunDistFa: f,
    dailyRunTimeFa: f,
    ttlRunDistFa: f,
    ttlRunTimeFa: f,
    runDistAneuvering: f,
    dailyRunTimeManeuvering: f,
    averageSpeed: f,
    averageRpm: f,
    engineSpeed: f,
    slip: f,
    averagePower: f,
    draftFwd: f,
    draftMid: f,
    draftAft: f,
    gm: f,
    arrivedTime: f,
    arrivalLocationPortCd: f,
    arrivalLocationPortNm: f,
    arrivalLocationPortType: f,
    density: f,
    esb: f,
    robOfHsfo: f,
    robOfLsfo: f,
    robOfHsmgo: f,
    robOfLsmgo: f,
    robOfFw: f,
    norTendered: f,
    apsLt: f,
    pobLt: f,
    dopLt: f,
    timeOfAnchor: f,
    anchoragePositionCd: f,
    anchoragePositionNm: f,
    anchoringDescription: f,
    fweCd: f,
    fweNm: f,
    etbLt: f,
    etdLt: f,
    leftAnchor: f,
    leftAnchorDeck: f,
    leftAnchorWater: f,
    leftAnchorCableLength: f,
    rightAnchor: f,
    rightAnchorDeck: f,
    rightAnchorWater: f,
    rightAnchorCableLength: f,
    timeLastReport: f,
    timeThisReport: f,
    durationOfConsumption: f,
    dthsfo: f,
    dtlsfo: f,
    dthsmgo: f,
    dtlsmgo: f,
    flowMeterFo: f,
    temperatureOfFo: f,
    densityOfFo: f,
    flowMeterOfMdo: f,
    temperatureOfMdo: f,
    densityOfMdo: f,
    hfo: f,
    lfo: f,
    hmgo: f,
    lmgo: f,
    cylinderLub: f,
    engineLub: f,
    generatorLub: f,
    fw: f,
    remarks: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    flowMeterOfMdoLast: f,
    flowMeterOfFoLast: f,
    allRevolutionCounter: f,
    timeLastReportZone: f,
    timeLastReportFlag: f,
    timeThisReportZone: f,
    revolutionCounterLast: f,
    timeThisReportFlag: f,
    totalRevolutionCounter: f,
    aspRobLsmgo: f,
    exVoyNo: f,
    aspRobLsfo: f,
    aspRobHsfo: f,
    aspRobHsmgo: f
  };
  ds.QAmiTDepLoadFlow = {
    id: p,
    tkDepLoadId: f,
    commDaballst: f,
    compDaballst: f,
    hoseConnected: f,
    hoseDisconnected: f,
    commLoading: f,
    compLoading: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QAmclAmiTDptDischPortDelay = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    delayFmTm: f,
    delayToTm: f,
    delayReason: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QActIdMembership = {
    userId: f,
    groupId: f
  };
  ds.QChrEstimateHireIn = {
    id: p,
    mainId: f,
    type: f,
    rentPerDays: f,
    durationDays: f,
    commission: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    totalAmount: f
  };
  ds.QFineOpsDumpAnalyze = {
    id: p,
    dumppath: f,
    failreason: f,
    node: f,
    time: f,
    type: f
  };
  ds.QOpsVoyagePort = {
    portSequence: f,
    esopTime: f,
    opsVoyageTaskId: f,
    esopHdo: f,
    esopLdo: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    arrivalTime: f,
    createTimeZone: f,
    id: p,
    departureGmtTime: f,
    issuePlace: f,
    actualDays: f,
    portPurpose: f,
    lastModifyBy: f,
    faTime: f,
    lastModifyOfficeName: f,
    sailingTime: f,
    timeZone: f,
    faLfo: f,
    hasAgent: f,
    createOffice: f,
    createOfficeName: f,
    countryName: f,
    faHfo: f,
    createName: f,
    esopHfo: f,
    departureTime: f,
    esopLfo: f,
    distance: f,
    remark: f,
    portName: f,
    berthingTime: f,
    countryCode: f,
    havePda: f,
    principalOrgCode: f,
    haveFda: f,
    lastModifyOffice: f,
    esopGmtTime: f,
    creator: f,
    portCode: f,
    lastModifyByName: f,
    faHdo: f,
    createTime: f,
    arrivalGmtTime: f,
    deletedFlag: f,
    faLdo: f,
    lastModifyTime: f,
    planDays: f,
    faGmtTime: f,
    ispFleetCode: f,
    disTofa: f,
    distToquay: f,
    depWater: f,
    depFoHigh: f,
    depFoLow: f,
    depDoLow: f,
    depDoHigh: f,
    arrivalFoHigh: f,
    arrivalMidDrf: f,
    arrivalFoLow: f,
    arrivalWater: f,
    arrivalDoHigh: f,
    arrivalDoLow: f,
    arrivalAftDrf: f,
    arrivalBefDrf: f,
    faTimeFlag: f,
    departureBefDrf: f,
    esopTimeFlag: f,
    arrivalWaterDensity: f,
    berthingTimeFlag: f,
    departureAftDrf: f,
    arrivalTimeFlag: f,
    departureAirCylinderOil: f,
    departureWaterDensity: f,
    arrivalAirCylinderOil: f,
    arrivalMainEngineOil: f,
    departureAuxiliaryEngineOil: f,
    portFlag: f,
    departureTimeFlag: f,
    departureMidDrf: f,
    departureMainEngineOil: f,
    arrivalAuxiliaryEngineOil: f,
    countryNameEn: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    endWorkTime: f,
    startWorkTime: f,
    anchorWork: f,
    berthingTimeGmt: f,
    avdSpd: f,
    opsVoyagePortOil: new c("OpsVoyagePortOil"),
    opsVoyageInPort: new c("OpsVoyageInPort"),
    opsPortAgt: new c("OpsPortAgt")
  };
  ds.QSpsInventoryRecord = {
    id: p,
    vesselCode: f,
    vesselId: f,
    dept: f,
    devInfoId: f,
    partsInfoId: f,
    locationId: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    devModel: f,
    devMakerNameCn: f,
    devNameCn: f,
    vesselNameEn: f,
    devSerialNo: f,
    devCode: f,
    devMakerNameEn: f,
    vesselNameCn: f,
    devNameEn: f,
    devMakerId: f,
    supplierNameCn: f,
    supplierId: f,
    supplierNameEn: f,
    receivePortNameCn: f,
    receivePortCode: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    businessId: f,
    productId: f,
    businessNo: f,
    devVesselCodeId: f,
    devFlag: f,
    sendFinanceTime: f,
    devTypeId: f,
    devTypeNameCn: f,
    devTypeNameEn: f,
    creatorNameCn: f,
    invoicePrice: f,
    creatorNameEn: f,
    chargeId: f,
    spsLocationInfo: new c("SpsLocationInfo"),
    SpsInventory2Location: new c("SpsLocationInfo")
  };
  ds.QProject = {
    id: p,
    projectCode: f,
    projectName: f,
    remark: f,
    appKey: f
  };
  ds.QAmclAmiTDptLoadSeaWater = {
    id: p,
    fileid: f,
    reportNo: f,
    berthAnchorageName: f,
    seaWaterDensity: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QSysMenu = {
    id: p,
    parentMenuId: f,
    path: f,
    pathType: f,
    name: f,
    title: f,
    component: f,
    pathSeq: f,
    redirect: f,
    icon: f,
    activeMenu: f,
    alwaysShow: f,
    hidden: f,
    noCache: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    titleEn: f,
    titleCn: f,
    applyCompanys: f
  };
  ds.QAmclAmiTBunkerDebunker = {
    id: p,
    reportNo: f,
    portCd: f,
    portNameCn: f,
    portNameEn: f,
    location: f,
    readyTime: f,
    draftFwd: f,
    draftMid: f,
    draftAft: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    baseInfoId: f,
    portType: f
  };
  ds.QAmiTDptDischCargo = {
    id: p,
    tkDptDischId: f,
    cargoCd: f,
    cargoDispartured: f,
    cargoRemained: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QOpsCpOilAct = {
    rod: f,
    contractNo: f,
    remark: f,
    contractVersion: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    opsCpOilId: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    cpNotice: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    oilTime: f,
    oilQty: f,
    lastModifyByName: f,
    oilPrice: f,
    createOffice: f,
    cpNoticeDesc: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    oilTyp: f,
    createName: f,
    status: f,
    timeFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    serialNum: f,
    sulfurQty: f,
    viscosity: f
  };
  ds.QRipBaseInfoChange = {
    id: p,
    ripBaseInfoId: f,
    changeApplicant: f,
    changeApplicantEn: f,
    applicantTime: f,
    applicantOffice: f,
    applicantOfficeEn: f,
    applicantStatus: f,
    applicantReason: f,
    approveReasons: f,
    approveStatus: f,
    ripCode: f,
    ripType: f,
    internalExternal: f,
    countryRegion: f,
    nameCn: f,
    nameEn: f,
    shortName: f,
    headquartersName: f,
    uniSoCreditCode: f,
    easCode: f,
    nature: f,
    mainDataStatus: f,
    initialEvaluateStatus: f,
    initialEvalDate: f,
    isoType: f,
    productsService: f,
    deletedFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ifRoot: f,
    regPerson: f,
    regDt: f,
    businessNo: f,
    regMoney: f,
    redAddr: f,
    redAddrEn: f,
    bizStatus: f,
    province: f,
    provinceCn: f,
    provinceEn: f,
    email: f,
    telephone: f,
    otherPhone: f,
    industry: f,
    corporateCode: f,
    parentCode: f,
    stockCode: f,
    taxNo: f,
    remark: f,
    web: f,
    vipFlag: f,
    company: f,
    areaCd: f,
    areaNm: f,
    settlementcenterCd: f,
    settlementcenterNm: f,
    customerGrade: f,
    effectDate: f,
    expireDate: f,
    gradeState: f,
    isCustGrade: f,
    hcbCode: f,
    uuid: f,
    countryNameEn: f,
    countryNameCn: f,
    isSupplier: f,
    isCustomer: f,
    groupEnterpriseNature: f,
    city: f,
    registeredCurrency: f,
    industryClassification: f,
    beforeName: f,
    isStrategy: f,
    isListed: f,
    partnerType: f,
    innnerCsCust: f,
    stockName: f,
    isVip: f,
    isMajorOilCompany: f,
    validPeriod: f,
    settlementCurrency: f,
    earliestTradingDay: f,
    recentTradingDay: f,
    earliestCloseDate: f,
    infoCloseDate: f,
    generateLicense: f,
    creditRateDes: f,
    zipCode: f,
    mainMail: f,
    mainFax: f,
    companyWebsite: f,
    companyMailAddressCn: f,
    companyMailAddressEn: f,
    ripBankInfoChanges: new c("RipBankInfoChange"),
    ripServiceTypeSetChanges: new c("RipServiceTypeSetChange"),
    ripInvoicesList: new c("RipInvoice")
  };
  ds.QAccessLog = {
    id: p,
    title: f,
    businesstype: f,
    businesstypes: f,
    method: f,
    requestmethod: f,
    operatortype: f,
    opername: f,
    deptname: f,
    operurl: f,
    operip: f,
    operlocation: f,
    operparam: f,
    jsonresult: f,
    status: f,
    errormsg: f,
    opertime: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f
  };
  ds.QPurchaseFaiInventoryPre = {
    id: p,
    mainId: f,
    inOutId: f,
    itemId: f,
    beginDate: f,
    endDate: f,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    currency: f,
    baseCurrency: f,
    price: f,
    stockQty: f,
    amountStandard: f,
    sendFinanceFlag: f,
    monitorFlag: f,
    needCalFlag: f,
    errorFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    poNo: f
  };
  ds.QTransferOldSupper = {
    oldId: f,
    newId: f,
    nameCn: f,
    nameEn: f
  };
  ds.QStcBaoBeiConstruction = {
    id: p,
    baoBeiId: f,
    constructionCountry: f,
    constructionCity: f,
    constructionProvince: f,
    constructionDistrict: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QFineDataPortal = {
    id: p,
    content: f,
    custom: f,
    lastmodifiedtime: f,
    name: f,
    terminal: f
  };
  ds.QAmclAmiTArrival = {
    id: p,
    reportNo: f,
    baseInfoId: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    portId: f,
    portCd: f,
    arrivedTm: f,
    norTenderedTm: f,
    berthedTm: f,
    estDepartureTm: f,
    runDist: f,
    actSailingHrs: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    slip: f,
    avgBhp: f,
    theoreticalSpd: f,
    stressBm: f,
    stressBmFr: f,
    stressSf: f,
    stressSfFr: f,
    draftFw: f,
    draftMid: f,
    draftAft: f,
    tankCleaningHrsDes: f,
    aFoHEng: f,
    aFoLEng: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aFoHCargoHeating: f,
    aFoLCargoHeating: f,
    aFoHTankCleaning: f,
    aFoLTankCleaning: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aWaterBoiler: f,
    aWaterDomestic: f,
    mFoH: f,
    mFoL: f,
    mMgoH: f,
    mMgoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBWater: f,
    mDWater: f,
    mNonLiqSlops: f,
    mLiqSlops: f,
    remarks: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    etbTm: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    dFoHEng: f,
    dFoLEng: f,
    dFoHGen: f,
    dFoLGen: f,
    dFoHBoiler: f,
    dFoLBoiler: f,
    dFoHIgg: f,
    dFoLIgg: f,
    dFoHInc: f,
    dFoLInc: f,
    dFoHOther: f,
    dFoLOther: f,
    dSulphurHfo: f,
    dSulphurLfo: f,
    dMgoHEng: f,
    dMgoLEng: f,
    dMgoHGen: f,
    dMgoLGen: f,
    dMgoHBoiler: f,
    dMgoLBoiler: f,
    dMgoHIgg: f,
    dMgoLIgg: f,
    dMgoHInc: f,
    dMgoLInc: f,
    dMgoHOther: f,
    dMgoLOther: f,
    dSulphurHmgo: f,
    dSulphurLmgo: f,
    dTHsfo: f,
    dTLsfo: f,
    dTHsmgo: f,
    dTLsmgo: f,
    dLuboilCyl: f,
    dLuboilEng: f,
    dLuboilGen: f,
    dBoilerWater: f,
    dDomesticWater: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    seawaterDensity: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    portType: f
  };
  ds.QSysTaskWorkflowInfo = {
    id: p,
    referenceId: f,
    taskCode: f,
    executionId: f,
    modelLogId: f,
    processInstanceId: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselId: f,
    synClockFlag: f,
    payload: f,
    filed: f,
    autoMethodFlag: f,
    autoRestartFlag: f,
    filedContent: f,
    companyCode: f,
    taskLog: new c("SysTaskWorkflowTaskLog")
  };
  ds.QStcOldInvoice = {
    invoiceNo: p
  };
  ds.QCdmVesselCharterHistory = {
    id: p,
    vesselGeneralId: f,
    charterId: f,
    charterNameCn: f,
    charterNameEn: f,
    charterCode: f,
    charterItems: f,
    charterRepurchase: f,
    bizMode: f,
    controlMethod: f,
    charterEndDate: f,
    charterStartDate: f,
    charterRemark: f,
    ownerFlag: f,
    controlType: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    masterDataCode: f
  };
  ds.QSysTaskRemarks = {
    id: p,
    modelLogId: f,
    remark: f,
    userCode: f,
    deletedFlag: f,
    validFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QAmclAmiTDptDisch = {
    id: p,
    baseInfoId: f,
    portCode: f,
    portType: f,
    portNameCn: f,
    portNameEn: f,
    reportNo: f,
    portCd: f,
    df: f,
    dm: f,
    da: f,
    tPortH: f,
    faopSpdTm: f,
    bmFr: f,
    sBmFr: f,
    sfFr: f,
    sSfFr: f,
    nextPort: f,
    nextPortNameCn: f,
    nextPortNameEn: f,
    etaNextPort: f,
    nextAssignment: f,
    cashReceived: f,
    cMm: f,
    prostestRemarks: f,
    liquid: f,
    nonLiquid: f,
    aFoHEng: f,
    aFoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aFoHBoiler: f,
    aFoLBoiler: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aBWater: f,
    aDWater: f,
    mFoH: f,
    mFoL: f,
    mDoH: f,
    mDoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBWater: f,
    mDWater: f,
    remarks: f,
    runningHours: f,
    runDist: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    berthing: f,
    unberthing: f,
    sscecValidDate: f,
    garDisp: f,
    pscOtherInsp: f,
    basisSpeed: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    onberthTm: f,
    tugsUsed: f,
    waterTreatUsed: f,
    reason: f,
    dFoHEng: f,
    dFoLEng: f,
    dFoHGen: f,
    dFoLGen: f,
    dFoHBoiler: f,
    dFoLBoiler: f,
    dFoHIgg: f,
    dFoLIgg: f,
    dFoHInc: f,
    dFoLInc: f,
    dFoHOther: f,
    dFoLOther: f,
    dSulphurHfo: f,
    dSulphurLfo: f,
    dMgoHEng: f,
    dMgoLEng: f,
    dMgoHGen: f,
    dMgoLGen: f,
    dMgoHBoiler: f,
    dMgoLBoiler: f,
    dMgoHIgg: f,
    dMgoLIgg: f,
    dMgoHInc: f,
    dMgoLInc: f,
    dMgoHOther: f,
    dMgoLOther: f,
    dSulphurHmgo: f,
    dSulphurLmgo: f,
    dTHsfo: f,
    dTLsfo: f,
    dTHsmgo: f,
    dTLsmgo: f,
    dLuboilCyl: f,
    dLuboilEng: f,
    dLuboilGen: f,
    dBoilerWater: f,
    dDomesticWater: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    waterDensity: f,
    terminalName: f,
    terminalBerth: f,
    nextPortType: f,
    shoreWasteOil: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QChrSettlementOffHireOil = {
    id: p,
    mainId: f,
    bunkerSpec: f,
    unitPrice: f,
    quantity: f,
    bunkerAmount: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFinReceiptImageRec = {
    id: p,
    barCode: f,
    scanUser: f,
    totalPage: f,
    recStatus: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFinePortalDynamicMobile = {
    id: p,
    actiontype: f,
    displayname: f,
    entryid: f,
    path: f,
    time: f,
    userid: f
  };
  ds.QComElectSealConfig = {
    id: p,
    companyCode: f,
    companyName: f,
    activeFlag: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    picBase: f
  };
  ds.QStcManageContractDtl = {
    id: p,
    manageContractId: f,
    chargeId: f,
    chargeCode: f,
    chargeNameEn: f,
    chargeNameCn: f,
    billingCycle: f,
    amount: f,
    currency: f,
    costType: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    costStyle: f
  };
  ds.QChrVlocEstimateDetail = {
    id: p,
    mainId: f,
    vlocDate: f,
    vesselName: f,
    vesselNameEn: f,
    vesselCode: f,
    voyageNo: f,
    contractId: f,
    contractNo: f,
    contractType: f,
    hireRate: f,
    operatingDays: f,
    totalOperatingDays: f,
    totalBunkerExpense: f,
    freightRentalAmount: f,
    totalFreightRentalAmount: f,
    totalIncome: f,
    chartererComm: f,
    chartererCommAmount: f,
    brokerComm: f,
    brokerCommAmount: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    generateType: f
  };
  ds.QFinSettlementReport = {
    id: p,
    belongMonth: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    monthlySettleVesselCount: f,
    monthlySettleVoyageCount: f,
    voyagePassCount: f,
    voyageEstimateCount: f,
    settleSummarizeText: f,
    deletedFlag: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    checkType: f,
    finSettlementReportVoyage: new c("FinSettlementReportVoyage"),
    finSettlementReportVessel: new c("FinSettlementReportVessel")
  };
  ds.QActDmnDatabasechangeloglock = {
    id: p,
    locked: f,
    lockgranted: f,
    lockedby: f
  };
  ds.QChrSettlementOffHire = {
    id: p,
    mainId: f,
    reportType: f,
    beginPortCode: f,
    beginPortName: f,
    beginPortNameEn: f,
    endPortCode: f,
    endPortName: f,
    endPortNameEn: f,
    cause: f,
    offHierTime: f,
    beginGmtTime: f,
    endGmtTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chrSettlementOffHireOilList: new c("ChrSettlementOffHireOil")
  };
  ds.QActIdUser = {
    id: p,
    rev: f,
    first: f,
    last: f,
    email: f,
    pwd: f,
    pictureId: f
  };
  ds.QChrContractCargoOver = {
    cargoOqMin: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    contractNo: f,
    remark: f,
    lastModifyByName: f,
    contractVersion: f,
    lastModifyTimeZone: f,
    cargoId: f,
    cargoOqMax: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    cargoOqMode: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    cargoOqStandards: f,
    createName: f,
    ispFleetCode: f,
    cargoOverNo: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QChrVoyagePlan = {
    id: p,
    estimateId: f,
    vesselName: f,
    voyageNo: f,
    voyageStatus: f,
    voyageType: f,
    vesselSource: f,
    manageCompany: f,
    currency: f,
    beginDate: f,
    endDate: f,
    estBeginDate: f,
    estEndDate: f,
    sailingSpeed: f,
    heavyLoadSpeed: f,
    operateBy: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    lastPortCode: f,
    vesselCode: f,
    operateByCode: f,
    manageCompanyCode: f,
    lastPortName: f,
    voyageCurrencyCode: f,
    beginPortCode: f,
    firstPortName: f,
    voyageCurrencyName: f,
    firstPortCode: f,
    beginPortName: f,
    ispFleetCode: f,
    oilPlan: f,
    pniGaugingInspection: f,
    urgentDispatch: f,
    fristLdPortCagro: f,
    speedRequest: f,
    charterAgent: f,
    ballastDirection: f,
    specialFouceCargo: f,
    specialCabinArrangements: f,
    voyageIntention: f,
    stateroomRequest: f,
    specialTermsCharter: f,
    useAgent: f,
    fuelConsumption: f,
    brokerContact: f,
    noBl: f,
    shipCraneDis: f,
    cargoGroup: f,
    grabBucket: f,
    needAgent: f,
    portConditions: f,
    tradeFlag: f,
    selectFlag: f,
    opsVoyageTaskId: f,
    beginPortNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    isObo: f,
    orOverweightItem: f,
    orPni: f,
    orPortInquiry: f,
    orIntendVoyage: f,
    orUseGab: f,
    orObo: f,
    orRecommendAgent: f,
    orChrAgent: f,
    orOwernAgent: f,
    orShipCrane: f,
    orBlFalg: f,
    otherRemark: f,
    orOilPlan: f,
    recommendAgent: f,
    depReq: f,
    operateByEn: f,
    manageCompanyEn: f,
    chrVoyagePlanPort: new c("ChrVoyagePlanPort")
  };
  ds.QActIdmPersistentToken = {
    series: p,
    userId: f,
    tokenValue: f,
    tokenDate: f,
    ipAddress: f,
    userAgent: f
  };
  ds.QAmiSofEvent = {
    id: p,
    mainId: f,
    eventName: f,
    nameEditable: f,
    eventTime: f,
    timeFillable: f,
    remark: f,
    remarkFillable: f,
    sequence: f,
    reportNo: f,
    deletable: f
  };
  ds.QFinFuelSequenceDetail = {
    id: p,
    mainId: f,
    sequence: f,
    vesselCode: f,
    vesselName: f,
    bunkerQuantity: f,
    batchNo: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    voyageType: f,
    voyageNo: f,
    stockOperation: f,
    operationTime: f,
    operationNo: f
  };
  ds.QChrPreSettlementInvoice = {
    id: p,
    mainId: f,
    invoiceNo: f,
    invoiceDate: f,
    rpType: f,
    rpTypeDetail: f,
    dueDate: f,
    stlDate: f,
    freightYm: f,
    partnerCode: f,
    partnerName: f,
    currencyCode: f,
    currencyName: f,
    invoiceAmount: f,
    particular: f,
    creditNoteFlag: f,
    remark: f,
    exchangeRate: f,
    baseCurrencyCode: f,
    baseCurrencyName: f,
    baseInvoiceAmount: f,
    invalidFlag: f,
    invalidUser: f,
    invalidUserName: f,
    invalidTime: f,
    businessType: f,
    invoiceType: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    bankInfoId: f,
    bankInfo: f,
    accountNo: f,
    accountName: f,
    bankName: f,
    contactTel: f,
    contactAddr: f,
    partnerBankInfoId: f,
    partnerAccountNo: f,
    partnerAccountName: f,
    partnerBankName: f,
    partnerContactTel: f,
    partnerContactAddr: f,
    contractId: f,
    contractNo: f,
    contractName: f,
    contractType: f,
    vesselCode: f,
    vesselName: f,
    voyageNo: f,
    installment: f,
    finalFlag: f,
    paymentApplicationId: f,
    vesselCmpInfo: f,
    manageCmpInfo: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    checkFlag: f,
    checkUser: f,
    checkUserName: f,
    checkDate: f,
    submitFlag: f,
    urlCode: f,
    autoTaxInvFlag: f,
    approvalStatus: f,
    voyagePortId: f,
    portCode: f,
    portName: f,
    agentCode: f,
    agentName: f,
    offsetAmount: f,
    paymentAmount: f,
    docNo: f,
    dockRepairFlag: f,
    vesselBuildFlag: f,
    allinFlag: f,
    substituteFlag: f,
    substitutePartnerCode: f,
    substitutePartnerName: f,
    docCollectFlag: f,
    fdaReceivedDate: f,
    pdaBalanceFlag: f,
    currentPercent: f,
    cancelInvoiceNo: f,
    invoiceProperty: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    agentNameEn: f,
    vesselNameEn: f,
    partnerNameEn: f,
    settleOfficeNameEn: f,
    portNameEn: f,
    substitutePartnerNameEn: f
  };
  ds.QActFoSubmittedForm = {
    id: p,
    formId: f,
    taskId: f,
    procInstId: f,
    procDefId: f,
    submittedDate: f,
    submittedBy: f,
    formValuesId: f,
    tenantId: f
  };
  ds.QAmiSuppliedFuel = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselCode: f,
    suppliedFuelId: f,
    vesselId: f,
    isInitData: f,
    bargeAlongsideTm: f,
    bargeOffTm: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    hoseDisconnectedTm: f,
    commencedPumpingTm: f,
    temperature: f,
    bdnNo: f,
    waterContent: f,
    bargeName: f,
    density: f,
    hoseConnectedTm: f
  };
  ds.QAmiSuppliedFuelBack2306142 = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    waterContent: f,
    density: f,
    temperature: f,
    bdnNo: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    bargeAlongsideTm: f,
    hoseConnectedTm: f,
    commencedPumpingTm: f,
    hoseDisconnectedTm: f,
    bargeOffTm: f,
    bargeName: f
  };
  ds.QAmiMonthRunTime = {
    id: p,
    monthOilMainId: f,
    sno: f,
    equname: f,
    equtype: f,
    lastData: f,
    thisData: f,
    thisRun: f,
    thisDataAdjust: f,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    senddate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselEnName: f,
    vesselCnName: f,
    tkrCheck: f,
    tkrHeckDate: f,
    trkCheck: f,
    asdLock: f,
    opnCheck: f,
    tkrHeckUser: f
  };
  ds.QStcPoDetail = {
    receivePortCode: f,
    receivePortNameEn: f,
    receivePortNameCn: f,
    receiveStatus: f,
    id: p,
    itemName: f,
    itemNo: f,
    poQty: f,
    receiveDate: f,
    receiveQty: f,
    unit: f,
    returnQty: f,
    price: f,
    financePrice: f,
    paidQty: f,
    taxRate: f,
    discount: f,
    totalAmount: f,
    specMark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    businessNo: f,
    businessId: f,
    poDetailId: f,
    materialId: f,
    sendFinanceFlag: f,
    sendFinanceTime: f,
    seqNo: f,
    taxAmount: f,
    taxRateCode: f
  };
  ds.QCdmBreakEvenPoint = {
    id: p,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    breakEvenPoint: f,
    status: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extendInt1: f,
    extendInt2: f,
    extendLong1: f,
    extendLong2: f,
    extendDecimal1: f,
    extendDecimal2: f,
    extendDate: f,
    extendStr1: f,
    extendStr2: f,
    extendStr3: f
  };
  ds.QAmiTDepLoadCargo = {
    id: p,
    tkDepLoadId: f,
    cargoCode: f,
    api: f,
    loadedTemperature: f,
    shipFigsMt: f,
    shipFigsBbl: f,
    blFigsMt: f,
    blFigsBbl: f,
    soLoadingRate: f,
    srLoadingRate: f,
    obqExcludingSlop: f,
    slopOnboard: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFinInterfaceSend = {
    receiptSummary: f,
    id: p,
    interfaceConfigId: f,
    bizId: f,
    bizType: f,
    interfaceName: f,
    sendTime: f,
    sendCount: f,
    sendContent: f,
    receiveContent: f,
    receiveTime: f,
    interfaceUrl: f,
    interfaceStatus: f,
    errorMessage: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSysAclColumn = {
    id: p,
    aclTableId: f,
    dataType: f,
    columnName: f,
    columnDesc: f,
    appId: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QComPaymentApplication = {
    payeeAccountNo: f,
    contractType: f,
    dueDate: f,
    paymentPriority: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    vesselCode: f,
    createTimeZone: f,
    payeeId: f,
    id: p,
    settleOfficeCode: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    particular: f,
    baseCurrencyName: f,
    baseAmount: f,
    paidType: f,
    paymentNo: f,
    createOffice: f,
    createOfficeName: f,
    createName: f,
    vesselName: f,
    settleStatus: f,
    contractNo: f,
    invalidUserName: f,
    settleAmount: f,
    settleOfficeName: f,
    readTime: f,
    remark: f,
    readUser: f,
    invalidTime: f,
    supplierCode: f,
    freightType: f,
    payeeName: f,
    invalidUser: f,
    ispFleetCode: f,
    currencyName: f,
    principalOrgCode: f,
    baseExchangeRate: f,
    meansOfPayment: f,
    voyageNo: f,
    approvalStatus: f,
    supplierName: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    subjectTitle: f,
    handleUserName: f,
    paidRemark: f,
    readFlag: f,
    lastModifyByName: f,
    paidParticular: f,
    baseCurrencyCode: f,
    payeeBankName: f,
    createTime: f,
    readUserName: f,
    lastModifyTime: f,
    currencyCode: f,
    shareStatus: f,
    pdaBalanceAmount: f,
    invoiceAmount: f,
    pdaBalanceFlag: f,
    pdaAmount: f,
    sendDate: f,
    sendUser: f,
    voucherNo: f,
    shareAuditor: f,
    sendFlag: f,
    sendUserName: f,
    shareAuditInfo: f,
    shareAuditDate: f,
    apNo: f,
    imageNo: f,
    exTaxation: f,
    taxRate: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    shareReturnDate: f,
    adjustPayeeId: f,
    adjustPayeeAccountNo: f,
    adjustPayeeName: f,
    adjustPayeeBankName: f,
    workflowRestartFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    supplierNameEn: f,
    settleOfficeNameEn: f,
    internalArCode: f,
    payeeSwiftCode: f,
    adjustPayeeSwiftCode: f,
    stcBaoBeiId: f,
    handleTaskNode: f,
    invalidReason: f,
    comPaymentInvoice: new c("ComPaymentInvoice"),
    comPaymentActualDetail: new c("ComPaymentActualDetail")
  };
  ds.QOpsVoyagePoint = {
    corp: f,
    opsVoyageTaskId: f,
    pointName: f,
    cargoCode: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    passtime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    pointCode: f,
    lastModifyOfficeName: f,
    pointFlag: f,
    lastModifyByName: f,
    createOffice: f,
    cargoName: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    qty: f,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QAmiBRedelivery = {
    id: p,
    baseInfoId: f,
    redeliveryTmLoc: f,
    redeliveryTmWor: f,
    place: f,
    charterer: f,
    shipOwner: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    remark: f,
    loaDisDamageFlag: f,
    holdsuncleaningFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QChrPlanTran = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    companyName: f,
    companyNameEn: f,
    companyCode: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    planYear: f,
    dataType: f,
    planQuarter: f,
    netTce: f,
    grossTce: f,
    hireDay: f,
    hireRate: f,
    commRate: f,
    commFee: f,
    netIncome: f,
    grossIncome: f,
    hireBeginDate: f,
    hireEndDate: f,
    voyageDay: f
  };
  ds.QChrSettlementCommission = {
    id: p,
    commission: f,
    billStandards: f,
    despatchCommission: f,
    despatchBillStandards: f,
    commDesc: f,
    commPayer: f,
    brokerCode: f,
    brokerName: f,
    type: f,
    totalCommission: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QComCmllaytimeDeduct = {
    deductReason: f,
    deductType: f,
    remark: f,
    deductDisputeSolve: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    cmllaytimeId: f,
    ispFleetCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    deductIndex: f,
    deductTime: f,
    deductAdjust: f,
    deductEndDate: f,
    lastModifyByName: f,
    deductBeginDate: f,
    cmllaytimePortId: f,
    deductBeginWeek: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    deductFinaltime: f,
    deductEndWeek: f,
    deductDisputeType: f,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    deductTerms: f,
    deductBeginRemark: f,
    deductEndRemark: f,
    deductTimeSecond: f
  };
  ds.QSysUserOfficeAcl = {
    id: p,
    userId: f,
    officeId: f,
    resourceId: f,
    creator: f,
    creatorName: f,
    createOffice: f,
    createOfficeName: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    sysRoleId: f,
    conditio: f,
    conditionSql: f,
    crudType: f,
    tableName: f,
    appId: f,
    appCode: f,
    deletedFlag: f
  };
  ds.QComInvoiceReceiptDetail = {
    dueDate: f,
    settleAmount: f,
    bankCharges: f,
    remark: f,
    settleDate: f,
    lastModifyTimeZone: f,
    settleArFlag: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    bankAccount: f,
    lastModifyOffice: f,
    creator: f,
    remittanceDate: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    invoiceId: f,
    invoiceApproveId: f,
    createName: f,
    exchangeRate: f,
    fimagenumber: f,
    unsettleAmount: f,
    hedgeDate: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QStcSeq = {
    date: f,
    companyCode: f,
    lastModifyOffice: f,
    creator: f,
    noType: f,
    lastModifyBy: f,
    seqNo: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    systemCode: f
  };
  ds.QAmiGArrivalPilot = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    amiId: f,
    pobLt: f,
    dopLt: f,
    remarks: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QCdmVesselConstruction = {
    id: p,
    vesselGeneralId: f,
    structDoBottExcer: f,
    structUoDeckExccross: f,
    structDoBottHeight: f,
    structDoBottEngroom: f,
    structFrameSpace: f,
    structLongitudinalSpace: f,
    rudderType: f,
    rudderHeight: f,
    rudderBreadth: f,
    rudderWeight: f,
    hatchCoverType: f,
    hatchCoverOpenningMethods: f,
    cranes: f,
    grabs: f,
    mainEngOut: f,
    mainEngOutFolReq: f,
    auxEngOut: f,
    auxEngOutFolReq: f,
    generatorsCapacity: f,
    propellerMaterial: f,
    propellerDiameter: f,
    propellerPitch: f,
    propellerWeight: f,
    propellerShaftSize: f,
    propellerShaftWeight: f,
    propellerShaftLube: f,
    ntermediateShaftSize: f,
    intermeediateShaftWeight: f,
    boilerType: f,
    boilerPressCapacity: f,
    boilerFoReq: f,
    fwGeneratorType: f,
    fwGeneratorCapacity: f,
    mainEngEedi: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    mainEngType: f,
    propellerShaftDiameter: f,
    propellerType: f,
    rudderMaker: f,
    propeller: f,
    sternTubeSeals: f,
    auxEngType: f,
    auxBoiler: f
  };
  ds.QTableColumnInfo = {
    id: p,
    tableId: f,
    fieldName: f,
    columnName: f,
    columnChineseName: f,
    jdbcType: f,
    columnLength: f,
    columnScale: f,
    javaTypeName: f,
    commonFieldType: f,
    syncFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSpsMaterialUseInfo = {
    id: p,
    vesselId: f,
    vesselCode: f,
    useType: f,
    locationId: f,
    referenceId: f,
    qty: f,
    prosQty: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    materialType: f,
    devModel: f,
    supplierId: f,
    devCode: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    supplierNameEn: f,
    vesselNameCn: f,
    supplierNameCn: f,
    devNameEn: f,
    devNameCn: f,
    vesselNameEn: f,
    devInfoId: f,
    devSerialNo: f,
    dept: f,
    devMakerId: f
  };
  ds.QCdmVesselDavit = {
    id: p,
    vesselGeneralId: f,
    davitItem: f,
    davitSpecifications: f,
    davitWorkingRadius: f,
    davitDriving: f,
    davitLocation: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QMtrStoresClass = {
    storesClassId: p,
    classCode: f,
    classFlag: f,
    classNameCn: f,
    classNameEn: f,
    remark: f,
    firstClassCode: f,
    createdByUser: f,
    createdOffice: f,
    createdDtmLoc: f,
    createdTimeZone: f,
    updatedByUser: f,
    updatedOffice: f,
    updatedDtmLoc: f,
    updatedTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    parentId: f
  };
  ds.QComArInvoiceAllDtl = {
    id: p,
    invoiceId: f,
    seqNo: f,
    vesselCode: f,
    vesselName: f,
    voyageNo: f,
    chargeCode: f,
    chargeName: f,
    contractNo: f,
    contractName: f,
    bunkerSpec: f,
    quantity: f,
    unit: f,
    unitPrice: f,
    rpType: f,
    currencyCode: f,
    amount: f,
    exchangeRate: f,
    invoiceAmount: f,
    settleAmount: f,
    businessDate: f,
    portCode: f,
    portName: f,
    period: f,
    calCommissionFlag: f,
    substituteFlag: f,
    substitutePartnerCode: f,
    substitutePartnerName: f,
    substituteAmount: f,
    freightOfficeCode: f,
    freightOfficeName: f,
    finType: f,
    particular: f,
    remark: f,
    ledgerItemId: f,
    ledgerItemTable: f,
    activeFlag: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    docNo: f,
    ext1: f,
    ext2: f,
    ext3: f,
    ext4: f,
    ext5: f,
    ext6: f,
    ext7: f,
    ext8: f,
    ext9: f,
    ext10: f,
    startTime: f,
    endTime: f,
    discount: f,
    discountAmount: f,
    discountBaseAmount: f,
    pdaDiscountAmount: f,
    diffAmount: f,
    departmentGroup: f,
    spareStoreType: f,
    taxFlag: f,
    taxRate: f,
    titleRemark: f,
    titleGroup: f,
    autoFlag: f,
    importFlag: f,
    titleGroupSub: f,
    contractId: f,
    contractType: f,
    offsetId: f,
    dueFeeId: f,
    voyageCostFlag: f,
    installment: f,
    portId: f,
    exTaxation: f,
    baseAmount: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    seqNoChild: f,
    rollFeeId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    substitutePartnerNameEn: f,
    freightOfficeNameEn: f,
    vesselNameEn: f,
    portNameEn: f,
    chargeNameEn: f,
    claimNo: f,
    claimFlag: f
  };
  ds.QFineProcessMessage = {
    id: p,
    alltaskid: f,
    deadline: f,
    processed: f,
    taskid: f
  };
  ds.QChrPreSettlementCommission = {
    id: p,
    commission: f,
    billStandards: f,
    despatchCommission: f,
    despatchBillStandards: f,
    commDesc: f,
    totalCommission: f,
    commPayer: f,
    brokerCode: f,
    brokerName: f,
    type: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineBaseOutput = {
    id: p,
    actionname: f,
    executebyuser: f,
    outputid: f,
    resulturl: f,
    runtype: f
  };
  ds.QFinePost = {
    id: f,
    tenantid: f,
    alias: f,
    creationtype: f,
    description: f,
    enable: f,
    lastoperationtype: f,
    name: f
  };
  ds.QSysLoginRecord = {
    id: p,
    ip: f,
    os: f,
    browser: f,
    usrName: f,
    usrId: f,
    isSuccess: f,
    errorMessage: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    officeName: f,
    companyName: f,
    usrNameEn: f,
    officeId: f,
    roleCode: f,
    companyCode: f,
    roleId: f,
    companyNameEn: f,
    officeCode: f,
    roleNameEn: f,
    companyId: f,
    roleName: f,
    officeNameEn: f,
    usrCode: f
  };
  ds.QAmiSofMain = {
    id: p,
    status: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    berth: f,
    callingPurpose: f,
    reportDate: f,
    timeZone: f,
    vygNo: f,
    cargoCode: f,
    cargoNameCn: f,
    cargoNameEn: f,
    quantity: f,
    remark: f,
    remark2: f,
    post: f,
    postNameCn: f,
    postNameEn: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    creatorNameCn: f,
    creatorNameEn: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reportNo: f
  };
  ds.QAmiBArrivalBack = {
    id: p,
    baseInfoId: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    endSailingTime: f,
    endMFoL: f,
    endMFoH: f,
    endMMgoH: f,
    endMMgoL: f,
    ataNor: f,
    ataMFoH: f,
    ataMFoL: f,
    ataMMgoH: f,
    ataMMgoL: f,
    ataMWater: f,
    macLuboilEng: f,
    macLuboilCyl: f,
    macLuboilGen: f,
    df: f,
    da: f,
    waterDensity: f,
    dailySailingRunDist: f,
    dailySailingRunTime: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    ttlWater: f,
    avgAFoH: f,
    avgAFoL: f,
    avgAMgoH: f,
    avgAMgoL: f,
    avgAWater: f,
    actSailingHrs: f,
    runDist: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    theoreticalSpd: f,
    slip: f,
    anchorTm: f,
    anchorDesc: f,
    anchorPosition: f,
    estBerthedTm: f,
    remark: f,
    fwe: f,
    asp: f,
    arrivedTime: f,
    remarkSea: f,
    dop: f,
    pob: f,
    etd: f,
    latitude: f,
    longitude: f,
    drifttime: f,
    trantime: f,
    distToquay: f,
    distToanch: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    anchorFoH: f,
    anchorFoL: f,
    anchorMgoH: f,
    anchorMgoL: f,
    anchorAWater: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasMLuboilEng: f,
    gasMLuboilGen: f,
    gasMLuboilCyl: f,
    avPuelMainH: f,
    avPuelMainL: f,
    avPuelAuxH: f,
    avPuelAuxL: f,
    avPuelBoilerH: f,
    avPuelBoilerL: f,
    avPuelIncH: f,
    avPuelIncL: f,
    avPuelSulphurH: f,
    avPuelSulphurL: f,
    avGasMainH: f,
    avGasMainL: f,
    avGasAuxH: f,
    avGasAuxL: f,
    avGasBoilerH: f,
    avGasBoilerL: f,
    avGasIncH: f,
    avGasIncL: f,
    avGasSulphurH: f,
    avGasSulphurL: f,
    avMLuboilEng: f,
    avMLuboilGen: f,
    avMLuboilCyl: f,
    puelTotalFoH: f,
    puelTotalFoL: f,
    gasTotalMgoH: f,
    gasTotalMgoL: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    foHConsumptionSum: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    lsfo1s: f,
    lsfo2s: f,
    lsfo3s: f,
    lsfo4s: f,
    lsfo1p: f,
    lsfo2p: f,
    lsfo3p: f,
    lsfo4p: f,
    lsfoSettling: f,
    lsfoService: f,
    lsfoOverflow: f,
    lsMdo: f,
    lsMgo: f,
    lsMgoSettling: f,
    lsMgoSpare: f,
    lsMgoService: f
  };
  ds.QOpsOilIncident = {
    lastModifyOffice: f,
    creator: f,
    incidentCode: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    incidentRemark: f,
    remark: f,
    bunkerId: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    incidentComplain: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QVscRecvTask = {
    id: p,
    vesselId: f,
    vesselCode: f,
    commType: f,
    contentType: f,
    businessType: f,
    recvFileName: f,
    batchNo: f,
    partCount: f,
    partIndex: f,
    fileName: f,
    fileSize: f,
    fileMd5: f,
    recvStatus: f,
    recvDtm: f,
    feedbackDtm: f,
    createTime: f,
    lastModifyTime: f,
    cdmVesselGeneral: new c("CdmVesselGeneral")
  };
  ds.QFineDataPortalLogMessage = {
    id: p,
    displayname: f,
    lastmessagetime: f,
    reportid: f,
    tname: f,
    type: f,
    userid: f,
    username: f
  };
  ds.QOpsVesselStatusOil = {
    id: p,
    opsVesselStatusId: f,
    oilType: f,
    oilQty: f,
    oilFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    dailyOilAe: f,
    dailyOilBoiler: f,
    dailyOilMe: f
  };
  ds.QCdmCodetype = {
    id: p,
    codeType: f,
    codeName: f,
    codeWidth: f,
    codeGrade: f,
    relateType: f,
    remark: f,
    activeFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    deletedFlag: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QQrtzBlobTriggers = {
    schedName: f,
    triggerGroup: f,
    triggerName: f,
    blobData: f
  };
  ds.QChrEstimateCargo = {
    cargoDesc: f,
    id: p,
    mainId: f,
    serialNumber: f,
    cargoType: f,
    pallets: f,
    palletsNo: f,
    cargoName: f,
    cargoCode: f,
    contractNo: f,
    quantity: f,
    quantityUnit: f,
    freightRate: f,
    freight: f,
    outAddrCommissonCargo: f,
    outbrokerCommissonCargo: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    loadPortName: f,
    contractStatus: f,
    palletsStatus: f,
    disPortName: f,
    otherIncome: f,
    chartererName: f,
    loadPort: f,
    disPort: f,
    numberType: f,
    palletsType: f,
    disPortNameEn: f,
    loadPortNameEn: f,
    freightType: f,
    flatRate: f,
    chartererCode: f,
    contractType: f,
    contractVersion: f,
    contractId: f,
    demurrageCharges: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    signSubjectCode: f,
    signSubjectName: f,
    signSubjectNameEn: f,
    chartererNameEn: f,
    cargoNameEn: f,
    isDanagerousCargo: f
  };
  ds.QComFeeMailConfig = {
    id: p,
    intervalDay: f,
    email: f,
    roleId: f,
    status: f,
    creator: f,
    createName: f,
    createOffice: f,
    createOfficeName: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QAmiTDepDischOilSupplited = {
    reservedDate: f,
    hsmgo: f,
    lsmgo: f,
    genLub: f,
    boWater: f,
    lastModifyTimeZone: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    tkDptDischId: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    doWater: f,
    reservedInt2: f,
    lastModifyOffice: f,
    creator: f,
    lsfo: f,
    lastModifyBy: f,
    hsfo: f,
    reservedLong2: f,
    cylLub: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    engLub: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f
  };
  ds.QComPaymentFinUserConfig = {
    id: p,
    ispFleetCode: f,
    freightType: f,
    vesselCode: f,
    vesselName: f,
    handleUser: f,
    handleUserName: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    vesselNameEn: f,
    rpType: f,
    invoiceType: f
  };
  ds.QSysPageConfig = {
    id: p,
    pageCode: f,
    pageName: f,
    dataType: f,
    dataValue: f,
    pageJson: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QChrContractFreightHistory = {
    id: p,
    ispFleetCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractId: f,
    contractVersion: f,
    contractType: f,
    freightTypeBefore: f,
    freightFeeBefore: f,
    freightRateBefore: f,
    cargoQuantityBefore: f,
    freightType: f,
    freightFee: f,
    freightRate: f,
    cargoQuantity: f,
    adjustType: f,
    invoiceId: f,
    invoiceNo: f
  };
  ds.QActHiActinst = {
    id: p,
    procDefId: f,
    procInstId: f,
    executionId: f,
    actId: f,
    taskId: f,
    callProcInstId: f,
    actName: f,
    actType: f,
    assignee: f,
    startTime: f,
    endTime: f,
    duration: f,
    deleteReason: f,
    tenantId: f
  };
  ds.QChrMarketFreightIndex = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    averageRate: f,
    indexCode: f,
    tceVolume: f,
    priceVolume: f,
    tceValue: f,
    indexDate: f,
    priceRange: f,
    indexValue: f,
    tceRange: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QRipBusinessEval = {
    businessId: f,
    remark: f,
    distribution: f,
    averageScore: f,
    lastModifyTimeZone: f,
    vesselId: f,
    businessNo: f,
    recordVersion: f,
    quote: f,
    price: f,
    vesselNameCn: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    id: p,
    vesselNameEn: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    evalDate: f,
    rater: f,
    totalScore: f,
    quality: f,
    amountStandard: f,
    bussinessType: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    applyMainId: f,
    afterSale: f,
    orderDate: f,
    ripBaseInfoId: f
  };
  ds.QOpsVoyageCargo = {
    opsVoyageTaskId: f,
    blNo: f,
    cargoCode: f,
    lastModifyTimeZone: f,
    perDisQty: f,
    recordVersion: f,
    createTimeZone: f,
    api: f,
    id: p,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    bsW: f,
    contractQty: f,
    lgNo: f,
    unloadQty: f,
    createOffice: f,
    cargoName: f,
    createOfficeName: f,
    cloudPoint: f,
    ldSts: f,
    createName: f,
    planQty: f,
    contractNo: f,
    remark: f,
    freightType: f,
    contractVersion: f,
    heatingCargo: f,
    ispFleetCode: f,
    blDate: f,
    principalOrgCode: f,
    company: f,
    loadQty: f,
    lastModifyOffice: f,
    creator: f,
    temp: f,
    cargoQty: f,
    portCode: f,
    lastModifyByName: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    pourPoint: f,
    originArea: f,
    portName: f,
    portSequence: f,
    seqNo: f,
    cargoUnit: f,
    tfPortCode: f,
    tfPortName: f,
    tfPortNameEn: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    cargoNameEn: f,
    originAreaName: f,
    originAreaNameEn: f,
    blFlag: f,
    maxCargo: f,
    opsVoyageCargoDis: new c("OpsVoyageCargoDis")
  };
  ds.QStcChargeConfig = {
    id: p,
    companyId: f,
    deptId: f,
    bussinessCode: f,
    bussinessName: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QEntryExitMechan = {
    id: p,
    vesselCode: f,
    vesselNmCn: f,
    poolContNo: f,
    shipOwnerNmCn: f,
    entryExitSign: f,
    entryExitTime: f,
    delReturnShipPlace: f,
    status: f,
    hsfoPrice: f,
    lsfoPrice: f,
    hsmgoPrice: f,
    lsmgoPrice: f,
    remark: f,
    relHsfo: f,
    relHsfoPrice: f,
    relHsfoRefuelTime: f,
    relLsfo: f,
    relLsfoPrice: f,
    relLsfoRefuelTime: f,
    relHsmgo: f,
    relHsmgoPrice: f,
    relHsmgoRefuelTime: f,
    relLsmgo: f,
    relLsmgoPrice: f,
    relLsmgoRefuelTime: f,
    relRemark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QXtDocument = {
    fileid: p,
    referenceid: f,
    filetype: f,
    filecontenttype: f,
    filetitle: f,
    filename: f,
    filesize: f,
    remarkinfo: f,
    filecontent: f
  };
  ds.QSysReleaseRecord = {
    id: p,
    upgradeVersion: f,
    theme: f,
    publisher: f,
    releaseTime: f,
    content: f,
    remark: f,
    createTime: f,
    createTimeZone: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyBy: f,
    recordVersion: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f
  };
  ds.QComFeeRemind = {
    id: p,
    level1: f,
    levelCode1: f,
    level2: f,
    levelCode2: f,
    parentId: f,
    days: f,
    prefix: f,
    roleId: f,
    isEnable: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    lastModifyByName: f,
    createName: f,
    lastModifyOffice: f,
    orderNo: f,
    lastModifyOfficeName: f,
    sequence: f,
    createOfficeName: f
  };
  ds.QActRuVariable = {
    id: p,
    rev: f,
    type: f,
    name: f,
    executionId: f,
    procInstId: f,
    taskId: f,
    bytearrayId: f,
    double: f,
    long: f,
    text: f,
    text2: f
  };
  ds.QComPortChargeDetail = {
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    comPortChargeHeaderId: f,
    discountAmount: f,
    discount: f,
    remark: f,
    lastModifyByName: f,
    discountBaseAmount: f,
    baseAmount: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    chargeName: f,
    createName: f,
    chargeCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    exTaxation: f,
    baseExTaxation: f,
    discountNotaxAmount: f,
    discountBaseNotaxAmount: f,
    taxRate: f,
    chargeNameEn: f,
    claimNo: f,
    claimFlag: f,
    vesselBuildFlag: f,
    inCostFlag: f,
    dockRepairFlag: f
  };
  ds.QOpsPortAgt = {
    fleet: f,
    agentType: f,
    agentCode: f,
    localAgentName: f,
    remark: f,
    opsVoyagePortId: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    localAgentCode: f,
    createTimeZone: f,
    id: p,
    fax: f,
    email: f,
    agentFeePay: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    agentName: f,
    telephone: f,
    lastModifyByName: f,
    chrgName: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    createName: f,
    agentBy: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    localAgentNameEn: f,
    chrgNameEn: f,
    agentNameEn: f
  };
  ds.QFinSettlementReportVessel = {
    id: p,
    mainId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselCode: f,
    vesselName: f,
    vesselSource: f,
    vesselStatus: f,
    commander: f,
    voyageStatus: f,
    voyageStartDate: f,
    voyageEndDate: f,
    voyageDateText: f,
    retireDate: f,
    checkPassStatus: f,
    checkReason: f,
    deletedFlag: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    taskId: f,
    contractType: f,
    contractNo: f
  };
  ds.QAmiTDptDischPortDelay = {
    id: p,
    tkDptDischId: f,
    delayFmTm: f,
    delayToTm: f,
    delayReason: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QChrVlocEstimateFuel = {
    id: p,
    mainId: f,
    vesselName: f,
    vesselNameEn: f,
    vesselCode: f,
    voyageNo: f,
    hsfoConsumptionQty: f,
    hsfoAveragePrice: f,
    hsfoConsumptionAmount: f,
    hsfoEstimateAmount: f,
    hsfoAmount: f,
    lsfoConsumptionQty: f,
    lsfoAveragePrice: f,
    lsfoConsumptionAmount: f,
    lsfoEstimateAmount: f,
    lsfoAmount: f,
    hsmgoConsumptionQty: f,
    hsmgoAveragePrice: f,
    hsmgoConsumptionAmount: f,
    hsmgoEstimateAmount: f,
    hsmgoAmount: f,
    lsmgoConsumptionQty: f,
    lsmgoAveragePrice: f,
    lsmgoConsumptionAmount: f,
    lsmgoEstimateAmount: f,
    lsmgoAmount: f,
    totalBunkerExpense: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    detailId: f,
    lsfoEstimateConsumptionQty: f,
    lsmgoEstimateConsumptionQty: f,
    hsfoEstimateConsumptionQty: f,
    hsmgoEstimateConsumptionQty: f
  };
  ds.QStcReceivePlan = {
    id: p,
    receiveRegisterId: f,
    amount: f,
    baseAmount: f,
    receiveDate: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFinInsuranceEstimate = {
    id: p,
    ispFleetCode: f,
    ispFleetName: f,
    ispFleetNameEn: f,
    statisticalMonth: f,
    hmCount: f,
    ivCount: f,
    warCount: f,
    piCount: f,
    fddCount: f,
    invoicedCount: f,
    completeCount: f,
    universalCount: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    insYears: f,
    insuranceDetails: new c("FinInsuranceDetail")
  };
  ds.QOpsInsPfagreementVsl = {
    id: p,
    vesselCode: f,
    ispFleetCode: f,
    vesselGwt: f,
    advanceCallRate: f,
    adjustmentRate: f,
    adjustmentAmount: f,
    brokerRate: f,
    brokerComm: f,
    delDate: f,
    redDate: f,
    totalDays: f,
    ownerPni: f,
    etcRate: f,
    insDay: f,
    finType: f,
    contractType: f,
    imo: f,
    class1: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    remark: f,
    tax: f,
    opsInsPfagreementId: f,
    vesselName: f,
    beginTime: f,
    endTime: f,
    surrender: f,
    quitDate: f,
    invoiceId: f,
    afterB2bPremium: f,
    b2bDiscount: f,
    fddGrossPremium: f,
    supplementaryAmount: f,
    estTotalCall: f,
    piGrossPremium: f,
    advanceCallAmount: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    insAgreement: f,
    builtDate: f,
    supplementaryRate: f
  };
  ds.QOpsOilStockSequence = {
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    lastModifyByName: f,
    oilProcessingStatus: f,
    lastModifyTimeZone: f,
    preSequenceOperationTime: f,
    sequence: f,
    voyageType: f,
    preSequenceOperation: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    vesselCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    vesselName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QChrPreSettlementPortFee = {
    id: p,
    mainId: f,
    portPurpose: f,
    portCode: f,
    portName: f,
    invoiceDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    estimatedPortDues: f,
    actualPortDues: f,
    portFeeIsAll: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f
  };
  ds.QOpsOilStockFlow = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselName: f,
    vesselCode: f,
    voyageNo: f,
    voyageType: f,
    operationNo: f,
    batchNo: f,
    unitPrice: f,
    bunkerSpec: f,
    operatingCompany: f,
    operatingCompanyCode: f,
    stockStatus: f,
    dataSource: f,
    operationType: f,
    quantity: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QOpsDryDockRepairReport = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    distance: f,
    speed: f,
    bunkerCost: f,
    opsVoyageTaskId: f,
    discountBunkerCost: f,
    reportTime: f,
    startPort: f,
    startPortCode: f,
    endPort: f,
    endPortCode: f,
    startTime: f,
    endTime: f,
    endTimeZone: f,
    startTimeZone: f,
    sysCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    endPortEn: f,
    opUserName: f,
    startPortEn: f,
    totalPdaCost: f,
    managerUserCode: f,
    opUserCode: f,
    voyageRemark: f,
    opUserNameEn: f,
    totalBunkerCost: f,
    managerUserNameEn: f,
    managerUserName: f
  };
  ds.QFinePrintOffsetIpRelate = {
    id: p,
    childip: f,
    motherid: f
  };
  ds.QFineWorkflow = {
    id: p,
    createtime: f,
    creatorid: f,
    description: f,
    name: f,
    nodesid: f
  };
  ds.QChrMarketIndexValue = {
    id: p,
    indexCode: f,
    indexRounte: f,
    reportTime: f,
    currency: f,
    indexType: f,
    indexValue: f,
    recordStatus: f,
    sno: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineWorkflowStashData = {
    id: p,
    data: f,
    reportpath: f,
    taskid: f,
    userid: f
  };
  ds.QChrEstimatePort = {
    id: p,
    mainId: f,
    portSequence: f,
    portCode: f,
    portName: f,
    workType: f,
    portDistance: f,
    weatherFactors: f,
    speed: f,
    seaDays: f,
    ldDays: f,
    lowSulfurArea: f,
    isLowSulfurArea: f,
    isShipCrane: f,
    notworkDays: f,
    workDays: f,
    portDays: f,
    portExpense: f,
    lodDisFee: f,
    timeZone: f,
    eta: f,
    etd: f,
    liftingFee: f,
    bindingFee: f,
    rulingFee: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    lowSulfurAreaDay: f,
    portNameEn: f,
    dispatchCharges: f,
    demurrageCharges: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    workEfficiency: f,
    overloadFlag: f
  };
  ds.QActGeBytearray = {
    id: p,
    rev: f,
    name: f,
    deploymentId: f,
    bytes: f,
    generated: f
  };
  ds.QFineDataPortalCustom = {
    id: p,
    content: f,
    portalid: f,
    time: f,
    userid: f
  };
  ds.QActDeDatabasechangeloglock = {
    id: p,
    locked: f,
    lockgranted: f,
    lockedby: f
  };
  ds.QRipBankInfo = {
    lastModifyOffice: f,
    country: f,
    creator: f,
    lastModifyBy: f,
    countryNameCn: f,
    swiftCode: f,
    corrBankSwiftCode: f,
    bankAddress: f,
    countryNameEn: f,
    lastModifyTimeZone: f,
    payee: f,
    corrBankAccount: f,
    recordVersion: f,
    payType: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    receivingBankAccount: f,
    receivingBank: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    id: p,
    corrBank: f,
    ripBaseInfoId: f,
    validFlag: f,
    remark: f,
    typ: f,
    corrCountry: f,
    bankNo: f,
    ripCode: f,
    auditDate: f,
    bankInfo: f,
    auditor: f,
    hcbId: f,
    bankOther: f,
    corrAddress: f,
    payeeAddress: f,
    corrCountryNameEn: f,
    auditStatus: f,
    billflag: f,
    bankCode: f,
    corrCountryNameCn: f,
    prohibitedStatus: f
  };
  ds.QActDeModelRelation = {
    id: p,
    parentModelId: f,
    modelId: f,
    relationType: f
  };
  ds.QStcPreparedBiding = {
    id: p,
    relationBusniessId: f,
    operationMode: f,
    domesticOrForeigh: f,
    nonTenderType: f,
    nonTenderRemark: f,
    uploadFlag: f,
    preparedReceipt: f,
    preparedFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deleteFlag: f
  };
  ds.QFineWorkflowTaskImpl = {
    id: p,
    alerted: f,
    completestate: f,
    createtime: f,
    currentnodeidx: f,
    deadline: f,
    frtaskid: f,
    name: f,
    needallcomplete: f,
    noderoute: f,
    note: f,
    operatorjson: f,
    operatoroffset: f,
    operatoroffsetname: f,
    parentid: f,
    processid: f,
    reportoffset: f,
    sendtime: f,
    sender: f,
    senderid: f,
    sontaskid: f,
    state: f,
    taskbacktarget: f,
    taskid: f
  };
  ds.QPurchaseFaiInventory = {
    id: p,
    beginDate: f,
    endDate: f,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    currency: f,
    baseCurrency: f,
    preAmountStandardSend: f,
    preAmountStandardUnSend: f,
    curInAmountStandardSend: f,
    curInAmountStandardUnSend: f,
    curOutAmountStandardSend: f,
    curOutAmountStandardUnSend: f,
    aftAmountStandardSend: f,
    aftAmountStandardUnSend: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSysUser = {
    defaultOfficeName: f,
    passwordModifyTime: f,
    emailPassword: f,
    principalGroupCode: f,
    employeeNo: f,
    uuid: f,
    vesselId: f,
    lastModifyTimeZone: f,
    password: f,
    recordVersion: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    defaultOfficeId: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    userRoleOfficeId: f,
    hcbCode: f,
    ipAddress: f,
    macAddress: f,
    defaultRoleName: f,
    createOffice: f,
    createOfficeName: f,
    loginErrorTime: f,
    superAdminFlag: f,
    validFlag: f,
    creatorName: f,
    defaultRoleCode: f,
    leaderUserNameEn: f,
    remark: f,
    leaderUserCode: f,
    boardingTime: f,
    userNameCn: f,
    userCode: f,
    leaderUserName: f,
    reservedStr4: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    defaultLanguage: f,
    reservedStr5: f,
    defaultRoleId: f,
    passwordModifyFlag: f,
    lastModifyOffice: f,
    creator: f,
    userName: f,
    invalidDate: f,
    lastModifyByName: f,
    defaultOfficeCode: f,
    userNameEn: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    errorTimes: f,
    manageWorkType: f,
    loginName: f,
    seqNo: f,
    employee: new c("SysEmployee")
  };
  ds.QNodeSeqLogCopy1 = {
    id: f,
    modelLogId: f,
    currActivityId: f,
    preActivityId: f
  };
  ds.QChrContractRent = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    deliveryRemark: f,
    rentType: f,
    deliveryBeginDate: f,
    ladenLegsRemark: f,
    isLadenLegs: f,
    deliveryEndDate: f,
    periodUnit: f,
    periodMin: f,
    periodMax: f,
    periodFloat: f,
    periodFloatUnit: f,
    paymentFrequencyUnit: f,
    paymentFrequency: f,
    periodRemark: f,
    ballastCompType: f,
    depositeMode: f,
    depositeRentDays: f,
    ballastComp: f,
    cve: f,
    cveDesc: f,
    cveUnit: f,
    ballastCompDesc: f,
    ilohc: f,
    ilohcDesc: f,
    rentDesc: f,
    contractVersion: f,
    compareMode: f,
    indexCompMode: f,
    indexCalcMode: f,
    isIndexRange: f,
    contractNo: f,
    contractId: f,
    ispFleetCode: f,
    rentNature: f,
    rentNatureRemark: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chrContractRentIndexLink: new c("ChrContractRentIndexLink"),
    chrContractRentIndexRange: new c("ChrContractRentIndexRange"),
    chrContractRentPeriod: new c("ChrContractRentPeriod")
  };
  ds.QFineSwiftSegLocation = {
    clusterid: f,
    segmentid: f,
    sourcekey: f
  };
  ds.QVscSequence = {
    id: p,
    vesselId: f,
    vesselCode: f,
    fileType: f,
    logSeq: f,
    lockFlag: f,
    lockTime: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QComPortPda = {
    basePaymentAmount: f,
    partnerCode: f,
    contractType: f,
    contractNo: f,
    agentCode: f,
    comPortChargeHeaderId: f,
    dueDate: f,
    remark: f,
    submitFlag: f,
    portName: f,
    paymentAmount: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    currencyName: f,
    exchangeRate: f,
    checkUserName: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    offsetAmount: f,
    lastModifyOfficeName: f,
    partnerName: f,
    agentName: f,
    paymentApplicationId: f,
    docNo: f,
    checkDate: f,
    baseCurrencyName: f,
    balanceAmount: f,
    portCode: f,
    lastModifyByName: f,
    checkFlag: f,
    checkUser: f,
    baseCurrencyCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    currencyCode: f,
    createName: f,
    vesselName: f,
    fdaInvoiceNo: f,
    suspendFlag: f,
    balanceRemark: f,
    pdaType: f,
    recInvoiceNo: f,
    recInvoiceId: f,
    fdaInvoiceId: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    agentNameEn: f,
    vesselNameEn: f,
    partnerNameEn: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    settleOfficeNameEn: f,
    voyagePortId: f,
    newPortCode: f,
    newVoyageNo: f,
    oldVesselCode: f,
    oldPortNameEn: f,
    changePortApprovalStatus: f,
    oldVesselNameEn: f,
    newPortName: f,
    oldVesselName: f,
    oldPortSequence: f,
    newPortNameEn: f,
    newVesselName: f,
    newVesselNameEn: f,
    oldPortCode: f,
    changePortRemark: f,
    oldPortName: f,
    changePortId: f,
    oldVoyageNo: f,
    newVesselCode: f,
    newPortSequence: f,
    changePortImageNo: f,
    comPortPdaOffsetRelate: new c("ComPortPdaOffsetRelate"),
    comPortPdaChargeDetail: new c("ComPortPdaChargeDetail")
  };
  ds.QSpsChargeConfigDtl = {
    id: p,
    chargeConfigId: f,
    chargeCodeId: f,
    chooseFlag: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QJob = {
    id: p,
    scheduleCode: f,
    cron: f,
    threadType: f,
    scheduleType: f,
    shardCount: f,
    timeout: f,
    enabled: f,
    description: f,
    createTime: f,
    updateTime: f
  };
  ds.QAmiMonthOilMain = {
    id: p,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    senddate: f,
    ischeckOpn: f,
    checkerOpn: f,
    checkdateOpn: f,
    isCheckTkrFlag: f,
    checkerTkr: f,
    checkdateTkr: f,
    isCheckSupFlag: f,
    checkerSup: f,
    checkdateSup: f,
    type: f,
    isCheckFinFlag: f,
    checkerFin: f,
    checkdateFin: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselEnName: f,
    vesselCnName: f,
    rhTkrHeckDate: f,
    asdLockDate: f,
    spyCheck: f,
    rhTkrHeckUser: f,
    opnCheckUser: f,
    asdLockUser: f,
    loTkrHeckUser: f,
    asdLock: f,
    opnCheck: f,
    spyCheckDate: f,
    loTkrHeckDate: f,
    spyCheckUser: f,
    rhTrkCheck: f,
    loTrkCheck: f,
    opnCheckDate: f,
    amiMonthOilLube: new c("AmiMonthOilLube"),
    amiMonthRunTime: new c("AmiMonthRunTime"),
    amiMonthOilCargo: new c("AmiMonthOilCargo")
  };
  ds.QAmiSuppliedFuelOldBackup = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    waterContent: f,
    density: f,
    temperature: f,
    bdnNo: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    bargeAlongsideTm: f,
    hoseConnectedTm: f,
    commencedPumpingTm: f,
    hoseDisconnectedTm: f,
    bargeOffTm: f,
    bargeName: f
  };
  ds.QComCmllaytime = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    demurrageRateUnit: f,
    dispatchRateUnit: f,
    layType: f,
    contractNo: f,
    cargoCode: f,
    customerCode: f,
    checker: f,
    loadEfficiency: f,
    checkName: f,
    contractVersion: f,
    checkStatus: f,
    ldTotalFlag: f,
    dischargeEfficiencyUnit: f,
    vesselCode: f,
    demurrageRate: f,
    voyageNo: f,
    ldTotalUnit: f,
    loadEfficiencyUnit: f,
    cargoQuantity: f,
    demuDispTermCode: f,
    customerName: f,
    dispatchRate: f,
    checkTime: f,
    cargoName: f,
    ldTotal: f,
    contractId: f,
    dischargeEfficiency: f,
    vesselName: f,
    ispFleetCode: f,
    receiverCode: f,
    receiverName: f,
    invoicerName: f,
    invoicerCode: f,
    totalAmount: f,
    vesselSource: f,
    currency: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    customerNameEn: f,
    vesselNameEn: f,
    invoicerNameEn: f,
    cargoNameEn: f,
    receiverNameEn: f
  };
  ds.QActDeModelCopy1 = {
    id: p,
    name: f,
    modelKey: f,
    description: f,
    modelComment: f,
    created: f,
    createdBy: f,
    lastUpdated: f,
    lastUpdatedBy: f,
    version: f,
    modelEditorJson: f,
    svgImg: f,
    thumbnail: f,
    modelType: f,
    modelProjectName: f,
    modelClass: f,
    modelProjectId: f
  };
  ds.QStcCpGeneralTerm = {
    id: p,
    cpNm: f,
    cpNo: f,
    syear: f,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    officeId: f,
    officeNameCn: f,
    officeNameEn: f,
    cpType: f,
    cpSeq: f,
    ownerCompanyId: f,
    ownerCompanyNameCn: f,
    ownerCompanyNameEn: f,
    cpObject: f,
    clearAmountFlag: f,
    amountStandard: f,
    cpAmount: f,
    cpCurrency: f,
    rate: f,
    effectiveDate: f,
    effectiveDesc: f,
    endDate: f,
    terminationDate: f,
    bidDate: f,
    cpPeriod: f,
    applicableLaw: f,
    effectConditions: f,
    signPlace: f,
    signDate: f,
    mainTerms: f,
    cpMainClass: f,
    cpSubClass: f,
    emergencyLevel: f,
    moneyFlow: f,
    assureFlag: f,
    assureNm: f,
    cpCount: f,
    foreignCpFlag: f,
    relateCpNo: f,
    oppSignerId: f,
    oppSignerNameEn: f,
    oppSignerNameCn: f,
    majorCpFlag: f,
    cpVersion: f,
    cpAuditStatus: f,
    cpStatus: f,
    relateVesselType: f,
    relateBizType: f,
    lawCheck: f,
    sanctionComplianceType: f,
    ownerFiles: f,
    oppPartyFiles: f,
    signerName: f,
    troubleFlag: f,
    sendLegal: f,
    sendDate: f,
    sendMessage: f,
    archFlag: f,
    endNoticeFlag: f,
    cpNoOpp: f,
    majorCpForCompanyFlag: f,
    secretFlag: f,
    jurisdictionArea: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creatorNameCn: f,
    creatorNameEn: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    vesselIds: f,
    vesselCodes: f,
    vesselNameCns: f,
    vesselNameEns: f,
    nonLawExamine: f,
    dataType: f,
    businessNo: f,
    businessId: f
  };
  ds.QRightShip = {
    id: p,
    imo: f,
    name: f,
    safetyRating: f,
    safetyRatingType: f,
    ghgRating: f,
    isGhgRatingPlus: f,
    isGhgGatingVerified: f,
    ghgRatingWeight: f,
    ageForInspection: f,
    dwtFoInspection: f,
    shipTypeId: f,
    shipType: f,
    dwt: f,
    dateOfBuild: f,
    age: f,
    updateTime: f,
    vesselId: f,
    managerId: f,
    managerNameEn: f,
    managerNameCn: f,
    deletedFlag: f,
    ratingTime: f
  };
  ds.QCdmTest = {
    id: p,
    vesselId: f,
    vesselCode: f,
    test1: f,
    test2: f,
    test3: f,
    test4: f,
    test5: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QChrContractEstimate = {
    id: p,
    ispFleetCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractId: f,
    contractVersion: f,
    contractType: f,
    estimateId: f,
    estimateNo: f,
    estimateContractId: f,
    mainFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QPoolEntryExitMechan = {
    id: p,
    vesselCode: f,
    vesselNmCn: f,
    poolContNo: f,
    shipOwnerNmCn: f,
    entryExitSign: f,
    timeZone: f,
    entryExitTimeLoc: f,
    entryExitTimeUtc: f,
    delReturnShipPlace: f,
    apprStatus: f,
    status: f,
    hsfoPrice: f,
    lsfoPrice: f,
    hsmgoPrice: f,
    lsmgoPrice: f,
    remark: f,
    relHsfo: f,
    relHsfoPrice: f,
    relHsfoRefuelTime: f,
    relLsfo: f,
    relLsfoPrice: f,
    relLsfoRefuelTime: f,
    relHsmgo: f,
    relHsmgoPrice: f,
    relHsmgoRefuelTime: f,
    relLsmgo: f,
    relLsmgoPrice: f,
    relLsmgoRefuelTime: f,
    relRemark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineSoftData = {
    id: p,
    deletedid: f,
    deletedname: f,
    type: f
  };
  ds.QComApTaxInvoice = {
    id: p,
    invoiceCode: f,
    invoiceNo: f,
    invoiceAcceptDate: f,
    invoiceDate: f,
    partnerCode: f,
    partnerName: f,
    partnerTaxNo: f,
    partnerAddrTel: f,
    partnerBankAccount: f,
    partnerBankInfoId: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    taxNo: f,
    addrTel: f,
    bankAccount: f,
    bankInfoId: f,
    invoiceType: f,
    currencyCode: f,
    currencyName: f,
    offsetFlag: f,
    offsetAmount: f,
    preTaxInvoiceAmount: f,
    taxAmount: f,
    invoiceAmount: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    invoiceId: f,
    submitDate: f,
    submitFlag: f,
    submitUserName: f,
    submitUser: f,
    uploadFlag: f,
    ocrInvFlag: f,
    partnerRipInvoiceId: f,
    ripInvoiceId: f,
    partnerInvoiceHeader: f,
    invoiceHeader: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    invoiceHeaderEn: f,
    partnerInvoiceHeaderEn: f,
    partnerNameEn: f,
    settleOfficeNameEn: f,
    comApTaxInvoiceDtl: new c("ComApTaxInvoiceDtl")
  };
  ds.QStcManageContract = {
    recordVersion: f,
    contractNo: f,
    vesselCode: f,
    contractName: f,
    activityDate: f,
    createOffice: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    shipOwnerId: f,
    lastModifyTimeZone: f,
    remindDays: f,
    principalOrgCode: f,
    shipOwnerNameCn: f,
    createTimeZone: f,
    id: p,
    shipOwnerNameEn: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    contractStatus: f,
    contractDate: f,
    invalidDate: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    managerType: f,
    remark: f,
    managerId: f,
    managerNameEn: f,
    managerNameCn: f
  };
  ds.QEbsRepairInquiry = {
    id: p,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    inquiryCode: f,
    inquiryStatus: f,
    repairApplyId: f,
    repairType: f,
    dockingType: f,
    electricFlag: f,
    technicalFlag: f,
    expenseSource: f,
    specBusinessMark: f,
    chargeId: f,
    chargeNameCn: f,
    chargeNameEn: f,
    repairPlanId: f,
    planStartDate: f,
    supplierId: f,
    supplierCode: f,
    supplierNameCn: f,
    supplierNameEn: f,
    dischargePort: f,
    inquiryRemark: f,
    quoteNo: f,
    quoteDate: f,
    repairLocation: f,
    currencyLocal: f,
    currency: f,
    rate: f,
    totalAmount: f,
    totalDiscount: f,
    taxRate: f,
    estRepairDay: f,
    estDockDay: f,
    estRepairStartTime: f,
    estRepairEndTime: f,
    supplierRemark: f,
    emailStatus: f,
    selectedFlag: f,
    inquiryDate: f,
    inquiryPersonCode: f,
    inquiryPersonName: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSysRoleGrant = {
    id: p,
    roleId: f,
    resourceId: f,
    urlTitle: f,
    appId: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    deletedFlag: f
  };
  ds.QFineScheduleTaskLog = {
    id: p,
    logtime: f,
    logtype: f,
    taskid: f,
    tasklog: f,
    taskname: f
  };
  ds.QStcReceiveRegister = {
    id: p,
    receiptNo: f,
    customerId: f,
    customerCode: f,
    customerNameEn: f,
    customerNameCn: f,
    receiveDueDate: f,
    receiptType: f,
    currency: f,
    amount: f,
    baseAmount: f,
    rate: f,
    receiveAccountNo: f,
    receiveBankNo: f,
    receiveBankName: f,
    status: f,
    fiStatus: f,
    actualReceiveAmount: f,
    actualReceiveDate: f,
    settlementStatus: f,
    imageNo: f,
    remark: f,
    voucherNo: f,
    fiAuditDate: f,
    fiRemark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    fiMageNumber: f
  };
  ds.QChrTceLockMain = {
    id: p,
    tceLockNo: f,
    vesselType: f,
    lockBeginDate: f,
    lockEndDate: f,
    annualEstTce: f,
    unlockYearTce: f,
    annualLockRate: f,
    rangeLockTce: f,
    rangeOperationDays: f,
    rangeLockRate: f,
    lockUserCode: f,
    lockUserName: f,
    lockTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    annualMarketTce: f,
    tceYear: f,
    annualOperationDays: f,
    selfAnnualEstTce: f,
    annualLockTce: f
  };
  ds.QChrEstimateCost = {
    id: p,
    mainId: f,
    type: f,
    commission: f,
    costPreDay: f,
    totalDay: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QStcReceiveInvoiceDtl = {
    id: p,
    receiveInvoiceId: f,
    contractNo: f,
    businessId: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    vesselCode: f,
    amount: f,
    taxRateCode: f,
    taxAmount: f,
    receiveDueDate: f,
    chargeId: f,
    chargeCode: f,
    chargeNameEn: f,
    chargeNameCn: f,
    rate: f,
    localAmount: f,
    dataSource: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QSysI18nMessage = {
    sysI18nMessageId: p,
    sysSupportedLocaleId: f,
    key: f,
    message: f,
    recordVersion: f,
    revisionNumber: f,
    sourceRevisionNumber: f,
    configItemCode: f,
    baseViewId: f,
    revisionStatus: f
  };
  ds.QSpsPoDetail = {
    id: p,
    poMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    partsInfoId: f,
    partsNameCn: f,
    partsCode: f,
    partsNameEn: f,
    partsDrawing: f,
    partsDrawingItem: f,
    unit: f,
    minStockQty: f,
    harmfulFlag: f,
    poDetailRemark: f,
    poQty: f,
    readyQty: f,
    receiveQty: f,
    returnQty: f,
    currency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    price: f,
    discount: f,
    amount: f,
    amountStandard: f,
    origin: f,
    receiveDate: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    specMark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    partsType: f,
    devModel: f,
    devMakerNameCn: f,
    devNameCn: f,
    devSerialNo: f,
    devCode: f,
    devMakerNameEn: f,
    devNameEn: f,
    devInfoId: f,
    devMakerId: f,
    devVesselCodeId: f,
    devFlag: f,
    partsModel: f,
    receiveRemark: f,
    spsPoStockingDetails: new c("SpsPoStockingDetail"),
    spsPoDetail2Main: new c("SpsPoMain")
  };
  ds.QFineSwiftSegments = {
    id: p,
    segmentorder: f,
    segmentowner: f,
    segmenturi: f,
    storetype: f,
    swiftschema: f
  };
  ds.QAmiGNoonCargo = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    amiId: f,
    startTime: f,
    endTime: f,
    reason: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QCdmVesselRadioNavEqui = {
    id: p,
    vesselGeneralId: f,
    commNavItemEquipmentName: f,
    commNavItemMakerModel: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QStcPaymentApplicationSettlementDtl = {
    id: p,
    paymentApplicationId: f,
    payAdvanceNo: f,
    currency: f,
    baseAmount: f,
    settlementAmount: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    payAdvanceId: f
  };
  ds.QCdmCurrency = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    currencyCode: f,
    currencyName: f,
    currencySymbol: f,
    activeFlag: f,
    frequencySeq: f
  };
  ds.QAmclAmiTNoon = {
    id: p,
    reportNo: f,
    sailingStatus: f,
    latitude: f,
    longitude: f,
    crs: f,
    runHrs: f,
    runDist: f,
    obsSpeed: f,
    distGo: f,
    nextPortCd: f,
    etaNextPort: f,
    windDir: f,
    windScale: f,
    waveDir: f,
    waveHeight: f,
    airTemp: f,
    seaTemp: f,
    currDir: f,
    velocity: f,
    meAvgRpm: f,
    meKw: f,
    avgSpd: f,
    slip: f,
    foRestriction: f,
    spdRestriction: f,
    rpmRestriction: f,
    etaRequirement: f,
    otherRqmnt: f,
    aFoHEng: f,
    aFoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aFoHBoiler: f,
    aFoLBoiler: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    tHsfo: f,
    tLsfo: f,
    tHsmgo: f,
    tLsmgo: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aBoilerWater: f,
    aDomesticWater: f,
    mFoH: f,
    mFoL: f,
    mMgoH: f,
    mMgoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBoilerWater: f,
    mDomesticWater: f,
    remark: f,
    fuelOilInertTemp: f,
    oilFlowRate: f,
    specialPoint1: f,
    eSpecialTime1: f,
    aPassTime1: f,
    specialPoint2: f,
    eSpecialTime2: f,
    aPassTime2: f,
    totalRunDist: f,
    totalRunTime: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    basisSpeed: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    nextPortType: f,
    dailyFwg: f,
    linshi: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    nextPortNameEn: f,
    nextPortNameCn: f,
    baseInfoId: f
  };
  ds.QFineSwiftRestoreResult = {
    uuid: p,
    clusterid: f,
    endtime: f,
    errorcode: f,
    errormsg: f,
    exception: f,
    starttime: f,
    success: f
  };
  ds.QAmiVerifyVessel = {
    id: p,
    configMainId: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSpsQuoteMain = {
    id: p,
    applyMainId: f,
    vesselId: f,
    vesselCode: f,
    applyNo: f,
    quotationNo: f,
    supplierId: f,
    quotationDate: f,
    quotationStatus: f,
    currency: f,
    rate: f,
    amount: f,
    amountStandard: f,
    discount: f,
    miscAmount: f,
    deductionAmount: f,
    leadTime: f,
    paymentPeriod: f,
    periodValidity: f,
    quotationSource: f,
    devInfoId: f,
    orderType: f,
    equipmentType: f,
    specBusinessMark: f,
    quotationRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    inquiryMainId: f,
    supplierNameCn: f,
    vesselNameEn: f,
    supplierNameEn: f,
    vesselNameCn: f,
    baseCurrency: f,
    electricFlag: f,
    devVesselCodeId: f,
    devFlag: f,
    taxRate: f,
    taxAmount: f,
    taxRateCode: f
  };
  ds.QChrContractMtfwContract = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractId: f,
    pContractId: f,
    approveOrg: f,
    archiveOrg: f,
    archiver: f,
    bidDate: f,
    changeFlag: f,
    contractAmount: f,
    contractMainType: f,
    contractName: f,
    signSubjectName: f,
    signSubjectCode: f,
    signSubjectNameEn: f,
    contractStatus: f,
    contractType: f,
    createUserTel: f,
    contractCurrency: f,
    archPeriod: f,
    effectedDate: f,
    effectiveDesc: f,
    endDate: f,
    foreignContFlag: f,
    guaranteeFlag: f,
    guaranteeOrg: f,
    holdOrg: f,
    majorContFlag: f,
    moneyFlow: f,
    filedNum: f,
    ourSignatory: f,
    otherSignatory: f,
    rate: f,
    relateContractId: f,
    signDate: f,
    sysFrom2: f,
    sysFrom1: f,
    urgentFlag: f,
    contractVersion: f,
    sendFlag: f,
    sendDate: f,
    sendMessage: f,
    checkFlag: f,
    checkMessage: f,
    checkDate: f,
    contractSubType: f,
    archiverDate: f,
    definiteMoney: f,
    moneyExplain: f,
    isLegalReviewFlag: f,
    headline: f,
    signDeptName: f,
    isBiddingType: f,
    ispFleetCode: f
  };
  ds.QActRuExecution = {
    id: p,
    rev: f,
    procInstId: f,
    businessKey: f,
    parentId: f,
    procDefId: f,
    superExec: f,
    rootProcInstId: f,
    actId: f,
    isActive: f,
    isConcurrent: f,
    isScope: f,
    isEventScope: f,
    isMiRoot: f,
    suspensionState: f,
    cachedEntState: f,
    tenantId: f,
    name: f,
    startTime: f,
    startUserId: f,
    lockTime: f,
    isCountEnabled: f,
    evtSubscrCount: f,
    taskCount: f,
    jobCount: f,
    timerJobCount: f,
    suspJobCount: f,
    deadletterJobCount: f,
    varCount: f,
    idLinkCount: f
  };
  ds.QMtrInfoName = {
    id: p,
    materialNameCn: f,
    materialNameEn: f
  };
  ds.QFineOutputSftp = {
    id: p,
    password: f,
    port: f,
    privatekey: f,
    savepath: f,
    securepassword: f,
    serveraddress: f,
    username: f
  };
  ds.QChrPreSettlementFreight = {
    id: p,
    mainId: f,
    ws: f,
    frtRate: f,
    cargoQuantity: f,
    cargoCode: f,
    cargoName: f,
    overageRate: f,
    charertersCode: f,
    charerterName: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cpMinimum: f,
    grossFlag: f,
    actualFreight: f,
    freightIsAll: f,
    estimatedFreight: f,
    contractNo: f,
    invoceType: f,
    invoiceNo: f,
    freightType: f,
    cpMaximum: f,
    contractType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    ilow: f,
    cargoNameEn: f,
    chrPreSettlementCargoOverList: new c("ChrPreSettlementCargoOver")
  };
  ds.QSysAuthorizationApprove = {
    id: p,
    modelName: f,
    authorizerCode: f,
    authorizedCode: f,
    authorizerCompanyCode: f,
    authorizedCompanyCode: f,
    authorizerRoleCode: f,
    authorizedRoleCode: f,
    startTime: f,
    endTime: f,
    terminationTime: f,
    taskCompletedNumber: f,
    authorizedCompanyId: f,
    authorizedRoleId: f,
    groupNo: f,
    authorizedCompanyCn: f,
    authorizedRoleCn: f,
    spare6: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    belongState: f,
    terminationPeopleCn: f,
    modelNameCn: f,
    modelNameEn: f,
    terminationPeopleEn: f,
    terminationPeopleCode: f,
    authorizerNameCn: f,
    authorizerNameEn: f,
    authorizedNameCn: f,
    authorizedNameEn: f,
    remark: f,
    authorizerRoleId: f,
    spare9: f,
    spare10: f,
    authorizerCompanyCn: f,
    authorizerCompanyEn: f,
    authorizerRoleCn: f,
    authorizerRoleEn: f,
    authorizedCompanyEn: f,
    authorizedRoleEn: f,
    spare11: f,
    spare12: f
  };
  ds.QFineComponentHealth = {
    id: p,
    clusternodeid: f,
    extrainfo: f,
    module: f,
    status: f,
    time: f
  };
  ds.QTaskModelRel = {
    id: f,
    modelLogId: f,
    modelKey: f,
    payload: f
  };
  ds.QAmiAnalysisShip = {
    id: p,
    vesselCode: f,
    vesselEnName: f,
    vesselCnName: f
  };
  ds.QChrOperationalPlan = {
    id: p,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    vesselType: f,
    operationalYear: f,
    dayNetTce: f,
    dayGrossTce: f,
    operationDay: f,
    voyageDay: f,
    operationRate: f,
    totalTceRevenue: f,
    totalGrossRevenue: f,
    commissionRate: f,
    commissionAmount: f,
    estDeliveryDate: f,
    estRetireDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QMtrApplyTemplateDetail = {
    id: p,
    templateId: f,
    vesselId: f,
    vesselCode: f,
    seqNo: f,
    materialCategoryId: f,
    materialCategoryNameCn: f,
    materialCategoryNameEn: f,
    materialCode: f,
    materialNameCn: f,
    materialNameEn: f,
    spec: f,
    unit: f,
    applyQty: f,
    rerarmk: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    materialInfoId: f
  };
  ds.QCdmExchangeRate = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    currencyFrom: f,
    currencyTo: f,
    effectDate: f,
    expireDate: f,
    exchangeRate: f,
    exchangeName: f,
    conversionMethod: f,
    remark: f,
    activeFlag: f,
    masterDataCode: f
  };
  ds.QComInvoiceReceiptBack = {
    lastModifyOffice: f,
    creator: f,
    estDueDate: f,
    lastModifyBy: f,
    receiptType: f,
    lastModifyOfficeName: f,
    settleStatus: f,
    invoiceReceiptId: f,
    particular: f,
    remark: f,
    balanceAmount: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    receiptAmount: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    principalOrgCode: f,
    invoiceId: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QMtrMedicineSetting = {
    recommendFlag: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    materialInfoId: f,
    equippedFlag: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    controlLevel: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    recommendQty: f,
    medicineStrength: f,
    recommendQtyRemark: f,
    medicineIndication: f,
    validateFlag: f,
    extFlag: f,
    controlFlag: f
  };
  ds.QAmclAmiTDptDischCargo = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    cargoCd: f,
    cargoNameCn: f,
    cargoNameEn: f,
    cargoDispartured: f,
    cargoRemained: f,
    fileid: f,
    cargoGovBbls: f,
    cargoTemp: f,
    cargoGsvBbls: f,
    cargoMetricTons: f,
    dischargedShipFigure: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineWorkflowLog = {
    id: p,
    datetime: f,
    message: f,
    operatorname: f,
    processname: f,
    taskname: f
  };
  ds.QComCmllaytimeFee = {
    feeSequence: f,
    despRate: f,
    demurrage: f,
    remark: f,
    demuRate: f,
    lastModifyTimeZone: f,
    laytimeDeduct: f,
    checkStatus: f,
    recordVersion: f,
    cmllaytimeId: f,
    ispFleetCode: f,
    despatch: f,
    despRateUnit: f,
    laytimeUsed: f,
    currency: f,
    demurrageCalcDate: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    ldType: f,
    adjustAmount: f,
    demuDate: f,
    lastModifyByName: f,
    totalAmount: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    invoiceImportStatus: f,
    lastModifyTime: f,
    laytimeAllowed: f,
    laytimeEarly: f,
    countType: f,
    demuRateUnit: f,
    despDate: f,
    createName: f,
    chargeName: f,
    chargeCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    ldTypeName: f,
    chargeNameEn: f,
    ldTypeNameEn: f,
    chartererAmount: f,
    ownerAmount: f
  };
  ds.QSpsCompareQtyHistory = {
    id: p,
    poMainId: f,
    partsInfoId: f,
    partsNameCn: f,
    partsCode: f,
    partsNameEn: f,
    beforePoQty: f,
    afterPoQty: f,
    modifyBy: f,
    poDetailId: f,
    supplierId: f,
    supplierNameCn: f,
    supplierNameEn: f,
    modifyTime: f
  };
  ds.QSysResourceRel = {
    id: p,
    seqNo: f,
    urlTitle: f,
    hideFlag: f,
    parentRootId: f,
    appId: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    resourceId: f,
    childResourceId: f,
    titleEn: f,
    titleCn: f
  };
  ds.QPoolContract = {
    id: p,
    contName: f,
    contType: f,
    contStatus: f,
    contNo: f,
    contTime: f,
    effectDate: f,
    endDate: f,
    contCurrency: f,
    vesselCode: f,
    vesselNmCn: f,
    sumWeight: f,
    fullLoadDraft: f,
    vesselDecribe: f,
    contBody: f,
    signer: f,
    contSecurity: f,
    signNetwork: f,
    shipOwnerNmCn: f,
    region: f,
    apprStatus: f,
    bond: f,
    manageExpense: f,
    busineManageFeeComm: f,
    entryTime: f,
    minTenancy: f,
    exitPoolClause: f,
    delHsFoPrice: f,
    delLsFoPrice: f,
    delHsMgoPrice: f,
    delLsMgoPrice: f,
    relDelOilPrice: f,
    delTimePlace: f,
    delRemark: f,
    redelHsFoPrice: f,
    redelLsFoPrice: f,
    redelHsMgoPrice: f,
    redelLsMgoPrice: f,
    relRedelOilPrice: f,
    redelTimePlace: f,
    redelRemark: f,
    handledBy: f,
    handledTime: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    superiorCompanyCode: f
  };
  ds.QOpsVoyageSpecialEvents = {
    opsVoyageTaskId: f,
    remark: f,
    lastModifyTimeZone: f,
    voyageType: f,
    recordVersion: f,
    ispFleetCode: f,
    chartererCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    attachmentId: f,
    extraTime: f,
    beginTime: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    evebtType: f,
    extraConFlag: f,
    exemptConType: f,
    lastModifyByName: f,
    createOffice: f,
    chartererName: f,
    createTime: f,
    extraTimeFlag: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    extraCon: f,
    endTime: f,
    createName: f,
    evebtDetail: f,
    recordTime: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chartererNameEn: f
  };
  ds.QFinePrintOffset = {
    id: p,
    cptname: f,
    ip: f,
    offsetx: f,
    offsety: f,
    sign: f
  };
  ds.QProduceMessage = {
    id: p,
    topic: f,
    msgId: f,
    message: f,
    retryTimes: f,
    status: f,
    createTime: f,
    createUser: f,
    updateTime: f,
    updateUser: f
  };
  ds.QVscRecvSerial = {
    lastModifyOffice: f,
    creator: f,
    commitSerialNo: f,
    lastModifyBy: f,
    receiveSerialNo: f,
    lastModifyTimeZone: f,
    vesselId: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    stageNo: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    fileType: f
  };
  ds.QMtrMaterialInfo = {
    applyType: f,
    criticalFlag: f,
    reservedDate: f,
    highValueFlag: f,
    drawingItem: f,
    materialCategoryId: f,
    annualSupply: f,
    remark: f,
    proposedPriceCurrency: f,
    spec: f,
    lastModifyTimeZone: f,
    reservedStr3: f,
    reservedStr2: f,
    specEn: f,
    reservedStr1: f,
    recordVersion: f,
    supplyIns: f,
    blindFlag: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    harmfulFlag: f,
    proposedPrice: f,
    lastModifyOffice: f,
    creator: f,
    partsDrawing: f,
    lastModifyBy: f,
    productId: f,
    reservedLong2: f,
    reservedDecimal2: f,
    materialCode: f,
    reservedDecimal1: f,
    reservedLong1: f,
    dept: f,
    materialNameEn: f,
    unit: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    materialNameCn: f,
    monitorFlag: f,
    status: f,
    partsType: f,
    partsParameter: f,
    safetyFlag: f,
    smisMrpid: f,
    mtrMedicineSetting: new c("MtrMedicineSetting"),
    mtrVesselMaterialInfo: new c("MtrVesselMaterialInfo"),
    category: new c("MtrMaterialCategory")
  };
  ds.QAmiTDepLoad = {
    id: p,
    baseInfoId: f,
    portCode: f,
    df: f,
    dm: f,
    da: f,
    stressBm: f,
    stressBmFr: f,
    stressSf: f,
    sterssSfFr: f,
    cashReceived: f,
    etaNextPort: f,
    nextPort: f,
    nextAssignment: f,
    prostestRemarks: f,
    fuelFoHEng: f,
    fuelFoLEng: f,
    fuelFoHGen: f,
    fuelFoLGen: f,
    fuelFoHHeating: f,
    fuelFoLHeating: f,
    gasMgoHEng: f,
    gasMgoLEng: f,
    gasMgoHGen: f,
    gasMgoLGen: f,
    gasMgoHBoiler: f,
    gasMgoLBoiler: f,
    ptLuboilEng: f,
    ptLuboilCyl: f,
    ptLuboilGen: f,
    freBWater: f,
    freDWater: f,
    rmFoH: f,
    rmFoL: f,
    rmMgoH: f,
    rmMgoL: f,
    rmLuboilEng: f,
    rmLuboilCyl: f,
    rmLuboilGen: f,
    rmBoilerWater: f,
    rmDomesticWater: f,
    ttlPortH: f,
    faopSpdTm: f,
    finalCargoPlan: f,
    crewMovement: f,
    remark: f,
    runningHours: f,
    runDist: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    berthing: f,
    unberthing: f,
    sscecValidDate: f,
    garDispFlag: f,
    pscOtherInspFlag: f,
    basisSpeed: f,
    fuelFoHIgg: f,
    fuelFoLIgg: f,
    fuelFoHInc: f,
    fuelFoLInc: f,
    fuelFoHOther: f,
    fuelFoLOther: f,
    gasMgoHIgg: f,
    gasMgoLIgg: f,
    gasMgoHInc: f,
    gasMgoLInc: f,
    gasMgoHOther: f,
    gasMgoLOther: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    onberthTm: f,
    waterTreatUsed: f,
    reason: f,
    tugsUsed: f,
    daFoHEng: f,
    daFoLEng: f,
    daFoHGen: f,
    daFoLGen: f,
    daFoHBoiler: f,
    daFoLBoiler: f,
    daFoHIgg: f,
    daFoLIgg: f,
    daFoHInc: f,
    daFoLInc: f,
    daFoHOther: f,
    daFoLOther: f,
    daSulphurHfo: f,
    daSulphurLfo: f,
    daMgoHEng: f,
    daMgoLEng: f,
    daMgoHGen: f,
    daMgoLGen: f,
    daMgoHBoiler: f,
    daMgoLBoiler: f,
    daMgoHIgg: f,
    daMgoLIgg: f,
    daMgoHInc: f,
    daMgoLInc: f,
    daMgoHOther: f,
    daMgoLOther: f,
    daSulphurHmgo: f,
    daSulphurLmgo: f,
    daTHsfo: f,
    daTLsfo: f,
    daTHsmgo: f,
    daTLsmgo: f,
    daLuboilCyl: f,
    daLuboilEng: f,
    daLuboilGen: f,
    daBoilerWater: f,
    daDomesticWater: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRobFlag: f,
    cargoRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    amiTDepLoadPortDelay: new c("AmiTDepLoadPortDelay"),
    amiTDepLoadFlow: new c("AmiTDepLoadFlow"),
    amiTDepLoadOilSupplited: new c("AmiTDepLoadOilSupplited"),
    amiTDepLoadCargo: new c("AmiTDepLoadCargo")
  };
  ds.QAmclAmiMonthSpecialPoint = {
    id: p,
    monthOilMainId: f,
    name: f,
    value: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QEbsRepairInquiryItem = {
    id: p,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    repairApplyId: f,
    repairInquiryId: f,
    repairApplyItemId: f,
    mainItemId: f,
    itemParentId: f,
    itemParentCode: f,
    itemCode: f,
    itemContent: f,
    itemLibContentCn: f,
    itemLibContentEn: f,
    itemLevel: f,
    itemDispOrder: f,
    itemBusinessFlag: f,
    itemBusinessId: f,
    devInfoId: f,
    devNameCn: f,
    devNameEn: f,
    devModel: f,
    devMakerId: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    itemPosition: f,
    itemRemark: f,
    shoreRemark: f,
    chargeId: f,
    chargeNameCn: f,
    chargeNameEn: f,
    specMark: f,
    itemUnit: f,
    itemQuantity: f,
    quoteContent: f,
    quoteUnit: f,
    quoteQuantity: f,
    orderQuantity: f,
    unitPrice: f,
    unitDiscount: f,
    taxRate: f,
    quoteRemark: f,
    quoteChangeFlag: f,
    inquiryDate: f,
    inquiryPersonCode: f,
    inquiryPersonName: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QStcFrameProtocolSupplier = {
    id: p,
    frameProtocolId: f,
    supplierName: f,
    contactPerson: f,
    contactTel: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineConfXmlentity = {
    id: p,
    value: f
  };
  ds.QChrContractMtfwLinkedFile = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    fileLink: f,
    fileName: f,
    fileSize: f,
    type: f,
    mtfwContractId: f,
    ispFleetCode: f
  };
  ds.QAmiGDepartureLoadDisc = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    dryBulkLTeu: f,
    dryBulkLFeu: f,
    dryBulkDTeu: f,
    dryBulkDFeu: f,
    dryBulkRobTeu: f,
    dryBulkRobFeu: f,
    frLTeu: f,
    frLFeu: f,
    frDTeu: f,
    frDFeu: f,
    frRobTeu: f,
    frRobFeu: f,
    imdgLTeu: f,
    imdgLFeu: f,
    imdgDTeu: f,
    imdgDFeu: f,
    imdgRobTeu: f,
    imdgRobFeu: f,
    imdgTypeCntr: f,
    rfLTeu: f,
    rfLFeu: f,
    rfDTeu: f,
    rfDFeu: f,
    rfRobTeu: f,
    rfRobFeu: f,
    otherLTeu: f,
    otherLFeu: f,
    otherDTeu: f,
    otherDFeu: f,
    otherRobTeu: f,
    otherRobFeu: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QChrSettlementDemurrage = {
    id: p,
    mainId: f,
    contractNo: f,
    invoiceNo: f,
    invoceType: f,
    grossFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    chargeDescription: f,
    actualChargeFee: f,
    chargeCode: f,
    chargeName: f,
    estimateChargeFee: f,
    chargeFeeRateUnit: f,
    chargeFeeRate: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f
  };
  ds.QAmiBDeviation = {
    id: p,
    baseInfoId: f,
    latitude: f,
    longitude: f,
    crs: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    slip: f,
    acFoH: f,
    acFoL: f,
    acMgoH: f,
    acMgoL: f,
    acWater: f,
    robFoH: f,
    robFoL: f,
    robMgoH: f,
    robMgoL: f,
    robWater: f,
    windDirection: f,
    windScale: f,
    waveDirection: f,
    waveHeight: f,
    swellHeight: f,
    swellDirect: f,
    visibilitysCale: f,
    runHrs: f,
    runDist: f,
    nextPortCd: f,
    nextPortNameCn: f,
    nextPortNameEn: f,
    etaNextPortLoc: f,
    distNextPort: f,
    specialPoint1: f,
    estArrivalTm1: f,
    ataArrivalTm1: f,
    specialPoint2: f,
    estArrivalTm2: f,
    ataArrivalTm2: f,
    remark: f,
    datetime: f,
    nextPortNm: f,
    sailingStatus: f,
    fwGenerated: f,
    totalRunDist: f,
    totalRunTime: f,
    basisSpeed: f,
    totalAvgSpd: f,
    totalAvgRpm: f,
    totalEngSpeed: f,
    totalSlip: f,
    totalOilWear: f,
    totalAvgOilWear: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    ataMWater: f,
    fwGen: f,
    fuelno1s: f,
    fuelno2s: f,
    fuelno3s: f,
    fuelno4s: f,
    fuelno1p: f,
    fuelno2p: f,
    fuelno3p: f,
    fuelno4p: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    calPurposeNextPort: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    deviationType: f,
    reason: f,
    periodBeginTm: f,
    utc: f,
    totalCylinderLub: f,
    totalGeneratorLub: f,
    endUtc: f,
    endTm: f,
    totalDistance: f,
    totalMgoH: f,
    totalMgoL: f,
    totalEngineLub: f,
    duration: f,
    totalFoL: f,
    totalFoH: f,
    averagePower: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f
  };
  ds.QFinFuelStockFlow = {
    id: p,
    operationNo: f,
    vesselName: f,
    vesselCode: f,
    voyageNo: f,
    contractNo: f,
    voyageType: f,
    stockOperate: f,
    trendDate: f,
    businessDate: f,
    currency: f,
    bunkerSpec: f,
    dynamicQuantity: f,
    endQuantity: f,
    avgPrice: f,
    dynamicAmount: f,
    closeStockAmount: f,
    universalOrderNo: f,
    verifyDate: f,
    status: f,
    voucherNo: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    bunkerSeq: f,
    validStatus: f,
    backId: f,
    operateType: f,
    nodeFuel: f,
    exchangeRate: f,
    refuelType: f,
    companyNameEn: f,
    companyNameCn: f,
    taxRate: f,
    companyId: f,
    companyCode: f,
    deliveryQuantity: f,
    deliveryUnitPrice: f,
    returnPreviousType: f,
    supplierCode: f,
    supplierName: f,
    ispFleetCode: f,
    universalOrderDate: f,
    vesselNameEn: f,
    finFuelStockDetailList: new c("FinFuelStockDetail")
  };
  ds.QAmiBShifting = {
    id: p,
    baseInfoId: f,
    portCode: f,
    formerBerthedno: f,
    esb: f,
    pob: f,
    unberthed: f,
    unberHsfo: f,
    unberLsfo: f,
    unberHsmgo: f,
    unberLsmgo: f,
    flAshore: f,
    amFast: f,
    nowBerthedno: f,
    dop: f,
    fwe: f,
    shiftedHsfo: f,
    shiftedLsfo: f,
    shiftedHsmgo: f,
    shiftedLsfmgo: f,
    remarks: f,
    berthedSide1: f,
    berthedSide2: f,
    quantilyTugboat: f,
    shiftingDist: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    portNameCn: f,
    portNameEn: f,
    berthedStatus: f,
    mgoLConsumptionSum: f,
    foLConsumptionSum: f,
    foHConsumptionSum: f,
    mgoHConsumptionSum: f
  };
  ds.QFineUsageData = {
    id: p,
    data: f,
    datatype: f,
    subtype: f,
    tag: f
  };
  ds.QPoolOffHireSituation = {
    apprStatus: f,
    beignHsmgo: f,
    remark: f,
    beignHsfo: f,
    offHireBeignTimeZone: f,
    lsfoCost: f,
    estimatOffHireBeignTime: f,
    offHireEndTimeLoc: f,
    lsfoPrice: f,
    lsmgoCost: f,
    lsfoConsump: f,
    endHsmgo: f,
    vesselCode: f,
    id: p,
    endLsmgo: f,
    endHsfo: f,
    hsmgoPrice: f,
    hsfoPrice: f,
    endLsfo: f,
    totalFuleCost: f,
    offHireBeignTimeLoc: f,
    hsmgoCost: f,
    offHireDay: f,
    offHireType: f,
    hsfoConsump: f,
    beignLsfo: f,
    hsfoCost: f,
    offHireEndTimeZone: f,
    lsmgoConsump: f,
    estimatOffHireEndTime: f,
    beignLsmgo: f,
    lsmgoPrice: f,
    hsmgoConsump: f,
    poolContNo: f,
    vesselNmCn: f,
    status: f
  };
  ds.QFineDepRole = {
    id: f,
    tenantid: f,
    creationtype: f,
    departmentid: f,
    fullpath: f,
    lastoperationtype: f,
    postid: f
  };
  ds.QStcReceiveInvoice = {
    id: p,
    customerId: f,
    customerCode: f,
    customerNameEn: f,
    customerNameCn: f,
    invoiceDate: f,
    currency: f,
    amount: f,
    taxAmount: f,
    receiveDueDate: f,
    status: f,
    invoiceType: f,
    invoiceCode: f,
    settlementStatus: f,
    receiptNo: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    receiveRegisterId: f,
    invoiceNo: f
  };
  ds.QFineSwiftColIdxConf = {
    columnname: f,
    tablekey: f,
    requireglobaldict: f,
    requireindex: f
  };
  ds.QOpsOffhire = {
    fleet: f,
    ttlDoLFlag: f,
    lastModifyTimeZone: f,
    ttlFoL: f,
    recordVersion: f,
    ttlDoL: f,
    ttlFoH: f,
    ttlDoH: f,
    createTimeZone: f,
    endTimeZone: f,
    beginTime: f,
    id: p,
    endWater: f,
    ttlFoHFlag: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    proRate: f,
    descr: f,
    createOffice: f,
    createOfficeName: f,
    beginTimeZone: f,
    createName: f,
    beginWater: f,
    reportTime: f,
    priceDoL: f,
    estDate: f,
    priceFoL: f,
    endPortCode: f,
    cause: f,
    remark: f,
    priceDoH: f,
    priceFoH: f,
    actDate: f,
    beginLong: f,
    endDoL: f,
    beginPortCode: f,
    beginGmtTime: f,
    endFoH: f,
    endLat: f,
    ttlFoLFlag: f,
    endDoH: f,
    endLong: f,
    principalOrgCode: f,
    endGmtTime: f,
    endFoL: f,
    lastModifyOffice: f,
    endGo: f,
    creator: f,
    dailyRent: f,
    borl: f,
    lastModifyByName: f,
    ttlDoHFlag: f,
    beginFoH: f,
    beginLat: f,
    feeFoL: f,
    beginDoH: f,
    createTime: f,
    feeFoH: f,
    deletedFlag: f,
    lastModifyTime: f,
    feeDoL: f,
    invoiceId: f,
    feeDoH: f,
    endTime: f,
    beginFoL: f,
    beginDoL: f,
    ispFleetCode: f,
    repairPortCode: f,
    isBunker: f,
    isOffHireDays: f,
    offHierTime: f,
    isOffHire: f,
    isClosed: f,
    opsVoyageTaskId: f,
    inDo: f,
    ballastFo: f,
    ballastTime: f,
    ballastMile: f,
    ballastDo: f,
    inFo: f,
    lockUser2: f,
    lockUser1: f,
    lockTime1: f,
    lockTime2: f,
    lockUserCode1: f,
    lockUserCode2: f,
    beginLongFlag: f,
    actTotalRent: f,
    beginLatFlag: f,
    actOffHireDays: f,
    estOffHireDays: f,
    actTotalOffhire: f,
    estTotalOffhire: f,
    estTotalRent: f,
    endLongFlag: f,
    actTotalOil: f,
    endLatFlag: f,
    estTotalOil: f,
    endPortName: f,
    beginPortName: f,
    repairPortName: f,
    estLockFlag: f,
    actLockFlag: f,
    endPortNameEn: f,
    beginPortNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    oilCalRate: f,
    beginPortId: f,
    endPortId: f,
    opsOffhireOil: new c("OpsOffhireOil")
  };
  ds.QSpsProsOrderMain = {
    id: p,
    vesselId: f,
    vesselCode: f,
    dept: f,
    prosType: f,
    prosSupplier: f,
    portCode: f,
    portNameEn: f,
    portNameCn: f,
    prosNo: f,
    prosDate: f,
    prosStatus: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    vesselNameCn: f,
    vesselNameEn: f
  };
  ds.QFinFuelSequence = {
    id: p,
    sequence: f,
    vesselCode: f,
    vesselName: f,
    previousOperation: f,
    previousOpreationTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    voyageNo: f,
    voyageType: f,
    finFuelSequenceDetail: new c("FinFuelSequenceDetail")
  };
  ds.QAmclAmiTDepDischOilSupplited = {
    id: p,
    reportNo: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    engLub: f,
    cylLub: f,
    genLub: f,
    bWater: f,
    dWater: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QSysPageComponent = {
    id: p,
    pageId: f,
    pageCode: f,
    componentCode: f,
    componentJson: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QCdmAutoReport = {
    id: p,
    vesselName: f,
    vesselNameEn: f,
    vesselCode: f,
    isAuto: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QWfLooseNumber = {
    id: p,
    looseKey: f,
    lastSn: f
  };
  ds.QActFoFormDeployment = {
    id: p,
    name: f,
    category: f,
    deployTime: f,
    tenantId: f,
    parentDeploymentId: f
  };
  ds.QVscTaskLog = {
    id: p,
    taskMessage: f,
    sendMessage: f,
    errorMessage: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    operationType: f,
    sendStatus: f,
    taskLogId: f,
    isSendTask: f,
    modelKey: f,
    isModelFlag: f,
    modelLogId: f
  };
  ds.QAmiBBunkerAdjustmentDetail = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    adjustToRob: f,
    variableAmount: f,
    reason: f
  };
  ds.QAmiTNoon = {
    gasMgoLBoiler: f,
    daLuboilEng: f,
    gasMgoLGen: f,
    windDir: f,
    basisSpeed: f,
    lastModifyTimeZone: f,
    gasMgoHInc: f,
    gasMgoHEng: f,
    etaRequirement: f,
    recordVersion: f,
    spdRestriction: f,
    daDomesticWater: f,
    meKw: f,
    anchoringTm: f,
    createTimeZone: f,
    id: p,
    fuelFoHInc: f,
    fuelFoHEng: f,
    daLuboilCyl: f,
    specialPoint2: f,
    specialPoint1: f,
    robLuboilGen: f,
    runHrs: f,
    createOffice: f,
    isCargoRobFlag: f,
    fuelFoLGen: f,
    meAvgRpm: f,
    sailingStatus: f,
    avgSpd: f,
    robMgoH: f,
    reservedDate: f,
    robMgoL: f,
    latitude: f,
    robFoH: f,
    rpmRestriction: f,
    robFoL: f,
    ttlHsmgo: f,
    baseInfoId: f,
    otherRqmnt: f,
    principalOrgCode: f,
    robLuboilCyl: f,
    windScale: f,
    creator: f,
    sulphurHmgo: f,
    totalRunTime: f,
    ataPassTime1: f,
    fuelFoLBoiler: f,
    fuelFoHIgg: f,
    ataPassTime2: f,
    createTime: f,
    slip: f,
    shiftingTm: f,
    lastModifyTime: f,
    ttlHsfo: f,
    gasMgoLIgg: f,
    fuelFoHOther: f,
    robLuboilEng: f,
    gasMgoHGen: f,
    seaTemp: f,
    fuelFoLIgg: f,
    gasMgoLInc: f,
    gasMgoLEng: f,
    runDist: f,
    distGo: f,
    totalTm: f,
    calPurposeNextPort: f,
    totalRunDist: f,
    robDomesticWater: f,
    longitude: f,
    lastModifyBy: f,
    fuelFoLInc: f,
    fuelFoLEng: f,
    reservedLong2: f,
    gasMgoHOther: f,
    ttlLsmgo: f,
    reservedLong1: f,
    daLuboilGen: f,
    fuelFoHGen: f,
    gasMgoLOther: f,
    ttlLsfo: f,
    fuelFoLOther: f,
    sulphurHfo: f,
    remark: f,
    sulphurLfo: f,
    fuelOilInertTemp: f,
    daBoilerWater: f,
    waveHeight: f,
    currDir: f,
    reservedStr3: f,
    cargoRob: f,
    reservedStr2: f,
    reservedStr1: f,
    nextPortCd: f,
    oilFlowRate: f,
    foRestriction: f,
    reservedInt1: f,
    reservedInt2: f,
    driftingTm: f,
    lastModifyOffice: f,
    sulphurLmgo: f,
    fuelFoHBoiler: f,
    crs: f,
    airTemp: f,
    etaNextPort: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    velocity: f,
    waveDir: f,
    obsSpeed: f,
    shiftingDist: f,
    gasMgoHBoiler: f,
    etaSpecialTime1: f,
    robBoilerWater: f,
    gasMgoHIgg: f,
    etaSpecialTime2: f
  };
  ds.QMtrInventoryRecordVir = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    dept: f,
    materialInfoId: f,
    validPeriod: f,
    materialVersion: f,
    locationId: f,
    supplierId: f,
    supplierNameEn: f,
    supplierNameCn: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    productId: f,
    businessId: f,
    businessNo: f,
    sendFinanceTime: f,
    creatorNameEn: f,
    creatorNameCn: f,
    invoicePrice: f
  };
  ds.QFinFuelStockQuantity = {
    id: p,
    vesselName: f,
    vesselCode: f,
    voyageNo: f,
    operationNo: f,
    batchNo: f,
    unitPrice: f,
    amountMoney: f,
    stockStatus: f,
    bunkerSpec: f,
    leftQuantity: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    stockQuantity: f,
    stockTime: f,
    status: f,
    exchangeRate: f,
    currency: f,
    companyNameEn: f,
    companyNameCn: f,
    taxRate: f,
    companyId: f,
    companyCode: f,
    supplierCode: f,
    supplierName: f,
    ispFleetCode: f,
    refuelType: f,
    vesselNameEn: f,
    specialBatch: f
  };
  ds.QMtrVesselMaterialInfo = {
    reservedDate: f,
    lastModifyTimeZone: f,
    vesselId: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    locationId: f,
    vesselNameCn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    personInCharge: f,
    vesselNameEn: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    productId: f,
    materialInfoId: f,
    reservedLong2: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    maxStockQty: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    minStockQty: f,
    location: new c("SpsLocationInfo")
  };
  ds.QOpsFuelFuturesContract = {
    contractDate: f,
    contractNo: f,
    supplierCode: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    supplierRemarks: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    approvalStatus: f,
    supplierName: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    contractStatus: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    createName: f,
    remarks: f,
    ispFleetCode: f,
    estFuelVesselCode: f,
    estFuelVesselName: f,
    estFuelEnddate: f,
    estFuelPortName: f,
    estFuelStartdate: f,
    estFuelPortCode: f,
    estFuelPortNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    estFuelVesselNameEn: f,
    supplierNameEn: f
  };
  ds.QActIdInfo = {
    id: p,
    rev: f,
    userId: f,
    type: f,
    key: f,
    value: f,
    password: f,
    parentId: f
  };
  ds.QSysTaskConfig = {
    id: p,
    taskType: f,
    taskCode: f,
    taskName: f,
    taskSummaryType: f,
    taskNameLeft: f,
    taskNameRight: f,
    modeKey: f,
    modelTypeKey: f,
    activeDate: f,
    invalidDate: f,
    deletedFlag: f,
    validFlag: f,
    autoMethodError: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    taskNameEn: f,
    taskNameCn: f,
    companyName: f,
    companyCode: f,
    companyId: f,
    companyNameEn: f
  };
  ds.QAmiBArrBerth = {
    id: p,
    baseInfoId: f,
    portCode: f,
    endSailingTm: f,
    endMFoH: f,
    endMFoL: f,
    endMMgoH: f,
    endMMgoL: f,
    ata: f,
    ataMFoH: f,
    ataMFoL: f,
    ataMMgoH: f,
    ataMMgoL: f,
    ataMWater: f,
    macLuboilEng: f,
    macLuboilCyl: f,
    macLuboilGen: f,
    df: f,
    da: f,
    pilotageOnShipTm: f,
    firstRopeAshoreTm: f,
    ttlCableReadyTm: f,
    pilotageOffShipTm: f,
    cargoInspectionTm: f,
    operationType: f,
    commLdOrDischTm: f,
    estDepartureTm: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    ttlWater: f,
    acFoH: f,
    acFoL: f,
    acMgoH: f,
    acMgoL: f,
    acWater: f,
    quantilyTugboat: f,
    actSailingHrs: f,
    runDist: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    theoreticalSpd: f,
    slip: f,
    remark: f,
    berthedName: f,
    asp: f,
    waterDensity: f,
    fwe: f,
    berthedSide1: f,
    arrivedTime: f,
    remarkSea: f,
    latitude: f,
    longitude: f,
    drifttime: f,
    trantime: f,
    distToquay: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    berHsfo: f,
    berLsfo: f,
    berHsmgo: f,
    berLsmgo: f,
    berAWater: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasMLuboilEng: f,
    gasMLuboilGen: f,
    gasMLuboilCyl: f,
    avPuelMainH: f,
    avPuelMainL: f,
    avPuelAuxH: f,
    avPuelAuxL: f,
    avPuelBoilerH: f,
    avPuelBoilerL: f,
    avPuelIncH: f,
    avPuelIncL: f,
    avPuelSulphurH: f,
    avPuelSulphurL: f,
    avGasMainH: f,
    avGasMainL: f,
    avGasAuxH: f,
    avGasAuxL: f,
    avGasBoilerH: f,
    avGasBoilerL: f,
    avGasIncH: f,
    avGasIncL: f,
    avGasSulphurH: f,
    avGasSulphurL: f,
    avMLuboilEng: f,
    avMLuboilGen: f,
    avMLuboilCyl: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    portNameCn: f,
    portNameEn: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f,
    dailySailingRunTime: f,
    dailySailingRunDist: f
  };
  ds.QRipSendAttachmentReminder = {
    id: p,
    qualificationType: f,
    ripBaseInfoId: f,
    attachmentId: f,
    attachmentName: f,
    expireTime: f,
    firstSendTime: f,
    secondSendTime: f,
    lastModifyTime: f,
    lastModifyBy: f
  };
  ds.QFsUploaderStrategy = {
    id: p,
    bucketName: f,
    allowExtensions: f,
    sizeLimit: f,
    countLimit: f,
    isLogicDelete: f,
    largeThumbnailSize: f,
    smallThumbnailSize: f
  };
  ds.QCdmPortMile = {
    id: p,
    startPortCode: f,
    startPortName: f,
    endPortCode: f,
    endPortName: f,
    portDistance: f,
    comments: f,
    validFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    lowSulfurDistance: f
  };
  ds.QCdmVesselPortFuelCost = {
    id: p,
    mainId: f,
    bunkerCost: f,
    bunkerId: f,
    bunkerSpec: f,
    portType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    foCargoHeating: f,
    foTankCleaning: f,
    foInerting: f,
    mgoInertGasGenerator: f
  };
  ds.QOpsInsInvoicePay = {
    dueDate: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    coverDays: f,
    comPaymentApplicationId: f,
    principalOrgCode: f,
    vesselCode: f,
    opsInsInvoiceId: f,
    createTimeZone: f,
    stagesNum: f,
    id: p,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    underwriteDatee: f,
    insItems: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    createName: f,
    underwriteDates: f,
    ispFleetCode: f,
    remark: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    rpType: f,
    baseAmount: f,
    baseCurrencyCode: f
  };
  ds.QFineLabel = {
    id: p,
    labelname: f,
    relatedtype: f
  };
  ds.QFinReceiptAuditSub = {
    id: f,
    receiptAuditId: f,
    receiptId: f,
    vesselId: f,
    vesselNameCn: f,
    vesselNameEn: f,
    receiptSceneCode: f,
    deletedFlag: f,
    recordVersion: f
  };
  ds.QFinReceiptAudit = {
    id: f,
    submitTime: f,
    submitUserCode: f,
    submitUserName: f,
    submitSubject: f,
    auditor: f,
    auditStatus: f,
    auditRemark: f,
    auditTime: f,
    deletedFlag: f,
    recordVersion: f
  };
  ds.QRipAnnualEvaluation = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    evalDate: f,
    remark: f,
    evalYear: f,
    evalDept: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    auditStatus: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    evaluator: f,
    ripAnnualEvalDetails: new c("RipAnnualEvalDetails")
  };
  ds.QFineLoginLock = {
    id: p,
    errortime: f,
    lockobject: f,
    lockobjectvalue: f,
    locktime: f,
    locked: f,
    unlocktime: f,
    userid: f
  };
  ds.QOpsLoiSecondSetBl = {
    lastModifyOffice: f,
    originFirstBl: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    opsLoiId: f,
    createOffice: f,
    createTime: f,
    revisedSecondBl: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    items: f,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineSentinelTodos = {
    id: p,
    assignee: f,
    creator: f,
    deadline: f,
    resultid: f,
    solved: f,
    solvedtimestamp: f,
    taskid: f,
    todoname: f,
    todoremark: f
  };
  ds.QFineDepartment = {
    id: f,
    tenantid: f,
    alias: f,
    creationtype: f,
    description: f,
    enable: f,
    fullpath: f,
    lastoperationtype: f,
    name: f,
    parentid: f
  };
  ds.QChrContractRentIndexRange = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    indexFloor: f,
    indexCeiling: f,
    indexFormula: f,
    contractNo: f,
    contractVersion: f,
    rentId: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QRipBankInfoChange = {
    country: f,
    validFlag: f,
    countryNameCn: f,
    swiftCode: f,
    remark: f,
    typ: f,
    ripBaseInfoChangeId: f,
    countryNameEn: f,
    lastModifyTimeZone: f,
    payee: f,
    corrBankAccount: f,
    corrCountry: f,
    recordVersion: f,
    payType: f,
    bankNo: f,
    receivingBankAccount: f,
    receivingBank: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    corrBank: f,
    auditDate: f,
    lastModifyOffice: f,
    bankInfo: f,
    creator: f,
    lastModifyBy: f,
    auditor: f,
    hcbId: f,
    corrBankSwiftCode: f,
    bankOther: f,
    bankAddress: f,
    corrAddress: f,
    payeeAddress: f,
    corrCountryNameEn: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    auditStatus: f,
    billflag: f,
    baseBankId: f,
    bankCode: f,
    corrCountryNameCn: f,
    prohibitedStatus: f
  };
  ds.QOpsInsExagreementOther = {
    id: p,
    opsInsExagreementId: f,
    voyageNo: f,
    vesselCode: f,
    vesselName: f,
    insStart: f,
    insEnd: f,
    insDays: f,
    premium: f,
    tax: f,
    brokerRate: f,
    brokerComm: f,
    netPremium: f,
    ispFleetCode: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f
  };
  ds.QChrSettlementFreight = {
    id: p,
    mainId: f,
    ws: f,
    frtRate: f,
    cargoQuantity: f,
    cargoCode: f,
    cargoName: f,
    cpMinimum: f,
    overageRate: f,
    actualFreight: f,
    grossFlag: f,
    freightIsAll: f,
    charertersCode: f,
    charerterName: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    invoceType: f,
    invoiceNo: f,
    cpMaximum: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    ilow: f,
    cargoNameEn: f,
    chrSettlementCargoOverList: new c("ChrSettlementCargoOver")
  };
  ds.QFineOutputClientNotice = {
    id: p,
    addressee: f,
    content: f,
    customizelink: f,
    linkopentype: f,
    mediaid: f,
    subject: f,
    terminal: f,
    type: f
  };
  ds.QChrSettlementOthers = {
    id: p,
    mainId: f,
    rpType: f,
    chargeCode: f,
    chargeName: f,
    amount: f,
    othersIsAll: f,
    chargeDescription: f,
    grossFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    estimatedAmount: f,
    othersType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f,
    orderId: f
  };
  ds.QAmclAmiTDepDischPumping = {
    id: f,
    reportNo: f,
    sADRate: f,
    sADPressure: f,
    pHours: f,
    pUsed: f,
    mPressure: f,
    tCow: f,
    bHConcurrent: f,
    bHSeparate: f,
    sdtCow: f,
    sdtStripping: f,
    sdtShore: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QOpsVoyageInPort = {
    portSequence: f,
    remark: f,
    portStatus: f,
    lastModifyTimeZone: f,
    voyageType: f,
    recordVersion: f,
    principalOrgCode: f,
    company: f,
    startTime: f,
    createTimeZone: f,
    id: p,
    portZone: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    actDays: f,
    portCode: f,
    lastModifyByName: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    endTime: f,
    createName: f,
    ispFleetCode: f,
    endTimeFlag: f,
    startTimeFlag: f,
    opsVoyagePortId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    checkFlag: f
  };
  ds.QTaskLog = {
    id: p,
    taskType: f,
    executionId: f,
    modelLogId: f,
    activityId: f,
    taskDefinitionId: f,
    begin: f,
    end: f,
    operatorId: f,
    operator: f,
    operateStatus: f,
    content: f,
    activityName: f,
    execTime: f,
    dueDate: f,
    status: f,
    notifyType: f,
    notifyCount: f,
    uri: f
  };
  ds.QRipServiceTypeSetHistory = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    serviceCode: f,
    remark: f,
    nameEn: f,
    ripBaseInfoHistoryId: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    hcbCode: f
  };
  ds.QPchVessel = {
    company: f,
    vesselName: f,
    vesselCode: f,
    vesselId: f
  };
  ds.QOpsVoyageRmk = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    opsVoyageTaskId: f,
    lastModifyOfficeName: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    ispFleetCode: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QOpsVoyagePortOil = {
    id: p,
    opsVoyagePortId: f,
    oilType: f,
    ispFleetCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    arrivalOilQty: f,
    faOilQty: f,
    esopOilQty: f,
    departureOilQty: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    berthingOilQty: f
  };
  ds.QActHiIdentitylink = {
    id: p,
    groupId: f,
    type: f,
    userId: f,
    taskId: f,
    procInstId: f
  };
  ds.QRipBaseInfoHistory = {
    countryNameCn: f,
    remark: f,
    ripBaseInfoChangeId: f,
    uuid: f,
    countryNameEn: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    createTimeZone: f,
    internalExternal: f,
    ripCode: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    nature: f,
    countryRegion: f,
    hcbCode: f,
    nameCn: f,
    nameEn: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    ripType: f,
    lastModifyTime: f,
    productsService: f,
    shortName: f,
    ripBaseInfoId: f,
    applicantStatus: f,
    applicantOffice: f,
    applicantTime: f,
    changeApplicant: f,
    changeApplicantEn: f,
    applicantOfficeEn: f,
    uniSoCreditCode: f,
    initialEvaluateStatus: f,
    corporateCode: f,
    gradeState: f,
    province: f,
    bizStatus: f,
    isCustGrade: f,
    redAddr: f,
    telephone: f,
    stockCode: f,
    isoType: f,
    redAddrEn: f,
    regDt: f,
    regPerson: f,
    easCode: f,
    areaCd: f,
    vipFlag: f,
    initialEvalDate: f,
    provinceEn: f,
    regMoney: f,
    mainDataStatus: f,
    industry: f,
    settlementcenterCd: f,
    businessNo: f,
    web: f,
    parentCode: f,
    areaNm: f,
    expireDate: f,
    company: f,
    taxNo: f,
    email: f,
    effectDate: f,
    settlementcenterNm: f,
    ifRoot: f,
    otherPhone: f,
    headquartersName: f,
    provinceCn: f,
    customerGrade: f,
    historyVersion: f,
    industryClassification: f,
    isSupplier: f,
    partnerType: f,
    registeredCurrency: f,
    city: f,
    beforeName: f,
    groupEnterpriseNature: f,
    isCustomer: f,
    isListed: f,
    isStrategy: f,
    ripBamkInfoHistories: new c("RipBankInfoHistory"),
    ripServiceTypeSetHistories: new c("RipServiceTypeSetHistory"),
    ripBankInfoHistories: new c("RipBankInfoHistory")
  };
  ds.QComCmllaytimeIssue = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    charterView: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    deductId: f,
    recordVersion: f,
    cmllaytimeId: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    ownerView: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QOpsOilBunkerDetail = {
    sulfurQty: f,
    marketPrice: f,
    bdnNumber: f,
    remark: f,
    bunkerId: f,
    lastModifyTimeZone: f,
    receiptPrice: f,
    recordVersion: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    actQty: f,
    lastModifyByName: f,
    isobrand: f,
    viscosity: f,
    estQty: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    createName: f,
    bunkerSpec: f,
    ispFleetCode: f,
    appraisalQtyQuality: f,
    appraisalDetention: f,
    appraisalService: f,
    leftQty: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QActRuTimerJob = {
    id: p,
    rev: f,
    type: f,
    lockExpTime: f,
    lockOwner: f,
    exclusive: f,
    executionId: f,
    processInstanceId: f,
    procDefId: f,
    retries: f,
    exceptionStackId: f,
    exceptionMsg: f,
    duedate: f,
    repeat: f,
    handlerType: f,
    handlerCfg: f,
    tenantId: f
  };
  ds.QChrPreSettlementBunkerCompleted = {
    id: p,
    mainId: f,
    bunkerQuantity: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    bunkerType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFinEstimateErrorOrder = {
    id: p,
    mainId: f,
    errorOrderId: f,
    errorOrder: f,
    errorOrderType: f,
    orderDealDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f
  };
  ds.QSpsPoStockingDetail = {
    id: p,
    vesselId: f,
    vesselCode: f,
    poMainStockingId: f,
    poDetailId: f,
    stockingQty: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    mtrPoDetail: new c("MtrPoDetail"),
    spsPoDetail: new c("SpsPoDetail")
  };
  ds.QAmiBBerth = {
    id: p,
    baseInfoId: f,
    portCode: f,
    engReadyTm: f,
    startBringAnchorTm: f,
    anchorAweighTm: f,
    pilotageOnShipTm: f,
    firstRopeAshoreTm: f,
    ttlCableReadyTm: f,
    pilotageOffShipTm: f,
    cargoInspectionTm: f,
    commLdOrDischTm: f,
    estDepartureTm: f,
    quantilyTugboat: f,
    remark: f,
    berthedName: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    fw: f,
    da: f,
    df: f,
    berthedSide1: f,
    waterDensity: f,
    distAnchQuay: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    portNameCn: f,
    portNameEn: f,
    completionTime: f,
    berthedSide2: f,
    nowBerthedno: f,
    mgoLConsumptionSum: f,
    foLConsumptionSum: f,
    foHConsumptionSum: f,
    mgoHConsumptionSum: f
  };
  ds.QOpsInsInvoice = {
    fleet: f,
    dueDate: f,
    customerCode: f,
    lockOrder: f,
    lastModifyTimeZone: f,
    sumStagesNum: f,
    recordVersion: f,
    coverDays: f,
    draft: f,
    invoiceType: f,
    principalOrgCode: f,
    currency: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    changeRate: f,
    invoiceNo: f,
    refundAmount: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    insYear: f,
    feeType: f,
    invoiceDate: f,
    lastModifyByName: f,
    customerName: f,
    underwriteDatee: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    clubYear: f,
    refundRate: f,
    currencyTo: f,
    createName: f,
    underwriteDates: f,
    ispFleetCode: f,
    paymentApplicationId: f,
    remark: f,
    insType: f,
    vesselName: f,
    insCompanyCode: f,
    taxRate: f,
    taxAmount: f,
    changeAmount: f,
    originAmount: f,
    insCompanyName: f,
    quitType: f,
    particular: f,
    rpType: f,
    currencyName: f,
    currencyToName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    customerNameEn: f,
    insCompanyNameEn: f,
    vesselNameEn: f,
    bankInfoId: f,
    bankInfo: f,
    settleOfficeCode: f,
    accountName: f,
    settleOfficeName: f,
    accountNo: f,
    settleOfficeNameEn: f,
    submitFlag: f,
    rpTypeDetail: f,
    invalidFlag: f,
    invalidReason: f,
    invalidUserName: f,
    invalidTime: f,
    invalidUser: f,
    invoiceFlag: f,
    opsInsInvoiceDetail: new c("OpsInsInvoiceDetail"),
    opsInsInvoicePay: new c("OpsInsInvoicePay")
  };
  ds.QOpsShippingline = {
    shippingLineType: f,
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    code: f,
    cnName: f,
    enName: f,
    recordStatus: f,
    sequenceNo: f,
    validFlag: f,
    ispFleetCode: f,
    bigCode: f,
    remark: f,
    bigCnName: f,
    bigEnName: f,
    companyName: f,
    companyId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    tradingArea: f
  };
  ds.QQmHighRiskAreas = {
    id: p,
    areaType: f,
    countryCode: f,
    countryNameCn: f,
    countryNameEn: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    riskDescribe: f,
    riskMeasure: f,
    riskType: f,
    riskTypeNameCn: f,
    riskTypeNameEn: f,
    effectiveDate: f,
    expiryDate: f,
    validFlag: f,
    areaRemark: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    creatorNameCn: f,
    creatorNameEn: f,
    createOfficeCn: f,
    createOfficeEn: f
  };
  ds.QFineLastLogin = {
    id: p,
    city: f,
    ip: f,
    time: f,
    userid: f
  };
  ds.QComPaymentInvoice = {
    lastModifyOffice: f,
    creator: f,
    amount: f,
    rpType: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    paymentApplicationId: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    principalOrgCode: f,
    invoiceId: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    createName: f,
    invoiceSource: f,
    comPortPdaId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QOpsVoyageTaskOil = {
    id: p,
    oilType: f,
    ispFleetCode: f,
    company: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    opsVoyageTaskId: f,
    endOilQty: f,
    startOilQty: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QActHiAttachment = {
    id: p,
    rev: f,
    userId: f,
    name: f,
    description: f,
    type: f,
    taskId: f,
    procInstId: f,
    url: f,
    contentId: f,
    time: f
  };
  ds.QChrPreSettlementOthers = {
    id: p,
    mainId: f,
    rpType: f,
    chargeCode: f,
    chargeName: f,
    chargeDescription: f,
    grossFlag: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    othersIsAll: f,
    actualAmount: f,
    estimatedAmount: f,
    othersType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f,
    orderId: f
  };
  ds.QBookCargoListApprove = {
    id: p,
    cargoListId: f,
    cargoListNo: f,
    oldVesselCode: f,
    oldVesselName: f,
    oldVesselNameEn: f,
    oldVoyageNo: f,
    newVesselCode: f,
    newVesselName: f,
    newVesselNameEn: f,
    newVoyageNo: f,
    subjectTitle: f,
    approvalStatus: f,
    invalidUser: f,
    invalidUserName: f,
    invalidTime: f,
    invalidReason: f,
    handleTaskNode: f,
    handleUserName: f,
    workflowRestartFlag: f,
    exCountersignFlag: f,
    approvalProcessCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extendInt1: f,
    extendInt2: f,
    extendLong1: f,
    extendLong2: f,
    extendDecimal1: f,
    extendDecimal2: f,
    extendDate: f,
    extendStr1: f,
    extendStr2: f,
    extendStr3: f
  };
  ds.QComArInvoice = {
    fdaReceivedDate: f,
    partnerAccountNo: f,
    substitutePartnerName: f,
    partnerBankInfoId: f,
    agentCode: f,
    contractType: f,
    dueDate: f,
    stlDate: f,
    vesselBuildFlag: f,
    invoiceAmount: f,
    submitFlag: f,
    contactTel: f,
    voyagePortId: f,
    lastModifyTimeZone: f,
    bankInfoId: f,
    recordVersion: f,
    exchangeRate: f,
    checkUserName: f,
    invoiceType: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    docCollectFlag: f,
    bankInfo: f,
    settleOfficeCode: f,
    lastModifyBy: f,
    offsetAmount: f,
    finalFlag: f,
    lastModifyOfficeName: f,
    agentName: f,
    invalidFlag: f,
    creditNoteFlag: f,
    particular: f,
    docNo: f,
    baseCurrencyName: f,
    substitutePartnerCode: f,
    urlCode: f,
    checkFlag: f,
    checkUser: f,
    partnerContactAddr: f,
    pdaBalanceFlag: f,
    createOffice: f,
    createOfficeName: f,
    installment: f,
    dockRepairFlag: f,
    vesselCmpInfo: f,
    createName: f,
    vesselName: f,
    partnerAccountName: f,
    rpType: f,
    partnerCode: f,
    autoTaxInvFlag: f,
    accountName: f,
    contractNo: f,
    invalidUserName: f,
    settleOfficeName: f,
    bankName: f,
    remark: f,
    rpTypeDetail: f,
    portName: f,
    invalidTime: f,
    paymentAmount: f,
    manageCmpInfo: f,
    partnerBankName: f,
    invalidUser: f,
    ispFleetCode: f,
    currencyName: f,
    contactAddr: f,
    accountNo: f,
    substituteFlag: f,
    principalOrgCode: f,
    approvalStatus: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    partnerName: f,
    paymentApplicationId: f,
    portCode: f,
    checkDate: f,
    invoiceDate: f,
    lastModifyByName: f,
    partnerContactTel: f,
    baseCurrencyCode: f,
    createTime: f,
    lastModifyTime: f,
    allinFlag: f,
    contractId: f,
    baseInvoiceAmount: f,
    businessType: f,
    currencyCode: f,
    contractName: f,
    freightYm: f,
    currentPercent: f,
    cancelInvoiceNo: f,
    invoiceProperty: f,
    rentBillMode: f,
    voyageExpenses: f,
    imageNo: f,
    electSeal: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    exTaxation: f,
    taxRate: f,
    invalidReason: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    workflowRestartFlag: f,
    portChargeAmount: f,
    agentNameEn: f,
    vesselNameEn: f,
    partnerNameEn: f,
    settleOfficeNameEn: f,
    companyCode: f,
    companyName: f,
    companyNameEn: f,
    csNameEn: f,
    csCode: f,
    csName: f,
    feeType: f,
    changeRate: f,
    insType: f,
    insYear: f,
    originInvoiceNo: f,
    lockOrder: f,
    handleUserName: f,
    handleTaskNode: f,
    comInvoiceApprove: new c("ComInvoiceApprove"),
    comArInvoiceDtl: new c("ComArInvoiceDtl"),
    comArInvoiceAllDtl: new c("ComArInvoiceAllDtl")
  };
  ds.QChrContractRentIndexLink = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    indexRounte: f,
    indexWeight: f,
    contractVersion: f,
    rentId: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QAmiMonthEnvironment = {
    id: p,
    monthOilId: f,
    gbatsea: f,
    gbincinerator: f,
    gbreception: f,
    oilreception: f,
    oilodme: f,
    oilows: f,
    sludge: f,
    paint: f,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    senddate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselEnName: f,
    vesselCnName: f,
    tankDeslopping: f,
    tankOdme: f,
    amiMonthGas: new c("AmiMonthGas")
  };
  ds.QFinSettlementReportTc = {
    estimateGenerateReason: f,
    checkPassStatus: f,
    checkReason: f,
    id: p,
    mainId: f,
    vesselCode: f,
    vesselName: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    contractNo: f,
    chartererCode: f,
    chartererName: f,
    contractType: f,
    participateReason: f,
    actDelTime: f,
    actRedTime: f,
    estimateGenerateFlag: f,
    estimateGenerateDate: f,
    lastestInvoiceNo: f,
    lastestInvoiceDate: f,
    finalFlag: f,
    period: f,
    period1: f,
    submitFlag: f,
    deletedFlag: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    voyageNo: f,
    estimateNo: f,
    contractStatus: f
  };
  ds.QAmiSuppliedFuelBack1 = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    waterContent: f,
    density: f,
    temperature: f,
    bdnNo: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    bargeAlongsideTm: f,
    hoseConnectedTm: f,
    commencedPumpingTm: f,
    hoseDisconnectedTm: f,
    bargeOffTm: f,
    bargeName: f
  };
  ds.QQrtzFiredTriggers = {
    entryId: f,
    schedName: f,
    firedTime: f,
    instanceName: f,
    isNonconcurrent: f,
    jobGroup: f,
    jobName: f,
    priority: f,
    requestsRecovery: f,
    schedTime: f,
    state: f,
    triggerGroup: f,
    triggerName: f
  };
  ds.QOpsOilAppraisal = {
    hsfoQtyQuality: f,
    hsfoService: f,
    hsmgoActualAvgPrice: f,
    remark: f,
    hsfoActualAvgPrice: f,
    lsfoQtyQuality: f,
    bunkerId: f,
    lsfoActualAvgPrice: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lsfoService: f,
    principalOrgCode: f,
    hsmgoQtyQuality: f,
    hsmgoReceivedQty: f,
    lsfoReceivedQty: f,
    createTimeZone: f,
    id: p,
    deliveryDate: f,
    lsmgoReceivedQty: f,
    lsfoDetention: f,
    lastModifyOffice: f,
    lsmgoQtyQuality: f,
    creator: f,
    lsmgoDetention: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    hsfoDetention: f,
    hsmgoDetention: f,
    lastModifyByName: f,
    hsfoReceivedQty: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    adviseMemo: f,
    lsmgoActualAvgPrice: f,
    lsmgoService: f,
    createName: f,
    hsmgoService: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QQrtzCalendars = {
    calendarName: f,
    schedName: f,
    calendar: f
  };
  ds.QSpsPoFeedBack = {
    id: p,
    vesselId: f,
    vesselCode: f,
    poMainId: f,
    serviceType: f,
    receiveData: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    vesselMaster: f,
    engineer: f,
    supplierId: f,
    commOfReturn: f,
    sameFlag: f,
    services: f,
    quality: f,
    feedBackDate: f,
    remark: f,
    comments: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    engineerNo: f,
    vesselMasterNo: f,
    supplierNameEn: f,
    supplierNameCn: f
  };
  ds.QMtrInquiryDetail = {
    id: p,
    inquiryMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    materialInfoId: f,
    materialCategoryId: f,
    materialCategoryNameCn: f,
    materialCategoryNameEn: f,
    materialNameCn: f,
    materialNameEn: f,
    materialCode: f,
    spec: f,
    specEn: f,
    unit: f,
    minStockQty: f,
    validPeriod: f,
    materialVersion: f,
    harmfulFlag: f,
    applyQty: f,
    enquireQty: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    orderCode: f,
    existVersion: f,
    newVersion: f,
    inquiryDetailRemark: f
  };
  ds.QBookEstimatePort = {
    id: p,
    mainId: f,
    portSequence: f,
    portCode: f,
    portName: f,
    portNameEn: f,
    workType: f,
    portDistance: f,
    weatherFactors: f,
    speed: f,
    seaDays: f,
    ldDays: f,
    lowSulfurArea: f,
    isLowSulfurArea: f,
    isShipCrane: f,
    lowSulfurAreaDay: f,
    notworkDays: f,
    workDays: f,
    portDays: f,
    portExpense: f,
    lodDisFee: f,
    timeZone: f,
    eta: f,
    etd: f,
    liftingFee: f,
    bindingFee: f,
    rulingFee: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    demurrageCharges: f,
    dispatchCharges: f,
    workEfficiency: f,
    overloadFlag: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    cargoQty: f,
    extraWaitTime: f,
    estWaitTime: f
  };
  ds.QOpsVoyageTask = {
    isEscrowVoyage: f,
    voyageIsuselowspeed: f,
    layCanTimeZone: f,
    voyageFlag: f,
    lastModifyTimeZone: f,
    mulContractVoy: f,
    recordVersion: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    voyageStatus: f,
    dispatcherName: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    layCanTimeStar: f,
    tradeFlag: f,
    endVoyageMonth: f,
    route: f,
    createOffice: f,
    createOfficeName: f,
    specialFlag: f,
    createName: f,
    bunkeringTime: f,
    vesselName: f,
    isLoi: f,
    operFlag: f,
    endPortCode: f,
    remark: f,
    voyageIsdd: f,
    voyageType: f,
    principalOrgCode: f,
    currency: f,
    voyageIscutout: f,
    layCanTimeEnd: f,
    voyageNo: f,
    lastModifyOffice: f,
    endPortName: f,
    creator: f,
    cargoGroup: f,
    lastModifyByName: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    planDockingDays: f,
    operatingCompany: f,
    ispFleetCode: f,
    ownerShip: f,
    dispatcherCode: f,
    vesselType: f,
    endTimeZone: f,
    endWater: f,
    endDoL: f,
    endFoH: f,
    endDoH: f,
    endFoL: f,
    lfoFee: f,
    ldoFee: f,
    hdoFee: f,
    hfoFee: f,
    isInit: f,
    operatingCompanyCode: f,
    startWater: f,
    startFoL: f,
    startFoH: f,
    startDoL: f,
    startDoH: f,
    startPortName: f,
    startTimeZone: f,
    startPortCode: f,
    interSubletFlag: f,
    commenceGmt: f,
    completeLt: f,
    charterVoyageNo: f,
    completeGmt: f,
    commenceLt: f,
    commenceFlag: f,
    completeFlag: f,
    dispatcherCode1: f,
    dispatcherName1: f,
    fuelNature: f,
    oilConfirm: f,
    endPortNameEn: f,
    startPortNameEn: f,
    managerNameEn: f,
    managerNameCn: f,
    extend3: f,
    managerCode: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    comment: f,
    dispatcherNameEn: f,
    vesselNameEn: f,
    routeEn: f,
    operatingCompanyEn: f,
    exchangeRate: f,
    taxRate: f,
    routeCn: f,
    escrowVoyageType: f,
    opsLoi: new c("OpsLoi"),
    opsVoyageTaskOil: new c("OpsVoyageTaskOil"),
    opsVoyageInit: new c("OpsVoyageInit"),
    opsVoyagePoint: new c("OpsVoyagePoint"),
    opsVoyageCargo: new c("OpsVoyageCargo"),
    opsVoyageSpecialEvents: new c("OpsVoyageSpecialEvents"),
    opsVoyagePort: new c("OpsVoyagePort"),
    opsVoyageSpeed: new c("OpsVoyageSpeed"),
    opsVoyageCp: new c("OpsVoyageCp"),
    opsOilBunker: new c("OpsOilBunker"),
    opsVoyageOtherfee: new c("OpsVoyageOtherfee")
  };
  ds.QAmclAmiTBunkerAdjustmentDetail = {
    id: p,
    fileid: f,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    vesselCd: f,
    reportNo: f,
    suppliedFuelId: f,
    isInitData: f,
    adjustToRob: f,
    variableAmount: f,
    reason: f,
    deletedFlag: f
  };
  ds.QNodeSeqLog = {
    id: f,
    modelLogId: f,
    currActivityId: f,
    preActivityId: f,
    sdkUsers: f
  };
  ds.QSpsInquiryMain = {
    id: p,
    applyMainId: f,
    vesselId: f,
    vesselCode: f,
    applyNo: f,
    enquireNo: f,
    supplierId: f,
    enquireDate: f,
    enquirer: f,
    enquireStatus: f,
    enquireRemark: f,
    comparePriceFlag: f,
    centralizedFlag: f,
    enquireGroup: f,
    orderType: f,
    equipmentType: f,
    specBusinessMark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    devInfoId: f,
    supplierNameEn: f,
    vesselNameCn: f,
    supplierNameCn: f,
    vesselNameEn: f,
    baseCurrency: f,
    electricFlag: f,
    devFlag: f,
    devVesselCodeId: f
  };
  ds.QSpsInquiryDetail = {
    id: p,
    inquiryMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    partsInfoId: f,
    partsNameCn: f,
    partsCode: f,
    partsNameEn: f,
    partsDrawing: f,
    partsDrawingItem: f,
    unit: f,
    minStockQty: f,
    harmfulFlag: f,
    applyQty: f,
    enquireQty: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    partsType: f,
    devModel: f,
    devCode: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    devNameEn: f,
    devNameCn: f,
    devInfoId: f,
    devSerialNo: f,
    devMakerId: f,
    devFlag: f,
    devVesselCodeId: f,
    inquiryDetailRemark: f,
    partsModel: f
  };
  ds.QSysTempMailSupplier = {
    id: p,
    tempMailId: f,
    supplierId: f,
    supplierCode: f,
    supplierNameEn: f,
    supplierNameCn: f,
    supplierSeq: f,
    complianceAttachId: f,
    integrityAttachId: f,
    mailTo: f,
    mailCc: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    creator: f
  };
  ds.QBookCargoList = {
    id: p,
    cargoListNo: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    voyageNo: f,
    status: f,
    cargoListPic: f,
    cargoListPicName: f,
    cargoListPicNameEn: f,
    changeVygStatus: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extendInt1: f,
    extendInt2: f,
    extendLong1: f,
    extendLong2: f,
    extendDecimal1: f,
    extendDecimal2: f,
    extendDate: f,
    extendStr1: f,
    extendStr2: f,
    extendStr3: f,
    bookCargoListDetail: new c("BookCargoListDetail"),
    bookCargoListApprove: new c("BookCargoListApprove")
  };
  ds.QVscLogAttachmentFile = {
    id: p,
    vesselId: f,
    vesselCode: f,
    attachmentFileId: f,
    attachmentName: f,
    attachmentUrl: f,
    uploaderStragegyId: f,
    attachmentSize: f,
    priority: f,
    logType: f,
    sendFlag: f,
    oppositeCommit: f,
    parseStatus: f,
    logFileId: f,
    referenceId: f,
    referenceTable: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cdmVesselGeneral: new c("CdmVesselGeneral"),
    vscLogFile: new c("VscLogFile")
  };
  ds.QChrSettlementPort = {
    id: p,
    mainId: f,
    portCode: f,
    portName: f,
    portPurpose: f,
    distance: f,
    speed: f,
    weatherFactor: f,
    sailDate: f,
    unloadQty: f,
    loadQty: f,
    ldEfficiency: f,
    ldTotal: f,
    ttTime: f,
    nonOperationInPort: f,
    inPortTime: f,
    timeZone: f,
    arrivalTime: f,
    departureTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    portSequence: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f,
    ballastOverload: f,
    laycanWaitTime: f
  };
  ds.QTimerVersion = {
    timerId: p,
    identifier: f,
    version: f,
    modifyTime: f
  };
  ds.QChrContractApprove = {
    icaClause: f,
    approveStatus: f,
    approveType: f,
    paramountClauseRemark: f,
    contractDate: f,
    otherSpClauseRemark: f,
    otherSpClause: f,
    contractType: f,
    contractNo: f,
    jurisdiction: f,
    remark: f,
    title: f,
    associatedContract: f,
    contractVersion: f,
    associatedContractRemark: f,
    lastModifyTimeZone: f,
    authorizeDischarge: f,
    btb: f,
    ourProformaContract: f,
    creditCheck: f,
    recordVersion: f,
    attachmentList: f,
    riskCheckFlag: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    cargoRentRemark: f,
    icaClauseRemark: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    applicableLaw: f,
    creditCheckRemark: f,
    creditCheckFlag: f,
    lastModifyByName: f,
    sanctionCheck: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    contractId: f,
    performanceFlag: f,
    btbRemark: f,
    createName: f,
    paramountClause: f,
    sanctionCheckRemark: f,
    handler: f,
    ispFleetCode: f,
    importantFlag: f,
    contractGroup: f,
    exCountersignFlag: f,
    approvalProcessCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    contractAddndate: f,
    contractAmount: f,
    coBackground: f
  };
  ds.QChrContractCargoPlan = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    contractNo: f,
    cargoCode: f,
    cargoQuantity: f,
    remark: f,
    lastModifyByName: f,
    contractVersion: f,
    lastModifyTimeZone: f,
    cargoId: f,
    recordVersion: f,
    cargoName: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    cargoLoadStartTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    cargoLoadEndTime: f,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    cargoNameEn: f
  };
  ds.QCdmVesselRadioFuelCostNew = {
    id: p,
    mainId: f,
    bunkerCost: f,
    bunkerId: f,
    bunkerSpec: f,
    voyageType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    voyagoSpeed: f
  };
  ds.QVscTableConfig = {
    id: p,
    datasourceId: f,
    tableName: f,
    tableChineseName: f,
    syncFlag: f,
    syncVesselCondition: f,
    syncShoreCondition: f,
    syncVesselField: f,
    syncVesselSql: f,
    editMode: f,
    editVesselCondition: f,
    editShoreCondition: f,
    showColumnName: f,
    modelName: f,
    modelParser: f,
    syncAttachmentFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    syncByCompanyFlag: f
  };
  ds.QStcPaymentInvoiceDtl = {
    deptName: f,
    shareFlag: f,
    remark: f,
    expenseSource: f,
    lastModifyTimeZone: f,
    vesselId: f,
    deptNameCn: f,
    chargeNameCn: f,
    businessNo: f,
    recordVersion: f,
    payAmount: f,
    specBusinessMark: f,
    vesselNameCn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    chargeName: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    claimAmount: f,
    deptId: f,
    payFor: f,
    taxRate: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    chargeId: f,
    lastModifyTime: f,
    repairPlanId: f,
    safetyAmount: f,
    paymentInvoiceId: f,
    taxAmount: f,
    dataSource: f,
    vesselName: f,
    technicalTransAmount: f,
    chargeCode: f,
    paymentApplicationId: f,
    rate: f,
    localAmount: f,
    conversionMethod: f,
    contractFlag: f,
    repairPlanDate: f,
    miscTax: f,
    taxRateCode: f,
    miscAmount: f,
    miscTaxAmount: f,
    taxBaseAmount: f,
    miscTaxRateCode: f,
    miscTaxBaseAmount: f
  };
  ds.QChrContractMtfwApprove = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    approveDept: f,
    approveOrg: f,
    approver: f,
    briefOption: f,
    contractNo: f,
    contractId: f,
    endTime: f,
    nodeName: f,
    optionDesc: f,
    startTime: f,
    sysFrom2: f,
    sysFrom1: f,
    ispFleetCode: f
  };
  ds.QScheduleAssignInfo = {
    id: p,
    supervisor: f,
    scheduleCode: f,
    createTime: f,
    updateTime: f
  };
  ds.QChrContractStamp = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractVersion: f,
    contractId: f,
    ispFleetCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    stampTime: f,
    stampCount: f
  };
  ds.QDueTaskLog = {
    id: p,
    modelLogId: f,
    taskLogId: f,
    activityId: f,
    activityName: f,
    dueDate: f
  };
  ds.QAmiBdCargo = {
    subLdQtyH1: f,
    subLdQtyH3: f,
    subLdQtyH2: f,
    subLdQtyH5: f,
    subLdQtyH4: f,
    subLdQtyH7: f,
    subLdQtyH6: f,
    subLdQtyH9: f,
    subLdQtyH8: f,
    reservedStr4: f,
    lastModifyTimeZone: f,
    cargoNum: f,
    recordVersion: f,
    reservedStr6: f,
    reservedStr5: f,
    reservedInt3: f,
    principalOrgCode: f,
    reservedInt4: f,
    createTimeZone: f,
    id: p,
    cargoNm: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    reservedDecimal4: f,
    reservedDecimal3: f,
    reservedLong3: f,
    loadDisType: f,
    ttlQty: f,
    subLdQtyH10: f,
    reservedDate2: f,
    createOffice: f,
    createTime: f,
    reservedLong4: f,
    bkDptId: f,
    lastModifyTime: f,
    cargoNameEn: f,
    cargoNameCn: f
  };
  ds.QQrtzCronTriggers = {
    schedName: f,
    triggerGroup: f,
    triggerName: f,
    cronExpression: f,
    timeZoneId: f
  };
  ds.QOpsBlSoRelate = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    blNo: f,
    opsSoId: f,
    soNo: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    opsBlId: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QAmiMonthOilCargo = {
    id: p,
    monthOilMainId: f,
    sno: f,
    pcore: f,
    sport: f,
    stimeBack: f,
    eport: f,
    etimeBack: f,
    status: f,
    loaded: f,
    onboard: f,
    distance: f,
    runtime: f,
    speed: f,
    tmile: f,
    remark: f,
    stime: f,
    etime: f,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    senddate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    eportNameCn: f,
    sportNameCn: f,
    vesselCnName: f,
    eportNameEn: f,
    vesselEnName: f,
    sportNameEn: f,
    opnCheckUser: f,
    asdLock: f,
    opnCheck: f,
    tkrCheck: f,
    trkCheck: f,
    opnCheckDate: f
  };
  ds.QVscSendSerial = {
    id: p,
    vesselId: f,
    vesselCode: f,
    fileType: f,
    stageNo: f,
    sendSerialNo: f,
    commitSerialNo: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QAmiGNoonPoint = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    amiId: f,
    pointName: f,
    etaLt: f,
    arrivedOnLt: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFineConfClassname = {
    id: p,
    classname: f
  };
  ds.QOpsVoyageInit = {
    id: p,
    opsVoyageTaskId: f,
    opsVoyagePortId: f,
    oilType: f,
    oilQty: f,
    receiptPrice: f,
    orderDate: f,
    ispFleetCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    isreceived: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    sulfurQty: f,
    viscosity: f
  };
  ds.QFineDataPortalDynamic = {
    id: p,
    actiontype: f,
    displayname: f,
    entryid: f,
    path: f,
    time: f,
    userid: f
  };
  ds.QAmiSuppliedFuel0614 = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    waterContent: f,
    density: f,
    temperature: f,
    bdnNo: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    bargeAlongsideTm: f,
    hoseConnectedTm: f,
    commencedPumpingTm: f,
    hoseDisconnectedTm: f,
    bargeOffTm: f,
    bargeName: f
  };
  ds.QViewInvoiceBdiValue = {
    indexRounte: f,
    reportTime: f,
    indexValue: f
  };
  ds.QFineBaseMessage = {
    id: p,
    createtime: f,
    datetime: f,
    message: f,
    readed: f,
    toasted: f,
    type: f,
    url: f,
    urltype: f,
    userid: f,
    username: f
  };
  ds.QOpsLoiBl = {
    blNo: f,
    consigneeDesc: f,
    discPortName: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    opsLoiId: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    loadPortName: f,
    discPortCode: f,
    lastModifyOffice: f,
    creator: f,
    cargoDesc: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    cargoQuantity: f,
    lastModifyByName: f,
    notifyDesc: f,
    shipperDesc: f,
    loadPortCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    cargoUnit: f,
    lastModifyTime: f,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    discPortNameEn: f,
    loadPortNameEn: f,
    cargoCode: f,
    cargoName: f
  };
  ds.QAmiVerifyConfigMain = {
    id: p,
    appCompanyId: f,
    appCompanyCode: f,
    appCompanyNameCn: f,
    appCompanyNameEn: f,
    verifyType: f,
    messageGrade: f,
    fieldName: f,
    fieldNameCn: f,
    verifyEnable: f,
    ruleDesc: f,
    msqlRule: f,
    accessRule: f,
    tipsCn: f,
    tipsEn: f,
    verifyTime: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    remark: f,
    ruleDescCn: f,
    messageTitle: f,
    messageTitleCn: f
  };
  ds.QCdmBank = {
    id: p,
    deletedFlag: f,
    bankCode: f,
    bankName: f,
    accountName: f,
    activeFlag: f,
    accountNo: f,
    bankSwiftCode: f,
    countryCode: f,
    accountType: f,
    bankAddress: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    companyCode: f,
    rpType: f
  };
  ds.QSysTempMailItem = {
    id: p,
    tempMailId: f,
    itemId: f,
    itemQty: f,
    itemSeq: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    creator: f
  };
  ds.QFinReceipt = {
    id: p,
    receiptCode: f,
    commitFlag: f,
    settlementFlag: f,
    introduceTtFlag: f,
    beginningRushFlag: f,
    companyId: f,
    companyCode: f,
    companyName: f,
    accountDate: f,
    businessDate: f,
    accountingYear: f,
    accountingMonth: f,
    voucher: f,
    imageCode: f,
    attachmentNum: f,
    refInfo: f,
    receiptSummary: f,
    voucherNo: f,
    auditor: f,
    businessSceneCode: f,
    accountingEngineSceneCode: f,
    sourceId: f,
    appKey: f,
    sendStatus: f,
    vesselId: f,
    vesselCode: f,
    vesselName: f,
    projectNum: f,
    ownerModule: f,
    startDate: f,
    endDate: f,
    receiptRemark: f,
    calFlag: f,
    trendCode: f,
    writeOffFlag: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    resendCount: f,
    specReceiptFlag: f,
    repairPlanId: f,
    apportionmentPeriod: f,
    writeOffId: f,
    isAccountCurrent: f,
    failReason: f,
    isWriteOff: f,
    isNextRush: f,
    businessSceneName: f,
    voucherMonth: f,
    totalAmount: f,
    businessScene: f,
    ispFleetCode: f,
    finReceiptItemList: new c("FinReceiptItem")
  };
  ds.QPmPartsInfo = {
    id: p,
    partsFlag: f,
    partsNameCn: f,
    partsNameEn: f,
    partsCode: f,
    partsDrawing: f,
    partsDrawingPage: f,
    partsDrawingItem: f,
    partsUnit: f,
    partsModel: f,
    safetyQuantity: f,
    partsDeptCode: f,
    postId: f,
    postNameCn: f,
    postNameEn: f,
    partsType: f,
    partsApplyType: f,
    partsSize: f,
    partsWeight: f,
    partsMakerId: f,
    partsMakerNameCn: f,
    partsMakerNameEn: f,
    partsParameter: f,
    proposedPrice: f,
    proposedPriceCurrency: f,
    useStatus: f,
    criticalFlag: f,
    highValueFlag: f,
    monitorFlag: f,
    blindFlag: f,
    harmfulFlag: f,
    partsRemark: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QSysVesselBackup = {
    id: p,
    vesselCode: f,
    backupFile: f,
    backupType: f,
    backupTime: f,
    majorVersion: f,
    minorVersion: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QAmclAmiTBunkerAdjustment = {
    id: p,
    reportNo: f,
    adjustNature: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    measurementLocation: f,
    correctReportId: f,
    correctReportType: f,
    correctReportTm: f,
    modifyTime: f,
    deletedFlag: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QRipBankInfoHistory = {
    country: f,
    validFlag: f,
    countryNameCn: f,
    swiftCode: f,
    remark: f,
    typ: f,
    ripBaseInfoHistoryId: f,
    countryNameEn: f,
    lastModifyTimeZone: f,
    payee: f,
    corrBankAccount: f,
    corrCountry: f,
    recordVersion: f,
    payType: f,
    bankNo: f,
    receivingBankAccount: f,
    receivingBank: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    corrBank: f,
    auditDate: f,
    lastModifyOffice: f,
    bankInfo: f,
    creator: f,
    lastModifyBy: f,
    auditor: f,
    hcbId: f,
    corrBankSwiftCode: f,
    bankOther: f,
    bankAddress: f,
    corrAddress: f,
    payeeAddress: f,
    corrCountryNameEn: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    auditStatus: f,
    billflag: f,
    bankCode: f,
    corrCountryNameCn: f
  };
  ds.QSpsInventoryRecordVir = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameCn: f,
    vesselNameEn: f,
    dept: f,
    devInfoId: f,
    devCode: f,
    devNameCn: f,
    devNameEn: f,
    devMakerId: f,
    devMakerNameCn: f,
    devMakerNameEn: f,
    devModel: f,
    devSerialNo: f,
    partsInfoId: f,
    locationId: f,
    supplierId: f,
    supplierNameCn: f,
    supplierNameEn: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    receivePortCode: f,
    receivePortNameCn: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    productId: f,
    businessId: f,
    businessNo: f,
    devVesselCodeId: f,
    devFlag: f,
    sendFinanceTime: f,
    devTypeId: f,
    devTypeNameCn: f,
    devTypeNameEn: f,
    creatorNameEn: f,
    creatorNameCn: f,
    invoicePrice: f
  };
  ds.QQrtzSchedulerState = {
    instanceName: f,
    schedName: f,
    checkinInterval: f,
    lastCheckinTime: f
  };
  ds.QComPortChargeConfig = {
    id: p,
    chargeCode: f,
    chargeName: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chargeNameEn: f,
    companyCode: f
  };
  ds.QAmiSuppliedLuboil = {
    id: p,
    baseInfoId: f,
    suppliedDate: f,
    engineLub: f,
    generatorLub: f,
    cylinderLub: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselCode: f,
    vesselId: f,
    isInitData: f
  };
  ds.QFinChargeConfigDtl = {
    id: p,
    chargeConfigId: f,
    chargeCodeId: f,
    chooseFlag: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QComInvoiceCancelApprove = {
    id: p,
    invoiceApproveId: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    cancelApprovalStatus: f,
    cancelFlag: f,
    cancelSubmitUser: f,
    cancelSubmitUserName: f,
    cancelSubmitDate: f,
    cancelParticular: f,
    cancelHandleUserName: f,
    cancelSubjectTitle: f
  };
  ds.QOpsVoyagePortEvents = {
    remark: f,
    title: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    countryCode: f,
    eventName: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    eventType: f,
    portCode: f,
    lastModifyByName: f,
    eventCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    countryName: f,
    createName: f,
    vesselName: f,
    ispFleetCode: f,
    portName: f,
    countryNameEn: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f
  };
  ds.QFineFavoriteEntry = {
    id: p,
    entryid: f,
    time: f,
    userid: f
  };
  ds.QVscUpgradeNotify = {
    id: p,
    vesselCode: f,
    upgradeNotify: f,
    majorVersion: f,
    minorVersion: f,
    upgradeTime: f,
    upgradeStatus: f,
    startTime: f,
    endTime: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSysRoleResource = {
    id: p,
    roleId: f,
    resourceId: f,
    urlTitle: f,
    appId: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    deletedFlag: f
  };
  ds.QStcPaymentInvoiceSub = {
    paymentInvoiceId: p,
    remark: f,
    invoiceAmount: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    invoiceDate: f,
    invoiceCode: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    taxAmount: f
  };
  ds.QOpsOffhireOil = {
    id: p,
    opsOffhireId: f,
    startOilQty: f,
    endOilQty: f,
    price: f,
    oilType: f,
    totalConsume: f,
    totalConsumeFlag: f,
    totalFee: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    oilQty: f,
    statusFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    startFlag: f
  };
  ds.QCdmVesselDeckEquip = {
    id: p,
    vesselGeneralId: f,
    deckMacItem: f,
    deckMacType: f,
    deckMacQuantity: f,
    deckMacSpecifications: f,
    deckEquItem: f,
    deckEquMaterial: f,
    deckEquQuantity: f,
    deckEquSpecifications: f,
    flag: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QSpsQuoteReplaceDetail = {
    id: p,
    quoteMainId: f,
    seqNo: f,
    partsCode: f,
    partsName: f,
    unit: f,
    partsDrawing: f,
    enquireQty: f,
    price: f,
    discount: f,
    taxRate: f,
    origin: f,
    remark: f,
    createTime: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f
  };
  ds.QFailureMessage = {
    id: p,
    msgId: f,
    retryTimes: f,
    node: f,
    topic: f,
    tags: f,
    groupName: f,
    mqName: f,
    exception: f,
    message: f,
    messageKey: f,
    state: f,
    consumeTime: f,
    createTime: f,
    createUser: f,
    updateTime: f,
    updateUser: f
  };
  ds.QSysDatasource = {
    id: p,
    dataSourceName: f,
    schemaName: f,
    databaseType: f,
    status: f,
    url: f,
    driverClassName: f,
    username: f,
    password: f,
    props: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSysVesselTeam = {
    id: p,
    officeId: f,
    officeCode: f,
    officeName: f,
    vesselTeamCode: f,
    vesselTeamName: f,
    vesselTeamEmail: f,
    managerCode: f,
    managerName: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QAmiGNoon = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    latitude: f,
    longitude: f,
    crs: f,
    latitudeScore: f,
    latitudeFlag: f,
    longitudeScore: f,
    longitudeFlag: f,
    baseLineCode: f,
    baseVslStatusCd: f,
    baseVslStatusNm: f,
    dailyRunDist: f,
    dailyRunTime: f,
    averageSpeed: f,
    ttlRunDist: f,
    ttlRunTime: f,
    distanceToGo: f,
    nextPortCd: f,
    nextPortNm: f,
    nextPortType: f,
    etaNextPort: f,
    basedOnSpeed: f,
    windDirectionCd: f,
    windDirectionNm: f,
    waveDirectionCd: f,
    waveDirectionNm: f,
    airTemp: f,
    windForce: f,
    waveScale: f,
    seaTemp: f,
    currentDirectionCd: f,
    currentDirectionNm: f,
    currentVelocity: f,
    visibility: f,
    swell: f,
    iceThickness: f,
    iceCoverage: f,
    barometricPressure: f,
    averageRpm: f,
    engineSpeed: f,
    slip: f,
    averagePower: f,
    revolutionCounter: f,
    timeLastReport: f,
    timeThisReport: f,
    durationOfConsumption: f,
    dthsfo: f,
    dtlsfo: f,
    dthsmgo: f,
    dtlsmgo: f,
    flowMeterFo: f,
    temperatureOfFo: f,
    densityOfFo: f,
    flowMeterOfMdo: f,
    temperatureOfMdo: f,
    densityOfMdo: f,
    hfo: f,
    lfo: f,
    hmgo: f,
    lmgo: f,
    cylinderLub: f,
    engineLub: f,
    generatorLub: f,
    fw: f,
    remarks: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    flowMeterOfMdoLast: f,
    timeThisReportZone: f,
    flowMeterOfFoLast: f,
    allRevolutionCounter: f,
    timeLastReportZone: f,
    revolutionCounterLast: f,
    timeThisReportFlag: f,
    timeLastReportFlag: f,
    totalRevolutionCounter: f
  };
  ds.QAmiBPortDynamic = {
    id: p,
    baseInfoId: f,
    portCode: f,
    windDirection: f,
    windScale: f,
    waveDirection: f,
    waveForce: f,
    surgeDirection: f,
    surgeForce: f,
    weather: f,
    estBerthedTm: f,
    estWorkTm: f,
    remark: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    fw: f,
    trendstm: f,
    status: f,
    etd: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    portNameCn: f,
    portNameEn: f,
    mgoLConsumptionSum: f,
    foLConsumptionSum: f,
    foHConsumptionSum: f,
    mgoHConsumptionSum: f
  };
  ds.QVscLogEntity = {
    id: p,
    vesselId: f,
    vesselCode: f,
    entityName: f,
    entityType: f,
    ddlType: f,
    entityId: f,
    entityData: f,
    logType: f,
    sendFlag: f,
    oppositeCommit: f,
    parseStatus: f,
    logFileId: f,
    transactionId: f,
    globalFlag: f,
    datasourceId: f,
    checkFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    isReport: f,
    reportMsg: f,
    isSolved: f
  };
  ds.QSysUserRoleOffice = {
    id: p,
    companyId: f,
    officeId: f,
    roleId: f,
    userId: f,
    userOfficeSeqNo: f,
    userRoleSeqNo: f,
    companyCode: f,
    companyName: f,
    officeCode: f,
    officeName: f,
    userCode: f,
    userName: f,
    roleCode: f,
    roleName: f,
    defaultFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    deletedFlag: f
  };
  ds.QChrPalletManage = {
    id: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    palletName: f,
    palletNo: f,
    palletType: f,
    palletStatus: f,
    palletSummary: f,
    isForwardPallet: f,
    summaryCommRate: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QRipEvalMonitor = {
    id: p,
    companyId: f,
    companyCode: f,
    companyName: f,
    companyNameEn: f,
    evalYear: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QAmiTWorking = {
    id: p,
    baseInfoId: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    jobName: f,
    jobStart: f,
    jobEnd: f,
    runDist: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    remark: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    isinsertFlag: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    tugsUsed: f,
    totalTm: f,
    driftingTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRobFlag: f,
    cargoRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QRipBaseInfo = {
    countryNameCn: f,
    uuid: f,
    lastModifyTimeZone: f,
    gradeState: f,
    recordVersion: f,
    createTimeZone: f,
    internalExternal: f,
    id: p,
    isCustGrade: f,
    redAddr: f,
    lastModifyBy: f,
    countryRegion: f,
    hcbCode: f,
    uniSoCreditCode: f,
    nameEn: f,
    isoType: f,
    regDt: f,
    regPerson: f,
    createOffice: f,
    easCode: f,
    areaCd: f,
    productsService: f,
    shortName: f,
    vipFlag: f,
    regMoney: f,
    mainDataStatus: f,
    remark: f,
    settlementcenterCd: f,
    countryNameEn: f,
    businessNo: f,
    web: f,
    areaNm: f,
    expireDate: f,
    company: f,
    principalOrgCode: f,
    ripCode: f,
    taxNo: f,
    lastModifyOffice: f,
    effectDate: f,
    creator: f,
    nature: f,
    settlementcenterNm: f,
    nameCn: f,
    ifRoot: f,
    createTime: f,
    headquartersName: f,
    deletedFlag: f,
    ripType: f,
    lastModifyTime: f,
    customerGrade: f,
    updateStatus: f,
    initialEvaluateStatus: f,
    ripStatus: f,
    initialEvalDate: f,
    methodRecord: f,
    province: f,
    bizStatus: f,
    redAddrEn: f,
    telephone: f,
    email: f,
    otherPhone: f,
    corporateCode: f,
    industry: f,
    parentCode: f,
    stockCode: f,
    provinceEn: f,
    provinceCn: f,
    industryClassification: f,
    isSupplier: f,
    partnerType: f,
    registeredCurrency: f,
    city: f,
    beforeName: f,
    groupEnterpriseNature: f,
    isCustomer: f,
    isListed: f,
    isStrategy: f,
    innnerCsCust: f,
    stockName: f,
    isVip: f,
    isMajorOilCompany: f,
    validPeriod: f,
    settlementCurrency: f,
    earliestTradingDay: f,
    recentTradingDay: f,
    earliestCloseDate: f,
    infoCloseDate: f,
    generateLicense: f,
    creditRateDes: f,
    zipCode: f,
    mainMail: f,
    mainFax: f,
    companyWebsite: f,
    companyMailAddressCn: f,
    companyMailAddressEn: f,
    ripQualifications: new c("RipQualification"),
    ripInvoices: new c("RipInvoice"),
    ripAnnualEvalDetails: new c("RipAnnualEvalDetails"),
    ripCompanyPermissions: new c("RipCompanyPermission"),
    ripEvaluationFroms: new c("RipEvaluationFrom"),
    ripBankInfos: new c("RipBankInfo"),
    ripContactInfos: new c("RipContactInfo"),
    ripSendAttachmentReminder: new c("RipSendAttachmentReminder"),
    ripServiceTypeSets: new c("RipServiceTypeSet")
  };
  ds.QAmclAmiTDepLoadCargo = {
    id: p,
    reportNo: f,
    cargoCode: f,
    api: f,
    loadedTemperature: f,
    shipFigsMt: f,
    shipFigsBbl: f,
    bLFigsMt: f,
    bLFigsBbl: f,
    sOLoadingRate: f,
    sRLoadingRate: f,
    obqExcludingSlop: f,
    fileid: f,
    slopOnboard: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f,
    cargoNameCn: f,
    cargoNameEn: f
  };
  ds.QActFoDatabasechangeloglock = {
    id: p,
    locked: f,
    lockgranted: f,
    lockedby: f
  };
  ds.QCdmVesselLife = {
    id: p,
    vesselGeneralId: f,
    lifeSavingMacItem: f,
    lifeSavingMacQuantity: f,
    lifeSavingMacSpecification: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QComPortChargeHeader = {
    id: p,
    opsVoyageTaskId: f,
    vesselCode: f,
    vesselName: f,
    voyageNo: f,
    contractNo: f,
    contractType: f,
    portCode: f,
    portName: f,
    agentCode: f,
    agentName: f,
    partnerCode: f,
    partnerName: f,
    currencyCode: f,
    currencyName: f,
    amount: f,
    exchangeRate: f,
    baseCurrencyCode: f,
    baseCurrencyName: f,
    baseAmount: f,
    dockRepairFlag: f,
    vesselBuildFlag: f,
    inCostFlag: f,
    checkFlag: f,
    checkUser: f,
    checkUserName: f,
    checkDate: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    opsVoyagePortAgentId: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    agentNameEn: f,
    vesselNameEn: f,
    partnerNameEn: f,
    approvalStatus: f,
    workflowRestartFlag: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    settleOfficeNameEn: f,
    voyagePortId: f,
    handleTaskNode: f,
    handleUserName: f,
    comPortChargeDetail: new c("ComPortChargeDetail")
  };
  ds.QSysSearchTableConfig = {
    tableChineseName: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    bizUrl: f,
    searchFieldConfig: f,
    tableName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    searchFlag: f,
    createTime: f,
    lastModifyTime: f,
    datasourceId: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    searchContentEl: f
  };
  ds.QFinCdmFeeTypeFleet = {
    id: p,
    mainId: f,
    fleetCnName: f,
    fleetEnName: f,
    fleetCode: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QBookEstimateBunker = {
    id: p,
    item: f,
    mainId: f,
    speed: f,
    hsfoBallastDailyCon: f,
    lsfoBallastDailyCon: f,
    lsmgoBallastDailyCon: f,
    hsmgoBallastDailyCon: f,
    hsfoBallastTotalCon: f,
    lsfoBallastTotalCon: f,
    lsmgoBallastTotalCon: f,
    hsmgoBallastTotalCon: f,
    hsfoBallastTotalConRound: f,
    lsfoBallastTotalRound: f,
    lsmgoBallastTotalRound: f,
    hsmgoBallastTotalRound: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    bookEstimateBunkerCost: new c("BookEstimateBunkerCost")
  };
  ds.QVscLogFile = {
    id: p,
    vesselId: f,
    vesselCode: f,
    fileName: f,
    fileSize: f,
    sendLogDtm: f,
    receiveLogDtm: f,
    logType: f,
    stageNo: f,
    serialNo: f,
    shipZipCreateDate: f,
    shipEmailSentDate: f,
    fileType: f,
    logFileStatus: f,
    retryCount: f,
    retryTime: f,
    isRetry: f,
    errorMessage: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cdmVesselGeneral: new c("CdmVesselGeneral"),
    vscLogAttachmentFile: new c("VscLogAttachmentFile")
  };
  ds.QFineSwiftServiceInfo = {
    id: p,
    clusterId: f,
    isSingleton: f,
    service: f,
    serviceInfo: f
  };
  ds.QAmclAmiTUnberth = {
    id: p,
    reportNo: f,
    portCd: f,
    portNm: f,
    jobName: f,
    jobStart: f,
    jobEnd: f,
    runDist: f,
    isinsert: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    mLuboilEng: f,
    mLuboilGen: f,
    mLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    tugsUsed: f,
    remark: f,
    totalTm: f,
    onberthTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    waterDensity: f,
    terminalName: f,
    berthedside1: f,
    berthedName: f,
    seawaterDensity: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    portType: f,
    portNameCn: f,
    baseInfoId: f,
    portNameEn: f
  };
  ds.QImpSearchTable = {
    activityId: f,
    activityTypeCode: f,
    activityName: f,
    activityDesc: f,
    activityTime: f,
    publisher: f,
    publishTime: f,
    officeCode: f,
    principalOrgCode: f,
    vesselCode: f,
    searchContent: f,
    deletedFlag: f
  };
  ds.QSysTempMail = {
    id: p,
    businessCode: f,
    vesselId: f,
    referenceId: f,
    subject: f,
    content: f,
    roleId: f,
    userId: f,
    attachmentIdGroup: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselNameCn: f,
    vesselNameEn: f,
    creator: f,
    referenceNo: f
  };
  ds.QChrSettlementPortFee = {
    id: p,
    mainId: f,
    portPurpose: f,
    portCode: f,
    portName: f,
    portDues: f,
    portFeeIsAll: f,
    invoiceDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    estimatedPortDues: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f
  };
  ds.QOpsOilApprove = {
    approveStatus: f,
    handler: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    bunkerId: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    exCountersignFlag: f,
    approvalProcessCode: f,
    imageNo: f
  };
  ds.QRipInvoice = {
    id: p,
    ripBaseInfoId: f,
    invoiceType: f,
    invoiceHeader: f,
    taxNumber: f,
    contactAddress: f,
    invoiceReceiver: f,
    phone: f,
    paymentDate: f,
    currencyType: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QActDmnDecisionTable = {
    id: p,
    name: f,
    version: f,
    key: f,
    category: f,
    deploymentId: f,
    parentDeploymentId: f,
    tenantId: f,
    resourceName: f,
    description: f
  };
  ds.QOpsVoyageSpeed = {
    id: p,
    opsVoyageTaskId: f,
    speedType: f,
    endTime: f,
    speed: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    startTime: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QMtrInventoryRecord = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    dept: f,
    materialInfoId: f,
    validPeriod: f,
    materialVersion: f,
    locationId: f,
    supplierId: f,
    supplierNameEn: f,
    supplierNameCn: f,
    activityType: f,
    activityDate: f,
    qty: f,
    price: f,
    priceWithoutTax: f,
    poNo: f,
    stockQty: f,
    currency: f,
    baseCurrency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    discount: f,
    specMark: f,
    remark: f,
    referenceId: f,
    referencePo: f,
    inOutFlag: f,
    returnFlag: f,
    monitorFlag: f,
    transferFlag: f,
    transferDate: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    receivePortNameCn: f,
    receivePortCode: f,
    receivePortNameEn: f,
    sendFinanceFlag: f,
    electricFlag: f,
    businessId: f,
    productId: f,
    businessNo: f,
    sendFinanceTime: f,
    creatorNameCn: f,
    invoicePrice: f,
    creatorNameEn: f,
    chargeId: f,
    mtrIventory2Location: new c("SpsLocationInfo")
  };
  ds.QOpsBunkerStock = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    vesselCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: f,
    createName: f,
    vesselName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QVscRecvQueue = {
    id: p,
    vesselId: f,
    vesselCode: f,
    contentType: f,
    commType: f,
    businessType: f,
    contentTitle: f,
    content: f,
    fileName: f,
    fileSize: f,
    fileMd5: f,
    recvDtm: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cdmVesselGeneral: new c("CdmVesselGeneral")
  };
  ds.QHibernateSequences = {
    sequenceName: f,
    sequenceNextHiValue: f
  };
  ds.QFinSettlementReportVoyage = {
    estimateGenerateReason: f,
    id: p,
    mainId: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselCode: f,
    vesselName: f,
    vesselSource: f,
    vesselStatus: f,
    commander: f,
    voyageNo: f,
    voyageType: f,
    voyageStatus: f,
    voyageStartDate: f,
    voyageEndDate: f,
    voyageDateText: f,
    retireDate: f,
    checkPassStatus: f,
    checkReason: f,
    checkRefreshDate: f,
    estimateGenerateFlag: f,
    estimateGenerateDate: f,
    participateReason: f,
    reportSource: f,
    completeDate: f,
    lastestInvoiceNo: f,
    lastestInvoiceDate: f,
    deletedFlag: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    portOtherStatus: f,
    latestReportAuditTime: f,
    portOtherReason: f,
    reportStatus: f,
    fuelReason: f,
    fuelStatus: f,
    reportReason: f,
    estimateNo: f,
    estimateAmount: f
  };
  ds.QSysUserWorkbenchBlock = {
    id: p,
    applyType: f,
    userId: f,
    blockCode: f,
    blockTypeCode: f,
    leftRightInd: f,
    seq: f,
    showFlag: f,
    fixFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f
  };
  ds.QRipEvalFrequencyConf = {
    serviceType: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    serviceCode: f,
    hcbCode: f,
    serviceTypeCn: f,
    remark: f,
    configStatus: f,
    evalDept: f,
    lastModifyTimeZone: f,
    evalDeptName: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    cooperationType: f,
    lastModifyTime: f,
    evalDeptNameEn: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    evalFrequency: f
  };
  ds.QReportExportIntfLog = {
    id: p,
    type: f,
    url: f,
    reqFrom: f,
    reqTo: f,
    reqIp: f,
    reqBody: f,
    reqTime: f,
    resStatus: f,
    resBody: f,
    resTime: f
  };
  ds.QSpsPoDetailTransfer = {
    id: p,
    poMainId: f,
    poDetailId: f,
    itemType: f,
    transferLocationId: f,
    itemId: f,
    transferItemId: f,
    devInfoId: f,
    devVesselCodeId: f,
    transferDevInfoId: f,
    transferDevVesselCodeId: f,
    vesselId: f,
    vesselCode: f,
    transferVesselId: f,
    transferVesselCode: f,
    transferQty: f,
    receiveQty: f,
    currency: f,
    rate: f,
    taxRate: f,
    taxes: f,
    price: f,
    discount: f,
    amount: f,
    amountStandard: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    supplierId: f,
    supplierNameEn: f,
    supplierNameCn: f
  };
  ds.QComPortPdaOffsetBiz = {
    id: p,
    portPdaOffsetRelateId: f,
    businessId: f,
    businessType: f,
    offsetAmount: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QChrSettlementInvoice = {
    id: p,
    mainId: f,
    invoiceNo: f,
    invoiceDate: f,
    rpType: f,
    rpTypeDetail: f,
    dueDate: f,
    stlDate: f,
    freightYm: f,
    partnerCode: f,
    partnerName: f,
    currencyCode: f,
    currencyName: f,
    invoiceAmount: f,
    particular: f,
    creditNoteFlag: f,
    remark: f,
    exchangeRate: f,
    baseCurrencyCode: f,
    baseCurrencyName: f,
    baseInvoiceAmount: f,
    invalidFlag: f,
    invalidUser: f,
    invalidUserName: f,
    invalidTime: f,
    businessType: f,
    invoiceType: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    bankInfoId: f,
    bankInfo: f,
    accountNo: f,
    accountName: f,
    bankName: f,
    contactTel: f,
    contactAddr: f,
    partnerBankInfoId: f,
    partnerAccountNo: f,
    partnerAccountName: f,
    partnerBankName: f,
    partnerContactTel: f,
    partnerContactAddr: f,
    contractId: f,
    contractNo: f,
    contractName: f,
    contractType: f,
    vesselCode: f,
    vesselName: f,
    voyageNo: f,
    installment: f,
    finalFlag: f,
    paymentApplicationId: f,
    vesselCmpInfo: f,
    manageCmpInfo: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    checkFlag: f,
    checkUser: f,
    checkUserName: f,
    checkDate: f,
    submitFlag: f,
    urlCode: f,
    autoTaxInvFlag: f,
    approvalStatus: f,
    voyagePortId: f,
    portCode: f,
    portName: f,
    agentCode: f,
    agentName: f,
    offsetAmount: f,
    paymentAmount: f,
    docNo: f,
    dockRepairFlag: f,
    vesselBuildFlag: f,
    allinFlag: f,
    substituteFlag: f,
    substitutePartnerCode: f,
    substitutePartnerName: f,
    docCollectFlag: f,
    fdaReceivedDate: f,
    pdaBalanceFlag: f,
    currentPercent: f,
    cancelInvoiceNo: f,
    invoiceProperty: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    substitutePartnerNameEn: f,
    agentNameEn: f,
    vesselNameEn: f,
    partnerNameEn: f,
    settleOfficeNameEn: f,
    portNameEn: f
  };
  ds.QComTest0817 = {
    id: p,
    remark: f,
    extend3: f
  };
  ds.QOpsInsClaimExpenses = {
    id: p,
    opsInsClaimId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    rpFlag: f,
    chargeCode: f,
    chargeName: f,
    chargeNameEn: f,
    chargeDesc: f,
    customerName: f,
    customerCode: f,
    customerNameEn: f,
    currencyCode: f,
    baseCurrencyCode: f,
    exchangeRate: f,
    originAmount: f,
    baseAmount: f,
    bankInfoId: f,
    accountNo: f,
    accountName: f,
    bankInfo: f,
    checkStatus: f,
    toFrt: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    costCode: f,
    costName: f,
    costNameEn: f,
    claimableFlag: f,
    originSys: f,
    taxRate: f,
    shareDeductibleAmount: f,
    baseClaimableAmount: f,
    claimableAmount: f,
    balanceAmount: f,
    actAmount: f,
    originSysId: f,
    invocieNo: f,
    costCompanyCode: f,
    costCompany: f,
    costCompanyEn: f
  };
  ds.QActRuDeadletterJob = {
    id: p,
    rev: f,
    type: f,
    exclusive: f,
    executionId: f,
    processInstanceId: f,
    procDefId: f,
    exceptionStackId: f,
    exceptionMsg: f,
    duedate: f,
    repeat: f,
    handlerType: f,
    handlerCfg: f,
    tenantId: f
  };
  ds.QCdmBaseinfoExchange = {
    id: p,
    userDept: f,
    handleStatus: f,
    exchangeName: f,
    currencyFrom: f,
    currencyTo: f,
    rate: f,
    effDate: f,
    disDate: f,
    baseIndicator: f,
    remark: f,
    backup1: f,
    backup2: f,
    officeCode: f,
    easSwitchCode: f,
    applyType: f,
    active: f,
    conversionMethod: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QAmclAmiTDepLoadPortDelay = {
    id: p,
    reportNo: f,
    delayFmTm: f,
    delayToTime: f,
    delayReason: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QSysResourceText = {
    sysResourceTextId: p,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyor: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    sysResourceId: f,
    ddLanguage: f,
    urlTitle: f,
    appId: f,
    appCode: f
  };
  ds.QChrContractMtfwContractParty = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    address: f,
    name: f,
    mtfwContractId: f,
    ispFleetCode: f
  };
  ds.QStcPaymentInvoice = {
    protocolId: f,
    supplierId: f,
    remark: f,
    invoiceAmount: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    payAmount: f,
    invoiceType: f,
    principalOrgCode: f,
    currency: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    chargeEndDate: f,
    unPayRemark: f,
    invoiceReceiveDate: f,
    costMultiDeptFlag: f,
    invoiceDate: f,
    invoiceSonNo: f,
    invoiceCode: f,
    chargeStartDate: f,
    paymentNo: f,
    paymentDueDate: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    invoiceStatus: f,
    taxAmount: f,
    payFlag: f,
    protocolNo: f,
    protocolName: f,
    supplierNameCn: f,
    supplierName: f,
    supplierCode: f,
    creditNote: f,
    orderInvoicesFlag: f,
    invoiceSource: f
  };
  ds.QComTaxInvoiceItem = {
    taxReliefCode: f,
    zeroRateType: f,
    favorablePolicy: f,
    lastModifyTimeZone: f,
    itemName: f,
    recordVersion: f,
    ispFleetCode: f,
    favorableParticular: f,
    price: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    quantity: f,
    lastModifyOfficeName: f,
    taxInvoiceId: f,
    taxClassify: f,
    specification: f,
    tradeCompanyType: f,
    lastModifyByName: f,
    taxRate: f,
    unit: f,
    createOffice: f,
    deduction: f,
    createTime: f,
    createOfficeName: f,
    preTaxInvoiceAmount: f,
    lastModifyTime: f,
    invoiceId: f,
    taxInvoiceAmount: f,
    taxAmount: f,
    createName: f,
    invoiceApproveId: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    comTaxInvoiceDetail: new c("ComTaxInvoiceDetail")
  };
  ds.QActDeDatabasechangelog = {
    id: f,
    author: f,
    filename: f,
    dateexecuted: f,
    orderexecuted: f,
    exectype: f,
    md5sum: f,
    description: f,
    comments: f,
    tag: f,
    liquibase: f
  };
  ds.QChrEstimateAnalysis = {
    id: p,
    mainId: f,
    analysisType: f,
    indexNum: f,
    analysisNumber: f,
    influenceNumber: f,
    actualTce: f,
    roundActualTce: f
  };
  ds.QFineNetCheckRecord = {
    id: p,
    config: f,
    handlernode: f,
    item: f,
    result: f,
    target: f,
    time: f,
    type: f
  };
  ds.QAmiGOthers = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    latitude: f,
    longitude: f,
    crs: f,
    latitudeScore: f,
    latitudeFlag: f,
    longitudeScore: f,
    longitudeFlag: f,
    baseLineCode: f,
    baseVslStatusCd: f,
    baseVslStatusNm: f,
    windDirectionCd: f,
    windDirectionNm: f,
    waveDirectionCd: f,
    waveDirectionNm: f,
    airTemp: f,
    windForce: f,
    waveScale: f,
    seaTemp: f,
    currentDirectionCd: f,
    currentDirectionNm: f,
    currentVelocity: f,
    visibility: f,
    swell: f,
    iceThickness: f,
    iceCoverage: f,
    barometricPressure: f,
    draftFwd: f,
    draftMid: f,
    draftAft: f,
    gm: f,
    shiftingReason: f,
    shiftingLocationCd: f,
    shiftingLocationNm: f,
    shiftingLocationType: f,
    unberthedANameNm: f,
    unberthedStarboardCd: f,
    unberthedStarboardNm: f,
    shiftingEsbLt: f,
    shiftingPobLt: f,
    unberthedATime: f,
    shiftingRobOfHsfo: f,
    shiftingRobOfLsfo: f,
    shiftingRobOfHsmgo: f,
    shiftingRobOfLsmgo: f,
    shiftingLineAshore: f,
    shiftingAllFinished: f,
    shiftingFweLt: f,
    shiftingBerth: f,
    shiftingAnchore: f,
    berthedAnchorNm: f,
    berthedStarboardCd: f,
    berthedStarboardNm: f,
    shiftingDopLt: f,
    shiftingTugs: f,
    shiftingDist: f,
    berthedLocationCd: f,
    berthedLocationNm: f,
    berthedLocationType: f,
    beforeBerthingNm: f,
    beforeBerthingStaCd: f,
    beforeBerthingStaNm: f,
    afterBerthingNm: f,
    afterBerthingStaCd: f,
    afterBerthingStaNm: f,
    distanceAnchorageBerth: f,
    berthedDensity: f,
    berthedEsbLt: f,
    berthedRobOfHsfo: f,
    berthedRobOfLsfo: f,
    berthedRobOfHsmgo: f,
    berthedRobOfLsmgo: f,
    berthedPobLt: f,
    berthedLineAshore: f,
    berthedAllFinished: f,
    berthedFweLt: f,
    berthedDopLt: f,
    berthedTugs: f,
    estWeighAnchor: f,
    deviationBeginEndCd: f,
    deviationBeginEndNm: f,
    deviationDetail: f,
    deviationBegin: f,
    deviationReasonCd: f,
    deviationReasonNm: f,
    deviationRobOfHsfo: f,
    deviationRobOfLsfo: f,
    deviationRobOfHsmgo: f,
    deviationRobOfLsmgo: f,
    deviationEnd: f,
    deviationTtlTime: f,
    deviationTtlSailed: f,
    driftingBeginEndCd: f,
    driftingBeginEndNm: f,
    driftingDetail: f,
    driftingBegin: f,
    driftingRobOfHsfo: f,
    driftingRobOfLsfo: f,
    driftingRobOfHsmgo: f,
    driftingRobOfLsmgo: f,
    driftingEnd: f,
    driftingTtlTime: f,
    driftingTtlSailed: f,
    timeLastReport: f,
    timeThisReport: f,
    durationOfConsumption: f,
    dthsfo: f,
    dtlsfo: f,
    dthsmgo: f,
    dtlsmgo: f,
    flowMeterFo: f,
    temperatureOfFo: f,
    densityOfFo: f,
    flowMeterOfMdo: f,
    temperatureOfMdo: f,
    densityOfMdo: f,
    hfo: f,
    lfo: f,
    hmgo: f,
    lmgo: f,
    cylinderLub: f,
    engineLub: f,
    generatorLub: f,
    fw: f,
    remarks: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    flowMeterOfMdoLast: f,
    flowMeterOfFoLast: f,
    timeLastReportZone: f,
    timeLastReportFlag: f,
    timeThisReportZone: f,
    revolutionCounterLast: f,
    timeThisReportFlag: f,
    leftCableLength: f,
    etdLt: f,
    realityEnduranceLt: f,
    enduranceLt: f,
    leftAnchorStatus: f,
    rightAnchorStatus: f,
    rightAnchor: f,
    berthedDepartureArrivalTime: f,
    timeOfAnchor: f,
    leftAnchor: f,
    etbLt: f,
    rightCableLength: f,
    anchoringDescription: f,
    anchoragePosition: f
  };
  ds.QChrContractGeneralPerformance = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    contractId: f,
    disputeFlag: f,
    amount: f,
    contractCurrency: f,
    dealMode: f,
    insuranceFlag: f,
    amountBase: f,
    contractCurrencyBase: f,
    externalLawyerFlag: f,
    lawFirmName: f,
    dealDesc: f,
    disputeDesc: f,
    performanceDesc: f
  };
  ds.QComPaymentActualDetail = {
    dueDate: f,
    settleAmount: f,
    remark: f,
    bankName: f,
    settleDate: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    lastModifyOffice: f,
    creator: f,
    remittanceDate: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    paymentApplicationId: f,
    lastModifyByName: f,
    bankSlip: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    lastModifyTime: f,
    settleApFlag: f,
    createName: f,
    fimagenumber: f,
    unsettleAmount: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QComInvoiceApprove = {
    contractType: f,
    dueDate: f,
    invoiceAmount: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    exchangeRate: f,
    invoiceType: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    broker1Name: f,
    invoiceNo: f,
    settleOfficeCode: f,
    lastModifyBy: f,
    receiptType: f,
    lastModifyOfficeName: f,
    receiptRemark: f,
    customerName: f,
    createOffice: f,
    createOfficeName: f,
    installment: f,
    createName: f,
    broker1Code: f,
    vesselName: f,
    settleStatus: f,
    contractNo: f,
    invalidUserName: f,
    settleAmount: f,
    settleOfficeName: f,
    readTime: f,
    customerCode: f,
    remark: f,
    readUser: f,
    invalidTime: f,
    broker2Code: f,
    invalidUser: f,
    ispFleetCode: f,
    currencyName: f,
    receiptParticular: f,
    principalOrgCode: f,
    voyageNo: f,
    approvalStatus: f,
    lastModifyOffice: f,
    creator: f,
    handleUserName: f,
    subjectTitle: f,
    readFlag: f,
    broker2Name: f,
    invoiceDate: f,
    lastModifyByName: f,
    createTime: f,
    readUserName: f,
    lastModifyTime: f,
    contractId: f,
    invoiceId: f,
    currencyCode: f,
    shareStatus: f,
    sendDate: f,
    sendUser: f,
    voucherNo: f,
    shareAuditor: f,
    sendFlag: f,
    sendUserName: f,
    shareAuditInfo: f,
    shareAuditDate: f,
    arNo: f,
    imageNo: f,
    cancelInvoiceNo: f,
    invoiceProperty: f,
    exTaxation: f,
    baseAmount: f,
    taxRate: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    baseCurrencyCode: f,
    invalidReason: f,
    cancelId: f,
    cancelApprovalStatus: f,
    workflowRestartFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    cancelFlag: f,
    customerNameEn: f,
    vesselNameEn: f,
    broker1NameEn: f,
    broker2NameEn: f,
    settleOfficeNameEn: f,
    originInvoiceNo: f,
    headApproveId: f,
    cancelSubmitUser: f,
    cancelSubmitDate: f,
    cancelHandleUserName: f,
    cancelSubjectTitle: f,
    cancelParticular: f,
    cancelSubmitUserName: f,
    cancelHandleTaskNode: f,
    handleTaskNode: f,
    caseNo: f,
    particular: f,
    comInvoiceReceiptDetail: new c("ComInvoiceReceiptDetail"),
    comTaxInvoice: new c("ComTaxInvoice"),
    comArInvoice: new c("ComArInvoice"),
    comTaxInvoiceDetailList: new c("ComTaxInvoiceDetail")
  };
  ds.QCpmProtocol = {
    id: p,
    protocolName: f,
    protocolNo: f,
    protocolType: f,
    signedCompany: f,
    signedSupplier: f,
    effectiveDate: f,
    expirationDate: f,
    currency: f,
    approveStatus: f,
    effectiveState: f,
    paymentPeriod: f,
    qualityService: f,
    otherCondition: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    invalidDate: f
  };
  ds.QComInvoiceCollection = {
    id: p,
    invoiceApproveId: f,
    invoiceId: f,
    collectionDate: f,
    chartererReplyDate: f,
    ownerCounterDate: f,
    collectionContent: f,
    finalFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QScheduleContext = {
    id: p,
    scheduleCode: f,
    workerServers: f,
    scheduleStatus: f,
    lastExecuteTime: f,
    nextExecuteTime: f,
    createTime: f,
    updateTime: f
  };
  ds.QCdmVesselManageHistory = {
    id: p,
    vesselGeneralId: f,
    managerId: f,
    managerNameCn: f,
    managerNameEn: f,
    managerCode: f,
    manageType: f,
    manageStyle: f,
    managerStartDate: f,
    managerEndDate: f,
    managerItems: f,
    managerRegCompany: f,
    inOutFlag: f,
    accountType: f,
    vesselSeq: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    managerRegCompanyEn: f,
    managerRegCompanyCn: f,
    masterDataCode: f
  };
  ds.QOpsOilBunker = {
    calType: f,
    waterQty: f,
    dueDate: f,
    leftWater: f,
    quantityPayFlag: f,
    allFee: f,
    lastModifyTimeZone: f,
    actPayDate: f,
    payType: f,
    recordVersion: f,
    exchangeRate: f,
    vesselCode: f,
    payid: f,
    createTimeZone: f,
    id: p,
    receivedDate: f,
    portPurpose: f,
    isreceived: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    bargingFee: f,
    contractNoCash: f,
    createOffice: f,
    toCurrency: f,
    emergencyRemark: f,
    orderDate: f,
    portSeq: f,
    createName: f,
    vesselName: f,
    remark: f,
    portName: f,
    advanceFlag: f,
    actDate: f,
    qualityPayFlag: f,
    emergencyFlag: f,
    incidentalFee: f,
    marketFlag: f,
    currency: f,
    principalOrgCode: f,
    qualityCustCode: f,
    planEndDate: f,
    quantityCustCode: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    waterPrice: f,
    otherFee: f,
    quantitySurveyFee: f,
    portCode: f,
    custCode: f,
    lastModifyByName: f,
    fuelType: f,
    totalFee: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    contractNoFuture: f,
    planStartDate: f,
    bunkerType: f,
    qualitySurveyFee: f,
    ispFleetCode: f,
    opsVoyageTaskId: f,
    estWaterQty: f,
    contractFutureType: f,
    appraisalTime: f,
    appraisalByName: f,
    deliveryDate: f,
    appraisalAdviseMemo: f,
    appraisalBy: f,
    suppliersIsselected: f,
    suppliersSelect: f,
    contractNo: f,
    contractVersion: f,
    contractId: f,
    qualityCustName: f,
    quantityCustName: f,
    voyageType: f,
    custName: f,
    fuelNature: f,
    portId: f,
    invoiceType: f,
    portNameEn: f,
    vesselType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    invalidFlag: f,
    invalidUserName: f,
    invalidTime: f,
    invalidUser: f,
    custNameEn: f,
    vesselNameEn: f,
    portPurposeName: f,
    qualityCustNameEn: f,
    portPurposeNameEn: f,
    quantityCustNameEn: f,
    traderNameEn: f,
    supplierNameEn: f,
    timeZone: f,
    actDateGmt: f,
    opsOilBunkerDetail: new c("OpsOilBunkerDetail")
  };
  ds.QCpmProtocolRebate = {
    id: p,
    protocolId: f,
    remark: f,
    rebate: f,
    currency: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    toAmount: f,
    fromAmount: f,
    toFlag: f,
    fromFlag: f
  };
  ds.QFineRemoteDesignAuth = {
    id: p,
    path: f,
    pathtype: f,
    roletype: f,
    userid: f,
    username: f
  };
  ds.QActivityIndex = {
    activityId: f,
    activityTypeCode: f,
    activityName: f,
    activityDesc: f,
    activityTime: f,
    publisher: f,
    publishTime: f,
    officeCode: f,
    principalOrgCode: f,
    vesselCode: f,
    searchContent: f,
    deletedFlag: f,
    syncFlag: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f
  };
  ds.QActHiDetail = {
    id: p,
    type: f,
    procInstId: f,
    executionId: f,
    taskId: f,
    actInstId: f,
    name: f,
    varType: f,
    rev: f,
    time: f,
    bytearrayId: f,
    double: f,
    long: f,
    text: f,
    text2: f
  };
  ds.QActReModel = {
    id: p,
    rev: f,
    name: f,
    key: f,
    category: f,
    createTime: f,
    lastUpdateTime: f,
    version: f,
    metaInfo: f,
    deploymentId: f,
    editorSourceValueId: f,
    editorSourceExtraValueId: f,
    tenantId: f,
    defaultRun: f,
    projectId: f,
    projectName: f,
    status: f,
    modelClass: f,
    publishTime: f,
    publishBy: f
  };
  ds.QFineBackupNode = {
    id: p,
    backupendtime: f,
    backupmodule: f,
    backupname: f,
    backuptime: f,
    detail: f,
    savepath: f,
    backupsize: f,
    status: f,
    type: f
  };
  ds.QFineOutputSznWebhook = {
    id: p,
    extra: f,
    url: f
  };
  ds.QStcMqRequest = {
    id: p,
    activityId: f,
    autoSubmit: f,
    referenceId: f,
    taskCode: f,
    userId: f,
    amount: f,
    approvalOffice: f,
    approvalOfficeEn: f,
    approvalOpinion: f,
    approvalStatus: f,
    approvalStatusEn: f,
    companyNameCn: f,
    companyNameEn: f,
    dataCreateTime: f,
    dataCreator: f,
    dataCreatorEn: f,
    dept: f,
    isCommit: f,
    spare1: f,
    spare2: f,
    spare3: f,
    spare4: f,
    spare5: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    paymenyNo: f,
    deptNameCn: f,
    deptNameEn: f,
    initRecordId: f,
    companyCode: f,
    referenceNo: f,
    activityName: f,
    submitAnyway: f,
    turnNextNodeData: f,
    reStart: f,
    vesselId: f,
    fromAssignerId: f,
    toAssignerId: f,
    sdkUsers: f,
    executionId: f,
    page: f
  };
  ds.QChrVoyagePlanPort = {
    id: p,
    mainId: f,
    portPurpose: f,
    portName: f,
    speed: f,
    distance: f,
    lsDistance: f,
    estArrivalTime: f,
    etbBerth: f,
    estDepartureTime: f,
    sailingDay: f,
    berthDays: f,
    tankWashDays: f,
    cargoManagementDays: f,
    portDisbursement: f,
    loadDischargeFee: f,
    eindingFee: f,
    supervisionFee: f,
    otherFee: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    portCode: f,
    workDays: f,
    portDisbursementSource: f,
    portSequence: f,
    timeZone: f,
    portId: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QChrEstimateOthers = {
    id: p,
    mainId: f,
    feeCode: f,
    feeName: f,
    amount: f,
    rpType: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    businessType: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    feeNameEn: f
  };
  ds.QMtrCompareQtyHistory = {
    id: p,
    poMainId: f,
    materialInfoId: f,
    materialNameCn: f,
    materialCode: f,
    materialNameEn: f,
    beforePoQty: f,
    afterPoQty: f,
    modifyBy: f,
    poDetailId: f,
    supplierId: f,
    supplierNameCn: f,
    supplierNameEn: f,
    modifyTime: f
  };
  ds.QChrPreSettlementVoyage = {
    id: p,
    vesselCode: f,
    dwt: f,
    charterersCode: f,
    charterersName: f,
    cpDate: f,
    voyageBeginDate: f,
    commFlag: f,
    voyageEndDate: f,
    compFlag: f,
    loadportCode: f,
    loadportName: f,
    dischportCode: f,
    dischportName: f,
    totalCargoQuantity: f,
    totalRevenue: f,
    totalExpense: f,
    overage: f,
    commissionRate: f,
    commissionFee: f,
    bunkerConsumptionCost: f,
    totalPortDisbursements: f,
    netIncome: f,
    totalInsuranceIncome: f,
    totalInsuranceCost: f,
    totalOtherIncome: f,
    totalOtherCost: f,
    totalFixedDifferential: f,
    totalDespatch: f,
    totalDemurrage: f,
    totalTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    perDayTc: f,
    perDayTcGross: f,
    voyageNo: f,
    completedTime: f,
    measureDailyTce: f,
    notCompletedTime: f,
    measureRevenue: f,
    preSettlementVersion: f,
    measureExpense: f,
    heavyLoadTotalTime: f,
    canalTime: f,
    nonCompletedEmptyLoadTime: f,
    vesselName: f,
    completedHeavyLoadTime: f,
    voyageType: f,
    ispFleetCode: f,
    nonCompletedHeavyLoadTime: f,
    emptyLoadTotalTime: f,
    approvalStatus: f,
    completedEmptyLoadTime: f,
    inPortTotalTime: f,
    approvalTime: f,
    measureTceRevenue: f,
    completedNonOperationTime: f,
    nonCompletedLoadTime: f,
    completedLoadTime: f,
    nonCompletedNonOperationTime: f,
    completedUnloadTime: f,
    nonCompletedUnloadTime: f,
    completedCanalTime: f,
    actualFreight: f,
    estimatedFreight: f,
    freightInvoiceAll: f,
    totalAddressComm: f,
    totalBrokerComm: f,
    brokerCommissionRate: f,
    transferFlag: f,
    charterOthersCost: f,
    charterComm: f,
    charterTotalCost: f,
    charterHireCost: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    charterCommAmount: f,
    contractInType: f,
    netIncomeDeduction: f,
    charterDemurrage: f,
    charterDespatchDes: f,
    charterDemurrageDes: f,
    charterDespatch: f,
    startWorkflowFlag: f,
    voyageCategory: f,
    dischportNameEn: f,
    loadportNameEn: f,
    estimateId: f,
    vesselNameEn: f,
    charterersNameEn: f,
    companyName: f,
    companyNameEn: f,
    companyCode: f,
    voyageCurrency: f,
    offHireDays: f,
    offHireAmount: f,
    signSubjectCode: f,
    signSubjectNameEn: f,
    signSubjectName: f,
    demurrageRate: f,
    dispatchRate: f,
    otherIncomeCommission: f,
    demurrageCommission: f,
    dispatchCommission: f,
    freightCommission: f,
    otherCostCommission: f,
    settlementCurrency: f,
    chrPreSettlementBunkerCompletedList: new c("ChrPreSettlementBunkerCompleted"),
    chrPreSettlementDemurrageList: new c("ChrPreSettlementDemurrage"),
    chrPreSettlementBunkerCostList: new c("ChrPreSettlementBunkerCost"),
    chrPreSettlementBunkerConsumptionList: new c("ChrPreSettlementBunkerConsumption"),
    chrPreSettlementPortFeeList: new c("ChrPreSettlementPortFee"),
    chrPreSettlementPortList: new c("ChrPreSettlementPort"),
    chrPreSettlementFreightList: new c("ChrPreSettlementFreight"),
    chrPreSettlementOthersList: new c("ChrPreSettlementOthers")
  };
  ds.QSpsSendFinance = {
    id: p,
    vesselCode: f,
    vesselId: f,
    vesselNameEn: f,
    vesselNameCn: f,
    deletedFlag: f,
    sendFinanceFlag: f,
    sendFinanceTime: f,
    sendContent: f,
    receiveContent: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    chargeId: f,
    chargeCode: f,
    chargeNameCn: f,
    chargeNameEn: f,
    companyId: f,
    companyNameEn: f,
    companyNameCn: f,
    referenceId: f,
    itemType: f,
    sendFinanceVersion: f,
    poNo: f
  };
  ds.QFineWriteStash = {
    id: p,
    data: f,
    reportpath: f,
    username: f
  };
  ds.QRipContactInfo = {
    zipCode: f,
    applyDeptNameEn: f,
    applyDeptNameCn: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    applyDept: f,
    contactsEmail: f,
    principalOrgCode: f,
    createTimeZone: f,
    ripCode: f,
    id: p,
    fax: f,
    department: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    contactsMobile: f,
    createOffice: f,
    applyDeptName: f,
    createTime: f,
    contactsTel: f,
    lastModifyTime: f,
    contactsAddress: f,
    position: f,
    contacts: f,
    ripBaseInfoId: f,
    applyCompanyNameCn: f,
    deletedFlag: f
  };
  ds.QCdmCompany = {
    registrationTime: f,
    socialCreditCode: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    countryCode: f,
    mnemonicNo: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    activeFlag: f,
    companyCode: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    companyNameEn: f,
    companyNameCn: f,
    registrationAddress: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    uuid: f
  };
  ds.QAmiBNoon = {
    id: p,
    baseInfoId: f,
    latitude: f,
    longitude: f,
    crs: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    slip: f,
    acFoH: f,
    acFoL: f,
    acMgoH: f,
    acMgoL: f,
    acWater: f,
    robFoH: f,
    robFoL: f,
    robMgoH: f,
    robMgoL: f,
    robWater: f,
    windDirection: f,
    windScale: f,
    waveDirection: f,
    waveHeight: f,
    swellHeight: f,
    swellDirect: f,
    visibilitysCale: f,
    runHrs: f,
    runDist: f,
    nextPortCd: f,
    etaNextPortLoc: f,
    distNextPort: f,
    specialPoint1: f,
    estArrivalTm1: f,
    ataArrivalTm1: f,
    specialPoint2: f,
    estArrivalTm2: f,
    ataArrivalTm2: f,
    remark: f,
    datetime: f,
    nextPortNm: f,
    sailingStatus: f,
    fwGenerated: f,
    totalRunDist: f,
    totalRunTime: f,
    basisSpeed: f,
    totalAvgSpd: f,
    totalAvgRpm: f,
    totalEngSpeed: f,
    totalSlip: f,
    totalOilWear: f,
    totalAvgOilWear: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    ataMWater: f,
    fwGen: f,
    fuelno1s: f,
    fuelno2s: f,
    fuelno3s: f,
    fuelno4s: f,
    fuelno1p: f,
    fuelno2p: f,
    fuelno3p: f,
    fuelno4p: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    calPurposeNextPort: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    nextPortNameEn: f,
    nextPortNameCn: f,
    averagePower: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f
  };
  ds.QQmVoyageRiskFile = {
    id: p,
    businessId: f,
    businessCode: f,
    vesselId: f,
    vesselNameCn: f,
    vesselNameEn: f,
    voyageNo: f,
    fileId: f,
    fileName: f,
    fileType: f,
    fileRemark: f,
    fileCreatorNameCn: f,
    fileCreatorNameEn: f,
    fileUploadTime: f,
    fileCreateOfficeCn: f,
    fileCreateOfficeEn: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    creatorNameCn: f,
    creatorNameEn: f,
    createOfficeCn: f,
    createOfficeEn: f
  };
  ds.QOpsOilStock = {
    leftQuantity: f,
    remark: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    stockStatus: f,
    vesselCode: f,
    principalOrgCode: f,
    amountMoney: f,
    createTimeZone: f,
    id: p,
    unitPrice: f,
    voyageNo: f,
    lastModifyOffice: f,
    batchNo: f,
    creator: f,
    lastModifyBy: f,
    operatingCompanyCode: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    operationNo: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    operatingCompany: f,
    dataSource: f,
    createName: f,
    bunkerSpec: f,
    vesselName: f,
    ispFleetCode: f,
    reportTime: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QChrContractPool = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    deliveryBeginDate: f,
    deliveryEndDate: f,
    deliveryRemark: f,
    periodMin: f,
    periodMax: f,
    periodUnit: f,
    periodFloat: f,
    periodFloatUnit: f,
    periodRemark: f,
    contractVersion: f,
    rentpayTerm: f,
    exitPoolTerm: f,
    managementCommUnit: f,
    managementFeeUnit: f,
    managementComm: f,
    managementFee: f,
    deposit: f,
    managementFeeRemark: f,
    contractNo: f,
    contractId: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QQrtzPausedTriggerGrps = {
    schedName: f,
    triggerGroup: f
  };
  ds.QTableRelation = {
    id: p,
    relationType: f,
    fromTableId: f,
    toTableId: f,
    fromColumnId: f,
    toColumnId: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QStcPaymentApplication = {
    sendEmailFlag: f,
    financeApprover: f,
    deptName: f,
    financeStatus: f,
    applicationType: f,
    supplierId: f,
    financeApprovedDate: f,
    imageNo: f,
    remark: f,
    baseCurrency: f,
    payeeBankId: f,
    paymentType: f,
    lastModifyTimeZone: f,
    payee: f,
    deptNameCn: f,
    financeRemark: f,
    recordVersion: f,
    settlementStatus: f,
    rate: f,
    payAdvanceFlag: f,
    principalOrgCode: f,
    supplierNameCn: f,
    currency: f,
    createTimeZone: f,
    id: p,
    payeeEmail: f,
    supplierName: f,
    lastModifyOffice: f,
    processInstanceId: f,
    creator: f,
    amount: f,
    lastModifyBy: f,
    deptId: f,
    priority: f,
    baseAmount: f,
    voucherNo: f,
    paymentNo: f,
    paymentDueDate: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    payeeBank: f,
    settlementAmount: f,
    payCompanyCode: f,
    paymentDate: f,
    payeeAccount: f,
    status: f,
    downloadPaymentPerson: f,
    payBank: f,
    returnDate: f,
    sendFinanceFlag: f,
    sendFinanceTime: f,
    supplierCode: f,
    fiMageNumber: f,
    payAmount: f,
    payBaseAmount: f,
    sendMqRemark: f,
    nextApproverEn: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    nextApproverCn: f,
    sendLocalTime: f,
    localSettleTime: f
  };
  ds.QFineWorkflowTask = {
    id: p,
    createtime: f,
    creatorid: f,
    creatorname: f,
    deadlinedate: f,
    deadlinetype: f,
    issuecontrol: f,
    issueover: f,
    leapfrogback: f,
    name: f,
    parentid: f,
    processid: f,
    remindcontrol: f,
    tasknamecalculateonce: f
  };
  ds.QAmclAmiTDepLoadFlow = {
    id: p,
    reportNo: f,
    commDaballst: f,
    compDaballst: f,
    hoseConnected: f,
    hoseDisconnected: f,
    commLoading: f,
    compLoading: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QSysSupportedLocale = {
    sysSupportedLocaleId: p,
    language: f,
    country: f,
    variant: f,
    display: f,
    state: f
  };
  ds.QFinFuelStockDetail = {
    id: p,
    mainId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    unitPrice: f,
    batchNo: f,
    beginFuelStorage: f,
    endBatchAmount: f,
    dynamicAmount: f,
    dynamicQuantity: f,
    endFuelStorage: f,
    bunkerSpec: f,
    beginAmount: f,
    endUnitPrice: f,
    dynamicUnitPrice: f,
    detailType: f,
    costStatus: f,
    previousId: f,
    batchCostSeq: f,
    voyageNo: f
  };
  ds.QOpsInsClaimContacts = {
    id: p,
    opsInsClaimId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    supplierCode: f,
    supplierName: f,
    supplierNameEn: f,
    contacts: f,
    contactsInfo: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    roleCode: f,
    roleName: f,
    roleNameEn: f
  };
  ds.QModelType = {
    id: p,
    name: f,
    remark: f
  };
  ds.QOpsLoi = {
    id: p,
    opsVoyageTaskId: f,
    loiType: f,
    loiDate: f,
    chartererCode: f,
    chartererName: f,
    remark: f,
    approvalStatus: f,
    blRemark: f,
    freightNote: f,
    shipperFirstMr: f,
    shipperSecondMr: f,
    loiFormatWording: f,
    loiFormatJurisdiction: f,
    headownersNote: f,
    loiFormatRemark: f,
    blReceivedDate: f,
    loiReceivedDate: f,
    originDocumentRemark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    contractNo: f,
    handleUserName: f,
    invalidUserName: f,
    invalidTime: f,
    invalidUser: f,
    imageNo: f,
    lastApprovalStatus: f,
    workflowRestartFlag: f,
    chartererNameEn: f,
    cargoUnitTotal: f,
    handleTaskNode: f,
    opsLoiSecondSetBl: new c("OpsLoiSecondSetBl"),
    opsLoiBl: new c("OpsLoiBl"),
    opsLoiPort: new c("OpsLoiPort")
  };
  ds.QActGeProperty = {
    name: p,
    value: f,
    rev: f
  };
  ds.QUndoLog = {
    id: p,
    branchId: f,
    xid: f,
    rollbackInfo: f,
    logStatus: f,
    logCreated: f,
    logModified: f,
    ext: f
  };
  ds.QMtrLubOilPurpose = {
    id: p,
    productId: f,
    materialInfoId: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    oilType: f,
    purposeName: f,
    tankCapacity: f,
    density: f,
    brand: f,
    seq: f,
    linkStock: f,
    deleteFlag: f,
    memo: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFineCustomRole = {
    id: f,
    tenantid: f,
    alias: f,
    creationtype: f,
    description: f,
    enable: f,
    lastoperationtype: f,
    name: f
  };
  ds.QChrSettlementVoyage = {
    id: p,
    vesselCode: f,
    vesselName: f,
    dwt: f,
    voyageNo: f,
    charterersCode: f,
    charterersName: f,
    cpDate: f,
    voyageBeginDate: f,
    voyageEndDate: f,
    loadportCode: f,
    loadportName: f,
    dischportCode: f,
    dischportName: f,
    freghtFee: f,
    totalCargoQuantity: f,
    voyageType: f,
    settlementVersion: f,
    approvalStatus: f,
    approvalTime: f,
    totalRevenue: f,
    totalExpense: f,
    overage: f,
    commissionRate: f,
    commissionFee: f,
    bunkerConsumptionCost: f,
    totalPortDisbursements: f,
    netIncome: f,
    dayTc: f,
    totalInsuranceIncome: f,
    totalInsuranceCost: f,
    totalOtherIncome: f,
    totalOtherCost: f,
    totalFixedDifferential: f,
    totalDespatch: f,
    totalDemurrage: f,
    remark: f,
    deletedFlag: f,
    totalTime: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    freightInvoiceAll: f,
    estimateFreightFee: f,
    dayTcGross: f,
    totalAddressComm: f,
    totalBrokerComm: f,
    brokerCommissionRate: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    charterDemurrageDes: f,
    charterDemurrage: f,
    charterDespatch: f,
    charterOthersCost: f,
    netIncomeDeduction: f,
    charterDespatchDes: f,
    charterComm: f,
    charterTotalCost: f,
    charterHireCost: f,
    contractInType: f,
    charterCommAmount: f,
    approvalUserCode: f,
    startWorkflowFlag: f,
    approvalUserName: f,
    voyageCategory: f,
    dischportNameEn: f,
    loadportNameEn: f,
    vesselNameEn: f,
    charterersNameEn: f,
    companyName: f,
    companyCode: f,
    companyNameEn: f,
    offHireDays: f,
    voyageCurrency: f,
    offHireAmount: f,
    ladenLQuantity: f,
    ballastLQuantity: f,
    ballastHQuantity: f,
    portLQuantity: f,
    ladenHQuantity: f,
    portHQuantity: f,
    estimateId: f,
    signSubjectCode: f,
    signSubjectNameEn: f,
    signSubjectName: f,
    demurrageRate: f,
    dispatchRate: f,
    otherIncomeCommission: f,
    demurrageCommission: f,
    dispatchCommission: f,
    freightCommission: f,
    otherCostCommission: f,
    settlementCurrency: f,
    ladenAvgSpeed: f,
    route: f,
    ballastDay: f,
    ballastAvgSpeed: f,
    ladenDay: f,
    ballastDistance: f,
    ladenDistance: f,
    ladenDayConsumption: f,
    ballastDayConsumption: f,
    lodPortConsumption: f,
    disPortConsumption: f,
    chrSettlementFreightList: new c("ChrSettlementFreight"),
    chrSettlementPortList: new c("ChrSettlementPort"),
    chrSettlementDemurrageList: new c("ChrSettlementDemurrage"),
    chrSettlementPortFeeList: new c("ChrSettlementPortFee"),
    chrSettlementBunkerConsumptionList: new c("ChrSettlementBunkerConsumption"),
    chrSettlementOthersList: new c("ChrSettlementOthers")
  };
  ds.QMtrApplyMain = {
    id: p,
    vesselId: f,
    vesselCode: f,
    dept: f,
    applyNo: f,
    applyDate: f,
    applyPurpose: f,
    applyType: f,
    applyReason: f,
    urgencyVessel: f,
    urgencyShore: f,
    applyStatus: f,
    orderFlag: f,
    compareAuditRemark: f,
    transferStatus: f,
    enquireStatus: f,
    orderType: f,
    processNode: f,
    specBusinessMark: f,
    etp: f,
    etpNameCn: f,
    etpNameEn: f,
    eta: f,
    etd: f,
    proxyDesc: f,
    memo: f,
    applyRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselNameCn: f,
    vesselNameEn: f,
    electricFlag: f,
    applyRoleCode: f,
    inquiryRemark: f,
    mergeMainNo: f,
    mergeOtherNo: f,
    creatorNameCn: f,
    creatorNameEn: f,
    applyForRoleCode: f,
    deviceInstallFlag: f,
    purposeType: f,
    purposeTypeDevice: f,
    mtrApplyDetails: new c("MtrApplyDetail")
  };
  ds.QFsFileInfo = {
    fileKey: p,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStrategyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f
  };
  ds.QWorkerInfo = {
    id: p,
    workerNode: f,
    createTime: f,
    updateTime: f
  };
  ds.QRipCompanyPermission = {
    companyCode: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    permissionCode: f,
    ripBaseInfoId: f,
    companyName: f,
    companyNameEn: f,
    initialEvaluateStatus: f,
    ripStatus: f,
    initialEvalDate: f,
    dutyOffice: f
  };
  ds.QActReDeployment = {
    id: p,
    name: f,
    category: f,
    key: f,
    tenantId: f,
    deployTime: f,
    engineVersion: f
  };
  ds.QCdmCity = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    cityCode: f,
    cityNameCn: f,
    cityNameEn: f,
    countryCode: f,
    province: f,
    activeFlag: f,
    remark: f,
    country: new c("CdmCountry")
  };
  ds.QFineSystemMessage = {
    id: p,
    terminal: f,
    title: f
  };
  ds.QComArInvoiceDtl = {
    substitutePartnerName: f,
    seqNo: f,
    invoiceAmount: f,
    freightOfficeCode: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    exchangeRate: f,
    calCommissionFlag: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    unitPrice: f,
    period: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    particular: f,
    docNo: f,
    substitutePartnerCode: f,
    ledgerItemId: f,
    unit: f,
    createOffice: f,
    createOfficeName: f,
    createName: f,
    chargeCode: f,
    vesselName: f,
    rpType: f,
    ledgerItemTable: f,
    contractNo: f,
    settleAmount: f,
    remark: f,
    portName: f,
    businessDate: f,
    ispFleetCode: f,
    substituteFlag: f,
    principalOrgCode: f,
    contractName: f,
    chargeName: f,
    activeFlag: f,
    voyageNo: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    quantity: f,
    portCode: f,
    lastModifyByName: f,
    freightOfficeName: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    invoiceId: f,
    finType: f,
    currencyCode: f,
    bunkerSpec: f,
    discountAmount: f,
    discount: f,
    ext9: f,
    ext8: f,
    ext7: f,
    ext6: f,
    ext5: f,
    ext4: f,
    ext3: f,
    ext2: f,
    ext1: f,
    taxFlag: f,
    departmentGroup: f,
    discountBaseAmount: f,
    taxRate: f,
    spareStoreType: f,
    ext10: f,
    substituteAmount: f,
    titleRemark: f,
    pdaDiscountAmount: f,
    diffAmount: f,
    autoFlag: f,
    importFlag: f,
    startTime: f,
    endTime: f,
    titleGroup: f,
    titleGroupSub: f,
    contractType: f,
    contractId: f,
    offsetId: f,
    dueFeeId: f,
    voyageCostFlag: f,
    installment: f,
    rentBillMode: f,
    exTaxation: f,
    portId: f,
    baseAmount: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    seqNoChild: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    sourceId: f,
    substitutePartnerNameEn: f,
    freightOfficeNameEn: f,
    vesselNameEn: f,
    chargeNameEn: f,
    claimNo: f,
    claimFlag: f,
    undertakeCompany: f,
    undertakeCompanyName: f,
    undertakeCompanyNameEn: f,
    usedId: f,
    usedFlag: f,
    comInvoiceApproveId: f,
    insAgreement: f,
    balanceFlag: f,
    voyagePortId: f
  };
  ds.QAmclAmiTDptDischSeaWater = {
    id: p,
    fileid: f,
    reportNo: f,
    berthAnchorageName: f,
    seaWaterDensity: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QDatabasechangelog = {
    id: f,
    author: f,
    filename: f,
    dateexecuted: f,
    orderexecuted: f,
    exectype: f,
    md5sum: f,
    description: f,
    comments: f,
    tag: f,
    liquibase: f,
    contexts: f,
    labels: f,
    deploymentId: f
  };
  ds.QCdmCodedict = {
    id: f,
    codetypeId: f,
    codeType: f,
    sequence: f,
    codeValue: f,
    displayValue: f,
    displayValueCn: f,
    relateValue: f,
    abbreCode: f,
    modifiableFlag: f,
    remark: f,
    remark2: f,
    activeFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    deletedFlag: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QMtrPoPayment = {
    poNo: p,
    paymentStatus: f
  };
  ds.QCdmBaseinfoFile = {
    id: p,
    sourceData: f,
    sourceId: f,
    baseInfoManagementId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QFinChargeConfig = {
    id: p,
    companyId: f,
    deptId: f,
    bussinessCode: f,
    bussinessName: f,
    remark: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QFineOutputClass = {
    id: p,
    classname: f
  };
  ds.QCdmVesselGeneral = {
    id: p,
    vesselCode: f,
    vesselEnName: f,
    vesselCnName: f,
    builder: f,
    builtDate: f,
    hullNo: f,
    seaBallastSpeed: f,
    seaLadenSpeed: f,
    company: f,
    vesselType: f,
    vesselType2: f,
    shipClass1: f,
    shipClass2: f,
    classCharacter: f,
    flag: f,
    homePort: f,
    officialNo: f,
    callSign: f,
    imo: f,
    telphoneDriver: f,
    telphoneCaptain: f,
    telphoneC: f,
    fax: f,
    email: f,
    retiredFlag: f,
    retiredDate: f,
    builderCost: f,
    addDepreciation: f,
    sscNameCn: f,
    sscNameEn: f,
    sscLegalPerson: f,
    sscCountry: f,
    sscRegistry: f,
    sscAddressCn: f,
    sscAddressEn: f,
    sscBankInfo: f,
    sscEmail: f,
    sscTelphone: f,
    sscContact: f,
    loa: f,
    lbp: f,
    mldbreadth: f,
    mlddepth: f,
    grtIntl: f,
    nrtIntl: f,
    grtPanama: f,
    nrtPanama: f,
    grtSuez: f,
    nrtSuez: f,
    ladderequ: f,
    ums: f,
    freeboardTrf: f,
    freeboardFrw: f,
    freeboardTro: f,
    freeboardSum: f,
    freeboardWin: f,
    draftTrf: f,
    draftFrw: f,
    draftTro: f,
    draft: f,
    draftWin: f,
    deadweightTrf: f,
    deadweightFrw: f,
    deadweightTro: f,
    sumWeight: f,
    deadweightWin: f,
    netDeadweight: f,
    capacityHfo: f,
    capacityLfo: f,
    capacityHdo: f,
    capacityLdo: f,
    capacityLoGeCyline: f,
    capacityLoMeSystem: f,
    capacityLoGeSystem: f,
    capacityFwDaily: f,
    capacityFwDrink: f,
    capacityBallast: f,
    totalGrainCapacity: f,
    ventilation: f,
    fireFightingSystem: f,
    foPortIdle: f,
    mgoPortIdle: f,
    foPortWorkLoad: f,
    mgoPortWorkLoad: f,
    foPortWorkDisch: f,
    mgoPortWorkDisch: f,
    foCargoHeating: f,
    foTankCleaning: f,
    foInerting: f,
    mgoInertGasGenerator: f,
    remark: f,
    focusCode: f,
    focusName: f,
    ownerShip: f,
    shipOwner: f,
    minManning: f,
    lightshipWeight: f,
    orderBy: f,
    smallCode: f,
    shortName: f,
    otherName: f,
    follow24Flag: f,
    managerCode: f,
    receiveTime: f,
    autoReportFlag: f,
    mmsi: f,
    fbb1: f,
    fbb2: f,
    smi1: f,
    smi2: f,
    amiversion: f,
    sisterCode: f,
    fbbPosition: f,
    iridiumNum: f,
    emailC: f,
    telphoneCcr: f,
    telphoneFbb1: f,
    telphoneFbb2: f,
    fax2: f,
    telphoneC2: f,
    telphoneC3: f,
    iridiumModel: f,
    iridiumImei: f,
    iridiumAct: f,
    iridiumEff: f,
    remarkFbb: f,
    staticTime: f,
    managementType: f,
    dockRepairTime: f,
    hcbCode: f,
    bizScope: f,
    builderCode: f,
    controlType: f,
    sscCode: f,
    fixTce: f,
    handleOffice: f,
    vlocType: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    superiorCompanyCode: f,
    uuid: f,
    financialCode: f,
    companyId: f,
    shipOwnerId: f,
    managerId: f,
    superiorCompanyId: f,
    companyNameCn: f,
    companyNameEn: f,
    managerNameCn: f,
    managerNameEn: f,
    shipOwnerNameCn: f,
    shipOwnerNameEn: f,
    homePortNameCn: f,
    homePortNameEn: f,
    vesselGroup: f,
    manageType: f,
    manageStyle: f,
    savingFlag: f,
    depoMethod: f,
    savingClass: f,
    proAndi: f,
    topside: f,
    lightDisplacement: f,
    keelLaying: f,
    launching: f,
    flatBottom: f,
    officersRatings: f,
    verticalBottom: f,
    boottop: f,
    safetyFlag: f,
    hsfoPortWorkLoad: f,
    hsfoPortIdle: f,
    hsmgoPortWorkDisch: f,
    hsfoPortWorkDisch: f,
    hsmgoPortWorkLoad: f,
    hsmgoPortIdle: f,
    cdmVesselCharterHistory: new c("CdmVesselCharterHistory"),
    cdmVesselDavit: new c("CdmVesselDavit"),
    cdmVesselLife: new c("CdmVesselLife"),
    cdmVesselManageHistory: new c("CdmVesselManageHistory"),
    cdmVesselConstruction: new c("CdmVesselConstruction"),
    cdmVesselCargohold: new c("CdmVesselCargohold"),
    cdmVesselRadioFuelCost: new c("CdmVesselRadioFuelCost"),
    cdmVesselPortFuelCost: new c("CdmVesselPortFuelCost"),
    cdmVesselRadioFuelCostNews: new c("CdmVesselRadioFuelCostNew"),
    cdmVesselRadioNavEqui: new c("CdmVesselRadioNavEqui"),
    cdmVesselErs: new c("CdmVesselErs"),
    cdmVesselDeckEquip: new c("CdmVesselDeckEquip")
  };
  ds.QActReProcdef = {
    id: p,
    rev: f,
    category: f,
    name: f,
    key: f,
    version: f,
    deploymentId: f,
    resourceName: f,
    dgrmResourceName: f,
    description: f,
    hasStartFormKey: f,
    hasGraphicalNotation: f,
    suspensionState: f,
    tenantId: f,
    engineVersion: f
  };
  ds.QCdmVesselCargohold = {
    lastModifyOffice: f,
    creator: f,
    breadthAft: f,
    vesselGeneralId: f,
    lastModifyBy: f,
    hatchCoverWeight: f,
    grainCapacity: f,
    holdno: f,
    breadthFwd: f,
    baleCapacity: f,
    length: f,
    hatchCoverLoadstrength: f,
    lastModifyTimeZone: f,
    hatchCoverDimension: f,
    uDeckExclcrossLoadstrength: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    tankTopLoadstrength: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    breadthDimension: f
  };
  ds.QOpsBlTemplateSono = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    contractNo: f,
    soNo: f,
    remark: f,
    opsBlTemplateId: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    chartererName: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    chartererCode: f,
    principalOrgCode: f,
    contractName: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chartererNameEn: f,
    contractNameEn: f
  };
  ds.QAmiBDpt = {
    id: p,
    baseInfoId: f,
    portCode: f,
    inPortTotaltm: f,
    acFoHPort: f,
    acFoLPort: f,
    acMgoHPort: f,
    acMgoLPort: f,
    acWaterPort: f,
    beforeDepDf: f,
    beforeDefDa: f,
    nextPortCd: f,
    estArrivalTmLoc: f,
    estArrivalTmZone: f,
    nextPortDist: f,
    estPortDraftFwd: f,
    waterDensity: f,
    followupPortCd: f,
    fupArrivalTm: f,
    specialPointName1: f,
    eta1: f,
    specialPointName2: f,
    eta2: f,
    finishTm: f,
    standbyEngineTm: f,
    pilotOnShipTm: f,
    unberthedTm: f,
    maFoHUnberthed: f,
    maFoLUnberthed: f,
    maMgoHUnberthed: f,
    maMgoLUnberthed: f,
    pilotageTm: f,
    maFoHPilotage: f,
    maFoLPilotage: f,
    maMgoHPilotage: f,
    maMgoLPilotage: f,
    maWaterPilotage: f,
    macLuboilEng: f,
    macLuboilCyl: f,
    macLuboilGen: f,
    faopSpdTmEng: f,
    ispweSbFlag: f,
    consSpdMFoH: f,
    consSpdMFoL: f,
    consSpdMDoH: f,
    consSpdMDoL: f,
    supFoH: f,
    supFoL: f,
    supMgoH: f,
    supMgoL: f,
    supLuboil: f,
    supWater: f,
    acceptCash: f,
    acceptMaterialFlag: f,
    otherDesc: f,
    remark: f,
    estPortDraftAft: f,
    departureTime: f,
    currentWaterDensity: f,
    remarkDep: f,
    remarkLod: f,
    runningHours: f,
    runDist: f,
    latitude: f,
    longitude: f,
    trantime: f,
    distTofa: f,
    distAnchFa: f,
    hsfo1s: f,
    hsfo2s: f,
    hsfo3s: f,
    hsfo4s: f,
    hsfo1p: f,
    hsfo2p: f,
    hsfo3p: f,
    hsfo4p: f,
    hsfoSettling: f,
    hsfoService: f,
    hsfoOverflow: f,
    mdo: f,
    mgo: f,
    mgoSettling: f,
    mgoSpare: f,
    mgoService: f,
    tugsUsed: f,
    damageProtestsFlag: f,
    sscecValidDate: f,
    garDispFlag: f,
    cashPurDone: f,
    crewChangeFlag: f,
    doctorVisitFlag: f,
    pscOtherinspFlag: f,
    basisSpeed: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelTotalFoH: f,
    puelTotalFoL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasTotalMgo: f,
    gasTotalMgoH: f,
    gasTotalMgoL: f,
    gasMLuboilEng: f,
    gasMLuboilGen: f,
    gasMLuboilCyl: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    nextPortNameEn: f,
    portNameCn: f,
    nextPortNameCn: f,
    followupPortNameCn: f,
    portNameEn: f,
    followupPortNameEn: f,
    estArrivalTmZoneCn: f,
    estArrivalTmZoneEn: f,
    shoreWasteOil: f,
    foLConsumptionSum: f,
    mgoHConsumptionSum: f,
    mgoLConsumptionSum: f,
    foHConsumptionSum: f,
    lsMgoSettling: f,
    lsfoSettling: f,
    lsfo1p: f,
    lsMgo: f,
    lsMgoSpare: f,
    lsfo1s: f,
    lsfo4s: f,
    lsfo4p: f,
    lsMdo: f,
    lsMgoService: f,
    lsfoOverflow: f,
    lsfo2p: f,
    lsfoService: f,
    lsfo2s: f,
    lsfo3p: f,
    lsfo3s: f,
    gasConsumeMgoL: f,
    gasConsumeMgoH: f,
    puelConsumeFoH: f,
    puelConsumeFoL: f,
    amiBdAllcargo: new c("AmiBdAllcargo"),
    amiBdCargo: new c("AmiBdCargo")
  };
  ds.QMtrApplyTemplate = {
    templateNameEn: f,
    applyType: f,
    companyCode: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    remark: f,
    templateCode: f,
    lastModifyTimeZone: f,
    vesselId: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    templateNameCn: f,
    status: f,
    companyNameEn: f,
    companyNameCn: f,
    vesselNameCn: f,
    vesselNameEn: f,
    templateDetail: new c("MtrApplyTemplateDetail")
  };
  ds.QSysVesselTeamUser = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    endDate: f,
    creatorName: f,
    principalGroupCode: f,
    remark: f,
    vesselTeamId: f,
    userName: f,
    lastModifyByName: f,
    userId: f,
    userCode: f,
    userNameEn: f,
    lastModifyTimeZone: f,
    beginDate: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    createTimeZone: f,
    id: p
  };
  ds.QAmiBWorking = {
    id: p,
    baseInfoId: f,
    portCode: f,
    arrivalPurpose: f,
    cargoName: f,
    commLdOrDischTm: f,
    beganWorkingTm: f,
    stopWorkingTm: f,
    currLdQty: f,
    gangNum: f,
    ttlLdQty: f,
    waitLdQty: f,
    estDepartureTm: f,
    windDir: f,
    waveDir: f,
    swellDir: f,
    windScale: f,
    waveHeight: f,
    swellHeight: f,
    weather: f,
    remark: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    fw: f,
    lsmgo: f,
    befDrf: f,
    aftDrf: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    totalHsfo: f,
    totalLsfo: f,
    totalHsmgo: f,
    totalLsmgo: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    portNameCn: f,
    portNameEn: f,
    cargoNameEn: f,
    cargoNameCn: f,
    amiBwStoppage: new c("AmiBwStoppage")
  };
  ds.QModelPublish = {
    id: p,
    processDefinitionId: f,
    name: f,
    modelKey: f,
    modelClass: f,
    modelProjectId: f,
    modelProjectName: f,
    publisher: f,
    publishTime: f,
    version: f,
    flag: f,
    remark: f,
    image: f,
    thumbnail: f,
    svgImg: f,
    description: f,
    modelComment: f,
    created: f,
    createdBy: f,
    lastUpdated: f,
    lastUpdatedBy: f,
    modelEditorJson: f,
    modelTypeRemark: f,
    modelTypeName: f,
    modelType: f,
    startDate: f,
    endDate: f
  };
  ds.QFineSentinelRecords = {
    id: p,
    alert: f,
    data: f,
    extsnapshot: f,
    indexname: f,
    rTimestamp: f,
    rulearg: f,
    rulename: f,
    taskid: f,
    triggerexpr: f
  };
  ds.QAmiMonthGas = {
    id: p,
    monthEnvironmentId: f,
    sno: f,
    gastype: f,
    lastRob: f,
    thisRvcd: f,
    thisRob: f,
    thisCon: f,
    equiptype: f,
    equipname: f,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    senddate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselEnName: f,
    vesselCnName: f,
    tkrCheck: f,
    tkrHeckDate: f,
    trkCheck: f,
    asdLock: f,
    opnCheck: f,
    tkrHeckUser: f
  };
  ds.QTransferLubOilPurpose = {
    id: p,
    seq: f,
    brand: f,
    oilType: f,
    purposeName: f,
    density: f
  };
  ds.QActRuJob = {
    id: p,
    rev: f,
    type: f,
    lockExpTime: f,
    lockOwner: f,
    exclusive: f,
    executionId: f,
    processInstanceId: f,
    procDefId: f,
    retries: f,
    exceptionStackId: f,
    exceptionMsg: f,
    duedate: f,
    repeat: f,
    handlerType: f,
    handlerCfg: f,
    tenantId: f
  };
  ds.QVoyReportView = {
    reportTm: f,
    reportType: f,
    displayValue: f,
    reportContentstatus: f,
    reportStatus: f,
    id: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    cfo: f,
    hmgo: f,
    cmgo: f,
    smgo: f,
    direction: f,
    scale: f,
    waveDir: f,
    height: f,
    latitude: f,
    longitude: f,
    version: f
  };
  ds.QQrtzSimpleTriggers = {
    schedName: f,
    triggerGroup: f,
    triggerName: f,
    repeatCount: f,
    repeatInterval: f,
    timesTriggered: f
  };
  ds.QBookEstimateMain = {
    id: p,
    vesselGroup: f,
    vesselType: f,
    canalDays: f,
    carbonEmissionCurrent: f,
    ciiRank: f,
    ciiRankEst: f,
    eeoi: f,
    estimateType: f,
    estimateNo: f,
    vesselName: f,
    vesselNameEn: f,
    vesselCode: f,
    vesselResoure: f,
    voyageNo: f,
    startTime: f,
    endTime: f,
    startPort: f,
    startPortNameCn: f,
    startPortNameEn: f,
    deadweight: f,
    carbonEmissionCumulative: f,
    eeoiEst: f,
    voyageProfit: f,
    carbonEmissionVoyage: f,
    currency: f,
    voyageDays: f,
    totalHireDay: f,
    ladenSeaDays: f,
    ballastDays: f,
    ballastSeaDays: f,
    loadDays: f,
    portNotworkDays: f,
    dischargeDays: f,
    roundVoyageDays: f,
    roundLadenSeaDays: f,
    roundBallastSeaDays: f,
    roundLoadDays: f,
    roundPortNotworkDays: f,
    roundDischargeDays: f,
    roundCanalDays: f,
    hsfoPrice: f,
    lsfoPrice: f,
    lsmgoPrice: f,
    hsmgoPrice: f,
    profit: f,
    tceNet: f,
    bbIncome: f,
    bbCost: f,
    freightTotalIncome: f,
    freightTotalExpense: f,
    demurrageTotalIncome: f,
    ohtersIncomeTotal: f,
    totalIncome: f,
    totalCommission: f,
    totalAddCommission: f,
    totalNetIncome: f,
    totalPortCost: f,
    totalBunkerExpense: f,
    totalBunkerExpenseRound: f,
    totalDailyRent: f,
    totalOthersCost: f,
    totalCost: f,
    tradeType: f,
    backToBack: f,
    description: f,
    lowBallastDays: f,
    lowBallastSeaDays: f,
    lowLadenSeaDays: f,
    lowPortNotworkDays: f,
    lowLoadDays: f,
    lowDischargeDays: f,
    lowCanalDays: f,
    lowVoyageDays: f,
    ballastSubsidy: f,
    totalSoliciteAmount: f,
    totalSaleAmount: f,
    totalSoliciteCommission: f,
    totalSaleCommission: f,
    commonType: f,
    sweepFee: f,
    tceBalance: f,
    tceBalanceRound: f,
    companyCode: f,
    companyNameCn: f,
    companyNameEn: f,
    version: f,
    status: f,
    approvalTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    groessFlag: f,
    dispatchChargesTotal: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    extraCharge: f,
    demurrageTotalIncomeRound: f,
    dispatchChargesTotalRound: f,
    grossFlagExtraCharge: f,
    grossFlagDemurrageCharge: f,
    grossFlagDispatchCharges: f,
    brokerComm: f,
    brokerCommAmount: f,
    brokerLumpAmount: f,
    route: f,
    routeName: f,
    routeNameEn: f,
    tradingArea: f,
    cargoClass: f,
    taskCode: f,
    approvalUserCode: f,
    approvalUserName: f,
    totalHeavyBunkerExpense: f,
    totalLightBunkerExpense: f,
    wsStep: f,
    flatRateStep: f,
    bunkerPriceStep: f,
    lsmgoBunkerStep: f,
    ballastSpeedStep: f,
    ladenSpeedStep: f,
    workEfficiencyStep: f,
    hireRateStep: f,
    ciiLevel: f,
    cargoListNo: f,
    estimateVersion: f,
    ladenUnit: f,
    ladenCbm: f,
    exchangeRate: f,
    carbonPrice: f,
    bunkerDays: f,
    lowBunkerDays: f,
    tceUsd: f,
    tceRmb: f,
    breakEvenPoint: f,
    dailyProfit: f,
    netProfitUsd: f,
    freightCommission: f,
    demurrageCommission: f,
    totalIncomeRmb: f,
    lodDisFee: f,
    carbonTaxCost: f,
    estimateName: f,
    dailyTce: f,
    bookEstimateOilCostPrice: new c("BookEstimateOilCostPrice"),
    bookEstimateHire: new c("BookEstimateHire"),
    bookEstimatePort: new c("BookEstimatePort"),
    bookEstimateBunker: new c("BookEstimateBunker"),
    bookEstimateHireIn: new c("BookEstimateHireIn"),
    bookEstimateOthers: new c("BookEstimateOthers"),
    bookEstimateAnalysis: new c("$reqMember.modelName"),
    bookEstimateCargo: new c("BookEstimateCargo")
  };
  ds.QChrEstimateOilCostPrice = {
    oilId: f,
    id: p,
    mainId: f,
    sortLevel: f,
    oilType: f,
    oilPrice: f,
    vesselCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QMtrLlubOilPurpose = {
    id: p,
    productId: f,
    materialInfoId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    oilType: f,
    purposeName: f,
    tankCapacity: f,
    density: f,
    brand: f,
    seq: f,
    linkStock: f,
    deleteFlag: f,
    memo: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSysAclTable = {
    id: p,
    aclMode: f,
    tableName: f,
    tableDesc: f,
    appId: f,
    appCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f
  };
  ds.QAmiTDepLoadPortDelay = {
    id: p,
    tkDepLoadId: f,
    delayFmTm: f,
    delayToTime: f,
    delayReason: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QActIdGroup = {
    id: p,
    rev: f,
    name: f,
    type: f
  };
  ds.QCpmProtocolItemDetail = {
    id: p,
    protocolId: f,
    protocolType: f,
    itemId: f,
    itemCode: f,
    itemNameEn: f,
    itemNameCn: f,
    unit: f,
    remark: f,
    countryId: f,
    countryCode: f,
    countryNameEn: f,
    countryNameCn: f,
    portId: f,
    portCode: f,
    portNameEn: f,
    portNameCn: f,
    price: f,
    discount: f,
    currency: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QActDmnDeployment = {
    id: p,
    name: f,
    category: f,
    deployTime: f,
    tenantId: f,
    parentDeploymentId: f
  };
  ds.QFinReceiptItemOrder = {
    id: p,
    bizOrderId: f,
    receiptId: f,
    receiptItemId: f,
    companyId: f,
    companyNameCn: f,
    companyNameEn: f,
    vesselId: f,
    vesselCode: f,
    vesselNameCn: f,
    vesselNameEn: f,
    orderId: f,
    orderNo: f,
    chargeId: f,
    chargeNameEn: f,
    chargeNameCn: f,
    applyType: f,
    repairType: f,
    supplierId: f,
    supplierNameCn: f,
    supplierNameEn: f,
    currency: f,
    rate: f,
    discount: f,
    orderAmount: f,
    taxAmount: f,
    currencyLocal: f,
    orderAmountLocal: f,
    taxAmountLocal: f,
    orderStatus: f,
    signStatus: f,
    paymentStatus: f,
    repairFlag: f,
    specialMark: f,
    costType: f,
    startDate: f,
    endDate: f,
    repairPlanId: f,
    repairPlanDate: f,
    dockRepairType: f,
    ownerModel: f,
    transferFlag: f,
    deptId: f,
    estimateReceiptId: f,
    technicalReceiptId: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QFineAuthorityObject = {
    id: f,
    tenantid: f,
    expandid: f,
    expandtype: f,
    fullpath: f,
    parentid: f,
    coverid: f,
    description: f,
    devicetype: f,
    displayname: f,
    icon: f,
    mobileicon: f,
    path: f,
    sortindex: f
  };
  ds.QSysEmployee = {
    id: p,
    employeeNo: f,
    cnName: f,
    enName: f,
    idcardNo: f,
    defaultOfficeId: f,
    defaultOfficeCode: f,
    defaultOfficeName: f,
    sexualInd: f,
    nationality: f,
    marriageInd: f,
    onjobInd: f,
    onjobDate: f,
    graduateDate: f,
    officemanagerFlag: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    wechat: f,
    qq: f,
    tel: f,
    email: f,
    mobilePhone: f,
    fax: f,
    validFlag: f,
    uuid: f,
    idcardType: f
  };
  ds.QAmiTInportnoon = {
    id: p,
    baseInfoId: f,
    portCode: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    macLuboilEng: f,
    macLuboilGen: f,
    macLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    windDir: f,
    waveDir: f,
    swellDir: f,
    windScale: f,
    waveHeight: f,
    swellHeight: f,
    weather: f,
    remark: f,
    portNm: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    onberthTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRobFlag: f,
    cargoRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QOpsBl = {
    deckDescKangjin: f,
    discPortDesc: f,
    noOfOriginalBl: f,
    blNo: f,
    retakeFlag: f,
    discPortName: f,
    packageType: f,
    loiConfirmFlag: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    retakeUserName: f,
    carrierName: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    frtSubmitFlag: f,
    issuePlace: f,
    goodsDesc: f,
    discPortCode: f,
    releaseFlag: f,
    lastModifyBy: f,
    frtSubmitUserName: f,
    lastModifyOfficeName: f,
    loiConfirmTime: f,
    loiConfirmUser: f,
    invalidFlag: f,
    shipperName: f,
    opsBlTemplateId: f,
    blSuffix: f,
    releaseUserName: f,
    issueType: f,
    blPrefix: f,
    frtSubmitUser: f,
    goodsCube: f,
    shipperDesc: f,
    createOffice: f,
    frtSubmitTime: f,
    createOfficeName: f,
    carrierCode: f,
    consigneeCode: f,
    createName: f,
    noOfPackage: f,
    weightUnit: f,
    vesselName: f,
    releaseTime: f,
    signature: f,
    invalidUserName: f,
    consigneeDesc: f,
    contractNo: f,
    remark: f,
    releaseUser: f,
    invalidTime: f,
    shipperCode: f,
    consigneeName: f,
    invalidUser: f,
    ispFleetCode: f,
    principalOrgCode: f,
    issueDate: f,
    loadPortName: f,
    notifyCode: f,
    loadPortDesc: f,
    approvalStatus: f,
    voyageNo: f,
    lastModifyOffice: f,
    retakeTime: f,
    creator: f,
    retakeUser: f,
    deckDesc: f,
    totalDesc: f,
    cubeUnit: f,
    marks: f,
    lastModifyByName: f,
    grossWeight: f,
    loadPortCode: f,
    notifyDesc: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    preloadingDesc: f,
    blFormat: f,
    notifyName: f,
    loiConfirmUserName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    discPortNameEn: f,
    loadPortNameEn: f,
    vesselNameEn: f,
    consigneeNameEn: f,
    shipperNameEn: f,
    carrierNameEn: f,
    consigneeDescEn: f,
    notifyNameEn: f,
    lastApprovalStatus: f,
    workflowRestartFlag: f,
    handleUserName: f,
    imageNo: f,
    opsBlSoRelate: new c("OpsBlSoRelate")
  };
  ds.QVscSendQueue = {
    id: p,
    vesselId: f,
    vesselCode: f,
    priority: f,
    contentType: f,
    commType: f,
    businessType: f,
    businessId: f,
    contentTitle: f,
    content: f,
    fileName: f,
    fileSize: f,
    fileMd5: f,
    splitCount: f,
    sendStatus: f,
    sendDtm: f,
    commitDtm: f,
    retryLimit: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cdmVesselGeneral: new c("CdmVesselGeneral")
  };
  ds.QComInvoiceExpressDetail = {
    id: p,
    invoiceExpressId: f,
    invoiceId: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QBookEstimateHireIn = {
    id: p,
    mainId: f,
    type: f,
    rentPerDays: f,
    durationDays: f,
    commission: f,
    totalAmount: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QSysResource = {
    id: p,
    menuId: f,
    url: f,
    urlType: f,
    urlImg: f,
    urlLevel: f,
    urlSeq: f,
    urlTitle: f,
    urlStatus: f,
    menuType: f,
    boName: f,
    methodName: f,
    tableName: f,
    urlParamList: f,
    showOnTreeFlag: f,
    appId: f,
    appCode: f,
    businessType: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyor: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    reservedStr4: f,
    reservedStr5: f,
    titleEn: f,
    titleCn: f
  };
  ds.QFineSwiftTabIdxConf = {
    tablekey: p,
    allotrule: f
  };
  ds.QQrtzTriggers = {
    schedName: f,
    triggerGroup: f,
    triggerName: f,
    appointId: f,
    calendarName: f,
    description: f,
    endTime: f,
    jobData: f,
    jobGroup: f,
    jobName: f,
    misfireInstr: f,
    nextFireTime: f,
    prevFireTime: f,
    priority: f,
    startTime: f,
    triggerState: f,
    triggerType: f
  };
  ds.QChrSettlementBunkerConsumption = {
    id: p,
    mainId: f,
    bunkerType: f,
    bunkerSeq: f,
    bunkerBatch: f,
    bunkerQuantity: f,
    bunkerPrice: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    consumptionQuantity: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    bunkerAmount: f
  };
  ds.QFinEstimateManage = {
    id: p,
    preparationCompany: f,
    reportType: f,
    reportNo: f,
    recordVersion: f,
    preparationDepartment: f,
    checkoutDate: f,
    exchangeRate: f,
    poc: f,
    vesselName: f,
    voyageNo: f,
    voyageStatus: f,
    mainBusniess: f,
    voyageBeginDate: f,
    voyageEndDate: f,
    totalVoyageTime: f,
    establishmentDate: f,
    deliveryDate: f,
    redeliveryDate: f,
    businessType: f,
    voyageType: f,
    personalityStatistics: f,
    cargoType: f,
    vesselSource: f,
    cargoQuantity: f,
    route: f,
    currencyCode: f,
    exportTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    vesselCode: f,
    totalPortAmount: f,
    totalFreightAmount: f,
    totalIncidentalAmount: f,
    totalBunkerAmount: f,
    estimateVersion: f,
    contractDate: f,
    contractType: f,
    dayRent: f,
    contractNo: f,
    chartererCode: f,
    tradeType: f,
    estimateType: f,
    chartererName: f,
    estimateDate: f,
    contractExecuteStatus: f,
    newestStartDate: f,
    receiptSendStatus: f,
    dataStatus: f,
    newestEndDate: f,
    receiptGenerateStatus: f,
    orderDealDate: f,
    newestRentInvoice: f,
    preparationCompanyCode: f,
    vesselType: f,
    ispFleetCode: f,
    vesselNameEn: f,
    chartererNameEn: f,
    preparationCompanyEn: f,
    exceptionOrderNo: f,
    oriCurrency: f,
    estimateNo: f,
    finEstimateFeeList: new c("FinEstimateFee")
  };
  ds.QOpsBlTemplatePod = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    portName: f,
    opsBlTemplateId: f,
    portCode: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f
  };
  ds.QMtrQuoteDetail = {
    id: p,
    quoteMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    materialInfoId: f,
    materialCategoryId: f,
    materialCategoryNameCn: f,
    materialCategoryNameEn: f,
    materialNameCn: f,
    materialNameEn: f,
    materialCode: f,
    spec: f,
    specEn: f,
    validPeriod: f,
    materialVersion: f,
    unit: f,
    minStockQty: f,
    harmfulFlag: f,
    enquireQty: f,
    quotationQty: f,
    supplierHarmfulFlag: f,
    origin: f,
    currency: f,
    rate: f,
    price: f,
    taxRate: f,
    taxes: f,
    discount: f,
    amount: f,
    amountStandard: f,
    leadTime: f,
    quoationDetailRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    existVersion: f,
    orderCode: f,
    newVersion: f
  };
  ds.QAmiSuppliedFuelBack230614 = {
    id: p,
    baseInfoId: f,
    suppliedFuelType: f,
    fuelType: f,
    suppliedDate: f,
    suppliedAmount: f,
    sulphurContent: f,
    visc: f,
    suppliedPortCode: f,
    suppliedPortNameCn: f,
    suppliedPortNameEn: f,
    bunkerRob: f,
    vesselCode: f,
    suppliedFuelId: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselId: f,
    isInitData: f,
    waterContent: f,
    density: f,
    temperature: f,
    bdnNo: f,
    bdnSupplier: f,
    completedPumpingTm: f,
    bargeAlongsideTm: f,
    hoseConnectedTm: f,
    commencedPumpingTm: f,
    hoseDisconnectedTm: f,
    bargeOffTm: f,
    bargeName: f
  };
  ds.QOpsBlTemplatePol = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    portName: f,
    opsBlTemplateId: f,
    portCode: f,
    lastModifyByName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    issuePlace: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f
  };
  ds.QAmclAmiTInportnoon = {
    id: p,
    reportNo: f,
    portCd: f,
    puelMainH: f,
    puelMainL: f,
    puelAuxH: f,
    puelAuxL: f,
    puelBoilerH: f,
    puelBoilerL: f,
    puelIggH: f,
    puelIggL: f,
    puelIncH: f,
    puelIncL: f,
    puelSulphurH: f,
    puelSulphurL: f,
    puelOtherH: f,
    puelOtherL: f,
    gasMainH: f,
    gasMainL: f,
    gasAuxH: f,
    gasAuxL: f,
    gasBoilerH: f,
    gasBoilerL: f,
    gasIggH: f,
    gasIggL: f,
    gasIncH: f,
    gasIncL: f,
    gasSulphurH: f,
    gasSulphurL: f,
    gasOtherH: f,
    gasOtherL: f,
    mLuboilEng: f,
    mLuboilGen: f,
    mLuboilCyl: f,
    boilerWater: f,
    lifeWater: f,
    robHsfo: f,
    robLsfo: f,
    robHsmgo: f,
    robLsmgo: f,
    robMLuboilEng: f,
    robMLuboilGen: f,
    robMLuboilCyl: f,
    robBoilerWater: f,
    robLifeWater: f,
    windDir: f,
    waveDir: f,
    swellDir: f,
    windScale: f,
    waveHeight: f,
    swellHeight: f,
    weather: f,
    remark: f,
    portNm: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    onberthTm: f,
    robTotalCargo: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRob: f,
    cargoRob: f,
    cascadeWaterTemp: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    portType: f,
    portNameCn: f,
    baseInfoId: f,
    portNameEn: f
  };
  ds.QStcRegisterRelation = {
    id: p,
    registerId: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    paymentApplicationId: f
  };
  ds.QAmiGDeparture = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    latitude: f,
    longitude: f,
    crs: f,
    latitudeScore: f,
    latitudeFlag: f,
    longitudeScore: f,
    longitudeFlag: f,
    baseLineCode: f,
    distanceBerthAway: f,
    distanceAnchorageAway: f,
    distanceSailing: f,
    distanceInward: f,
    draftFwd: f,
    draftMid: f,
    draftAft: f,
    gm: f,
    draftFwdArrival: f,
    draftMidArrival: f,
    draftAftArrival: f,
    gmArrival: f,
    averageRpm: f,
    engineSpeed: f,
    slip: f,
    averagePower: f,
    revolutionCounter: f,
    departureTime: f,
    departureLocationPortCd: f,
    departureLocationPortNm: f,
    departureLocationPortType: f,
    esbLt: f,
    pobLt: f,
    lastLineOffLt: f,
    dopLt: f,
    faLt: f,
    proceedingWithEng: f,
    robOfHsfo: f,
    robOfLsfo: f,
    robOfHsmgo: f,
    robOfLsmgo: f,
    nextPortCd: f,
    nextPortNm: f,
    nextPortType: f,
    estDistance: f,
    etdThisPort: f,
    basedOnSpeed: f,
    etaNextPort: f,
    tugs: f,
    sludgeRemoval: f,
    sludgeVolum: f,
    ballastWater: f,
    timeLastReport: f,
    timeThisReport: f,
    durationOfConsumption: f,
    dthsfo: f,
    dtlsfo: f,
    dthsmgo: f,
    dtlsmgo: f,
    recycleWasterOil: f,
    flowMeterFo: f,
    temperatureOfFo: f,
    densityOfFo: f,
    flowMeterMdo: f,
    temperatureOfMdo: f,
    densityOfMdo: f,
    hfo: f,
    lfo: f,
    hmgo: f,
    lmgo: f,
    cylinderLub: f,
    engineLub: f,
    generatorLub: f,
    fw: f,
    remarks: f,
    loadingDischarging: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    flowMeterOfMdoLast: f,
    flowMeterOfFoLast: f,
    allRevolutionCounter: f,
    timeLastReportZone: f,
    timeCommenceOperation: f,
    timeLastReportFlag: f,
    timeThisReportZone: f,
    timeCompleteOperation: f,
    revolutionCounterLast: f,
    distanceOutward: f,
    timeThisReportFlag: f,
    totalRevolutionCounter: f,
    exVoyNo: f
  };
  ds.QFinFuelStock = {
    id: p,
    vesselName: f,
    vesselCode: f,
    voyageNo: f,
    contractNo: f,
    voyageType: f,
    currency: f,
    operationNo: f,
    status: f,
    verifyDate: f,
    voucherNo: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    stockOperate: f,
    universalOrderNo: f,
    hsfoAvgPrice: f,
    lsfoAvgPrice: f,
    hsmgoDynamicQuantity: f,
    businessDate: f,
    dynamicAmount: f,
    hsfoDynamicQuantity: f,
    trendDate: f,
    closeStockAmount: f,
    lsmgoDynamicQuantity: f,
    hsmgoAvgPrice: f,
    lsfoDynamicQuantity: f,
    lsmgoAvgPrice: f,
    lsmgoEndQuantity: f,
    lsfoEndQuantity: f,
    hsmgoEndQuantity: f,
    hsfoEndQuantity: f,
    finFuelStockDetail: new c("FinFuelStockDetail")
  };
  ds.QSpsApplyDetail = {
    vesselApplyQty: f,
    id: p,
    applyMainId: f,
    seqNo: f,
    vesselId: f,
    vesselCode: f,
    productId: f,
    partsInfoId: f,
    partsNameCn: f,
    partsCode: f,
    partsNameEn: f,
    partsDrawing: f,
    partsDrawingItem: f,
    unit: f,
    minStockQty: f,
    harmfulFlag: f,
    applyQty: f,
    crewFlag: f,
    transferQty: f,
    newItemFlag: f,
    newItemId: f,
    applyRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    partsType: f,
    devModel: f,
    devMakerNameCn: f,
    devNameCn: f,
    devSerialNo: f,
    devCode: f,
    devMakerNameEn: f,
    devNameEn: f,
    devInfoId: f,
    devMakerId: f,
    devVesselCodeId: f,
    devFlag: f,
    partsModel: f,
    spsApplyDetailToMain: new c("SpsApplyMain")
  };
  ds.QActRuIdentitylink = {
    id: p,
    rev: f,
    groupId: f,
    type: f,
    userId: f,
    taskId: f,
    procInstId: f,
    procDefId: f
  };
  ds.QAmiGDeparturePilot = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    amiId: f,
    pobLt: f,
    dopLt: f,
    remarks: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QAmiBBunkerDebunker = {
    id: p,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    location: f,
    readyTime: f,
    draftFwd: f,
    draftMid: f,
    draftAft: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    baseInfoId: f,
    exVoyNo: f
  };
  ds.QOpsInsClaimEvent = {
    id: p,
    opsInsClaimId: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    majorEvent: f,
    majorEventDsc: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QFineOutputPrint = {
    id: p,
    printername: f
  };
  ds.QSysCorpOffice = {
    sysCorpOfficeId: p,
    creator: f,
    creatorName: f,
    createOffice: f,
    createOfficeName: f,
    createTime: f,
    createTimeZone: f,
    lastModifyor: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    sysCorpId: f,
    sysOfficeId: f,
    deptOffice: f,
    deptOfficeName: f,
    ebSysCorpOfficeId: f,
    isDeleted: f,
    lastModifyorName: f,
    lastModifyOfficeName: f,
    settleOffice: f,
    settleOfficeName: f
  };
  ds.QActDeModel = {
    id: p,
    name: f,
    modelKey: f,
    description: f,
    modelComment: f,
    created: f,
    createdBy: f,
    lastUpdated: f,
    lastUpdatedBy: f,
    version: f,
    modelEditorJson: f,
    svgImg: f,
    thumbnail: f,
    modelType: f,
    modelProjectName: f,
    modelClass: f,
    modelProjectId: f
  };
  ds.QChrPreSettlementPortFeeDetail = {
    id: p,
    portFeeId: f,
    portCode: f,
    portName: f,
    dataSourceId: f,
    portFee: f,
    type: f,
    invoiceDate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    oriCurrency: f,
    exchangeRate: f
  };
  ds.QRuleNumberConfig = {
    id: p,
    expression: f,
    ruleName: f,
    ruleCode: f,
    resetType: f,
    controlType: f,
    initValue: f,
    maxValue: f,
    step: f,
    createTime: f,
    updateTime: f,
    projectKey: f,
    destroyed: f,
    creator: f,
    modifier: f,
    modifyTime: f,
    version: f
  };
  ds.QFinReceiptAux = {
    id: p,
    receiptItemId: f,
    receiptId: f,
    businessNo: f,
    paymentMethod: f,
    paymentNo: f,
    auxBusinessDate: f,
    auxAmountLocal: f,
    settlementHang: f,
    creator: f,
    createTime: f,
    createTimeZone: f,
    createOffice: f,
    lastModifyBy: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QActEvtLog = {
    logNr: p,
    type: f,
    procDefId: f,
    procInstId: f,
    executionId: f,
    taskId: f,
    timeStamp: f,
    userId: f,
    data: f,
    lockOwner: f,
    lockTime: f,
    isProcessed: f
  };
  ds.QRipEvalMonitorDetails = {
    id: p,
    ripEvalMonitorId: f,
    officeId: f,
    officeCode: f,
    officeName: f,
    officeNameEn: f,
    supplierRipCount: f,
    supplierRipIsEval: f,
    supplierRipUnderEval: f,
    supplierRipNotEval: f,
    otherRipCount: f,
    otherRipIsEval: f,
    otherRipUnderEval: f,
    otherRipNotEval: f,
    creator: f,
    createOffice: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    deletedFlag: f,
    creatorName: f,
    createOfficeName: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    seqNo: f
  };
  ds.QMtrInquiryMain = {
    applyType: f,
    orderType: f,
    reservedDate: f,
    supplierId: f,
    baseCurrency: f,
    lastModifyTimeZone: f,
    vesselId: f,
    reservedStr3: f,
    centralizedFlag: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    comparePriceFlag: f,
    enquireNo: f,
    specBusinessMark: f,
    supplierNameEn: f,
    vesselNameCn: f,
    supplierNameCn: f,
    principalOrgCode: f,
    enquirer: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    vesselNameEn: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    reservedLong2: f,
    enquireStatus: f,
    enquireRemark: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    enquireDate: f,
    createOffice: f,
    createTime: f,
    enquireGroup: f,
    lastModifyTime: f,
    applyNo: f,
    applyMainId: f,
    electricFlag: f
  };
  ds.QMtrPoDetail = {
    seqNo: f,
    discount: f,
    taxes: f,
    spec: f,
    lastModifyTimeZone: f,
    vesselId: f,
    recordVersion: f,
    price: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    harmfulFlag: f,
    lastModifyBy: f,
    returnQty: f,
    materialInfoId: f,
    reservedLong2: f,
    receiveDate: f,
    reservedLong1: f,
    receiveQty: f,
    materialCategoryNameCn: f,
    taxRate: f,
    materialNameEn: f,
    amountStandard: f,
    unit: f,
    createOffice: f,
    receivePortNameCn: f,
    reservedDate: f,
    origin: f,
    readyQty: f,
    materialCategoryId: f,
    receivePortCode: f,
    materialVersion: f,
    reservedStr3: f,
    reservedStr2: f,
    specEn: f,
    reservedStr1: f,
    rate: f,
    poMainId: f,
    principalOrgCode: f,
    currency: f,
    reservedInt1: f,
    reservedInt2: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    reservedDecimal2: f,
    poQty: f,
    materialCode: f,
    reservedDecimal1: f,
    validPeriod: f,
    materialCategoryNameEn: f,
    poDetailRemark: f,
    createTime: f,
    lastModifyTime: f,
    materialNameCn: f,
    minStockQty: f,
    specMark: f,
    receivePortNameEn: f,
    existVersion: f,
    orderCode: f,
    newVersion: f,
    receiveRemark: f,
    spsPoStockingDetails: new c("SpsPoStockingDetail"),
    mtrPoDetailMain: new c("MtrPoMain")
  };
  ds.QCdmBaseinfoManagement = {
    id: p,
    analysisCode: f,
    analysisCodeName: f,
    analysisCodeEnName: f,
    operationType: f,
    sourceType: f,
    sourceData: f,
    status: f,
    operationUser: f,
    operationDate: f,
    resv: f,
    resv1: f,
    resv2: f,
    sendDate: f,
    feedbackDate: f,
    easSwitchCode: f,
    sourceId: f,
    feedbackInfo: f,
    handleStatus: f,
    handleDate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QBookEstimateCargo = {
    id: p,
    mainId: f,
    serialNumber: f,
    cargoType: f,
    pallets: f,
    palletsNo: f,
    cargoName: f,
    cargoNameEn: f,
    cargoCode: f,
    contractNo: f,
    quantity: f,
    quantityUnit: f,
    freightRate: f,
    freight: f,
    otherIncome: f,
    outAddrCommissonCargo: f,
    outbrokerCommissonCargo: f,
    palletsStatus: f,
    contractStatus: f,
    chartererCode: f,
    chartererName: f,
    chartererNameEn: f,
    loadPort: f,
    loadPortName: f,
    loadPortNameEn: f,
    disPort: f,
    disPortName: f,
    disPortNameEn: f,
    numberType: f,
    palletsType: f,
    freightType: f,
    flatRate: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractId: f,
    contractVersion: f,
    contractType: f,
    demurrageCharges: f,
    cargoDesc: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    signSubjectCode: f,
    signSubjectName: f,
    signSubjectNameEn: f,
    isDanagerousCargo: f,
    shipperCode: f,
    shipperName: f,
    shipperNameEn: f,
    brand: f,
    model: f,
    length: f,
    width: f,
    height: f,
    singleVolume: f,
    singleWeight: f,
    totalVolume: f,
    totalWeight: f,
    currencyCode: f,
    currencyName: f,
    cargoUnit: f,
    price: f,
    totalAmount: f,
    sourseId: f
  };
  ds.QStcPaymentProject = {
    settlementAmount: f,
    fiImageNumber: f,
    id: p,
    paymentApplicationId: f,
    remark: f,
    baseAmount: f,
    amount: f,
    paymentDate: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    settlementDate: f
  };
  ds.QSysRole = {
    id: p,
    roleCode: f,
    roleName: f,
    roleNameEn: f,
    parentRoleId: f,
    parentRoleCode: f,
    parentRoleName: f,
    officeChiefFlag: f,
    remark: f,
    appId: f,
    appCode: f,
    sysAppId: f,
    sysAppCode: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    deletedFlag: f,
    lastModifyByName: f,
    lastModifyOfficeName: f,
    createOfficeName: f,
    creatorName: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    reservedStr4: f,
    reservedStr5: f,
    seqNo: f,
    validFlag: f,
    effDate: f,
    expDate: f,
    invalidDate: f,
    officeId: f,
    isJobFlag: f,
    haveResFlag: f
  };
  ds.QFineParamTemplate = {
    id: p,
    templateid: f,
    tpgroup: f,
    username: f
  };
  ds.QMtrMaterialCategory = {
    applyType: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    remark: f,
    categoryNameEn: f,
    categoryCode: f,
    categoryNameCn: f,
    parentId: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    categoryDescCn: f,
    sortNum: f,
    principalOrgCode: f,
    createTimeZone: f,
    categoryDescEn: f,
    id: p,
    applyFlag: f,
    deletedFlag: f
  };
  ds.QSysRoleAcl = {
    id: p,
    roleId: f,
    aclTableId: f,
    conditionSql: f,
    crudType: f,
    tableName: f,
    conditionSqlDisplay: f,
    appId: f,
    appCode: f,
    creator: f,
    creatorName: f,
    createOffice: f,
    createOfficeName: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalGroupCode: f,
    roleCode: f,
    roleName: f
  };
  ds.QAmiTArrival = {
    id: p,
    baseInfoId: f,
    portNameEn: f,
    portCode: f,
    portNameCn: f,
    arrivedTm: f,
    norTenderedTm: f,
    berthedTm: f,
    estDepartureTm: f,
    runDist: f,
    actSailingHrs: f,
    avgSpd: f,
    avgRevolutionPerMin: f,
    slip: f,
    avgBhp: f,
    theoreticalSpd: f,
    stressBm: f,
    stressBmFr: f,
    stressSf: f,
    stressSfFr: f,
    draftFw: f,
    draftMid: f,
    draftAft: f,
    tankCleaningHrsDes: f,
    fuelFoHEng: f,
    fuelFoLEng: f,
    gasMgoHEng: f,
    gasMgoLEng: f,
    fuelFoHGen: f,
    fuelFoLGen: f,
    gasMgoHGen: f,
    gasMgoLGen: f,
    fuelFoHCargoHeating: f,
    fuelFoLCargoHeating: f,
    fuelFoHTankCleaning: f,
    fuelFoLTankCleaning: f,
    fuelFoHOther: f,
    fuelFoLOther: f,
    gasMgoHBoiler: f,
    gasMgoLBoiler: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    ttlLuboilEng: f,
    ttlLuboilCyl: f,
    ttlLuboilGen: f,
    ttlWaterBoiler: f,
    ttlWaterDomestic: f,
    rmFoH: f,
    rmFoL: f,
    rmMgoH: f,
    rmMgoL: f,
    rmLuboilEng: f,
    rmLuboilCyl: f,
    rmLuboilGen: f,
    rmBWater: f,
    rmDWater: f,
    rmNonLiqSlops: f,
    rmLiqSlops: f,
    remarks: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    fuelFoHIgg: f,
    fuelFoLIgg: f,
    fuelFoHInc: f,
    fuelFoLInc: f,
    gasMgoHIgg: f,
    gasMgoLIgg: f,
    gasMgoHInc: f,
    gasMgoLInc: f,
    gasMgoHOther: f,
    gasMgoLOther: f,
    etbTm: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    daFoHEng: f,
    daFoLEng: f,
    daFoHGen: f,
    daFoLGen: f,
    daFoHBoiler: f,
    daFoLBoiler: f,
    daFoHIgg: f,
    daFoLIgg: f,
    daFoHInc: f,
    daFoLInc: f,
    daFoHOther: f,
    daFoLOther: f,
    daSulphurHfo: f,
    daSulphurLfo: f,
    daMgoHEng: f,
    daMgoLEng: f,
    daMgoHGen: f,
    daMgoLGen: f,
    daMgoHBoiler: f,
    daMgoLBoiler: f,
    daMgoHIgg: f,
    daMgoLIgg: f,
    daMgoHInc: f,
    daMgoLInc: f,
    daMgoHOther: f,
    daMgoLOther: f,
    daSulphurHmgo: f,
    daSulphurLmgo: f,
    daTHsfo: f,
    daTLsfo: f,
    daTHsmgo: f,
    daTLsmgo: f,
    daLuboilCyl: f,
    daLuboilEng: f,
    daLuboilGen: f,
    daBoilerWater: f,
    daDomesticWater: f,
    latitude: f,
    longitude: f,
    crs: f,
    isCargoRobFlag: f,
    cargoRob: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    amiTArrivalCargo: new c("AmiTArrivalCargo")
  };
  ds.QAmclAmiTDepLoadOilSupplited = {
    id: p,
    reportNo: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    engLub: f,
    cylLub: f,
    genLub: f,
    bWater: f,
    dWater: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f
  };
  ds.QSpsPoMain = {
    orderType: f,
    devModel: f,
    repairPlanDate: f,
    discount: f,
    devMakerNameCn: f,
    receiveStatus: f,
    lastModifyTimeZone: f,
    vesselId: f,
    recordVersion: f,
    deductionAmount: f,
    eta: f,
    poNo: f,
    etd: f,
    officeId: f,
    supplierNameCn: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    vesselNameEn: f,
    devNameCn: f,
    etp: f,
    lastModifyBy: f,
    devSerialNo: f,
    reservedLong2: f,
    reservedLong1: f,
    payFor: f,
    applyPurpose: f,
    etpNameCn: f,
    amountStandard: f,
    transferVesselNameCn: f,
    createOffice: f,
    logisticsReceiveFlag: f,
    applyMainId: f,
    paymentPeriod: f,
    orderDate: f,
    chargeCode: f,
    transferFlag: f,
    reservedDate: f,
    miscAmount: f,
    extraMiscAmount: f,
    supplierId: f,
    devCode: f,
    leadTime: f,
    expenseSource: f,
    stockingStatus: f,
    devMakerNameEn: f,
    equipmentType: f,
    paymentType: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    rate: f,
    urgency: f,
    specBusinessMark: f,
    supplierNameEn: f,
    vesselNameCn: f,
    poRemark: f,
    principalOrgCode: f,
    currency: f,
    poStatus: f,
    reservedInt1: f,
    devNameEn: f,
    reservedInt2: f,
    paymentStatus: f,
    devInfoId: f,
    lastModifyOffice: f,
    creator: f,
    amount: f,
    transferSource: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    dept: f,
    transferVesselNameEn: f,
    etpNameEn: f,
    createTime: f,
    inquiryMainId: f,
    chargeId: f,
    lastModifyTime: f,
    applyNo: f,
    supplierConfirmFlag: f,
    transferType: f,
    repairPlanId: f,
    devMakerId: f,
    chargeNameEn: f,
    officeNameCn: f,
    chargeNameCn: f,
    officeNameEn: f,
    transferVesselId: f,
    quoteMainId: f,
    baseCurrency: f,
    auditGroupId: f,
    electricFlag: f,
    sendFinanceFlag: f,
    applyRoleCode: f,
    applyType: f,
    devTypeId: f,
    devTypeNameCn: f,
    devTypeNameEn: f,
    devVesselCodeId: f,
    devFlag: f,
    sendFinanceTime: f,
    purposeType: f,
    deviceInstallFlag: f,
    extraMiscFlag: f,
    purposeTypeDevice: f,
    taxRateCode: f,
    taxRate: f,
    taxAmount: f,
    safetyContainFlag: f,
    safetyCharge: f,
    safetyReviewStatus: f,
    signRate: f,
    receiveCompleteUserNameEn: f,
    receiveCompleteUserCode: f,
    receiveCompleteDate: f,
    receiveCompleteUserNameCn: f,
    spsInventoryRecords: new c("SpsInventoryRecord"),
    spsPoDetails: new c("SpsPoDetail"),
    spsPoStockingMains: new c("SpsPoStockingMain"),
    spsMiscInfos: new c("SpsMiscInfo"),
    spsPoFeedBacks: new c("SpsPoFeedBack")
  };
  ds.QSpsTenderProcurementInfo = {
    id: p,
    poMainId: f,
    operationMode: f,
    domesticOrForeigh: f,
    nonTender: f,
    nonTenderRemark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QSpsMiscInfo = {
    id: p,
    referenceId: f,
    seqNo: f,
    vesselId: f,
    extraMiscFlag: f,
    approvedFlag: f,
    vesselCode: f,
    miscName: f,
    chargeCode: f,
    currency: f,
    rate: f,
    amount: f,
    amountStandard: f,
    remark: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QOpsVoyageCp = {
    voyageNo: f,
    opsVoyageTaskId: f,
    contractType: f,
    contractNo: f,
    num: f,
    broker2Name: f,
    broker2Code: f,
    recordVersion: f,
    ispFleetCode: f,
    chartererName: f,
    chartererCode: f,
    vesselCode: f,
    id: p,
    broker1Name: f,
    broker1Code: f,
    vesselName: f,
    remark: f,
    contractVersion: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    createTimeZone: f,
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    lastModifyByName: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    createName: f,
    contractId: f,
    contractFlag: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    vesselNameEn: f,
    chartererNameEn: f,
    broker2NameEn: f,
    broker1NameEn: f
  };
  ds.QFineVcs = {
    id: p,
    commitcode: f,
    commitmsg: f,
    filename: f,
    time: f,
    username: f,
    version: f
  };
  ds.QTInquiryIntfLog = {
    id: p,
    type: f,
    url: f,
    reqFrom: f,
    reqTo: f,
    reqIp: f,
    reqBody: f,
    reqTime: f,
    resStatus: f,
    resBody: f,
    resTime: f
  };
  ds.QAmiBDelivery = {
    id: p,
    baseInfoId: f,
    deliveryTmLoc: f,
    deliveryTmWor: f,
    place: f,
    shipOwner: f,
    charterer: f,
    hsfo: f,
    lsfo: f,
    hsmgo: f,
    lsmgo: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QChrVlocEstimateMain = {
    id: p,
    vlocDate: f,
    companyName: f,
    companyNameEn: f,
    companyCode: f,
    totalIncome: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    ispFleetCode: f,
    lockFlag: f
  };
  ds.QFinePortalMobileHistory = {
    id: p,
    portalid: f,
    querystring: f,
    querytime: f,
    userid: f
  };
  ds.QFineDataPortalAnnouncement = {
    id: p,
    content: f,
    releasetime: f
  };
  ds.QFineOutputPlatformMsg = {
    id: p,
    content: f,
    linkopentype: f,
    subject: f
  };
  ds.QAmiVerifyReport = {
    id: p,
    configMainId: f,
    reportNo: f,
    reportNameCn: f,
    reportNameEn: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QChrEstimateBunker = {
    id: p,
    mainId: f,
    hsfoBallastDailyCon: f,
    lsfoBallastDailyCon: f,
    lsmgoBallastDailyCon: f,
    hsmgoBallastDailyCon: f,
    hsfoBallastTotalCon: f,
    lsfoBallastTotalCon: f,
    lsmgoBallastTotalCon: f,
    hsmgoBallastTotalCon: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    speed: f,
    item: f,
    lsfoBallastTotalRound: f,
    hsmgoBallastTotalRound: f,
    lsmgoBallastTotalRound: f,
    hsfoBallastTotalConRound: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    chrEstimateBunkerCost: new c("ChrEstimateBunkerCost")
  };
  ds.QFinEstimateFee = {
    id: p,
    mainId: f,
    feeType: f,
    invoicedAmount: f,
    pocFee: f,
    actualUniversalQuantity: f,
    portName: f,
    portCode: f,
    portType: f,
    currency: f,
    invoiceNo: f,
    invoiceIsAll: f,
    thisMonthWriteElimination: f,
    thisMonthEstimateAmount: f,
    lastMonthEstimateAmount: f,
    supplierName: f,
    supplierCode: f,
    bunkerSpec: f,
    consumption: f,
    unitPrice: f,
    consumptionAmount: f,
    localCurrencyAmount: f,
    localPoc: f,
    pocTax: f,
    payableAmount: f,
    lastPocAmount: f,
    lastPocTax: f,
    thisMonthCurrency: f,
    bunkerMerchantCode: f,
    bunkerMerchantName: f,
    lastRentTime: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    contractNo: f,
    chartererCode: f,
    chartererName: f,
    reportAmount: f,
    cargoCode: f,
    differentNumber: f,
    orderNo: f,
    cargoQuantity: f,
    cargoName: f,
    receiptNo: f,
    rpType: f,
    orderAmount: f,
    chargeName: f,
    invoiceType: f,
    rentStartDate: f,
    rentEndDate: f,
    rentAmount: f,
    returnCommissionAmount: f,
    period: f,
    otherReceiptNo: f,
    dayRent: f,
    checkAmount: f,
    rentEstimateType: f,
    commissionAmount: f,
    rentType: f,
    checkUnitPrice: f,
    returnDate: f,
    rentDays: f,
    checkQuantity: f,
    closeDate: f,
    cveAmount: f,
    needEstimateAmount: f,
    chargeCode: f,
    invoiceStatus: f,
    receiptStatus: f,
    otherReceiptAmount: f,
    otherReceiptStatus: f,
    needConfirmFlag: f,
    needEstimateFlag: f,
    chargeNameEn: f,
    supplierNameEn: f,
    chartererNameEn: f,
    portNameEn: f,
    portId: f
  };
  ds.QActWoRelatedContent = {
    id: p,
    name: f,
    created: f,
    createdBy: f,
    taskId: f,
    processId: f,
    contentSource: f,
    sourceId: f,
    storeId: f,
    mimeType: f,
    field: f,
    relatedContent: f,
    link: f,
    linkUrl: f,
    contentAvailable: f,
    locked: f,
    lockDate: f,
    lockExpDate: f,
    lockOwner: f,
    checkedOut: f,
    checkoutDate: f,
    checkoutOwner: f,
    lastModified: f,
    lastModifiedBy: f,
    checkedOutToLocal: f,
    contentSize: f
  };
  ds.QBookEstimateHire = {
    id: p,
    mainId: f,
    serialNumber: f,
    beginDate: f,
    endDate: f,
    hireDay: f,
    hireRate: f,
    hire: f,
    outAddrCommissonCargo: f,
    outbrokerCommissonCargo: f,
    ballastSubsidy: f,
    sweepFee: f,
    cve: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    contractNo: f,
    contractId: f,
    contractVersion: f,
    contractType: f,
    otherIncome: f,
    preCve: f,
    ballastGrossType: f,
    chartererCode: f,
    chartererName: f,
    chartererNameEn: f
  };
  ds.QOpsLoiPort = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    remark: f,
    portName: f,
    portCode: f,
    lastModifyByName: f,
    ata: f,
    lastModifyTimeZone: f,
    etb: f,
    recordVersion: f,
    eta: f,
    opsLoiId: f,
    createOffice: f,
    createTime: f,
    createOfficeName: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    id: p,
    createName: f,
    ispFleetCode: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    portNameEn: f,
    portSequence: f
  };
  ds.QSysFileInfo2 = {
    id: f,
    fileKey: f,
    name: f,
    url: f,
    etag: f,
    byteSize: f,
    uploaderStragegyId: f,
    largeThumbnailUrl: f,
    largeThumbnailEtag: f,
    smallThumbnailUrl: f,
    smallThumbnailEtag: f,
    fileType: f,
    deleteFlag: f,
    syncFlag: f,
    businessCode: f,
    subBusinessCode: f,
    businessContent: f,
    vesselCode: f,
    vesselId: f,
    referenceId: f,
    referenceTable: f,
    sequence: f,
    dataSource: f,
    creator: f,
    createOffice: f,
    createTime: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f
  };
  ds.QPmsPoPayment = {
    poNo: p,
    paymentStatus: f
  };
  ds.QAmclAmiTStoppage = {
    id: p,
    reportNo: f,
    stoppageType: f,
    stoppageDistance: f,
    sailingStatus: f,
    latitude: f,
    longitude: f,
    crs: f,
    runHrs: f,
    runDist: f,
    obsSpeed: f,
    distGo: f,
    nextPortCd: f,
    etaNextPort: f,
    windDir: f,
    windScale: f,
    waveDir: f,
    waveHeight: f,
    airTemp: f,
    seaTemp: f,
    currDir: f,
    velocity: f,
    meAvgRpm: f,
    meKw: f,
    avgSpd: f,
    slip: f,
    foRestriction: f,
    spdRestriction: f,
    rpmRestriction: f,
    etaRequirement: f,
    otherRqmnt: f,
    aFoHEng: f,
    aFoLEng: f,
    aFoHGen: f,
    aFoLGen: f,
    aFoHBoiler: f,
    aFoLBoiler: f,
    aMgoHEng: f,
    aMgoLEng: f,
    aMgoHGen: f,
    aMgoLGen: f,
    aMgoHBoiler: f,
    aMgoLBoiler: f,
    tHsfo: f,
    tLsfo: f,
    tHsmgo: f,
    tLsmgo: f,
    aLuboilEng: f,
    aLuboilCyl: f,
    aLuboilGen: f,
    aBoilerWater: f,
    aDomesticWater: f,
    mFoH: f,
    mFoL: f,
    mMgoH: f,
    mMgoL: f,
    mLuboilEng: f,
    mLuboilCyl: f,
    mLuboilGen: f,
    mBoilerWater: f,
    mDomesticWater: f,
    remark: f,
    fuelOilInertTemp: f,
    oilFlowRate: f,
    specialPoint1: f,
    eSpecialTime1: f,
    aPassTime1: f,
    specialPoint2: f,
    eSpecialTime2: f,
    aPassTime2: f,
    totalRunDist: f,
    totalRunTime: f,
    sulphurHfo: f,
    sulphurLfo: f,
    sulphurHmgo: f,
    sulphurLmgo: f,
    basisSpeed: f,
    aFoHIgg: f,
    aFoLIgg: f,
    aFoHInc: f,
    aFoLInc: f,
    aFoHOther: f,
    aFoLOther: f,
    aMgoHIgg: f,
    aMgoLIgg: f,
    aMgoHInc: f,
    aMgoLInc: f,
    aMgoHOther: f,
    aMgoLOther: f,
    shiftingTm: f,
    anchoringTm: f,
    shiftingDist: f,
    totalTm: f,
    driftingTm: f,
    isCargoRob: f,
    cargoRob: f,
    reason: f,
    periodBeginTm: f,
    utc: f,
    periodEndTm: f,
    endUtc: f,
    duration: f,
    aFoHCargoHeating: f,
    aFoLCargoHeating: f,
    aFoHTankCleaning: f,
    aFoLTankCleaning: f,
    ttlFoH: f,
    ttlFoL: f,
    ttlMgoH: f,
    ttlMgoL: f,
    aWaterBoiler: f,
    aWaterDomestic: f,
    mBWater: f,
    mDWater: f,
    mNonLiqSlops: f,
    mLiqSlops: f,
    tFoHEng: f,
    tFoLEng: f,
    tFoHGen: f,
    tFoLGen: f,
    tMgoHEng: f,
    tMgoLEng: f,
    tMgoHGen: f,
    tMgoLGen: f,
    tMgoHBoiler: f,
    tMgoLBoiler: f,
    tFoHCargoHeating: f,
    tFoLCargoHeating: f,
    tFoHTankCleaning: f,
    tFoLTankCleaning: f,
    tMgoHIgg: f,
    tMgoLIgg: f,
    tMgoHInc: f,
    tMgoLInc: f,
    tMgoHOther: f,
    tMgoLOther: f,
    tFoHIgg: f,
    tFoLIgg: f,
    tFoHInc: f,
    tFoLInc: f,
    tFoHOther: f,
    tFoLOther: f,
    tSulphurHfo: f,
    tSulphurLfo: f,
    tSulphurHmgo: f,
    tSulphurLmgo: f,
    tTtlFoH: f,
    tTtlFoL: f,
    tTtlMgoH: f,
    tTtlMgoL: f,
    tLuboilEng: f,
    tLuboilCyl: f,
    tLuboilGen: f,
    tBoilerWater: f,
    tDomesticWater: f,
    tMFoH: f,
    tMFoL: f,
    tMMgoH: f,
    tMMgoL: f,
    tMLuboilEng: f,
    tMLuboilCyl: f,
    tMLuboilGen: f,
    tMBoilerWater: f,
    tMDomesticWater: f,
    tMNonLiqSlops: f,
    tMLiqSlops: f,
    portCd: f,
    cascadeWaterTemp: f,
    reasonDetail: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    tFoHBoiler: f,
    nextPortNameEn: f,
    nextPortType: f,
    nextPortNameCn: f,
    baseInfoId: f,
    tFoLBoiler: f
  };
  ds.QFinCdmFeeType = {
    id: p,
    feeCode: f,
    feeSimpleName: f,
    cnName: f,
    enName: f,
    status: f,
    feeType: f,
    feeBelongScene: f,
    debitSubject: f,
    incomeSubject: f,
    creditSubject: f,
    costSubject: f,
    singleCompanyCost: f,
    fdaVoyageCost: f,
    commissionCost: f,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    suitOrgName: f,
    suitOrgEnName: f,
    suitOrgCode: f,
    finCdmFeeTypeFleet: new c("FinCdmFeeTypeFleet")
  };
  ds.QFinInsuranceDetail = {
    agreementId: f,
    id: p,
    mainId: f,
    vesselCode: f,
    vesselName: f,
    insureType: f,
    insurerCode: f,
    insurerName: f,
    insurerNameEn: f,
    brokerCode: f,
    brokerName: f,
    brokerNameEn: f,
    isSigned: f,
    startDate: f,
    endDate: f,
    amount: f,
    brokerAmount: f,
    invoiceNo: f,
    invoiceAmount: f,
    invoiceDate: f,
    invoiceComplete: f,
    invoiceCompleteNum: f,
    cost: f,
    estimateCost: f,
    offsetCost: f,
    receiptNo: f,
    receiptAmount: f,
    receiptStatus: f,
    recordVersion: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    principalOrgCode: f,
    insYear: f,
    generateReason: f,
    generateFlag: f
  };
  ds.QSpsPoStockingMain = {
    logisticsNameCn: f,
    reservedDate: f,
    logisticsId: f,
    seqNo: f,
    countryNameCn: f,
    currentCity: f,
    cityId: f,
    logisticsNameEn: f,
    countryNameEn: f,
    countryId: f,
    lastModifyTimeZone: f,
    stockingDate: f,
    vesselId: f,
    reservedStr3: f,
    reservedStr2: f,
    reservedStr1: f,
    recordVersion: f,
    cityNameCn: f,
    poMainId: f,
    vesselNameCn: f,
    principalOrgCode: f,
    vesselCode: f,
    createTimeZone: f,
    id: p,
    reservedInt1: f,
    reservedInt2: f,
    vesselNameEn: f,
    lastModifyOffice: f,
    creator: f,
    stockingRemark: f,
    lastModifyBy: f,
    currentStatus: f,
    logisticsRemark: f,
    reservedLong2: f,
    cityNameEn: f,
    reservedDecimal2: f,
    reservedDecimal1: f,
    reservedLong1: f,
    createOffice: f,
    createTime: f,
    lastModifyTime: f,
    logisticsType: f,
    waybillNo: f,
    lgReceCountryId: f,
    lgReceDate: f,
    lgReceCityNameEn: f,
    lgReceCountryNameEn: f,
    lgReceCityId: f,
    lgReceCityNameCn: f,
    lgReceCountryNameCn: f
  };
  ds.QYewukucun = {
    companyCode: f,
    activityDate: f,
    activityType: f,
    amountUsd: f,
    qty: f,
    price: f,
    discount: f,
    rate: f,
    currency: f,
    sendFinanceTime: f,
    vesselCode: f,
    vesselNameEn: f,
    poNo: f,
    referencePo: f,
    businessId: f,
    businessNo: f,
    remark: f,
    creatorNameEn: f,
    oilType: f,
    id: f,
    reservedStr1: f,
    companyId: f,
    newCompanyCode: f,
    newCompanyId: f,
    newPrice: f,
    newRate: f,
    newAmountUsd: f,
    newChargeId: f
  };
  ds.QCdmPort = {
    id: p,
    deletedFlag: f,
    activeFlag: f,
    portCode: f,
    portNameCn: f,
    portNameEn: f,
    countryCode: f,
    countryNameCn: f,
    countryNameEn: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    masterDataCode: f,
    timeZone: f,
    cdmCountry: new c("CdmCountry")
  };
  ds.QFineUser = {
    id: f,
    tenantid: f,
    birthday: f,
    creationtype: f,
    description: f,
    email: f,
    enable: f,
    language: f,
    lastoperationtype: f,
    male: f,
    mobile: f,
    password: f,
    realalias: f,
    realname: f,
    salt: f,
    useralias: f,
    username: f,
    workphone: f
  };
  ds.QFineSentinelOpRecords = {
    id: p,
    endtime: f,
    errormsg: f,
    op: f,
    starttime: f,
    success: f,
    taskid: f
  };
  ds.QOpsVoyageOtherfee = {
    contractDate: f,
    isAdvance: f,
    contractType: f,
    dueDate: f,
    toComm: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    exchangeRate: f,
    createTimeZone: f,
    id: p,
    invoiceNo: f,
    rpFlag: f,
    lastModifyBy: f,
    lastModifyOfficeName: f,
    coaContractNo: f,
    customerName: f,
    createOffice: f,
    createOfficeName: f,
    toFrt: f,
    createName: f,
    advanceAmount: f,
    contractNo: f,
    customerCode: f,
    remark: f,
    bankName: f,
    portName: f,
    checkStatus: f,
    ispFleetCode: f,
    principalOrgCode: f,
    currency: f,
    lastModifyOffice: f,
    bankCode: f,
    creator: f,
    amount: f,
    actualAmount: f,
    invoiceDate: f,
    portCode: f,
    lastModifyByName: f,
    bankInf: f,
    amountFlag: f,
    abandon: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    currencyTo: f,
    isPayByOtherDept: f,
    opsVoyageTaskId: f,
    contractId: f,
    chargeCode: f,
    chargeName: f,
    portSequence: f,
    invoiceId: f,
    businessName: f,
    businessCode: f,
    portNameEn: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    customerNameEn: f,
    chargeNameEn: f,
    bankNameEn: f,
    vesselCode: f,
    vesselNameEn: f,
    vesselName: f,
    voyageNo: f,
    offsetCompanyName: f,
    offsetCompanyNameEn: f,
    docNo: f,
    offsetCompanyCode: f,
    advanceId: f,
    escrowFlag: f,
    portId: f
  };
  ds.QOpsInsInvoiceDetail = {
    id: p,
    paymentApplicationId: f,
    agreementType: f,
    agreementId: f,
    opsInsInvoiceId: f,
    vesselCode: f,
    vesselName: f,
    voyageNo: f,
    currency: f,
    originalAmount: f,
    changeRate: f,
    currencyTo: f,
    amount: f,
    paymentSubject: f,
    finType: f,
    shoulderCompanyCode: f,
    shoulderCompanyName: f,
    yearType: f,
    insCompanyCode: f,
    insCompanyName: f,
    insAgreement: f,
    refundAmount: f,
    refundRate: f,
    remark: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    quitTime: f,
    startTime: f,
    endTime: f,
    baseCurrencyCode: f,
    baseCurrencyName: f,
    baseAmount: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f,
    insCompanyNameEn: f,
    vesselNameEn: f,
    shoulderCompanyNameEn: f,
    exTaxation: f,
    taxRate: f,
    notaxAmount: f,
    baseExTaxation: f,
    baseNotaxAmount: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    settleOfficeNameEn: f,
    comInvoiceApproveId: f,
    chargeNameEn: f,
    chargeCode: f,
    rpType: f,
    chargeName: f
  };
  ds.QSysBusinessFollow = {
    id: p,
    userCode: f,
    roleCode: f,
    vesselId: f,
    vesselCode: f,
    businessMode: f,
    businessMenu: f,
    businessSummary: f,
    followTime: f,
    followSequence: f,
    businessKey: f,
    businessKeyValue: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f
  };
  ds.QSysMessageRemindConfig = {
    id: p,
    messageRemindId: f,
    messageSubType: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f
  };
  ds.QActHiTaskinst = {
    id: p,
    procDefId: f,
    taskDefKey: f,
    procInstId: f,
    executionId: f,
    name: f,
    parentTaskId: f,
    description: f,
    owner: f,
    assignee: f,
    startTime: f,
    claimTime: f,
    endTime: f,
    duration: f,
    deleteReason: f,
    priority: f,
    dueDate: f,
    formKey: f,
    category: f,
    tenantId: f
  };
  ds.QOpsDryDockRepairReportOil = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    bunkerCost: f,
    opsDryDockRepairReportId: f,
    oilType: f,
    startOilQty: f,
    endOilQty: f,
    ispFleetCode: f,
    discountBunkerCost: f,
    voyageBunkerCost: f,
    oilPrice: f,
    currency: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    repireBunkerCost: f
  };
  ds.QBgtAnnualBudgetDtl = {
    id: p,
    annualBudgetVesselId: f,
    parentId: f,
    chargeId: f,
    chargeCode: f,
    chargeName: f,
    chargeNameCn: f,
    totalAmount: f,
    januaryAmount: f,
    februaryAmount: f,
    marchAmount: f,
    aprilAmount: f,
    mayAmount: f,
    juneAmount: f,
    julyAmount: f,
    augustAmount: f,
    septemberAmount: f,
    octoberAmount: f,
    novemberAmount: f,
    decemberAmount: f,
    remark12: f,
    remark11: f,
    remark10: f,
    remark9: f,
    remark8: f,
    remark7: f,
    remark6: f,
    remark5: f,
    remark4: f,
    remark3: f,
    remark2: f,
    remark1: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    totalRemark: f
  };
  ds.QSysMobileApproveLog = {
    id: p,
    referenceId: f,
    taskCode: f,
    operation: f,
    url: f,
    outerId: f,
    title: f,
    targetUid: f,
    successFlag: f,
    sendType: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedInt1: f,
    reservedLong1: f
  };
  ds.QRipQualification = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    qualificationName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    uploader: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    alwaysValidFlag: f,
    id: p,
    attachmentPath: f,
    effectiveDate: f,
    ripBaseInfoId: f
  };
  ds.QPoolRouteScor = {
    id: p,
    voyRoute: f,
    cargoType: f,
    freightRate: f,
    maxLoa: f,
    maxBeam: f,
    minOutrReq: f,
    noLoadMile: f,
    fullLoadMile: f,
    stowFac: f,
    loadArea: f,
    loadRate: f,
    loadCraneNum: f,
    loadPortCharge: f,
    selfload: f,
    unloadArea: f,
    unloadRate: f,
    unloadCraneNum: f,
    unloadPortCharge: f,
    selfdischarge: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    superiorCompanyCode: f
  };
  ds.QFineOutputSms = {
    id: p,
    smsparam: f,
    templateid: f
  };
  ds.QTemp = {
    id: f,
    parentid: f,
    officename: f
  };
  ds.QActFoDatabasechangelog = {
    id: f,
    author: f,
    filename: f,
    dateexecuted: f,
    orderexecuted: f,
    exectype: f,
    md5sum: f,
    description: f,
    comments: f,
    tag: f,
    liquibase: f,
    contexts: f,
    labels: f,
    deploymentId: f
  };
  ds.QAmiGDepartureItems = {
    id: p,
    baseInfoId: f,
    reportNo: f,
    amiId: f,
    ldQty: f,
    ldType: f,
    cargoNm: f,
    cargoCd: f,
    pcs: f,
    subLdQtyH1: f,
    subLdQtyH2: f,
    subLdQtyH3: f,
    subLdQtyH4: f,
    subLdQtyH5: f,
    subLdQtyH6: f,
    subLdQtyH7: f,
    subLdQtyH8: f,
    subLdQtyH9: f,
    subLdQtyH10: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f
  };
  ds.QAmiMonthOilDetail = {
    id: p,
    monthOilId: f,
    sno: f,
    tankname: f,
    vol100: f,
    volper: f,
    typ: f,
    hl: f,
    volxx: f,
    qty: f,
    vesselId: f,
    vesselCode: f,
    syear: f,
    smonth: f,
    ischeck: f,
    checker: f,
    checkdate: f,
    senddate: f,
    isImportFlag: f,
    importer: f,
    importdate: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    reservedInt1: f,
    reservedInt2: f,
    reservedLong1: f,
    reservedLong2: f,
    reservedDecimal1: f,
    reservedDecimal2: f,
    reservedDate: f,
    reservedStr1: f,
    reservedStr2: f,
    reservedStr3: f,
    vesselEnName: f,
    vesselCnName: f,
    tkrCheck: f,
    trkCheck: f,
    opnCheckUser: f,
    asdLock: f,
    opnCheck: f,
    opnCheckDate: f
  };
  ds.QSysMessageRemind = {
    id: p,
    applyType: f,
    applyObject: f,
    postRoleFlag: f,
    remark: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    deletedFlag: f,
    customFlag: f,
    companyCode: f,
    sysMessageRemindConfig: new c("SysMessageRemindConfig")
  };
  ds.QFineMobileDevice = {
    id: p,
    createdate: f,
    devicename: f,
    macaddress: f,
    passed: f,
    updatedate: f,
    username: f
  };
  ds.QTestDsEntity = {
    size: f,
    id: p,
    message: f,
    content: f
  };
  ds.QFineDataPortalAnnMiddle = {
    id: p,
    announcementid: f,
    portalid: f
  };
  ds.QSysVesselFollow = {
    id: p,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    teamVesselId: f,
    userCode: f
  };
  ds.QComInsApprove = {
    id: p,
    customerCode: f,
    customerName: f,
    customerNameEn: f,
    currencyCode: f,
    currencyName: f,
    invoiceAmount: f,
    exchangeRate: f,
    remark: f,
    approvalStatus: f,
    shareStatus: f,
    invalidUser: f,
    invalidUserName: f,
    invalidTime: f,
    invalidReason: f,
    sendFlag: f,
    sendUser: f,
    sendUserName: f,
    sendDate: f,
    readFlag: f,
    readUser: f,
    readUserName: f,
    readTime: f,
    settleStatus: f,
    settleAmount: f,
    settleOfficeCode: f,
    settleOfficeName: f,
    settleOfficeNameEn: f,
    handleUserName: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createOfficeName: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    ispFleetCode: f,
    principalOrgCode: f,
    baseCurrencyCode: f,
    baseAmount: f,
    notaxAmount: f,
    taxRate: f,
    exTaxation: f,
    baseNotaxAmount: f,
    baseExTaxation: f,
    imageNo: f,
    cancelId: f,
    cancelApprovalStatus: f,
    cancelFlag: f,
    workflowRestartFlag: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    comInsApproveInvoice: new c("ComInsApproveInvoice")
  };
  ds.QActFoFormResource = {
    id: p,
    name: f,
    deploymentId: f,
    resourceBytes: f
  };
  ds.QBookEstimateOilCostPrice = {
    id: p,
    mainId: f,
    sortLevel: f,
    oilType: f,
    oilPrice: f,
    vesselCode: f,
    creator: f,
    createOffice: f,
    createOfficeName: f,
    createTime: f,
    lastModifyBy: f,
    createTimeZone: f,
    lastModifyOffice: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f,
    oilId: f,
    deletedFlag: f
  };
  ds.QFineOutputFtp = {
    id: p,
    ftpmode: f,
    password: f,
    port: f,
    savepath: f,
    securepassword: f,
    serveraddress: f,
    username: f
  };
  ds.QChrSettlementCargoOver = {
    id: p,
    remark: f,
    deletedFlag: f,
    creator: f,
    createName: f,
    createTime: f,
    createOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    lastModifyByName: f,
    lastModifyTime: f,
    lastModifyOffice: f,
    lastModifyOfficeName: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    principalOrgCode: f,
    cargoOqMin: f,
    cargoOqMax: f,
    cargoOqStandards: f,
    cargoOqMode: f,
    cargoId: f,
    ispFleetCode: f,
    cargoOverNo: f,
    extend3: f,
    extend2: f,
    extend5: f,
    extend4: f,
    extend1: f
  };
  ds.QFineWorkflowNode = {
    id: p,
    alertcontrol: f,
    authority: f,
    description: f,
    name: f,
    needallcomplete: f,
    needofflinereport: f,
    processid: f,
    reportcontrol: f
  };
  ds.QAmclAmiTDepDischFlow = {
    id: p,
    reportNo: f,
    hoseConnected: f,
    hoseDisconnected: f,
    commenceDischarging: f,
    completeDischarging: f,
    fileid: f,
    deletedFlag: f,
    createTime: f,
    createOffice: f,
    creator: f,
    lastModifyTime: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    lastModifyOffice: f,
    createTimeZone: f,
    lastModifyBy: f,
    principalOrgCode: f,
    baseInfoId: f
  };
  ds.QStcChargeConfigDtl = {
    lastModifyOffice: f,
    creator: f,
    lastModifyBy: f,
    chargeConfigId: f,
    chargeCodeId: f,
    lastModifyTimeZone: f,
    recordVersion: f,
    createOffice: f,
    createTime: f,
    deletedFlag: f,
    lastModifyTime: f,
    principalOrgCode: f,
    createTimeZone: f,
    chooseFlag: f,
    id: p
  };
  ds.QChrTceLockSummary = {
    id: p,
    mainId: f,
    vesselCode: f,
    vesselName: f,
    vesselNameEn: f,
    dataType: f,
    contractNo: f,
    annualOperationDays: f,
    annualLockDays: f,
    annualUnlockDays: f,
    annualLockTce: f,
    annualLockTceIncome: f,
    annualOffHire: f,
    annualLockRate: f,
    rangeOperationDays: f,
    rangeLockDays: f,
    rangeUnlockDays: f,
    rangeLockTce: f,
    rangeLockTceIncome: f,
    rangeOffHire: f,
    rangeLockRate: f,
    extend1: f,
    extend2: f,
    extend3: f,
    extend4: f,
    extend5: f
  };
  ds.QFineConfEntity = {
    id: p,
    value: f
  };
  ds.QFineScheduleTaskExtend = {
    id: p,
    taskid: f,
    taskparametermap: f,
    templatepaths: f
  };
})(window);
// @formatter:on